webpackJsonp([1],Array(105).concat([
/* 105 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(788)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(577),
  /* template */
  __webpack_require__(979),
  /* scopeId */
  "data-v-3fb3a960",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var files = __webpack_require__(1045);
var modules = {};

files.keys().forEach(function (key) {
  if (key === './index.js') return;
  modules[key.replace(/(\.\/|\.js)/g, '')] = files(key).default;
});

/* harmony default export */ __webpack_exports__["default"] = (modules);

/***/ }),
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(566),
  /* template */
  __webpack_require__(1013),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(771)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(569),
  /* template */
  __webpack_require__(958),
  /* scopeId */
  "data-v-187255fc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(779)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(571),
  /* template */
  __webpack_require__(967),
  /* scopeId */
  "data-v-2b9cb8a2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(773)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(573),
  /* template */
  __webpack_require__(961),
  /* scopeId */
  "data-v-212fa545",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(778)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(575),
  /* template */
  __webpack_require__(966),
  /* scopeId */
  "data-v-2a491d2a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(833)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(579),
  /* template */
  __webpack_require__(1025),
  /* scopeId */
  "data-v-d7bce3b4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(803)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(588),
  /* template */
  __webpack_require__(995),
  /* scopeId */
  "data-v-5f008e3b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(775)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(593),
  /* template */
  __webpack_require__(963),
  /* scopeId */
  "data-v-2494e49d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(784)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(597),
  /* template */
  __webpack_require__(974),
  /* scopeId */
  "data-v-352a0148",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(789)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(614),
  /* template */
  __webpack_require__(980),
  /* scopeId */
  "data-v-403038ab",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 498 */,
/* 499 */,
/* 500 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_dist_css_bootstrap_min_css__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_dist_css_bootstrap_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bootstrap_dist_css_bootstrap_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_admin_lte_dist_css_AdminLTE_min_css__ = __webpack_require__(749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_admin_lte_dist_css_AdminLTE_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_admin_lte_dist_css_AdminLTE_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_admin_lte_dist_css_skins_all_skins_min_css__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_admin_lte_dist_css_skins_all_skins_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_admin_lte_dist_css_skins_all_skins_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_font_awesome_css_font_awesome_min_css__ = __webpack_require__(752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_font_awesome_css_font_awesome_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_font_awesome_css_font_awesome_min_css__);





/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);


var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue___default.a();

/* harmony default export */ __webpack_exports__["a"] = (EventBus);

/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__grid_Row__ = __webpack_require__(937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__grid_Row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__grid_Row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__grid_Column__ = __webpack_require__(936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__grid_Column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__grid_Column__);



__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component('row', __WEBPACK_IMPORTED_MODULE_1__grid_Row___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component('column', __WEBPACK_IMPORTED_MODULE_2__grid_Column___default.a);

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_expose_loader_expose_loader_jQuery_jquery__ = __webpack_require__(747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_expose_loader_expose_loader_jQuery_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_expose_loader_expose_loader_jQuery_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery_slimscroll__ = __webpack_require__(840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery_slimscroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery_slimscroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery_ui_ui_widgets_sortable_js__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery_ui_ui_widgets_sortable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery_ui_ui_widgets_sortable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery_ui_ui_widgets_datepicker_js__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery_ui_ui_widgets_datepicker_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery_ui_ui_widgets_datepicker_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery_ui_themes_base_datepicker_css__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery_ui_themes_base_datepicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery_ui_themes_base_datepicker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_admin_lte__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_admin_lte___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_admin_lte__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_chart_js__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_chart_js__);











/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(1038);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_sla_IndexSla_vue__ = __webpack_require__(930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_sla_IndexSla_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_sla_IndexSla_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_sla_ControleApuracaoSla_vue__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_sla_ControleApuracaoSla_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_sla_ControleApuracaoSla_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_loginLogout_Logout_vue__ = __webpack_require__(893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_loginLogout_Logout_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_loginLogout_Logout_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_perfilUsuario_Perfil__ = __webpack_require__(909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_perfilUsuario_Perfil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_perfilUsuario_Perfil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_modal_InserirEvidencia__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_modal_InserirEvidencia___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_modal_InserirEvidencia__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_notificacao_InserirNotificacao__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_notificacao_InserirNotificacao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_notificacao_InserirNotificacao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_notificacao_ListarNotificacoes__ = __webpack_require__(906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_notificacao_ListarNotificacoes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_notificacao_ListarNotificacoes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_notificacao_ExibirNotificacao__ = __webpack_require__(903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_notificacao_ExibirNotificacao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_notificacao_ExibirNotificacao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_aplicacaoFechamentoExtra_ListarFechamentoExtra__ = __webpack_require__(884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_aplicacaoFechamentoExtra_ListarFechamentoExtra___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_components_aplicacaoFechamentoExtra_ListarFechamentoExtra__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_aplicacaoGlosaFranquias_AplicarGlosaFranquias__ = __webpack_require__(885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_aplicacaoGlosaFranquias_AplicarGlosaFranquias___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_components_aplicacaoGlosaFranquias_AplicarGlosaFranquias__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_aplicacaoFechamentoExtra_ExibirFechamentoExtra__ = __webpack_require__(883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_aplicacaoFechamentoExtra_ExibirFechamentoExtra___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_components_aplicacaoFechamentoExtra_ExibirFechamentoExtra__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_notificacao_form_FormExibirNotificacaoSemLogin_vue__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_notificacao_form_FormExibirNotificacaoSemLogin_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_notificacao_form_FormExibirNotificacaoSemLogin_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_loginLogout_LoginTokenTemporario_vue__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_loginLogout_LoginTokenTemporario_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_loginLogout_LoginTokenTemporario_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_planilha_DownloadCsv__ = __webpack_require__(910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_planilha_DownloadCsv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_components_planilha_DownloadCsv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_aplicacaoFechamentoExtra_DetalhesFechamentoExtra_vue__ = __webpack_require__(882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_aplicacaoFechamentoExtra_DetalhesFechamentoExtra_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_aplicacaoFechamentoExtra_DetalhesFechamentoExtra_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_planilha_extracontratual_ExportarFechamentoExtra_vue__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_planilha_extracontratual_ExportarFechamentoExtra_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_planilha_extracontratual_ExportarFechamentoExtra_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_planilha_planilhaGeral_ExportSla_vue__ = __webpack_require__(913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_planilha_planilhaGeral_ExportSla_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_components_planilha_planilhaGeral_ExportSla_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_loginLogout_redirecionar_Index_vue__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_loginLogout_redirecionar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_components_loginLogout_redirecionar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_loginLogout_redirecionar_RedirecionarAdministrativo_vue__ = __webpack_require__(894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_loginLogout_redirecionar_RedirecionarAdministrativo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_components_loginLogout_redirecionar_RedirecionarAdministrativo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_components_simulacaoPreventivas_SimulacaoGeral_vue__ = __webpack_require__(929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_components_simulacaoPreventivas_SimulacaoGeral_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_components_simulacaoPreventivas_SimulacaoGeral_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_components_simulacaoPreventivas_ImportarPreventivas_vue__ = __webpack_require__(928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_components_simulacaoPreventivas_ImportarPreventivas_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_components_simulacaoPreventivas_ImportarPreventivas_vue__);

























__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/autenticar/:hash',
    name: 'LoginTokenTemporario',
    component: __WEBPACK_IMPORTED_MODULE_14__components_loginLogout_LoginTokenTemporario_vue___default.a
  }, {
    path: '/redirecionarAdministrativo/',
    name: 'RedirecionarAdministrativo',
    component: __WEBPACK_IMPORTED_MODULE_20_components_loginLogout_redirecionar_RedirecionarAdministrativo_vue___default.a
  }, {
    path: '/simulacao-geral',
    name: 'SimulacaoGeral',
    component: __WEBPACK_IMPORTED_MODULE_21_components_simulacaoPreventivas_SimulacaoGeral_vue___default.a
  }, {
    path: '/importar-preventivas',
    name: 'ImportarPreventivas',
    component: __WEBPACK_IMPORTED_MODULE_22_components_simulacaoPreventivas_ImportarPreventivas_vue___default.a
  }, {
    path: '/FormNotificacaoEmail/:hash',
    name: 'FormNotificacaoEmail',
    component: __WEBPACK_IMPORTED_MODULE_13__components_notificacao_form_FormExibirNotificacaoSemLogin_vue___default.a
  }, {
    path: '/Logout/',
    name: 'Logout',
    component: __WEBPACK_IMPORTED_MODULE_4_components_loginLogout_Logout_vue___default.a
  }, {
    path: '/listarSla',
    name: 'ListarSla',
    component: __WEBPACK_IMPORTED_MODULE_2_components_sla_IndexSla_vue___default.a
  }, {
    path: '/getslas',
    name: 'getSlas',
    component: __WEBPACK_IMPORTED_MODULE_3_components_sla_ControleApuracaoSla_vue___default.a
  }, {
    path: '/perfilusuario',
    name: 'perfilusuario',
    component: __WEBPACK_IMPORTED_MODULE_5_components_perfilUsuario_Perfil___default.a
  }, {
    path: '/InserirEvidencia',
    name: 'InserirEvidencia',
    component: __WEBPACK_IMPORTED_MODULE_6_components_modal_InserirEvidencia___default.a
  }, {
    path: '/InserirNotificacao',
    name: 'InserirNotificacao',
    component: __WEBPACK_IMPORTED_MODULE_7__components_notificacao_InserirNotificacao___default.a
  }, {
    path: '/ListarNotificacoes',
    name: 'ListarNotificacoes',
    component: __WEBPACK_IMPORTED_MODULE_8__components_notificacao_ListarNotificacoes___default.a
  }, {
    path: '/ExibirNotificacao',
    name: 'ExibirNotificacao',
    component: __WEBPACK_IMPORTED_MODULE_9__components_notificacao_ExibirNotificacao___default.a
  }, {
    path: '/planilhas',
    name: 'Planilhas',
    component: __WEBPACK_IMPORTED_MODULE_15_components_planilha_DownloadCsv___default.a
  }, {
    path: '/ListarFechamentoExtra',
    name: 'ListarFechamentoExtra',
    component: __WEBPACK_IMPORTED_MODULE_10_components_aplicacaoFechamentoExtra_ListarFechamentoExtra___default.a
  }, {
    path: '/AplicarGlosaFranquias',
    name: 'AplicarGlosaFranquias',
    component: __WEBPACK_IMPORTED_MODULE_11_components_aplicacaoGlosaFranquias_AplicarGlosaFranquias___default.a
  }, {
    path: '/ExibirFechamentoExtra',
    name: 'ExibirFechamentoExtra',
    component: __WEBPACK_IMPORTED_MODULE_12_components_aplicacaoFechamentoExtra_ExibirFechamentoExtra___default.a
  }, {
    path: '/DetalhesFechamentoExtra',
    name: 'DetalhesFechamentoExtra',
    component: __WEBPACK_IMPORTED_MODULE_16__components_aplicacaoFechamentoExtra_DetalhesFechamentoExtra_vue___default.a
  }, {
    path: '/ExportarFechamentoExtra',
    name: 'ExportarFechamentoExtra',
    component: __WEBPACK_IMPORTED_MODULE_17__components_planilha_extracontratual_ExportarFechamentoExtra_vue___default.a
  }, {
    path: '/ExportSla',
    name: 'ExportSla',
    component: __WEBPACK_IMPORTED_MODULE_18_components_planilha_planilhaGeral_ExportSla_vue___default.a
  }, {
    path: '/redirecionar',
    name: 'redirecionarUsuarioPorGrupo',
    component: __WEBPACK_IMPORTED_MODULE_19_components_loginLogout_redirecionar_Index_vue___default.a
  }],
  linkActiveClass: 'active'
}));

/***/ }),
/* 506 */,
/* 507 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 508 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 509 */,
/* 510 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(829)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(552),
  /* template */
  __webpack_require__(1021),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AtomSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1000
    },
    size: {
      type: Number,
      default: 60
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    circleStyle: function circleStyle() {
      return {
        color: this.color,
        fontSize: this.size * 0.24 + 'px'
      };
    },
    lineStyle: function lineStyle() {
      return {
        animationDuration: this.animationDuration + 'ms',
        borderLeftWidth: this.size / 25 + 'px',
        borderTopWidth: this.size / 25 + 'px',
        borderLeftColor: this.color
      };
    }
  }
});

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BreedingRhombusSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 2000
    },
    size: {
      type: Number,
      default: 150
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      animationBaseName: 'breeding-rhombus-spinner-animation-child',
      rhombusesNum: 8
    };
  },


  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    rhombusStyle: function rhombusStyle() {
      return {
        height: this.size / 7.5 + 'px',
        width: this.size / 7.5 + 'px',
        animationDuration: this.animationDuration + 'ms',
        top: this.size / 2.3077 + 'px',
        left: this.size / 2.3077 + 'px',
        backgroundColor: this.color
      };
    },
    rhombusesStyles: function rhombusesStyles() {
      var rhombusesStyles = [];
      var delayModifier = this.animationDuration * 0.05;

      for (var i = 1; i <= this.rhombusesNum; i++) {
        rhombusesStyles.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: delayModifier * (i + 1) + 'ms'
        }, this.rhombusStyle));
      }

      return rhombusesStyles;
    },
    bigRhombusStyle: function bigRhombusStyle() {
      return {
        height: this.size / 3 + 'px',
        width: this.size / 3 + 'px',
        animationDuration: '' + this.animationDuration,
        top: this.size / 3 + 'px',
        left: this.size / 3 + 'px',
        backgroundColor: this.color
      };
    }
  }

});

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CirclesToRhombusesSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1200
    },
    circleSize: {
      type: Number,
      default: 15
    },
    color: {
      type: String,
      default: '#fff'
    },
    circlesNum: {
      type: Number,
      default: 3
    }
  },

  computed: {
    circleMarginLeft: function circleMarginLeft() {
      return this.circleSize * 1.125;
    },
    spinnertStyle: function spinnertStyle() {
      return {
        height: this.circleSize + 'px',
        width: (this.circleSize + this.circleMarginLeft) * this.circlesNum + 'px'
      };
    },
    circleStyle: function circleStyle() {
      return {
        borderColor: this.color,
        animationDuration: this.animationDuration + 'ms',
        height: this.circleSize + 'px',
        width: this.circleSize + 'px',
        marginLeft: this.circleMarginLeft + 'px'
      };
    },
    circlesStyles: function circlesStyles() {
      var circlesStyles = [];
      var delay = 150;

      for (var i = 1; i <= this.circlesNum; i++) {
        var style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: i * delay + 'ms'
        }, this.circleStyle);

        if (i === 1) {
          style.marginLeft = 0;
        }

        circlesStyles.push(style);
      }

      return circlesStyles;
    }
  }
});

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FingerprintSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1500
    },
    size: {
      type: Number,
      default: 60
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      ringsNum: 9,
      containerPadding: 2
    };
  },


  computed: {
    outerRingSize: function outerRingSize() {
      return this.size - this.containerPadding * 2;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        padding: this.containerPadding + 'px'
      };
    },
    ringStyle: function ringStyle() {
      return {
        borderTopColor: this.color,
        animationDuration: this.animationDuration + 'ms'
      };
    },
    ringsStyles: function ringsStyles() {
      var ringsStyles = [];
      var ringBase = this.outerRingSize / this.ringsNum;
      var ringInc = ringBase;

      for (var i = 1; i <= this.ringsNum; i++) {
        var style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: i * 50 + 'ms',
          height: ringBase + (i - 1) * ringInc + 'px',
          width: ringBase + (i - 1) * ringInc + 'px'
        }, this.ringStyle);
        ringsStyles.push(style);
      }

      return ringsStyles;
    }
  }
});

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_utils__ = __webpack_require__(171);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FlowerSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 2500
    },
    size: {
      type: Number,
      default: 70
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      smallDotName: 'flower-spinner-small-dot-' + Date.now(),
      bigDotName: 'flower-spinner-big-dot-' + Date.now()
    };
  },


  computed: {
    dotSize: function dotSize() {
      return this.size / 7;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        width: this.size + 'px',
        height: this.size + 'px'
      };
    },
    dotsContainerStyle: function dotsContainerStyle() {
      return {
        width: this.dotSize + 'px',
        height: this.dotSize + 'px'
      };
    },
    smallerDotStyle: function smallerDotStyle() {
      return {
        background: this.color,
        animationDuration: this.animationDuration + 'ms',
        animationName: this.smallDotName
      };
    },
    biggerDotStyle: function biggerDotStyle() {
      return {
        background: this.color,
        animationDuration: this.animationDuration + 'ms',
        animationName: this.bigDotName
      };
    }
  },

  watch: {
    size: {
      handler: 'updateAnimation',
      immediate: true
    },
    color: {
      handler: 'updateAnimation',
      immediate: true
    }
  },

  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_0__services_utils__["a" /* default */].removeKeyframes(this.smallDotName);
    __WEBPACK_IMPORTED_MODULE_0__services_utils__["a" /* default */].removeKeyframes(this.bigDotName);
  },


  methods: {
    updateAnimation: function updateAnimation() {
      __WEBPACK_IMPORTED_MODULE_0__services_utils__["a" /* default */].removeKeyframes(this.smallDotName);
      __WEBPACK_IMPORTED_MODULE_0__services_utils__["a" /* default */].appendKeyframes(this.smallDotName, this.generateSmallDotKeyframes());
      __WEBPACK_IMPORTED_MODULE_0__services_utils__["a" /* default */].removeKeyframes(this.bigDotName);
      __WEBPACK_IMPORTED_MODULE_0__services_utils__["a" /* default */].appendKeyframes(this.bigDotName, this.generateBigDotKeyframes());
    },
    generateSmallDotKeyframes: function generateSmallDotKeyframes() {
      return '0%, 100% {\n                    box-shadow: 0 0 0 ' + this.color + ',\n                                0 0 0 ' + this.color + ',\n                                0 0 0 ' + this.color + ',\n                                0 0 0 ' + this.color + ',\n                                0 0 0 ' + this.color + ',\n                                0 0 0 ' + this.color + ',\n                                0 0 0 ' + this.color + ',\n                                0 0 0 ' + this.color + ';\n                  }\n                  25%, 75% {\n                    box-shadow: ' + this.dotSize * 1.4 + 'px 0 0 ' + this.color + ',\n                                -' + this.dotSize * 1.4 + 'px 0 0 ' + this.color + ',\n                                0 ' + this.dotSize * 1.4 + 'px 0 ' + this.color + ',\n                                0 -' + this.dotSize * 1.4 + 'px 0 ' + this.color + ',\n                                ' + this.dotSize + 'px -' + this.dotSize + 'px 0 ' + this.color + ',\n                                ' + this.dotSize + 'px ' + this.dotSize + 'px 0 ' + this.color + ',\n                                -' + this.dotSize + 'px -' + this.dotSize + 'px 0 ' + this.color + ',\n                                -' + this.dotSize + 'px ' + this.dotSize + 'px 0 ' + this.color + ';\n\n                  }\n                  100% {\n                    box-shadow: 0 0 0 ' + this.color + ',\n                                0 0 0 ' + this.color + ',\n                                0 0 0 ' + this.color + ',\n                                0 0 0 ' + this.color + ',\n                                0 0 0 ' + this.color + ',\n                                0 0 0 ' + this.color + ',\n                                0 0 0 ' + this.color + ',\n                                0 0 0 ' + this.color + ';\n                  }';
    },
    generateBigDotKeyframes: function generateBigDotKeyframes() {
      return '0%, 100% {\n                    box-shadow: 0 0 0 ' + this.color + ',\n                                0 0 0 ' + this.color + ',\n                                0 0 0 ' + this.color + ',\n                                0 0 0 ' + this.color + ',\n                                0 0 0 ' + this.color + ',\n                                0 0 0 ' + this.color + ',\n                                0 0 0 ' + this.color + ',\n                                0 0 0 ' + this.color + ';\n                  }\n                  50% {\n                    transform: rotate(180deg);\n                  }\n                  25%, 75% {\n                    box-shadow: ' + this.dotSize * 2.6 + 'px 0 0 ' + this.color + ',\n                                -' + this.dotSize * 2.6 + 'px 0 0 ' + this.color + ',\n                                0 ' + this.dotSize * 2.6 + 'px 0 ' + this.color + ',\n                                0 -' + this.dotSize * 2.6 + 'px 0 ' + this.color + ',\n                                ' + this.dotSize * 1.9 + 'px -' + this.dotSize * 1.9 + 'px 0 ' + this.color + ',\n                                ' + this.dotSize * 1.9 + 'px ' + this.dotSize * 1.9 + 'px 0 ' + this.color + ',\n                                -' + this.dotSize * 1.9 + 'px -' + this.dotSize * 1.9 + 'px 0 ' + this.color + ',\n                                -' + this.dotSize * 1.9 + 'px ' + this.dotSize * 1.9 + 'px 0 ' + this.color + ';\n\n                  }\n                  100% {\n                    transform: rotate(360deg);\n                    box-shadow: 0 0 0 ' + this.color + ',\n                                0 0 0 ' + this.color + ',\n                                0 0 0 ' + this.color + ',\n                                0 0 0 ' + this.color + ',\n                                0 0 0 ' + this.color + ',\n                                0 0 0 ' + this.color + ',\n                                0 0 0 ' + this.color + ',\n                                0 0 0 ' + this.color + ';\n                  }';
    }
  }
});

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FulfillingBouncingCircleSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 4000
    },
    size: {
      type: Number,
      default: 60
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        animationDuration: this.animationDuration + 'ms'
      };
    },
    orbitStyle: function orbitStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        borderColor: this.color,
        borderWidth: this.size * 0.03 + 'px',
        animationDuration: this.animationDuration + 'ms'
      };
    },
    circleStyle: function circleStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        borderColor: this.color,
        color: this.color,
        borderWidth: this.size * 0.1 + 'px',
        animationDuration: this.animationDuration + 'ms'
      };
    }
  }
});

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FulfillingSquareSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 4000
    },
    size: {
      type: Number,
      default: 50
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        borderColor: this.color
      };
    },
    spinnerInnerStyle: function spinnerInnerStyle() {
      return {
        backgroundColor: this.color
      };
    }
  }
});

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'HalfCircleSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1000
    },
    size: {
      type: Number,
      default: 60
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    circleStyle: function circleStyle() {
      return {
        borderWidth: this.size / 10 + 'px',
        animationDuration: this.animationDuration + 'ms'
      };
    },
    circle1Style: function circle1Style() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
        borderTopColor: this.color
      }, this.circleStyle);
    },
    circle2Style: function circle2Style() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
        borderBottomColor: this.color
      }, this.circleStyle);
    }
  }
});

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'HollowDotsSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1000
    },
    dotSize: {
      type: Number,
      default: 15
    },
    dotsNum: {
      type: Number,
      default: 3
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  computed: {
    horizontalMargin: function horizontalMargin() {
      return this.dotSize / 2;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.dotSize + 'px',
        width: (this.dotSize + this.horizontalMargin * 2) * this.dotsNum + 'px'
      };
    },
    dotStyle: function dotStyle() {
      return {
        animationDuration: this.animationDuration + 'ms',
        width: this.dotSize + 'px',
        height: this.dotSize + 'px',
        margin: '0 ' + this.horizontalMargin + 'px',
        borderWidth: this.dotSize / 5 + 'px',
        borderColor: this.color
      };
    },
    dotsStyles: function dotsStyles() {
      var dotsStyles = [];
      var delayModifier = 0.3;
      var basicDelay = 1000;

      for (var i = 1; i <= this.dotsNum; i++) {
        var style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: basicDelay * i * delayModifier + 'ms'
        }, this.dotStyle);

        dotsStyles.push(style);
      }

      return dotsStyles;
    }
  }
});

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'IntersectingCirclesSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1200
    },
    size: {
      type: Number,
      default: 70
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  computed: {
    circleSize: function circleSize() {
      return this.size / 2;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        width: this.size + 'px',
        height: this.size + 'px'
      };
    },
    spinnerBlockStyle: function spinnerBlockStyle() {
      return {
        animationDuration: this.animationDuration + 'ms',
        width: this.circleSize + 'px',
        height: this.circleSize + 'px'
      };
    },
    circleStyle: function circleStyle() {
      return {
        borderColor: this.color
      };
    },
    circleStyles: function circleStyles() {
      var _this = this;

      var circlesPositions = [{ top: 0, left: 0 }, { left: this.circleSize * -0.36 + 'px', top: this.circleSize * 0.2 + 'px' }, { left: this.circleSize * -0.36 + 'px', top: this.circleSize * -0.2 + 'px' }, { left: 0, top: this.circleSize * -0.36 + 'px' }, { left: this.circleSize * 0.36 + 'px', top: this.circleSize * -0.2 + 'px' }, { left: this.circleSize * 0.36 + 'px', top: this.circleSize * 0.2 + 'px' }, { left: 0, top: this.circleSize * 0.36 + 'px' }];

      return circlesPositions.map(function (cp) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(cp, _this.circleStyle);
      });
    }
  }
});

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LoopingRhombusesSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 2500
    },
    rhombusSize: {
      type: Number,
      default: 15
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      rhombusesNum: 3
    };
  },


  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.rhombusSize + 'px',
        width: this.rhombusSize * 4 + 'px'
      };
    },
    rhombusStyle: function rhombusStyle() {
      return {
        height: this.rhombusSize + 'px',
        width: this.rhombusSize + 'px',
        backgroundColor: this.color,
        animationDuration: this.animationDuration + 'ms',
        left: this.rhombusSize * 4 + 'px'
      };
    },
    rhombusesStyles: function rhombusesStyles() {
      var rhombusesStyles = [];
      var delay = -this.animationDuration / 1.5;

      for (var i = 1; i <= this.rhombusesNum; i++) {
        var style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: i * delay + 'ms'
        }, this.rhombusStyle);

        rhombusesStyles.push(style);
      }

      return rhombusesStyles;
    }
  }
});

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'OrbitSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1000
    },
    size: {
      type: Number,
      default: 50
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    orbitStyle: function orbitStyle() {
      return {
        borderColor: this.color,
        animationDuration: this.animationDuration + 'ms'
      };
    }
  }
});

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_utils__ = __webpack_require__(171);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PixelSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1500
    },
    size: {
      type: Number,
      default: 70
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      animationName: 'pixel-spinner-animation-' + Date.now()
    };
  },


  computed: {
    pixelSize: function pixelSize() {
      return this.size / 7;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        width: this.size + 'px',
        height: this.size + 'px'
      };
    },
    spinnerInnerStyle: function spinnerInnerStyle() {
      return {
        animationDuration: this.animationDuration + 'ms',
        animationName: this.animationName,
        width: this.pixelSize + 'px',
        height: this.pixelSize + 'px',
        backgroundColor: this.color,
        color: this.color,
        boxShadow: '\n                        ' + this.pixelSize * 1.5 + 'px ' + this.pixelSize * 1.5 + 'px 0 0,\n                        ' + this.pixelSize * -1.5 + 'px ' + this.pixelSize * -1.5 + 'px 0 0,\n                        ' + this.pixelSize * 1.5 + 'px ' + this.pixelSize * -1.5 + 'px 0 0,\n                        ' + this.pixelSize * -1.5 + 'px ' + this.pixelSize * 1.5 + 'px 0 0,\n                        0 ' + this.pixelSize * 1.5 + 'px 0 0,\n                        ' + this.pixelSize * 1.5 + 'px 0 0 0,\n                        ' + this.pixelSize * -1.5 + 'px 0 0 0,\n                        0 ' + this.pixelSize * -1.5 + 'px 0 0\n                      '
      };
    }
  },

  watch: {
    size: {
      handler: 'updateAnimation',
      immediate: true
    }
  },

  mounted: function mounted() {
    this.updateAnimation();
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_0__services_utils__["a" /* default */].removeKeyframes(this.animationName);
  },


  methods: {
    updateAnimation: function updateAnimation() {
      __WEBPACK_IMPORTED_MODULE_0__services_utils__["a" /* default */].removeKeyframes(this.animationName);
      __WEBPACK_IMPORTED_MODULE_0__services_utils__["a" /* default */].appendKeyframes(this.animationName, this.generateKeyframes());
    },
    generateKeyframes: function generateKeyframes() {
      return '\n        50% {\n          box-shadow:  ' + this.pixelSize * 2 + 'px ' + this.pixelSize * 2 + 'px 0 0,\n                       ' + this.pixelSize * -2 + 'px ' + this.pixelSize * -2 + 'px 0 0,\n                       ' + this.pixelSize * 2 + 'px ' + this.pixelSize * -2 + 'px 0 0,\n                       ' + this.pixelSize * -2 + 'px ' + this.pixelSize * 2 + 'px 0 0,\n                       0 ' + this.pixelSize + 'px 0 0,\n                       ' + this.pixelSize + 'px 0 0 0,\n                       ' + this.pixelSize * -1 + 'px 0 0 0,\n                       0 ' + this.pixelSize * -1 + 'px 0 0;\n        }\n\n\n        75% {\n          box-shadow:  ' + this.pixelSize * 2 + 'px ' + this.pixelSize * 2 + 'px 0 0,\n                       ' + this.pixelSize * -2 + 'px ' + this.pixelSize * -2 + 'px 0 0,\n                       ' + this.pixelSize * 2 + 'px ' + this.pixelSize * -2 + 'px 0 0,\n                       ' + this.pixelSize * -2 + 'px ' + this.pixelSize * 2 + 'px 0 0,\n                       0 ' + this.pixelSize + 'px 0 0,\n                       ' + this.pixelSize + 'px 0 0 0,\n                       ' + this.pixelSize * -1 + 'px 0 0 0,\n                       0 ' + this.pixelSize * -1 + 'px 0 0;\n        }\n\n        100% {\n          transform: rotate(360deg);\n        }';
    }
  }
});

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RadarSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 2000
    },
    size: {
      type: Number,
      default: 110
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      circlesNum: 4
    };
  },


  computed: {
    borderWidth: function borderWidth() {
      return this.size * 5 / 110;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    circleStyle: function circleStyle() {
      return {
        animationDuration: this.animationDuration + 'ms'
      };
    },
    circleInnerContainerStyle: function circleInnerContainerStyle() {
      return {
        borderWidth: this.borderWidth + 'px'
      };
    },
    circleInnerStyle: function circleInnerStyle() {
      return {
        borderLeftColor: this.color,
        borderRightColor: this.color,
        borderWidth: this.borderWidth + 'px'
      };
    },
    circlesStyles: function circlesStyles() {
      var circlesStyles = [];
      var delay = this.animationDuration * 0.15;

      for (var i = 0; i < this.circlesNum; i++) {
        circlesStyles.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          padding: this.borderWidth * 2 * i + 'px',
          animationDelay: (i === this.circlesNum - 1 ? 0 : delay) + 'ms'
        }, this.circleStyle));
      }

      return circlesStyles;
    }
  }
});

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ScalingSquaresSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1250
    },
    size: {
      type: Number,
      default: 65
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      squaresNum: 4
    };
  },


  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        animationDuration: this.animationDuration + 'ms'
      };
    },
    squareStyle: function squareStyle() {
      return {
        height: this.size * 0.25 / 1.3 + 'px',
        width: this.size * 0.25 / 1.3 + 'px',
        animationDuration: this.animationDuration + 'ms',
        borderWidth: this.size * 0.04 / 1.3 + 'px',
        borderColor: this.color
      };
    },
    squaresStyles: function squaresStyles() {
      var squaresStyles = [];

      for (var i = 1; i <= this.squaresNum; i++) {
        squaresStyles.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.squareStyle));
      }

      return squaresStyles;
    }
  }
});

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SelfBuildingSquareSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 6000
    },
    size: {
      type: Number,
      default: 40
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      squaresNum: 9
    };
  },


  computed: {
    squareSize: function squareSize() {
      return this.size / 4;
    },
    initialTopPosition: function initialTopPosition() {
      return -this.squareSize * 2 / 3;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        top: -this.initialTopPosition + 'px',
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    squareStyle: function squareStyle() {
      return {
        height: this.squareSize + 'px',
        width: this.squareSize + 'px',
        top: this.initialTopPosition + 'px',
        marginRight: this.squareSize / 3 + 'px',
        marginTop: this.squareSize / 3 + 'px',
        animationDuration: this.animationDuration + 'ms',
        background: this.color
      };
    },
    squaresStyles: function squaresStyles() {
      var squaresStyles = [];
      var delaysMultipliers = [6, 7, 8, 3, 4, 5, 0, 1, 2];
      var delayModifier = this.animationDuration * 0.05;

      for (var i = 0; i < this.squaresNum; i++) {
        squaresStyles.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: delayModifier * delaysMultipliers[i] + 'ms'
        }, this.squareStyle));
      }

      return squaresStyles;
    }
  }
});

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SemipolarSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 2000
    },
    size: {
      type: Number,
      default: 65
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      ringsNum: 5
    };
  },


  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    ringStyle: function ringStyle() {
      return {
        animationDuration: this.animationDuration + 'ms',
        borderTopColor: this.color,
        borderLeftColor: this.color
      };
    },
    ringsStyles: function ringsStyles() {
      var ringsStyles = [];
      var delayModifier = 0.1;
      var ringWidth = this.size * 0.05;
      var positionIncrement = ringWidth * 2;
      var sizeDecrement = this.size * 0.2;

      for (var i = 0; i < this.ringsNum; i++) {
        var computedSize = this.size - sizeDecrement * i + 'px';
        var computedPosition = positionIncrement * i + 'px';
        var style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: this.animationDuration * delayModifier * (this.ringsNum - i - 1) + 'ms',
          height: computedSize,
          width: computedSize,
          left: computedPosition,
          top: computedPosition,
          borderWidth: ringWidth + 'px'
        }, this.ringStyle);
        ringsStyles.push(style);
      }

      return ringsStyles;
    }
  }
});

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_utils__ = __webpack_require__(171);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SpringSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 3000
    },
    size: {
      type: Number,
      default: 70
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      animationName: 'spring-spinner-animation-' + Date.now()
    };
  },


  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    spinnerPartStyle: function spinnerPartStyle() {
      return {
        height: this.size / 2 + 'px',
        width: this.size + 'px'
      };
    },
    rotatorStyle: function rotatorStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        borderRightColor: this.color,
        borderTopColor: this.color,
        borderWidth: this.size / 7 + 'px',
        animationDuration: this.animationDuration + 'ms',
        animationName: this.animationName
      };
    }
  },

  watch: {
    size: {
      handler: 'updateAnimation',
      immediate: true
    },
    color: {
      handler: 'updateAnimation',
      immediate: true
    }
  },

  mounted: function mounted() {
    this.updateAnimation();
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_0__services_utils__["a" /* default */].removeKeyframes(this.animationName);
  },


  methods: {
    updateAnimation: function updateAnimation() {
      __WEBPACK_IMPORTED_MODULE_0__services_utils__["a" /* default */].removeKeyframes(this.animationName);
      __WEBPACK_IMPORTED_MODULE_0__services_utils__["a" /* default */].appendKeyframes(this.animationName, this.generateKeyframes());
    },
    generateKeyframes: function generateKeyframes() {
      return '\n          0% {\n            border-width: ' + this.size / 7 + 'px;\n          }\n          25% {\n            border-width: ' + this.size / 23.33 + 'px;\n          }\n          50% {\n            transform: rotate(115deg);\n            border-width: ' + this.size / 7 + 'px;\n          }\n          75% {\n            border-width: ' + this.size / 23.33 + 'px;\n           }\n          100% {\n           border-width: ' + this.size / 7 + 'px;\n          }';
    }
  }
});

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SwappingSquaresSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1000
    },
    size: {
      type: Number,
      default: 65
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      animationBaseName: 'swapping-squares-animation-child',
      squaresNum: 4
    };
  },


  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    squareStyle: function squareStyle() {
      return {
        height: this.size * 0.25 / 1.3 + 'px',
        width: this.size * 0.25 / 1.3 + 'px',
        animationDuration: this.animationDuration + 'ms',
        borderWidth: this.size * 0.04 / 1.3 + 'px',
        borderColor: this.color
      };
    },
    squaresStyles: function squaresStyles() {
      var squaresStyles = [];
      var delay = this.animationDuration * 0.5;

      for (var i = 1; i <= this.squaresNum; i++) {
        squaresStyles.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: (i % 2 === 0 ? delay : 0) + 'ms'
        }, this.squareStyle));
      }

      return squaresStyles;
    }
  }
});

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TrinityRingsSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1500
    },
    size: {
      type: Number,
      default: 60
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      containerPadding: 3
    };
  },


  computed: {
    outerRingSize: function outerRingSize() {
      return this.size - this.containerPadding * 2;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        padding: this.containerPadding + 'px'
      };
    },
    ring1Style: function ring1Style() {
      return {
        height: this.outerRingSize + 'px',
        width: this.outerRingSize + 'px',
        borderColor: this.color,
        animationDuration: this.animationDuration + 'ms'
      };
    },
    ring2Style: function ring2Style() {
      return {
        height: this.outerRingSize * 0.65 + 'px',
        width: this.outerRingSize * 0.65 + 'px',
        borderColor: this.color,
        animationDuration: this.animationDuration + 'ms'
      };
    },
    ring3Style: function ring3Style() {
      return {
        height: this.outerRingSize * 0.1 + 'px',
        width: this.outerRingSize * 0.1 + 'px',
        borderColor: this.color,
        animationDuration: this.animationDuration + 'ms'
      };
    }
  }
});

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_xlsx_xlsx__ = __webpack_require__(1044);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_xlsx_xlsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_xlsx_xlsx__);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: "vue-excel-xlsx",
    props: {
        columns: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        data: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        fileName: {
            type: String,
            default: 'excel'
        },
        sheetName: {
            type: String,
            default: 'SheetName'
        },
        fileType: {
            type: String,
            default: 'xlsx',
            validator: function validator(val) {
                return ['xlsx', 'xls'].includes(val);
            }
        }
    },

    methods: {
        exportExcel: function exportExcel() {
            var _this = this;

            var createXLSLFormatObj = [];
            var newXlsHeader = [];
            var vm = this;
            if (vm.columns.length === 0) {
                console.log("Add columns!");
                return;
            }
            if (vm.data.length === 0) {
                console.log("Add data!");
                return;
            }
            vm.columns.map(function (column) {
                newXlsHeader.push(column.label);
            });

            createXLSLFormatObj.push(newXlsHeader);
            vm.data.map(function (value) {
                var innerRowData = [];
                vm.columns.map(function (val) {
                    var fieldValue = value[val.field];
                    if (val.field.split('.').length > 1) {
                        fieldValue = _this.getNestedValue(value, val.field);
                    }
                    if (val.dataFormat && typeof val.dataFormat === 'function') {
                        innerRowData.push(val.dataFormat(fieldValue));
                    } else {
                        innerRowData.push(fieldValue);
                    }
                });
                createXLSLFormatObj.push(innerRowData);
            });

            var fileName = vm.fileName + "." + vm.fileType;

            var ws_name = vm.sheetName;

            var wb = __WEBPACK_IMPORTED_MODULE_0_xlsx_xlsx___default.a.utils.book_new(),
                ws = __WEBPACK_IMPORTED_MODULE_0_xlsx_xlsx___default.a.utils.aoa_to_sheet(createXLSLFormatObj);
            __WEBPACK_IMPORTED_MODULE_0_xlsx_xlsx___default.a.utils.book_append_sheet(wb, ws, ws_name);
            __WEBPACK_IMPORTED_MODULE_0_xlsx_xlsx___default.a.writeFile(wb, fileName);
        },
        getNestedValue: function getNestedValue(object, string) {
            string = string.replace(/\[(\w+)\]/g, '.$1');
            string = string.replace(/^\./, '');
            var a = string.split('.');
            for (var i = 0, n = a.length; i < n; ++i) {
                var k = a[i];
                if (k in object) {
                    object = object[k];
                } else {
                    return;
                }
            }
            return object;
        }
    }
});

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NaviBar_vue__ = __webpack_require__(879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NaviBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__NaviBar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Slider_vue__ = __webpack_require__(880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Slider_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Slider_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ContentWrap_vue__ = __webpack_require__(878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ContentWrap_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ContentWrap_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_modal_Index_vue__ = __webpack_require__(897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_modal_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_modal_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vuex_store_js__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_slideMenuItems_js__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_slideMenuItems_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__lib_slideMenuItems_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_loginLogout_Login_vue__ = __webpack_require__(892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_loginLogout_Login_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_loginLogout_Login_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_notificacao_form_FormExibirNotificacaoSemLogin_vue__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_notificacao_form_FormExibirNotificacaoSemLogin_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_notificacao_form_FormExibirNotificacaoSemLogin_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_loginLogout_redirecionar_Index_vue__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_loginLogout_redirecionar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_loginLogout_redirecionar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_loginLogout_LoginTokenTemporario_vue__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_loginLogout_LoginTokenTemporario_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_loginLogout_LoginTokenTemporario_vue__);













/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      slideMenuItems: __WEBPACK_IMPORTED_MODULE_5__lib_slideMenuItems_js___default.a,
      env: __webpack_require__.i({"NODE_ENV":"production","AUTENTICA":"https://autentica-single.portalssp.com/api","CADASTRO_USUARIO":"https://cadastro.oi.portalssp.com","RECUPERAR_SENHA":"https://cadastro.oi.portalssp.com/reset","STORAGE":"https://storage.portalssp.com/api/v1","FINANCEIRO":__webpack_require__.i({"SLA":"https://financeiro.sla.portalssp.com/api","NOTIFICACAO":"https://financeiro.notificacoes.portalssp.com/api","GLOSA":"https://financeiro.glosa.portalssp.com/api/v1"}),"ADMINISTRATIVO":"undefined"}).ROOT_API,
      rotasLiberadas: ['FormNotificacaoEmail']
    };
  },
  created: function created() {},

  components: {
    'va-navibar': __WEBPACK_IMPORTED_MODULE_0__NaviBar_vue___default.a,
    'va-slider': __WEBPACK_IMPORTED_MODULE_1__Slider_vue___default.a,
    'va-content-wrap': __WEBPACK_IMPORTED_MODULE_2_ContentWrap_vue___default.a,
    'formulario-notificacao-sem-login': __WEBPACK_IMPORTED_MODULE_7__components_notificacao_form_FormExibirNotificacaoSemLogin_vue___default.a,
    'login-ssp': __WEBPACK_IMPORTED_MODULE_9__components_loginLogout_LoginTokenTemporario_vue___default.a,
    Modals: __WEBPACK_IMPORTED_MODULE_3__components_modal_Index_vue___default.a,
    Login: __WEBPACK_IMPORTED_MODULE_6__components_loginLogout_Login_vue___default.a,
    'redirecionar-usuario-apos-login': __WEBPACK_IMPORTED_MODULE_8__components_loginLogout_redirecionar_Index_vue___default.a
  },
  methods: {
    rotasNaoAutenticadas: function rotasNaoAutenticadas() {
      var _this = this;

      var resposta = this.rotasLiberadas.filter(function (item) {
        return item === _this.$route.name || item === _this.$route.path;
      });
      return resposta.length > 0 ? 1 : 0;
    }
  },
  store: __WEBPACK_IMPORTED_MODULE_4__vuex_store_js__["a" /* default */]
});

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'va-content-wrap',
  created: function created() {}
});

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_modal_AlertAtualizacoes_vue__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_modal_AlertAtualizacoes_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_modal_AlertAtualizacoes_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      calendario: false,
      grupo: this.$store.state.login.loginUsuario.grupo
    };
  },

  components: {
    'alert-alteracoes': __WEBPACK_IMPORTED_MODULE_2__components_modal_AlertAtualizacoes_vue___default.a
  },
  name: 'va-navibar',
  mounted: function mounted() {},

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['unreadMessagesCount', 'unreadNotificationsCount', 'remainTasksCount', 'currentUser']), {
    siglaNomeUsuario: function siglaNomeUsuario() {
      var siglaNome = [];
      var nome = this.$store.state.login.loginUsuario.usuario.name;
      var nomeArray = nome.split(' ');
      for (var i in nomeArray) {
        siglaNome.push(' ' + nomeArray[i][0]);
      }

      var siglaNome1 = siglaNome.toString().replace(',', '').replace(',', '');
      if (nomeArray.length >= 4) {
        return siglaNome1.substring(0, 6);
      } else {
        return siglaNome1;
      }
    }
  }),
  methods: {
    irPara: function irPara(rota) {
      this.$router.push(rota);
    },
    getCalendario: function getCalendario() {
      this.calendario = true;
    }
  }
});

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_VASlideItem__ = __webpack_require__(881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_VASlideItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_VASlideItem__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'va-slider',
  props: {
    slideMenuItems: {
      type: Array,
      default: []
    }
  },
  created: function created() {},

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['currentUser'])),
  components: {
    'va-slide-item': __WEBPACK_IMPORTED_MODULE_2__components_VASlideItem___default.a
  }
});

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'va-slide-item',
  props: {
    type: {
      type: String,
      default: 'item'
    },
    isHeader: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: ''
    },
    name: {
      type: String
    },
    badge: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    router: {
      type: Object,
      default: function _default() {
        return {
          name: ''
        };
      }
    },
    link: {
      type: String,
      default: ''
    }
  },
  created: function created() {},

  computed: {
    getType: function getType() {
      if (this.isHeader) {
        return 'header';
      }
      return this.type === 'item' ? '' : 'treeview';
    },
    filterItems: function filterItems() {
      var _this = this;

      return this.items.filter(function (i) {
        if (i.router.name == 'Ajustes') {
          return _this.verificarPermissao();
        }

        if (i.router && ['SimulacaoGeral', 'ImportarPreventivas'].includes(i.router.name)) {
          return _this.isFabricio();
        }
        return i.router && i.router.name;
      });
    },
    ocultarItem: function ocultarItem() {
      return this.type === 'tree' && this.name === 'Simulação Preventivas' && !this.isFabricio();
    }
  },
  methods: {
    changeTree: function changeTree(obj) {
      var found = null;
      document.querySelectorAll('[class*=root-tree]').forEach(function (element, index) {
        if (element.textContent.trim() !== obj.trim()) {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(document.querySelectorAll('.treeview')), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var a = _step.value;

              if (a.textContent.includes(element.textContent.trim())) {
                found = a;
                break;
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          if (found.classList.contains('menu-open')) {
            found.classList.remove('menu-open');
            found.childNodes[3].style.display = 'none';
          }
        }
      });
    },

    comparaArrays: function comparaArrays(a, b) {
      for (var j = 0; j < b.length; j++) {
        return true;
      }
      return false;
    },
    exibeSubMenuGrupoUsuario: function exibeSubMenuGrupoUsuario(subMenu) {
      var usuarioGrupo = this.$store.state.login.loginUsuario.grupo;
      console.log('subMenu', subMenu);

      var _usuarioGrupo = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(usuarioGrupo, 3),
          g1 = _usuarioGrupo[0],
          g2 = _usuarioGrupo[1],
          g3 = _usuarioGrupo[2];

      console.log('Gs', g1, g2, g3);
      if (subMenu.grupos === undefined) {
        return true;
      }
      if (g2 === undefined) {
        return subMenu.grupos.includes(g1.nome);
      }

      if (g3 === undefined) {
        return subMenu.grupos.includes(g1.nome) || subMenu.grupos.includes(g2.nome);
      }

      return subMenu.grupos.includes(g1.nome) || subMenu.grupos.includes(g2.nome) || subMenu.grupos.includes(g3.nome);
    },

    verificarPermissao: function verificarPermissao() {
      var emailsPermitidos = ['fabricio.elias@portalssp.com', 'fabricio.alves@portalssp.com', 'filipe.husak@portalssp.com', 'ssp@portalssp.com', 'suporte@portalssp.com', 'leila.gomes@portalssp.com', 'caroline.maciel@oi.net.br', 'luciano.carvalho@oi.net.br'];
      var emailUser = this.$store.state.login.loginUsuario.usuario.email.toLowerCase();
      if (emailsPermitidos.indexOf(emailUser) === -1) {
        return false;
      } else {
        return true;
      }
    },
    isFabricio: function isFabricio() {
      try {
        var email = (this.$store.state.login.loginUsuario.usuario.email || '').toLowerCase();
        return email === 'fabricio.elias@portalssp.com';
      } catch (e) {
        return false;
      }
    }
  }

});

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      fechamentoAtual: [],
      predios: [],
      controlerLoadingDownload: true,
      env: __webpack_require__.i({"NODE_ENV":"production","AUTENTICA":"https://autentica-single.portalssp.com/api","CADASTRO_USUARIO":"https://cadastro.oi.portalssp.com","RECUPERAR_SENHA":"https://cadastro.oi.portalssp.com/reset","STORAGE":"https://storage.portalssp.com/api/v1","FINANCEIRO":__webpack_require__.i({"SLA":"https://financeiro.sla.portalssp.com/api","NOTIFICACAO":"https://financeiro.notificacoes.portalssp.com/api","GLOSA":"https://financeiro.glosa.portalssp.com/api/v1"}),"ADMINISTRATIVO":"undefined"})
    };
  },

  mounted: function mounted() {
    this.getFechamentoAtual();
  },
  computed: {
    fechamentoExtra: function (_fechamentoExtra) {
      function fechamentoExtra() {
        return _fechamentoExtra.apply(this, arguments);
      }

      fechamentoExtra.toString = function () {
        return _fechamentoExtra.toString();
      };

      return fechamentoExtra;
    }(function () {
      var fechamentoId = this.$route.query.id;
      var vm = this;
      this.$store.commit('setFechamentoAtual', '');
      this.$axios.get(this.env.FINANCEIRO.SLA + '/getfechamentoatual/' + fechamentoId, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token
        }
      }).then(function (response) {
        vm.fechamentoAtual = response.data;
        vm.$store.commit('setFechamentoAtual', response.data);
      });
      this.getFechamentoAtual();
      return fechamentoExtra;
    })
  },
  methods: {
    moeda: function moeda(valor) {
      valor = valor.replace(',', '');
      valor = valor.replace('.', ',');
      valor = 'R$ ' + valor;
      return valor;
    },
    getFechamentoAtual: function getFechamentoAtual() {
      var todosOsPredios = '';
      var fechamentoId = this.$route.query.id;
      var vm = this;
      this.$store.commit('setFechamentoAtual', '');
      this.$axios.get(this.env.FINANCEIRO.SLA + '/getfechamentoatual/' + fechamentoId, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token
        }
      }).then(function (response) {
        vm.fechamentoAtual = response.data;
        todosOsPredios = JSON.parse(JSON.parse(vm.fechamentoAtual.predio_id));
        if (todosOsPredios) {
          todosOsPredios.forEach(function (element) {
            vm.predios.push(element);
          });
        }
        vm.$store.commit('setFechamentoAtual', response.data);
      });
    },

    downloadArquivo: function downloadArquivo(nomeArquivo) {
      var vm = this;
      var dirBucket = 'extra_contratual';
      this.controlerLoadingDownload = false;
      this.$axios.get(this.env.FINANCEIRO.SLA + '/downloadarquivofechamentoextra/' + dirBucket + '/' + nomeArquivo, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token
        }
      }).then(function (response) {
        vm.controlerLoadingDownload = true;
        if (response.data.mensagem) {
          vm.$store.commit('setAlert', { msg: response.data.mensagem, status: false, show: true });
          return;
        }
        window.open(response.data.url, '_blank');
      });
    }
  }
});

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_pagination_2__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_pagination_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_pagination_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2__ = __webpack_require__(852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_epic_spinners__ = __webpack_require__(65);







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      env: __webpack_require__.i({"NODE_ENV":"production","AUTENTICA":"https://autentica-single.portalssp.com/api","CADASTRO_USUARIO":"https://cadastro.oi.portalssp.com","RECUPERAR_SENHA":"https://cadastro.oi.portalssp.com/reset","STORAGE":"https://storage.portalssp.com/api/v1","FINANCEIRO":__webpack_require__.i({"SLA":"https://financeiro.sla.portalssp.com/api","NOTIFICACAO":"https://financeiro.notificacoes.portalssp.com/api","GLOSA":"https://financeiro.glosa.portalssp.com/api/v1"}),"ADMINISTRATIVO":"undefined"}),
      page: 1,
      startIndex: 1,
      endIndex: 15,
      perPage: 15,
      records: [],
      recordsLength: 0,
      fechamentos: null,
      ufs: [],
      tipo_imovel_servicos: [],
      anos: [],
      meses: [],
      gruposPermitidos: ['oi', 'admin'],
      permissao: true,
      ufSelecionada: null,
      contratoSelecionado: null,
      mesSelecionado: null,
      anoSelecionado: null,
      filtro: null,
      loading: false
    };
  },

  components: {
    Pagination: __WEBPACK_IMPORTED_MODULE_0_vue_pagination_2___default.a,
    Swal: __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default.a,
    HalfCircleSpinner: __WEBPACK_IMPORTED_MODULE_2_epic_spinners__["b" /* HalfCircleSpinner */]
  },
  mounted: function mounted() {
    var usuarioGrupo = this.$store.state.login.loginUsuario.grupo;

    var msgGrupos = usuarioGrupo[0].nome;
    if (usuarioGrupo[1]) {
      msgGrupos = usuarioGrupo[0].nome + ' ,' + usuarioGrupo[1].nome;
      if (usuarioGrupo[2]) {
        msgGrupos = usuarioGrupo[0].nome + ' ,' + usuarioGrupo[1].nome + ' ,' + usuarioGrupo[2].nome;
      }
    }

    if (usuarioGrupo.find(function (permissao) {
      return permissao.nome === 'oi' || permissao.nome === 'admin' || permissao.nome === 'adminVTAL';
    })) {
      this.getFechamentos();
      this.getPage(this.page);
      this.getUfsDoUsuario();
      this.getTipoImovelServico();
      this.getAno();
      this.getMes();
    } else {
      this.permissao = false;
      this.$store.commit('setPermissaoNegada', { msg: 'Seu grupo de usu\xE1ro [ ' + msgGrupos + ' ] n\xE3o permite acesso a esta \xE1rea.', status: false, show: true });
    }
  },
  methods: {
    detalhesFechamentoExtra: function detalhesFechamentoExtra(idFechamento) {
      this.$router.push('/DetalhesFechamentoExtra/?id=' + idFechamento);
    },
    getPage: function getPage(page) {
      var vm = this;
      var startIndex = vm.perPage * (page - 1) + 1;
      var endIndex = startIndex + vm.perPage - 1;
      vm.startIndex = startIndex;
      vm.endIndex = endIndex;
      if (vm.fechamentos !== null) {
        vm.records = vm.fechamentos;
      }
    },
    getFechamentos: function getFechamentos() {
      this.loading = true;
      var parametros = {
        grupo: this.$store.state.login.loginUsuario.grupo,
        estado: this.$store.state.login.loginUsuario.estado,
        contrato: this.$store.state.login.loginUsuario.contrato,
        filtro: this.filtro
      };
      var vm = this;
      this.$axios.post(this.env.FINANCEIRO.SLA + '/getAllExtraContratual', parametros, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token
        }
      }).then(function (response) {
        if (response.status === 200 || response.status === 201) {
          vm.fechamentos = response.data;
          vm.records = response.data;
          vm.recordsLength = response.data.length;
          vm.loading = false;
        } else {
          vm.$store.commit('setAlert', { msg: response.data.erro, status: false, show: true });
        }
      });
    },
    getUfsDoUsuario: function getUfsDoUsuario() {
      this.ufs = this.$store.state.login.loginUsuario.estado;
    },
    getTipoImovelServico: function getTipoImovelServico() {
      var vm = this;
      this.$axios.get(this.env.FINANCEIRO.SLA + '/gettipoimovelservico', {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token
        }
      }).then(function (response) {
        vm.tipo_imovel_servicos = response.data;
      });
    },
    getAno: function getAno() {
      var vm = this;
      this.$axios.get(this.env.FINANCEIRO.SLA + '/getano', {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token
        }
      }).then(function (response) {
        vm.anos = response.data;
      });
    },
    getMes: function getMes() {
      var date = new Date();
      this.mes_atual = date.getMonth();
      var vm = this;
      this.$axios.get(this.env.FINANCEIRO.SLA + '/getmes', {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token
        }
      }).then(function (response) {
        vm.meses = response.data;
      });
    },
    excluirFechamentoExtra: function excluirFechamentoExtra(id) {
      var _this = this;

      var vm = this;
      __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default.a.fire({
        title: 'Tem certeza que deseja excluir?',

        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, excluir!'
      }).then(function (result) {
        if (result.isConfirmed) {
          var payload = {
            usuario_id: _this.$store.state.login.loginUsuario.usuario.id,
            fechamento_extra_id: id
          };
          _this.$axios.post(_this.env.FINANCEIRO.SLA + '/excluirExtraContratual', payload, {
            headers: {
              'Authorization': 'Bearer ' + _this.$store.state.login.loginUsuario.token
            }
          }).then(function (response) {
            if (response.status === 200 || response.status === 201) {
              __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default.a.fire('Excluído!', response.data);
              setTimeout(function () {
                location.reload();
              }, 1500);
            } else {
              vm.$store.commit('setAlert', { msg: response.data.erro, status: false, show: true });
            }
          });
        }
      });
    },
    onChangeFiltro: function onChangeFiltro() {
      this.filtro = {
        ufSelecionada: this.ufSelecionada,
        contratoSelecionado: this.contratoSelecionado,
        mesSelecionado: this.mesSelecionado,
        anoSelecionado: this.anoSelecionado
      };

      this.page = 1;
      this.getFechamentos();
    },
    limparFiltro: function limparFiltro() {
      this.filtro = null;
      this.ufSelecionada = null;
      this.contratoSelecionado = null;
      this.mesSelecionado = null;
      this.anoSelecionado = null;

      this.page = 1;
      this.getFechamentos();
    }
  }
});

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      anos: [],
      ano_selecionado: new Date().getFullYear(),
      uf_selecionada: null,
      contrato_selecionado: null,
      mes: [],
      meses: [],
      tipo_imovel_servicos: '',
      env: __webpack_require__.i({"NODE_ENV":"production","AUTENTICA":"https://autentica-single.portalssp.com/api","CADASTRO_USUARIO":"https://cadastro.oi.portalssp.com","RECUPERAR_SENHA":"https://cadastro.oi.portalssp.com/reset","STORAGE":"https://storage.portalssp.com/api/v1","FINANCEIRO":__webpack_require__.i({"SLA":"https://financeiro.sla.portalssp.com/api","NOTIFICACAO":"https://financeiro.notificacoes.portalssp.com/api","GLOSA":"https://financeiro.glosa.portalssp.com/api/v1"}),"ADMINISTRATIVO":"undefined"}),
      estado: this.$store.state.login.loginUsuario.estado,
      ufs: [],
      ufId: [],
      gruposPermitidos: ['oi', 'admin'],
      permissao: true,
      loading: true,
      dadosFechamento: [],
      mesSelecionado: null,
      janelaAplicacao: null
    };
  },

  mounted: function mounted() {
    var usuarioGrupo = this.$store.state.login.loginUsuario.grupo;

    var msgGrupos = usuarioGrupo[0].nome;
    if (usuarioGrupo[1]) {
      msgGrupos = usuarioGrupo[0].nome + ' ,' + usuarioGrupo[1].nome;
      if (usuarioGrupo[2]) {
        msgGrupos = usuarioGrupo[0].nome + ' ,' + usuarioGrupo[1].nome + ' ,' + usuarioGrupo[2].nome;
      }
    }

    if (usuarioGrupo.find(function (permissao) {
      return permissao.nome === 'oi' || permissao.nome === 'admin';
    })) {
      this.getAno();
      this.getTipoImovelServico();
      this.getUfsUsuario();
      this.getIdUfsUsuario();
      this.getContratosPorUf();
    } else {
      this.permissao = false;
      this.$store.commit('setPermissaoNegada', { msg: 'Seu grupo de usu\xE1ro [ ' + msgGrupos + ' ] n\xE3o permisse acesso a esta \xE1rea.', status: false, show: true });
    }
    this.getJanelaAplicacao();
  },
  watch: {
    mesSelecionado: function mesSelecionado() {
      this.mes_atual = this.mesSelecionado;
    }
  },
  computed: {
    verificaCamposPrenchidos: function verificaCamposPrenchidos() {
      if (this.contrato_selecionado !== null && this.mesSelecionado !== null && this.uf_selecionada !== null) {
        return 1;
      }
      return 0;
    }
  },
  methods: {
    exibeModalFechamento: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.dadosFechamento = [];
                _context.next = 3;
                return this.dadosFechamento.push({
                  'uf_selecionada': this.uf_selecionada.nome,
                  'mesSelecionado': this.mesSelecionado.nome,
                  'ano_selecionado': this.ano_selecionado,
                  'contrato_selecionado': this.contrato_selecionado.nome,
                  'id_contrato': this.contrato_selecionado.id,
                  'uf_id': this.uf_selecionada.id,
                  'mes_id': this.mesSelecionado.id
                });

              case 3:
                _context.next = 5;
                return this.$store.commit('setDadosFechamento', this.dadosFechamento[0]);

              case 5:
                this.$store.commit('setExtraContratual', { conteudo: null, show: true });

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function exibeModalFechamento() {
        return _ref.apply(this, arguments);
      }

      return exibeModalFechamento;
    }(),
    getItemSla: function getItemSla() {
      var vm = this;
      this.$axios.get(this.env.FINANCEIRO.SLA + '/getitenssla/' + vm.contrato.tipo_contrato_id, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token
        }
      }).then(function (response) {
        vm.itens_sla = response.data;
      });
    },
    getTipoImovelServico: function getTipoImovelServico() {
      var vm = this;
      this.$axios.get(this.env.FINANCEIRO.SLA + '/gettipoimovelservico', {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token
        }
      }).then(function (response) {
        vm.tipo_imovel_servicos = response.data;
      });
    },
    getMes: function getMes() {
      var date = new Date();
      this.mes_atual = date.getMonth();
      var vm = this;
      this.$axios.get(this.env.FINANCEIRO.SLA + '/getmes', {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token
        }
      }).then(function (response) {
        vm.meses = response.data;
        vm.mesSelecionado = vm.meses.find(function (el) {
          return el.id == vm.janelaAplicacao;
        });
      });
    },
    getAno: function getAno() {
      var vm = this;
      this.$axios.get(this.env.FINANCEIRO.SLA + '/getano', {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token
        }
      }).then(function (response) {
        vm.anos = response.data;
      });
    },
    getContratosPorUf: function getContratosPorUf() {
      var vm = this;
      this.$axios.post(this.env.FINANCEIRO.SLA + '/getcontratosporuf', vm.ufs, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token
        }
      }).then(function (response) {
        vm.contratos = response.data;
      });
    },
    getUfsUsuario: function getUfsUsuario() {
      this.ufs = this.$store.state.login.loginUsuario.estado;
    },
    getIdUfsUsuario: function getIdUfsUsuario() {
      this.ufId = this.$store.state.login.loginUsuario.estado;
    },
    getJanelaAplicacao: function getJanelaAplicacao() {
      var vm = this;
      vm.$axios.get(vm.env.FINANCEIRO.SLA + '/getJanelaAplicacaoExtraContratual', {
        headers: {
          'Authorization': 'Bearer ' + vm.$store.state.login.loginUsuario.token
        }
      }).then(function (response) {
        vm.janelaAplicacao = response.data;
        vm.getMes();
        vm.loading = false;
      }).catch(function (error) {
        vm.loading = true;
        vm.$store.commit('setAlert', { msg: 'Falha ao tentar carregar a janela de aplicação do ExtraContratual', status: false, show: true });
      });
    }
  }
});

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      franquias: [],
      anos: [],
      ano_selecionado: new Date().getFullYear(),
      uf_selecionada: null,
      contrato_selecionado: null,
      mes: [],
      meses: [],
      tipo_imovel_servicos: '',
      env: __webpack_require__.i({"NODE_ENV":"production","AUTENTICA":"https://autentica-single.portalssp.com/api","CADASTRO_USUARIO":"https://cadastro.oi.portalssp.com","RECUPERAR_SENHA":"https://cadastro.oi.portalssp.com/reset","STORAGE":"https://storage.portalssp.com/api/v1","FINANCEIRO":__webpack_require__.i({"SLA":"https://financeiro.sla.portalssp.com/api","NOTIFICACAO":"https://financeiro.notificacoes.portalssp.com/api","GLOSA":"https://financeiro.glosa.portalssp.com/api/v1"}),"ADMINISTRATIVO":"undefined"}),
      estado: this.$store.state.login.loginUsuario.estado,
      ufs: [],
      ufId: [],
      gruposPermitidos: ['oi', 'admin'],
      permissao: true,
      loading: true,
      loadingTrimestre: null,
      dadosFechamento: [],
      mesSelecionado: null,
      janelaAplicacao: null
    };
  },

  mounted: function mounted() {
    this.getFranquias();
  },
  methods: {
    glosar: function glosar(meses, trimestre, ano) {
      var vm = this;
      vm.loading = true;
      vm.loadingTrimestre = trimestre;
      var form = {
        meses: JSON.parse(meses),
        ano: ano,
        user_id: vm.$store.state.login.loginUsuario.usuario.id
      };
      vm.$axios.post(vm.env.FINANCEIRO.SLA + '/glosarFranquiasNaoTratadas', form, {
        headers: {
          'Authorization': 'Bearer ' + vm.$store.state.login.loginUsuario.token,
          'Content-Type': 'application/json'
        }
      }).then(function (response) {
        vm.$store.commit('setAlert', { msg: response.data.total_afetadas + ' franquia(s) glosadas.', status: true, show: true });
        vm.loading = true;
        vm.loadingTrimestre = null;
        vm.getFranquias();
      });
    },
    getFranquias: function getFranquias() {
      var vm = this;
      vm.loading = true;
      vm.$axios.get(vm.env.FINANCEIRO.SLA + '/get-franquias-pendentes-fornecedor', {
        headers: {
          'Authorization': 'Bearer ' + vm.$store.state.login.loginUsuario.token
        }
      }).then(function (response) {
        vm.franquias = response.data;
        console.log(response.data);
        vm.loading = false;
      }).catch(function (error) {
        vm.loading = true;
        vm.$store.commit('setAlert', { msg: 'Falha ao tentar carregar a janela de aplicação do ExtraContratual', status: false, show: true });
      });
    },
    formatarMoeda: function formatarMoeda(valor) {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      }).format(valor);
    }
  }
});

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_epic_spinners__ = __webpack_require__(65);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['consultaEvidencias'],
  data: function data() {
    return {
      controlerLoadingDownload: true,
      controlerLoadingDelete: true,
      controlerLoading: null,
      env: __webpack_require__.i({"NODE_ENV":"production","AUTENTICA":"https://autentica-single.portalssp.com/api","CADASTRO_USUARIO":"https://cadastro.oi.portalssp.com","RECUPERAR_SENHA":"https://cadastro.oi.portalssp.com/reset","STORAGE":"https://storage.portalssp.com/api/v1","FINANCEIRO":__webpack_require__.i({"SLA":"https://financeiro.sla.portalssp.com/api","NOTIFICACAO":"https://financeiro.notificacoes.portalssp.com/api","GLOSA":"https://financeiro.glosa.portalssp.com/api/v1"}),"ADMINISTRATIVO":"undefined"}),
      zIndex: 999999,
      form: [],
      evidencias: [],
      fieldsEvidencias: [{ key: 'mes_referencia', label: 'Mês Referência' }, { key: 'nao_conformidade_apurada', label: 'Não Conformidade Apurada' }, { key: 'numero_item', label: 'Item Sla' }, { key: 'quantidade_apurada', label: 'Quantidade apurada' }, { key: 'observacoes', label: 'Observações' }, { key: 'arquivo', label: 'Arquivo' }, { key: 'anulado', label: 'Anular' }, { key: 'excluir', label: 'Excluir' }],
      loadingEvidencias: true
    };
  },

  components: {
    HalfCircleSpinner: __WEBPACK_IMPORTED_MODULE_0_epic_spinners__["b" /* HalfCircleSpinner */]
  },
  watch: {
    consultaEvidencias: function consultaEvidencias() {
      this.getEvidencias(this.consultaEvidencias);
    }
  },
  methods: {
    configuraEvidenciaAnulada: function configuraEvidenciaAnulada() {
      var vm = this;
      setTimeout(function () {
        var registrosAnulados = document.querySelectorAll('.btn-desanular');
        registrosAnulados.forEach(function (item) {
          var elem = item.parentElement.parentElement;
          elem.style.textDecoration = 'line-through';
          elem.style.color = '#ccc';
        });
        vm.loadingEvidencias = false;
      }, 0);
    },
    getEvidencias: function getEvidencias(evidencias) {
      var vm = this;
      this.controlerLoading = false;
      this.evidencias = [];
      this.$axios.post(this.env.FINANCEIRO.SLA + '/getevidenciaspormes', evidencias, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token
        }
      }).then(function (response) {
        vm.evidencias = response.data;
        vm.controlerLoading = true;
        vm.configuraEvidenciaAnulada();
      }).catch(function (error) {
        vm.controlerLoading = true;
        vm.loadingEvidencias = false;
        console.log(error);
      });
    },

    excluirEvidencia: function excluirEvidencia(id) {
      var vm = this;
      if (!this.confirmarAcao()) {
        return;
      }
      this.loadingEvidencias = true;
      this.$axios.delete(this.env.FINANCEIRO.SLA + '/evidencias/' + id, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token,
          'Content-Type': 'application/json'
        },
        params: {
          'usuario_nome': this.$store.state.login.loginUsuario.usuario.name,
          'usuario_email': this.$store.state.login.loginUsuario.usuario.email
        }
      }).then(function (response) {
        var refreshComponentes = Math.floor(Math.random() * 2 * 1000);
        vm.$store.commit('setRefreshComponente', refreshComponentes);
        vm.getEvidencias(vm.consultaEvidencias);
      }).catch(function (error) {
        console.log(error);
      });
    },
    anularEvidencia: function anularEvidencia(id) {
      var vm = this;
      if (!this.confirmarAcao()) {
        return;
      }
      this.loadingEvidencias = true;
      this.$axios.post(this.env.FINANCEIRO.SLA + '/anularEvidencia', {
        evidencia_id: id,
        'usuario_nome': this.$store.state.login.loginUsuario.usuario.name,
        'usuario_email': this.$store.state.login.loginUsuario.usuario.email
      }, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token,
          'Content-Type': 'application/json'
        }
      }).then(function (response) {
        var refreshComponentes = Math.floor(Math.random() * 2 * 1000);
        vm.$store.commit('setRefreshComponente', refreshComponentes);
        vm.getEvidencias(vm.consultaEvidencias);
      }).catch(function (error) {
        vm.loadingEvidencias = true;
        console.log(error);
      });
    },
    desanularEvidencia: function desanularEvidencia(id) {
      var vm = this;
      if (!this.confirmarAcao()) {
        return;
      }
      this.loadingEvidencias = true;
      this.$axios.post(this.env.FINANCEIRO.SLA + '/desanularEvidencia', {
        evidencia_id: id,
        'usuario_nome': this.$store.state.login.loginUsuario.usuario.name,
        'usuario_email': this.$store.state.login.loginUsuario.usuario.email
      }, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token,
          'Content-Type': 'application/json'
        }
      }).then(function (response) {
        var refreshComponentes = Math.floor(Math.random() * 2 * 1000);
        vm.$store.commit('setRefreshComponente', refreshComponentes);
        vm.getEvidencias(vm.consultaEvidencias);
      }).catch(function (error) {
        vm.loadingEvidencias = true;
        console.log(error);
      });
    },
    downloadArquivo: function downloadArquivo(nomeArquivo) {
      var vm = this;
      var dirBucket = 'evidencias';
      this.controlerLoadingDownload = false;
      this.$axios.get(this.env.FINANCEIRO.SLA + '/downloadarquivo/' + dirBucket + '/' + nomeArquivo, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token
        }
      }).then(function (response) {
        vm.controlerLoadingDownload = true;

        if (response.data.mensagem) {
          vm.$store.commit('setAlert', { msg: response.data.mensagem, status: false, show: true });
          return;
        }
        window.open(response.data.url, '_blank');
      });
    },
    confirmarAcao: function confirmarAcao() {
      return confirm('Confirma esta ação?');
    }
  }
});

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['evidencia'],
  data: function data() {
    return {
      evidenciasPorItem: []
    };
  },
  mounted: function mounted() {
    this.preparaEvidencias();
  },

  watch: {
    evidencia: function evidencia() {
      this.preparaEvidencias();
    }
  },
  methods: {
    preparaEvidencias: function preparaEvidencias() {
      var _this = this;

      var evidencia = this.evidencia;
      this.evidenciasPorItem = [];
      for (var i in evidencia) {
        if (evidencia[i].evidencias) {
          evidencia[i].evidencias.map(function (itemEvidencia) {
            if (itemEvidencia.existe_evidencia === 1) {
              _this.evidenciasPorItem.push({
                mes_referencia: itemEvidencia.mes_referencia,
                nao_conformidade_apurada: itemEvidencia.nao_conformidade_apurada,
                item_sla_id: itemEvidencia.item_sla_id,
                unidade_medicao: itemEvidencia.unidade_medicao,
                quandidade_apurada: itemEvidencia.quantidade_apurada,
                'observação': itemEvidencia.observacoes
              });
            }
          });
        }
      }
    }
  }
});

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_v_money__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_v_money___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_v_money__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['contrato'],
  data: function data() {
    return {
      env: __webpack_require__.i({"NODE_ENV":"production","AUTENTICA":"https://autentica-single.portalssp.com/api","CADASTRO_USUARIO":"https://cadastro.oi.portalssp.com","RECUPERAR_SENHA":"https://cadastro.oi.portalssp.com/reset","STORAGE":"https://storage.portalssp.com/api/v1","FINANCEIRO":__webpack_require__.i({"SLA":"https://financeiro.sla.portalssp.com/api","NOTIFICACAO":"https://financeiro.notificacoes.portalssp.com/api","GLOSA":"https://financeiro.glosa.portalssp.com/api/v1"}),"ADMINISTRATIVO":"undefined"}),
      form: {
        usuario_nome: this.$store.state.login.loginUsuario.usuario.name,
        usuario_email: this.$store.state.login.loginUsuario.usuario.email,
        mes_id: Number,
        ano: Number,
        quantidade: '',
        valor: '',
        observacao: '',
        arquivo: '',
        contrato_id: Number,
        existe_glosa: 0
      },
      formEstadoInicial: [],
      meses: '',
      existeGlosa: [{ 'text': 'Não', 'value': 0 }, { 'text': 'Sim', 'value': 1 }],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: ' ',
        precision: 2,
        masked: false
      },
      controlerBtnSubmit: true,
      evidenciaEnviada: []
    };
  },

  components: {
    Money: __WEBPACK_IMPORTED_MODULE_0_v_money__["Money"]
  },
  mounted: function mounted() {
    this.defineContrato();
    this.getMeses();
    this.copiaFormEstadoInicial();
  },
  watch: {
    contrato: function contrato() {
      this.defineContrato();
    }
  },
  methods: {
    copiaFormEstadoInicial: function copiaFormEstadoInicial() {
      for (var i in this.form) {
        this.formEstadoInicial[i] = this.form[i];
      }
    },
    restauraFormSelecaoNegativa: function restauraFormSelecaoNegativa() {
      if (this.form.existe_glosa === 0) {
        for (var i in this.formEstadoInicial) {
          if (i !== 'mes_id') {
            this.form[i] = this.formEstadoInicial[i];
          }
        }
      }
    },
    getArquivo: function getArquivo() {
      var arquivo = this.$refs.arquivo.files[0];
      this.form.arquivo = arquivo;
    },
    defineContrato: function defineContrato() {
      this.evidenciaEnviada = this.$store.state.fechamentoMultaGlosa;
      this.form.ano = this.$store.state.ano.ano_selecionado;
      this.form.contrato_id = this.contrato.itensContrato.contrato_id;
    },
    getMeses: function getMeses() {
      var vm = this;
      this.$axios.get(this.env.FINANCEIRO.GLOSA + '/mes', {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token
        }
      }).then(function (response) {
        vm.meses = response.data;
      });
    },
    confirmarAcao: function confirmarAcao() {
      return confirm('Confirma esta ação?');
    },
    salvarGlosa: function salvarGlosa() {
      var vm = this;
      var formData = new FormData();
      if (!this.confirmarAcao()) {
        return;
      }
      this.form.quantidade = parseInt(this.form.quantidade);
      this.form.valor = parseFloat(this.form.valor);
      for (var atributo in this.form) {
        formData.append(atributo, this.form[atributo]);
      }
      this.controlerBtnSubmit = false;
      this.$axios.post(this.env.FINANCEIRO.GLOSA + '/salvarEvidenciaGlosa', formData, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token,
          'Content-Type': 'multipart/form-data'
        }
      }).then(function (response) {
        vm.finalizaPosConclusaoSalvarGlosa();
      }).catch(function (error) {
        vm.controlerBtnSubmit = true;
        console.log(error);
      });
    },

    finalizaPosConclusaoSalvarGlosa: function finalizaPosConclusaoSalvarGlosa() {
      this.controlerBtnSubmit = true;
      var refreshComponentes = Math.floor(Math.random() * 2 * 1000);
      this.$store.commit('setRefreshComponente', refreshComponentes);
      this.fecharModal();
      this.$store.commit('setAlert', { msg: 'Glosa salva com sucesso!', status: true, show: true });
    },
    fecharModal: function fecharModal() {
      this.$store.commit('setAdicionarGlosa', { conteudo: null, show: false });
    }
  }
});

/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_FormAdicionarGlosa_vue__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_FormAdicionarGlosa_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__form_FormAdicionarGlosa_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'form-adicionar-glosa': __WEBPACK_IMPORTED_MODULE_0__form_FormAdicionarGlosa_vue___default.a
  },
  methods: {
    fecharModal: function fecharModal() {
      this.$store.commit('setAdicionarGlosa', { conteudo: null, show: false });
    }
  }
});

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_epic_spinners__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_v_money__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_v_money___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_v_money__);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['glosasMesAtual'],
  data: function data() {
    return {
      controlerLoadingDownload: true,
      controlerLoadingDelete: true,

      env: __webpack_require__.i({"NODE_ENV":"production","AUTENTICA":"https://autentica-single.portalssp.com/api","CADASTRO_USUARIO":"https://cadastro.oi.portalssp.com","RECUPERAR_SENHA":"https://cadastro.oi.portalssp.com/reset","STORAGE":"https://storage.portalssp.com/api/v1","FINANCEIRO":__webpack_require__.i({"SLA":"https://financeiro.sla.portalssp.com/api","NOTIFICACAO":"https://financeiro.notificacoes.portalssp.com/api","GLOSA":"https://financeiro.glosa.portalssp.com/api/v1"}),"ADMINISTRATIVO":"undefined"}),
      zIndex: 999999,
      form: [],
      glosas: [],
      fieldsGlosas: [{ key: 'mes.nome', label: 'Mês' }, { key: 'quantidade', label: 'Quantidade' }, { key: 'valor', label: 'Valor' }, { key: 'observacao', label: 'Observações' }, { key: 'arquivo', label: 'Arquivo' }, { key: 'excluir', label: 'Excluir' }],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: ' ',
        precision: 2,
        masked: false
      },
      loadingGlosas: true
    };
  },

  mounted: function mounted() {
    this.getGlosaFiltroAnoContratoMes();
  },
  components: {
    HalfCircleSpinner: __WEBPACK_IMPORTED_MODULE_0_epic_spinners__["b" /* HalfCircleSpinner */],
    Money: __WEBPACK_IMPORTED_MODULE_1_v_money__["Money"]
  },
  watch: {
    glosasMesAtual: function glosasMesAtual() {
      this.loadingGlosas = true;
      this.getGlosaFiltroAnoContratoMes();
    }
  },
  methods: {
    getTimeoutLoadingGlosa: function getTimeoutLoadingGlosa() {
      var _this = this;

      setTimeout(function () {
        _this.loadingGlosas = null;
      }, 7000);
    },
    configuraGlosaAnulada: function configuraGlosaAnulada() {
      var vm = this;
      setTimeout(function () {
        var registrosAnulados = document.querySelectorAll('.btn-desanular');
        registrosAnulados.forEach(function (item) {
          var elem = item.parentElement.parentElement;
          elem.style.textDecoration = 'line-through';
          elem.style.color = '#ccc';
        });
        vm.loadingGlosas = false;
      }, 0);
    },
    getGlosaFiltroAnoContratoMes: function getGlosaFiltroAnoContratoMes() {
      var vm = this;
      if (this.glosasMesAtual.conteudo.length === 0) {
        return;
      }

      var formData = new FormData();
      formData.append('ano', this.glosasMesAtual.conteudo.itens.ano);
      formData.append('contrato_id', this.glosasMesAtual.conteudo.itens.contrato_id);
      formData.append('mes_id', this.glosasMesAtual.conteudo.itens.mes.mes_id);

      this.$axios.post(this.env.FINANCEIRO.GLOSA + '/getGlosaFiltroAnoContratoMes', formData, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token
        }
      }).then(function (response) {
        vm.glosas = response.data;
        vm.loadingGlosas = false;
      }).catch(function (error) {
        vm.loadingGlosas = false;
        console.log(error);
      });
    },

    excluirGlosa: function excluirGlosa(glosa) {
      var vm = this;
      if (!this.confirmarAcao()) {
        return;
      }
      this.loadingGlosas = true;
      glosa['usuario_nome'] = this.$store.state.login.loginUsuario.usuario.name;
      glosa['usuario_email'] = this.$store.state.login.loginUsuario.usuario.email;
      glosa['glosa_id'] = glosa.id;
      this.$axios.post(this.env.FINANCEIRO.GLOSA + '/excluirGlosa', glosa, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token,
          'Content-Type': 'application/json'
        }
      }).then(function (response) {
        var refreshComponentes = Math.floor(Math.random() * 2 * 1000);
        vm.$store.commit('setRefreshComponente', refreshComponentes);
        vm.getGlosaFiltroAnoContratoMes();
      }).catch(function (error) {
        console.log(error);
      });
    },
    anularGlosa: function anularGlosa(id) {
      var vm = this;
      if (!this.confirmarAcao()) {
        return;
      }
      this.loadingGlosas = true;
      this.$axios.post(this.env.FINANCEIRO.GLOSA + '/anularGlosa', {
        glosa_id: id,
        'usuario_nome': this.$store.state.login.loginUsuario.usuario.name,
        'usuario_email': this.$store.state.login.loginUsuario.usuario.email
      }, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token,
          'Content-Type': 'application/json'
        }
      }).then(function (response) {
        var refreshComponentes = Math.floor(Math.random() * 2 * 1000);
        vm.$store.commit('setRefreshComponente', refreshComponentes);
        vm.getGlosaFiltroAnoContratoMes();
      }).catch(function (error) {
        vm.loadingGlosas = true;
        console.log(error);
      });
    },
    desanularGlosa: function desanularGlosa(id) {
      var vm = this;
      if (!this.confirmarAcao()) {
        return;
      }
      this.loadingGlosas = true;
      this.$axios.post(this.env.FINANCEIRO.GLOSA + '/desanularGlosa', {
        glosa_id: id,
        'usuario_nome': this.$store.state.login.loginUsuario.usuario.name,
        'usuario_email': this.$store.state.login.loginUsuario.usuario.email
      }, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token,
          'Content-Type': 'application/json'
        }
      }).then(function (response) {
        var refreshComponentes = Math.floor(Math.random() * 2 * 1000);
        vm.$store.commit('setRefreshComponente', refreshComponentes);
        vm.getGlosaFiltroAnoContratoMes();
      }).catch(function (error) {
        vm.loadingGlosas = true;
        console.log(error);
      });
    },
    downloadArquivo: function downloadArquivo(fileName) {
      var vm = this;
      var dirBucket = 'glosa';
      this.controlerLoadingDownload = false;
      this.$axios.get(this.env.STORAGE + '/download?dirBucket=' + dirBucket + '&fileName=' + fileName, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token,
          'Content-Type': 'application/json'
        }
      }).then(function (response) {
        vm.controlerLoadingDownload = true;

        if (response.data.mensagem) {
          vm.$store.commit('setAlert', { msg: response.data.mensagem, status: false, show: true });
          return;
        }
        window.open(response.request.responseURL, '_blank');
      });
    },
    confirmarAcao: function confirmarAcao() {
      return confirm('Confirma esta ação?');
    },
    fecharModal: function fecharModal() {
      this.$store.commit('setModalListaGlosasPorMes', { conteudo: [], show: false });
      console.log('fechar');
    }
  }
});

/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['filtro'],
  data: function data() {
    return {
      glosasPorItem: [],
      env: __webpack_require__.i({"NODE_ENV":"production","AUTENTICA":"https://autentica-single.portalssp.com/api","CADASTRO_USUARIO":"https://cadastro.oi.portalssp.com","RECUPERAR_SENHA":"https://cadastro.oi.portalssp.com/reset","STORAGE":"https://storage.portalssp.com/api/v1","FINANCEIRO":__webpack_require__.i({"SLA":"https://financeiro.sla.portalssp.com/api","NOTIFICACAO":"https://financeiro.notificacoes.portalssp.com/api","GLOSA":"https://financeiro.glosa.portalssp.com/api/v1"}),"ADMINISTRATIVO":"undefined"})
    };
  },
  mounted: function mounted() {
    this.getGlosasFiltroAnoIdContrato();
  },

  watch: {
    filtro: function filtro() {
      this.getGlosasFiltroAnoIdContrato();
    }
  },
  methods: {
    getGlosasFiltroAnoIdContrato: function getGlosasFiltroAnoIdContrato() {
      var vm = this;
      console.warn('filtro', this.filtro);
      var formData = new FormData();
      formData.append('ano', this.filtro.ano);
      formData.append('contrato_id', this.filtro.contrato.contrato_id);
      if (this.filtro.contrato.contrato_id * 1 !== undefined) {
        this.$axios.post(this.env.FINANCEIRO.GLOSA + '/getGlosaImpressao', formData, {
          headers: {
            'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token
          }
        }).then(function (response) {
          vm.glosasPorItem = response.data.map(function (item) {
            return {
              mes: item.mes_nome,
              quantidade: item.quantidade,
              valor: item.valor
            };
          });
        }).catch(function (error) {
          console.log(error);
        });
      }
    }
  }
});

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_v_money__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_v_money___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_v_money__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__print_GlosaImpressao_vue__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__print_GlosaImpressao_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__print_GlosaImpressao_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['contrato', 'ano', 'fornecedor'],
  data: function data() {
    return {
      anoSelecionado: Number,
      contratoSelecionado: [],
      glosas: [],
      quantidades: [],
      valores: [],
      controlerLoading: true,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: ' ',
        precision: 2,
        masked: false
      },
      env: __webpack_require__.i({"NODE_ENV":"production","AUTENTICA":"https://autentica-single.portalssp.com/api","CADASTRO_USUARIO":"https://cadastro.oi.portalssp.com","RECUPERAR_SENHA":"https://cadastro.oi.portalssp.com/reset","STORAGE":"https://storage.portalssp.com/api/v1","FINANCEIRO":__webpack_require__.i({"SLA":"https://financeiro.sla.portalssp.com/api","NOTIFICACAO":"https://financeiro.notificacoes.portalssp.com/api","GLOSA":"https://financeiro.glosa.portalssp.com/api/v1"}),"ADMINISTRATIVO":"undefined"})
    };
  },
  mounted: function mounted() {
    this.definePros();
    this.getGlosaFiltroAnoContrato();
  },
  components: {
    Money: __WEBPACK_IMPORTED_MODULE_0_v_money__["Money"],
    'exibir-glosas-impressao': __WEBPACK_IMPORTED_MODULE_1__print_GlosaImpressao_vue___default.a
  },
  watch: {
    ano: function ano() {
      this.definePros();
      this.getGlosaFiltroAnoContrato();
    }
  },
  methods: {
    definePros: function definePros() {
      this.anoSelecionado = this.ano;
      this.contratoSelecionado = this.contrato;
    },
    getGlosaFiltroAnoContrato: function getGlosaFiltroAnoContrato() {
      var _this = this;

      var vm = this;
      this.controlerLoading = false;
      this.$axios.post(this.env.FINANCEIRO.GLOSA + '/getGlosaFiltroAnoContrato', {
        ano: this.anoSelecionado,
        contrato_id: this.contratoSelecionado.contrato_id
      }, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token
        }
      }).then(function (response) {
        vm.glosas = response.data;
        vm.controlerLoading = true;
      }).catch(function (error) {
        _this.controlerLoading = true;
        console.log(error);
      });
    },
    listaGlosasPorMes: function listaGlosasPorMes(itens) {
      this.$store.commit('setModalListaGlosasPorMes', { conteudo: itens, show: true });
    }
  }
});

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      form: {
        email: '',
        password: ''
      },
      show: true,
      env: __webpack_require__.i({"NODE_ENV":"production","AUTENTICA":"https://autentica-single.portalssp.com/api","CADASTRO_USUARIO":"https://cadastro.oi.portalssp.com","RECUPERAR_SENHA":"https://cadastro.oi.portalssp.com/reset","STORAGE":"https://storage.portalssp.com/api/v1","FINANCEIRO":__webpack_require__.i({"SLA":"https://financeiro.sla.portalssp.com/api","NOTIFICACAO":"https://financeiro.notificacoes.portalssp.com/api","GLOSA":"https://financeiro.glosa.portalssp.com/api/v1"}),"ADMINISTRATIVO":"undefined"}),
      sessaoUsuario: this.$store.state.login.loginUsuario.token,
      gruposPermitidos: ['oi', 'admin', 'adminVTAL']
    };
  },

  mounted: function mounted() {
    if (localStorage.getItem('sessaoUsuario')) {
      var sessaoUsuario = JSON.parse(localStorage.getItem('sessaoUsuario'));
      this.$store.commit('setLoginUsuario', sessaoUsuario);
    }

    if (!this.$store.state.login.loginUsuario.token) {
      var vm = this;
      window.addEventListener('keyup', function (key) {
        if (key.code === 'NumpadEnter' || key.code === 'Enter') {
          console.log(key.code);
          vm.onSubmit();
        }
      });
    }
  },
  methods: {
    onSubmit: function onSubmit() {
      localStorage.clear();
      this.solicitaToken();
    },

    solicitaToken: function solicitaToken() {
      var vm = this;
      this.$axios.post(this.env.AUTENTICA + '/solicitatoken', this.form).then(function (response) {
        if (!response.data.token) {
          vm.$store.commit('setAlert', { msg: 'Usuário ou senha estão incorretos', status: false, show: true });
          return;
        }
        if (response.data.grupo.find(function (permissao) {
          return permissao.nome === 'oi' || permissao.nome === 'admin' || permissao.nome === 'adminVTAL';
        })) {
          localStorage.setItem('sessaoUsuario', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));
          window.location.href = vm.$route.fullPath;

          window.location.href = '/listarSla';
        } else {
          var sessaoUsuario = [];
          vm.$store.commit('setLoginUsuario', sessaoUsuario);
          localStorage.clear();
          vm.$store.commit('setAlert', { msg: 'Seu perfil não permite acesso a esta plataforma.', status: false, show: true });
          return;
        }
      }).catch(function (error) {
        console.log(error);
        vm.$store.commit('setAlert', { msg: 'Falha tempor\xE1ria. Tente novamente mais tarde!', status: false, show: true });
        localStorage.clear();
        if (error.response.data.mensagem || error.response.data.message) {
          if (error.response.status === 410) {
            vm.$store.commit('setAlert', { msg: error.response.data.mensagem, status: false, show: true });
            setTimeout(function () {
              window.location.href = '' + vm.env.CADASTRO_USUARIO;
            }, 3000);
          } else if (error.response.status === 401) {
            vm.$store.commit('setAlert', { msg: error.response.data.mensagem, status: false, show: true });
            return;
          } else {
            vm.$store.commit('setAlert', { msg: error.response.data.mensagem, status: false, show: true });
            return;
          }
        }
      });
    },
    encriptBase64: function encriptBase64(string) {
      var varB64 = btoa(string);
      return varB64;
    },
    decriptBase64: function decriptBase64(string) {
      var varB64 = void 0;
      try {
        varB64 = atob(string);
      } catch (e) {
        localStorage.clear();
      }
      return varB64;
    }
  }
});

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_epic_spinners__ = __webpack_require__(65);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      env: __webpack_require__.i({"NODE_ENV":"production","AUTENTICA":"https://autentica-single.portalssp.com/api","CADASTRO_USUARIO":"https://cadastro.oi.portalssp.com","RECUPERAR_SENHA":"https://cadastro.oi.portalssp.com/reset","STORAGE":"https://storage.portalssp.com/api/v1","FINANCEIRO":__webpack_require__.i({"SLA":"https://financeiro.sla.portalssp.com/api","NOTIFICACAO":"https://financeiro.notificacoes.portalssp.com/api","GLOSA":"https://financeiro.glosa.portalssp.com/api/v1"}),"ADMINISTRATIVO":"undefined"})
    };
  },

  components: {
    BreedingRhombusSpinner: __WEBPACK_IMPORTED_MODULE_1_epic_spinners__["a" /* BreedingRhombusSpinner */]
  },
  mounted: function mounted() {
    this.autenticaComSSP();
  },

  methods: {
    autenticaComSSP: function autenticaComSSP() {
      var vm = this;
      vm.$axios.post(vm.env.AUTENTICA + '/autenticarComTokenTemporario', {
        hash: vm.$route.query.hash
      }).then(function (response) {
        localStorage.setItem('sessaoUsuario', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));
        window.location.href = '/';
      }).catch(function (error) {
        vm.$store.commit('setAlert', { msg: 'Não foi possível autenticar', status: false, show: true });
        console.log(error);
        window.location.href = vm.env.ADMINISTRATIVO;
      });
    }
  }
});

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      var sessaoUsuario = [];
      _this.$store.commit('setLoginUsuario', sessaoUsuario);
      localStorage.clear();

      document.location.href = '/';
    }, 2000);
  }
});

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_epic_spinners__ = __webpack_require__(65);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      grupoRedirect: [{ grupo: 'nomeDeGrupoDeExemplo', rota: './nomeDaRotaExemplo' }, { grupo: 'cgs', rota: './meusChamadosCgs' }],
      rotaDefault: '/MeusChamados',
      animacao: true
    };
  },

  mounted: function mounted() {
    var _this = this;

    var rotaGrupo = this.grupoRedirect.filter(function (item) {
      return item.grupo === _this.$store.state.login.loginUsuario.grupo.nome;
    });
    var vm = this;
    setTimeout(function () {
      rotaGrupo.length && vm.$route.fullPath === '/' ? _this.$router.push({ path: rotaGrupo[0].rota }) : _this.$router.push({ path: vm.$route.fullPath });
      vm.animacao = false;
    }, 2000);
  },
  components: {
    BreedingRhombusSpinner: __WEBPACK_IMPORTED_MODULE_0_epic_spinners__["a" /* BreedingRhombusSpinner */]
  },
  methods: {
    redirecionarUsuarioAposLogin: function redirecionarUsuarioAposLogin() {
      return 'isso é um teste';
    }
  }
});

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_epic_spinners__ = __webpack_require__(65);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    HalfCircleSpinner: __WEBPACK_IMPORTED_MODULE_0_epic_spinners__["b" /* HalfCircleSpinner */]
  },
  computed: {
    token: function token() {
      return this.$store.state.login.loginUsuario.token;
    }
  },
  data: function data() {
    return {
      env: __webpack_require__.i({"NODE_ENV":"production","AUTENTICA":"https://autentica-single.portalssp.com/api","CADASTRO_USUARIO":"https://cadastro.oi.portalssp.com","RECUPERAR_SENHA":"https://cadastro.oi.portalssp.com/reset","STORAGE":"https://storage.portalssp.com/api/v1","FINANCEIRO":__webpack_require__.i({"SLA":"https://financeiro.sla.portalssp.com/api","NOTIFICACAO":"https://financeiro.notificacoes.portalssp.com/api","GLOSA":"https://financeiro.glosa.portalssp.com/api/v1"}),"ADMINISTRATIVO":"undefined"})
    };
  },
  mounted: function mounted() {
    this.validarAdministrativo();
  },

  methods: {
    validarAdministrativo: function validarAdministrativo() {
      var vm = this;
      vm.$axios.post(vm.env.AUTENTICA + '/validarTokenTemporario', { sistema: 'adm' }, {
        headers: {
          'Authorization': 'Bearer ' + vm.$store.state.login.loginUsuario.token
        }
      }).then(function (response) {
        window.location.href = vm.env.ADMINISTRATIVO + '/autenticar?hash=' + response.data;
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  updated: function updated() {
    this.carregaExterno();
  },
  methods: {
    carregaExterno: function carregaExterno() {
      if (this.$store.state.alertAtualizacoes.alertAtualizacoes.show === true) {
        $('#loadContent').load('https://manual.portalssp.com/notas-ssp-financeiro/ div.bloco-conteudo', function (data, status, jqXGR) {
          var conteudo = '';
          $('#loadContent article').each(function () {
            conteudo += '<div class="list-group-item list-group-item-light">' + $(this).find('.entry-title').text() + ' <br> ' + $(this).find('.post-meta').text() + '</div>';
          });
          $('#loadContent').html(conteudo);
        });
      }
    },
    fecharModal: function fecharModal() {
      this.$store.commit('setAlertAtualizacoes', { status: true, show: false });
    }
  }
});

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      data: ''
    };
  },

  mounted: function mounted() {
    this.getData();
  },
  methods: {
    fecharModal: function fecharModal() {
      this.$store.commit('setAlertCalendario', { status: true, show: false });
    },
    getData: function getData() {
      this.data = new Date().getDate();
    },
    addDays: function addDays(days) {
      var date = new Date();
      console.log(date);
      date.setDate(date.getDate() + days);
      return date;
    }
  }
});

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  methods: {
    fecharModal: function fecharModal() {
      this.$store.commit('setAlert', { msg: '', status: true, show: false });
    }
  }
});

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      anoSelecionado: new Date().getFullYear(),
      alert: false,
      minYear: 2020,
      maxYear: new Date().getFullYear() };
  },

  computed: {
    modalIsVisible: function modalIsVisible() {
      console.log('Estado modal completo no modal:', this.$store.state.modal);
      console.log('Estado modalExportarExtra no modal:', this.$store.state.modalExportarExtra);
      return this.$store.state.modalExportarExtra && this.$store.state.modalExportarExtra.show;
    }
  },
  methods: {
    fecharModal: function fecharModal() {
      this.alert = false;

      this.$store.commit('setModalExportarExtra', { show: false });
    },
    selecionar: function selecionar() {
      if (!this.anoSelecionado) {
        this.alert = true;
        return;
      }
      this.alert = false;
      this.$emit('selecionado', this.anoSelecionado);
      this.fecharModal();
    }
  },
  watch: {
    modalIsVisible: function modalIsVisible(newValue) {
      console.log('Visibilidade do modal mudou para:', newValue);
    }
  }
});

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      mesAnoSelecionado: '',
      alert: false
    };
  },

  computed: {
    bienios: function bienios() {
      var bienios = [];
      var dataAtual = new Date();
      var anoAtual = dataAtual.getFullYear();

      for (var i = anoAtual; i >= 2020; i -= 2) {
        var x = i - 1 + '_' + i;
        bienios.push(x);
      }
      return bienios;
    }
  },
  components: {},
  methods: {
    fecharModal: function fecharModal() {
      this.alert = false;
      this.$store.commit('setModalFechamentoFixoVariavel', { conteudo: null, show: false });
    },
    selecionar: function selecionar() {
      if (this.mesAnoSelecionado === undefined || this.mesAnoSelecionado === '') {
        this.alert = true;
        return;
      }
      this.alert = false;
      this.$emit('selecionado', this.mesAnoSelecionado);
      this.fecharModal();
    }
  }
});

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AlertGlobal_vue__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AlertGlobal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__AlertGlobal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__evidencia_modal_ModalListarEvidencia_vue__ = __webpack_require__(886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__evidencia_modal_ModalListarEvidencia_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__evidencia_modal_ModalListarEvidencia_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InserirEvidencia_vue__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InserirEvidencia_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__InserirEvidencia_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sla_modal_ModalHistoricoSla_vue__ = __webpack_require__(934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sla_modal_ModalHistoricoSla_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__sla_modal_ModalHistoricoSla_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__notificacao_modal_ModalFormExibirNotificacao_vue__ = __webpack_require__(907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__notificacao_modal_ModalFormExibirNotificacao_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__notificacao_modal_ModalFormExibirNotificacao_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__notificacao_modal_ModalHistoricoNotificacao_vue__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__notificacao_modal_ModalHistoricoNotificacao_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__notificacao_modal_ModalHistoricoNotificacao_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AlertCalendario_vue__ = __webpack_require__(895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AlertCalendario_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__AlertCalendario_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__permissoes_PermissaoNegada_vue__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__permissoes_PermissaoNegada_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__permissoes_PermissaoNegada_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__glosa_modal_ModalAdicionarEvidenciaGlosa_vue__ = __webpack_require__(889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__glosa_modal_ModalAdicionarEvidenciaGlosa_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__glosa_modal_ModalAdicionarEvidenciaGlosa_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__glosa_modal_ModalListarGlosas_vue__ = __webpack_require__(890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__glosa_modal_ModalListarGlosas_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__glosa_modal_ModalListarGlosas_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__extraContratual_AplicarExtraContratual_vue__ = __webpack_require__(901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__extraContratual_AplicarExtraContratual_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__extraContratual_AplicarExtraContratual_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__sla_modal_ModalConfirmarMultaGlosa__ = __webpack_require__(933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__sla_modal_ModalConfirmarMultaGlosa___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__sla_modal_ModalConfirmarMultaGlosa__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__AlertAtualizacoes_vue__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__AlertAtualizacoes_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__AlertAtualizacoes_vue__);
















/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'modal-alert-global': __WEBPACK_IMPORTED_MODULE_0__AlertGlobal_vue___default.a,
    'modal-listar-evidencia': __WEBPACK_IMPORTED_MODULE_1__evidencia_modal_ModalListarEvidencia_vue___default.a,
    'modal-inserir-evidencia': __WEBPACK_IMPORTED_MODULE_2__InserirEvidencia_vue___default.a,
    'modal-historico-sla': __WEBPACK_IMPORTED_MODULE_3__sla_modal_ModalHistoricoSla_vue___default.a,
    'modal-form-exibir-notificacao': __WEBPACK_IMPORTED_MODULE_4__notificacao_modal_ModalFormExibirNotificacao_vue___default.a,
    'modal-historico-notificacao': __WEBPACK_IMPORTED_MODULE_5__notificacao_modal_ModalHistoricoNotificacao_vue___default.a,
    'modal-alert-calendario': __WEBPACK_IMPORTED_MODULE_6__AlertCalendario_vue___default.a,
    'modal-permissao-negada': __WEBPACK_IMPORTED_MODULE_7__permissoes_PermissaoNegada_vue___default.a,
    'modal-adiconar-glosa': __WEBPACK_IMPORTED_MODULE_8__glosa_modal_ModalAdicionarEvidenciaGlosa_vue___default.a,
    'modal-extraContratual': __WEBPACK_IMPORTED_MODULE_10__extraContratual_AplicarExtraContratual_vue___default.a,
    'modal-listar-glosas': __WEBPACK_IMPORTED_MODULE_9__glosa_modal_ModalListarGlosas_vue___default.a,
    'modal-confirmar-multa-glosa': __WEBPACK_IMPORTED_MODULE_11__sla_modal_ModalConfirmarMultaGlosa___default.a,
    'modal-alert-atualizacoes': __WEBPACK_IMPORTED_MODULE_12__AlertAtualizacoes_vue___default.a
  }
});

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal_AlertGlobal__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal_AlertGlobal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__modal_AlertGlobal__);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      text: '',
      formEvidencia: {
        ano_de_referencia: { nome: 'ano_de_referencia', placeholder: 'Ano de referência', valor: '' },
        mes_de_referencia: { nome: 'mes_de_referencia', placeholder: 'Mês de referência', valor: '' },
        item_sla_id: { nome: 'item_sla_id', placeholder: 'Item SLA', valor: '' },
        nao_conformidade_apurada: { nome: 'nao_conformidade_apurada', placeholder: 'Não conformidade apurada', valor: '' },
        quantidade_apurada: { nome: 'quantidade_apurada', placeholder: 'Quantidade apurada', valor: '' },
        observacoes: { nome: 'observacoes', placeholder: 'Observações', valor: '' },
        evidencias: { nome: 'evidencias', placeholder: 'Evidências', valor: '' },
        existe_evidencia: { nome: 'existe_evidencia', valor: null },
        arquivo_de_evidencia: { nome: 'arquivo_de_evidencia', placeholder: 'Anexar evidência', valor: '' },
        unidade_medicao: {
          nome: '',
          id: { nome: 'unidade_medicao_id', valor: '' }
        },
        contrato_id: { nome: 'contrato_id', valor: '' },
        tipo_contrato_id: { nome: 'tipo_contrato_id', valor: '' }
      },
      contrato: '',
      show: true,
      itens_sla: '',
      meses: '',
      sla: this.$store.state.itensSla,
      classValidacao: 'form-validacao',
      env: __webpack_require__.i({"NODE_ENV":"production","AUTENTICA":"https://autentica-single.portalssp.com/api","CADASTRO_USUARIO":"https://cadastro.oi.portalssp.com","RECUPERAR_SENHA":"https://cadastro.oi.portalssp.com/reset","STORAGE":"https://storage.portalssp.com/api/v1","FINANCEIRO":__webpack_require__.i({"SLA":"https://financeiro.sla.portalssp.com/api","NOTIFICACAO":"https://financeiro.notificacoes.portalssp.com/api","GLOSA":"https://financeiro.glosa.portalssp.com/api/v1"}),"ADMINISTRATIVO":"undefined"}),
      controleBtnSubmit: true,
      evidenciaEnviada: []
    };
  },

  computed: {
    conteudo: function conteudo() {
      var infoContrato = this.$store.state.infoContrato.infoContrato;
      this.formEvidencia.ano_de_referencia.valor = this.$store.state.ano.ano_selecionado;
      this.contrato = infoContrato;
      if (this.$store.state.infoContrato.infoContrato.tipo_contrato_id) {
        this.getItemSla();
        this.getMes();
      }
      return infoContrato;
    }
  },
  components: {
    'modal-alert-global': __WEBPACK_IMPORTED_MODULE_0__modal_AlertGlobal___default.a
  },
  methods: {
    fecharModal: function fecharModal() {
      this.$store.commit('setAdicionarEvidencia', { conteudo: null, show: false });
    },
    getItemSla: function getItemSla() {
      var vm = this;
      var tipo_contrato_id = this.$store.state.infoContrato.infoContrato.tipo_contrato_id;
      var tipo_imovel_contrato_id = this.$store.state.infoContrato.infoContrato.tipo_imovel_contrato_id;
      var ano = this.$store.state.ano.ano_selecionado;

      console.warn(tipo_contrato_id, tipo_imovel_contrato_id, ano);

      vm.evidenciaEnviada = vm.$store.state.fechamentoMultaGlosa;
      this.$axios.get(this.env.FINANCEIRO.SLA + '/getitenssla/' + tipo_contrato_id + '/' + tipo_imovel_contrato_id + '/' + ano, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token
        }
      }).then(function (response) {
        vm.itens_sla = response.data;
      });
    },
    getMes: function getMes() {
      var vm = this;
      this.$axios.get(this.env.FINANCEIRO.SLA + '/getmes', {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token
        }
      }).then(function (response) {
        vm.meses = response.data;
      });
    },
    salvarEvidencia: function salvarEvidencia() {
      var vm = this;
      if (parseInt(this.formEvidencia.existe_evidencia.valor) === 1 && !this.validacaoForm()) {
        this.$store.commit('setAlert', { msg: 'Preencha corretamente os campos.', status: false, show: true });
        return;
      }
      this.controlerBtnSubmit = false;

      this.$axios.post(this.env.FINANCEIRO.SLA + '/evidencias', this.preencherFormData(), {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token,
          'Content-Type': 'multipart/form-data'
        }
      }).then(function (response) {
        var refreshComponentes = Math.floor(Math.random() * 2 * 1000);
        document.getElementById('alertGlobal').style.zIndex = 99999;
        if (response.status === 200 || response.status === 201) {
          if (response.data.mensagem !== '0') {
            vm.$store.commit('setAlert', { msg: 'Evid\xEAncia salva com sucesso.', status: true, show: true });
          } else {
            vm.$store.commit('setAlert', { msg: '0 Evid\xEAncias confirmadas para o m\xEAs ' + vm.formEvidencia.mes_de_referencia.valor, status: true, show: true });
          }
        } else {
          vm.$store.commit('setAlert', { msg: 'Evidencia n\xE3o foi salva.', status: false, show: true });
        }
        vm.limparDadosFormulario();
        vm.formEvidencia.ano_de_referencia.valor = vm.$store.state.ano.ano_selecionado;
        vm.formEvidencia.contrato_id.valor = vm.$store.state.contrato.itensContrato.contrato_id;
        vm.formEvidencia.tipo_contrato_id.valor = vm.$store.state.contrato.itensContrato.tipo_contrato_id;
        vm.controlerBtnSubmit = true;
        vm.$store.commit('setRefreshComponente', refreshComponentes);
      }).catch(function (error) {
        console.log(error.response);
        if (error.response.data.mensagem || error.response.data.message) {
          vm.$store.commit('setAlert', { msg: '' + error.response.data.mensagem, status: false, show: true });
          console.log(error.response.data.erro);
        }
      });
    },
    setUnidadeMedicao: function setUnidadeMedicao() {
      var _this = this;

      this.itens_sla.forEach(function (item, index) {
        if (_this.formEvidencia.item_sla_id.valor === item.id) {
          _this.formEvidencia.unidade_medicao.id.valor = item.unidade_medicao_id;
          _this.formEvidencia.unidade_medicao.nome = item.unidade_medicao_tipo;
        }
      });
    },
    preencherFormData: function preencherFormData() {
      var formData = new FormData();
      formData.append('usuario_nome', this.$store.state.login.loginUsuario.usuario.name);
      formData.append('usuario_email', this.$store.state.login.loginUsuario.usuario.email);
      formData.append('ano_de_referencia', this.formEvidencia.ano_de_referencia.valor);
      formData.append('mes_de_referencia', this.formEvidencia.mes_de_referencia.valor);
      formData.append('existe_evidencia', this.formEvidencia.existe_evidencia.valor);
      formData.append('item_sla_id', this.formEvidencia.item_sla_id.valor);
      formData.append('contrato_id', this.$store.state.contrato.itensContrato.contrato_id);
      formData.append('tipo_contrato_id', this.$store.state.contrato.itensContrato.tipo_contrato_id);
      if (parseInt(this.formEvidencia.existe_evidencia.valor) !== 0) {
        formData.append('nao_conformidade_apurada', this.formEvidencia.nao_conformidade_apurada.valor);
        formData.append('quantidade_apurada', this.formEvidencia.quantidade_apurada.valor);
        formData.append('observacoes', this.formEvidencia.observacoes.valor);
        formData.append('unidade_medicao_id', this.formEvidencia.unidade_medicao.id.valor);
        formData.append('arquivo_de_evidencia', this.$refs[this.formEvidencia.arquivo_de_evidencia.nome].files[0]);
      }
      return formData;
    },
    limparDadosFormulario: function limparDadosFormulario() {
      this.formEvidencia.mes_de_referencia.valor = '';
      this.formEvidencia.mes_de_referencia.valor = '';
      this.formEvidencia.existe_evidencia.valor = null;
      this.formEvidencia.item_sla_id.valor = '';
      this.formEvidencia.nao_conformidade_apurada.valor = '';
      this.formEvidencia.quantidade_apurada.valor = '';
      this.formEvidencia.observacoes.valor = '';
      this.formEvidencia.unidade_medicao.id.valor = '';
      this.formEvidencia.evidencias.valor = '';
      this.formEvidencia.arquivo_de_evidencia.valor = '';
    },
    validacaoForm: function validacaoForm() {
      var validado = true;
      if (this.formEvidencia.mes_de_referencia.valor === '' || this.formEvidencia.existe_evidencia.valor === '' || this.formEvidencia.nao_conformidade_apurada.valor === '' || this.formEvidencia.item_sla_id.valor === '' || this.formEvidencia.unidade_medicao.id.valor === '' || this.formEvidencia.quantidade_apurada.valor === '' || this.formEvidencia.observacoes.valor === '' || this.formEvidencia.evidencias.valor === '') {
        validado = false;
      }
      return validado;
    }
  }
});

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      bienio: '2022_2023'
    };
  },

  computed: {
    bienios: function bienios() {
      var bienios = [];
      var dataAtual = new Date();
      var anoAtual = dataAtual.getFullYear();

      for (var i = anoAtual; i >= 2020; i -= 2) {
        var x = i - 1 + '_' + i;
        bienios.push(x);
      }
      return bienios;
    }
  },
  components: {},
  methods: {
    fecharModal: function fecharModal() {
      this.$store.commit('setPlanilhasChamados', { conteudo: null, show: false });
    },
    selecionar: function selecionar() {
      this.$emit('selecionado', this.bienio);
      this.fecharModal();
    }
  }
});

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      bienio: '2022_2023'
    };
  },

  computed: {
    bienios: function bienios() {
      var bienios = [];
      var dataAtual = new Date();
      var anoAtual = dataAtual.getFullYear();

      for (var i = anoAtual; i >= 2020; i -= 2) {
        var x = i - 1 + '_' + i;
        bienios.push(x);
      }
      return bienios;
    }
  },
  components: {},
  methods: {
    fecharModal: function fecharModal() {
      this.$store.commit('setPlanilhasPreventivas', { conteudo: null, show: false });
    },
    selecionar: function selecionar() {
      this.$emit('selecionado', this.bienio);
      this.fecharModal();
    }
  }
});

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_v_money__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_v_money___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_v_money__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_multiselect__ = __webpack_require__(1030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_multiselect__);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      contrato: [],
      siglas: [],
      servicos: [],
      servicoAtual: null,
      servicosSelecionados: [],
      selected: [],
      dadosFechamento: '',
      verificaRegistroAnterior: '',
      env: __webpack_require__.i({"NODE_ENV":"production","AUTENTICA":"https://autentica-single.portalssp.com/api","CADASTRO_USUARIO":"https://cadastro.oi.portalssp.com","RECUPERAR_SENHA":"https://cadastro.oi.portalssp.com/reset","STORAGE":"https://storage.portalssp.com/api/v1","FINANCEIRO":__webpack_require__.i({"SLA":"https://financeiro.sla.portalssp.com/api","NOTIFICACAO":"https://financeiro.notificacoes.portalssp.com/api","GLOSA":"https://financeiro.glosa.portalssp.com/api/v1"}),"ADMINISTRATIVO":"undefined"}),
      controlerBtnSubmit: true,
      formFechamentoExtra: {
        usuario_nome: { nome: 'usuario_nome', valor: this.$store.state.login.loginUsuario.usuario.name, status: undefined, tipo: '' },
        usuario_email: { nome: 'usuario_email', valor: this.$store.state.login.loginUsuario.usuario.email, status: undefined, tipo: '' },
        valor_extra: { nome: 'valor_extra', placeholder: 'Apenas valores monetários R$', valor: '', tipo: 'valor' },
        valor_comodato: { nome: 'valor_comodato', placeholder: 'Apenas valores monetários R$', valor: '', tipo: 'valor' },
        descricao: { nome: 'descricao', placeholder: 'Digite uma descrição', valor: '', tipo: 'texto' },
        arquivo_extra: { nome: 'arquivo_extra', placeholder: 'Anexar arquivo', valor: '', tipo: 'arquivo', status: undefined },
        arquivo_carga_extra: { nome: 'arquivo_carga_extra', placeholder: 'Arquivo de carga dos Valores Oi', valor: '', tipo: 'arquivo', status: undefined },
        arquivo_comodato: { nome: 'arquivo_comodato', placeholder: 'Anexar arquivo', valor: '', tipo: 'arquivo', status: undefined },
        arquivo_carga_comodato: { nome: 'arquivo_carga_comodato', placeholder: 'Arquivo de carga dos Valores Comodato', valor: '', tipo: 'arquivo', status: undefined }
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: ' ',
        precision: 2,
        masked: false
      }
    };
  },

  components: {
    Money: __WEBPACK_IMPORTED_MODULE_1_v_money__["Money"],
    Multiselect: __WEBPACK_IMPORTED_MODULE_2_vue_multiselect___default.a
  },
  computed: {
    servicosDisponiveis: function servicosDisponiveis() {
      var idsSelecionados = this.servicosSelecionados.map(function (s) {
        return s.id;
      });
      return this.servicos.filter(function (s) {
        return !idsSelecionados.includes(s.id);
      });
    }
  },
  mounted: function mounted() {
    this.dadosFechamentoExtra();
    this.getContratoAtual();
    this.getSiglasPredios();
    this.getServicos();
  },
  methods: {
    fecharModal: function fecharModal() {
      localStorage.removeItem('fechamentoExtra.dadosFechamento');
      this.$store.commit('setExtraContratual', { conteudo: null, show: false });
    },
    dadosFechamentoExtra: function dadosFechamentoExtra() {
      this.dadosFechamento = this.$store.state.fechamentoExtra.dadosFechamento;
    },
    getContratoAtual: function getContratoAtual() {
      var vm = this;
      var formContratoAtual = {
        'tipo_imovel_servico_id': this.$store.state.fechamentoExtra.dadosFechamento.id_contrato,
        'uf_id': this.$store.state.fechamentoExtra.dadosFechamento.uf_id,
        'ano_selecionado': this.$store.state.fechamentoExtra.dadosFechamento.ano_selecionado
      };
      this.$axios.post(this.env.FINANCEIRO.SLA + '/getcontratoatual', formContratoAtual, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token,
          'Content-Type': 'application/json'
        }
      }).then(function (response) {
        vm.contrato = response.data;
      });
    },
    getSiglasPredios: function getSiglasPredios() {
      var vm = this;
      var formContratoAtual = {
        'tipo_imovel_servico_id': this.$store.state.fechamentoExtra.dadosFechamento.id_contrato,
        'uf_id': this.$store.state.fechamentoExtra.dadosFechamento.uf_id,
        'ano_selecionado': this.$store.state.fechamentoExtra.dadosFechamento.ano_selecionado
      };

      this.$axios.post(this.env.FINANCEIRO.SLA + '/getSiglasPredios', formContratoAtual, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token,
          'Content-Type': 'application/json'
        }
      }).then(function (response) {
        vm.siglas = response.data;
      });
    },
    getServicos: function getServicos() {
      var vm = this;
      this.$axios.post(this.env.FINANCEIRO.SLA + '/getServicos', {
        'tipo_imovel_servico_id': this.$store.state.fechamentoExtra.dadosFechamento.id_contrato
      }, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token,
          'Content-Type': 'application/json'
        }
      }).then(function (response) {
        vm.servicos = response.data;
      }).catch(function (error) {
        console.log('Erro ao carregar serviços:', error);
      });
    },
    adicionarServico: function adicionarServico() {
      if (this.servicoAtual) {
        this.servicosSelecionados.push(this.servicoAtual);
        this.servicoAtual = null;
      }
    },
    removerServico: function removerServico(index) {
      this.servicosSelecionados.splice(index, 1);
    },

    setArquivo: function setArquivo(event) {
      this.formFechamentoExtra.arquivo_extra.valor = event.target.files[0];
    },
    setArquivoCarga: function setArquivoCarga(event) {
      this.formFechamentoExtra.arquivo_carga_extra.valor = event.target.files[0];
    },
    setArquivoComodato: function setArquivoComodato(event) {
      this.formFechamentoExtra.arquivo_comodato.valor = event.target.files[0];
    },
    setArquivoCargaComodato: function setArquivoCargaComodato(event) {
      this.formFechamentoExtra.arquivo_carga_comodato.valor = event.target.files[0];
    },
    salvarAplicacaoExtra: function salvarAplicacaoExtra() {
      var vm = this;
      if (!this.validacaoForm()) {
        this.$store.commit('setAlert', { msg: 'Preencha corretamente os campos.', status: false, show: true });
        return;
      }

      var form = this.preencherFormData();

      this.controlerBtnSubmit = false;
      this.$axios.post(this.env.FINANCEIRO.SLA + '/salvarFechamentoExtra', form, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token,
          'Content-Type': 'multipart/form-data'
        }
      }).then(function (response) {
        var refreshComponentes = Math.floor(Math.random() * 2 * 1000);
        document.getElementById('alertGlobal').style.zIndex = 9999;
        if (response.data.erro) {
          vm.$store.commit('setAlert', { msg: response.data.erro, status: false, show: true });
          vm.controlerBtnSubmit = true;
          return;
        }
        if (response.status === 200 || response.status === 201) {
          vm.$store.commit('setAlert', { msg: 'Informa\xE7\xF5es salvas com sucesso.', status: true, show: true });
        } else {
          vm.$store.commit('setAlert', { msg: 'A Aplica\xE7\xE3o de extra n\xE3o foi salva.', status: false, show: true });
        }
        vm.fecharModal();
        vm.limparDadosFormulario();
        vm.controlerBtnSubmit = true;
        vm.$store.commit('setRefreshComponente', refreshComponentes);
        vm.$router.push('/ExibirFechamentoExtra');
      }).catch(function (error) {
        vm.$store.commit('setAlert', { msg: '' + error, status: false, show: true });
        vm.controlerBtnSubmit = true;
      });
    },
    verificaSeExisteRegistroAnterior: function verificaSeExisteRegistroAnterior() {},
    preencherFormData: function preencherFormData() {
      var formData = new FormData();
      formData.append('valor_comodato', this.formFechamentoExtra.valor_comodato.valor);
      formData.append('valor_extra', this.formFechamentoExtra.valor_extra.valor);
      formData.append('descricao_extra', this.formFechamentoExtra.descricao.valor);

      var elemExtra = this.$refs[this.formFechamentoExtra.arquivo_extra.nome];

      if (elemExtra.value) {
        formData.append('arquivo_extra', elemExtra.files[0]);
        this.formFechamentoExtra.arquivo_extra.valor = this.$refs.arquivo_extra.value.replace('C:\\fakepath\\', '');
      } else {
        formData.append('arquivo_extra', this.formFechamentoExtra.arquivo_extra.valor);
      }

      var elemCargaExtra = this.$refs[this.formFechamentoExtra.arquivo_carga_extra.nome];

      if (elemCargaExtra.value) {
        formData.append('arquivo_carga_extra', elemCargaExtra.files[0]);
        this.formFechamentoExtra.arquivo_carga_extra.valor = this.$refs.arquivo_carga_extra.value.replace('C:\\fakepath\\', '');
      } else {
        formData.append('arquivo_carga_extra', this.formFechamentoExtra.arquivo_carga_extra.valor);
      }

      var elemComodato = this.$refs[this.formFechamentoExtra.arquivo_comodato.nome];

      if (elemComodato.value) {
        formData.append('arquivo_comodato', elemComodato.files[0]);
        this.formFechamentoExtra.arquivo_comodato.valor = this.$refs.arquivo_comodato.value.replace('C:\\fakepath\\', '');
      } else {
        formData.append('arquivo_comodato', this.formFechamentoExtra.arquivo_comodato.valor);
      }

      var elemCargaComodato = this.$refs[this.formFechamentoExtra.arquivo_carga_comodato.nome];

      if (elemCargaComodato.value) {
        formData.append('arquivo_carga_comodato', elemCargaComodato.files[0]);
        this.formFechamentoExtra.arquivo_carga_comodato.valor = this.$refs.arquivo_carga_comodato.value.replace('C:\\fakepath\\', '');
      } else {
        formData.append('arquivo_carga_comodato', this.formFechamentoExtra.arquivo_carga_comodato.valor);
      }

      formData.append('uf_id', this.$store.state.fechamentoExtra.dadosFechamento.uf_id);
      formData.append('ano_selecionado', this.$store.state.fechamentoExtra.dadosFechamento.ano_selecionado);
      formData.append('contrato_id', this.contrato.contrato_id);
      formData.append('mes_id', this.$store.state.fechamentoExtra.dadosFechamento.mes_id);
      formData.append('usuario_nome', this.$store.state.login.loginUsuario.usuario.name);
      formData.append('usuario_email', this.$store.state.login.loginUsuario.usuario.email);
      formData.append('servicos_ids', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.servicosSelecionados.map(function (s) {
        return s.id;
      })));

      return formData;
    },
    preencherFormDataVerifiarRegistroAnterior: function preencherFormDataVerifiarRegistroAnterior() {
      var formData = new FormData();
      formData.append('ano_selecionado', this.$store.state.fechamentoExtra.dadosFechamento.ano_selecionado);
      formData.append('contrato_id', this.contrato.contrato_id);
      formData.append('mes_id', this.$store.state.fechamentoExtra.dadosFechamento.mes_id);
      return formData;
    },
    limparDadosFormulario: function limparDadosFormulario() {
      this.formFechamentoExtra.valor_extra.valor = '';
      this.formFechamentoExtra.valor_comodato.valor = '';
      this.formFechamentoExtra.descricao.valor = '';
      this.formFechamentoExtra.arquivo_comodato.valor = '';
      this.formFechamentoExtra.arquivo_carga_comodato.valor = '';
      this.formFechamentoExtra.arquivo_extra.valor = '';
      this.formFechamentoExtra.arquivo_carga_extra.valor = '';
      this.formFechamentoExtra.usuario_nome.valor = '';
      this.formFechamentoExtra.usuario_email.valor = '';
      this.servicoAtual = null;
      this.servicosSelecionados = [];
      this.$refs['arquivo_extra'].value = null;
      this.$refs['arquivo_carga_extra'].value = null;
      this.$refs['arquivo_comodato'].value = null;
      this.$refs['arquivo_carga_comodato'].value = null;
    },
    validacaoForm: function validacaoForm() {
      var validadoValorOi = false;
      var validadoValorComodato = false;
      var validadoDescricao = false;

      if (this.formFechamentoExtra['valor_extra'].valor > 0 && this.formFechamentoExtra['arquivo_extra'].valor !== '' && this.formFechamentoExtra['valor_comodato'].valor >= 0) {
        validadoValorOi = true;
      }

      if (this.formFechamentoExtra['valor_comodato'].valor > 0 && this.formFechamentoExtra['arquivo_comodato'].valor !== '' && this.formFechamentoExtra['valor_extra'].valor >= 0) {
        validadoValorComodato = true;
      }

      if (this.formFechamentoExtra['descricao'].valor !== '') {
        validadoDescricao = true;
      }
      console.log('validadoValorOi', validadoValorOi);
      console.log('validadoValorComodato', validadoValorComodato);
      console.log('validadoDescricao', validadoDescricao);
      console.log('final', validadoDescricao && (validadoValorComodato || validadoValorOi));
      return validadoDescricao && (validadoValorComodato || validadoValorOi);
    }
  }
});

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  methods: {
    fecharModal: function fecharModal() {
      this.$store.commit('setPermissaoNegada', { msg: '', status: true, show: false });
      this.$router.push('/');
    }
  }
});

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HistoricoNotificacoes_vue__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HistoricoNotificacoes_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__HistoricoNotificacoes_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { HistoricoNotificacoes: __WEBPACK_IMPORTED_MODULE_0__HistoricoNotificacoes_vue___default.a },
  data: function data() {
    return {
      notificacaoAtual: [],
      historico: [],
      controlerLoadingDownload: true,
      env: __webpack_require__.i({"NODE_ENV":"production","AUTENTICA":"https://autentica-single.portalssp.com/api","CADASTRO_USUARIO":"https://cadastro.oi.portalssp.com","RECUPERAR_SENHA":"https://cadastro.oi.portalssp.com/reset","STORAGE":"https://storage.portalssp.com/api/v1","FINANCEIRO":__webpack_require__.i({"SLA":"https://financeiro.sla.portalssp.com/api","NOTIFICACAO":"https://financeiro.notificacoes.portalssp.com/api","GLOSA":"https://financeiro.glosa.portalssp.com/api/v1"}),"ADMINISTRATIVO":"undefined"}),
      gruposPermitidos: ['oi', 'admin'],
      permissao: true
    };
  },

  mounted: function mounted() {
    this.getGrupos();

    var usuarioGrupo = this.$store.state.login.loginUsuario.grupo;

    var msgGrupos = usuarioGrupo[0].nome;
    if (usuarioGrupo[1]) {
      msgGrupos = usuarioGrupo[0].nome + ' ,' + usuarioGrupo[1].nome;
      if (usuarioGrupo[2]) {
        msgGrupos = usuarioGrupo[0].nome + ' ,' + usuarioGrupo[1].nome + ' ,' + usuarioGrupo[2].nome;
      }
    }
    if (this.usuarioGrupos.includes('admin') === true || this.usuarioGrupos.includes('oi') === true) {
      this.getNotificacaoAtual();
    } else {
      this.permissao = false;
      this.$store.commit('setPermissaoNegada', {
        msg: 'Seu(s) grupo(s) de usu\xE1rio [' + msgGrupos + '] n\xE3o permite(m) acesso a esta \xE1rea.',
        status: false,
        show: true
      });
    }
  },
  computed: {
    notificacao: function (_notificacao) {
      function notificacao() {
        return _notificacao.apply(this, arguments);
      }

      notificacao.toString = function () {
        return _notificacao.toString();
      };

      return notificacao;
    }(function () {
      var notificacaoId = this.$route.query.id;
      var vm = this;
      this.$store.commit('setNotificacaoAtual', '');
      this.$axios.get(this.env.FINANCEIRO.NOTIFICACAO + '/gethistorico/' + notificacaoId, {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.login.loginUsuario.token
        }
      }).then(function (response) {
        var _response$data = response.data,
            notificacao = _response$data.notificacao,
            historico = _response$data.historico;

        vm.notificacaoAtual = notificacao;
        vm.historico = historico;
        vm.$store.commit('setNotificacaoAtual', vm.notificacaoAtual);
      });
      this.getNotificacaoAtual();
      return notificacao;
    })
  },
  methods: {
    getNotificacaoAtual: function getNotificacaoAtual() {
      var notificacaoId = this.$route.query.id;
      var vm = this;
      this.$store.commit('setNotificacaoAtual', '');
      this.$axios.get(this.env.FINANCEIRO.NOTIFICACAO + '/gethistorico/' + notificacaoId, {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.login.loginUsuario.token
        }
      }).then(function (response) {
        var _response$data2 = response.data,
            notificacao = _response$data2.notificacao,
            historico = _response$data2.historico;

        vm.notificacaoAtual = notificacao;
        vm.historico = historico;
        vm.$store.commit('setNotificacaoAtual', vm.notificacaoAtual);
      });
    },

    downloadArquivo: function downloadArquivo(nomeArquivo) {
      var vm = this;
      var dirBucket = 'notificacoes';
      this.controlerLoadingDownload = false;
      this.$axios.get(this.env.FINANCEIRO.NOTIFICACAO + '/downloadarquivo/' + dirBucket + '/' + nomeArquivo, {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.login.loginUsuario.token
        }
      }).then(function (response) {
        vm.controlerLoadingDownload = true;

        if (response.data.mensagem) {
          vm.$store.commit('setAlert', {
            msg: response.data.mensagem,
            status: false,
            show: true
          });
          return;
        }
        window.open(response.data.url, '_blank');
      });
    },
    getGrupos: function getGrupos() {
      var grupos = [];
      this.$store.state.login.loginUsuario.grupo.forEach(function (element) {
        grupos.push(element.nome);
      });
      this.usuarioGrupos = grupos;
    },

    formataData: function formataData(dataForm) {
      var dataArray = dataForm.split(' ');
      var data = dataArray[0].split('-');
      var horarioArray = dataArray[1].split(':');

      var hora = horarioArray[0];
      var minuto = horarioArray[1];
      return data[2] + '/' + data[1] + '/' + data[0] + ' ' + hora + ':' + minuto;
    }
  }
});

/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['historico']
});

/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      formNotificacao: {
        ano_de_referencia: { nome: 'ano_de_referencia', placeholder: 'Ano de referência', valor: '' },
        mes_de_referencia: { nome: 'mes_de_referencia', placeholder: 'Mês de referência', valor: '' },
        uf_selecionada: { nome: 'uf_selecionada', placeholder: 'UF', valor: '' },
        tipo_imovel_servico: { nome: 'tipo_imovel_servico', placeholder: 'Contrato selecionado', valor: '' },
        descricao: { nome: 'descricao', placeholder: 'Digite uma descrição', valor: '' },
        email_envio: { nome: 'email_envio', placeholder: 'Insira email', valor: '' },
        arquivo_de_notificacao: { nome: 'arquivo_de_notificacao', placeholder: 'Anexar arquivo', valor: '', tipo: 'arquivo', status: undefined },
        data_resposta_esperada: { nome: 'Data de resposta esperada', valor: '' }
      },
      env: __webpack_require__.i({"NODE_ENV":"production","AUTENTICA":"https://autentica-single.portalssp.com/api","CADASTRO_USUARIO":"https://cadastro.oi.portalssp.com","RECUPERAR_SENHA":"https://cadastro.oi.portalssp.com/reset","STORAGE":"https://storage.portalssp.com/api/v1","FINANCEIRO":__webpack_require__.i({"SLA":"https://financeiro.sla.portalssp.com/api","NOTIFICACAO":"https://financeiro.notificacoes.portalssp.com/api","GLOSA":"https://financeiro.glosa.portalssp.com/api/v1"}),"ADMINISTRATIVO":"undefined"}),
      meses: [],
      anos: [],
      ufs: [],
      gruposPermitidos: ['oi', 'admin'],
      permissao: true,
      tipo_imovel_servicos: '',
      controlerBtnSubmit: true,
      emails: [{ email: '' }]
    };
  },

  mounted: function mounted() {
    var usuarioGrupo = this.$store.state.login.loginUsuario.grupo;

    var msgGrupos = usuarioGrupo[0].nome;
    if (usuarioGrupo[1]) {
      msgGrupos = usuarioGrupo[0].nome + ' ,' + usuarioGrupo[1].nome;
      if (usuarioGrupo[2]) {
        msgGrupos = usuarioGrupo[0].nome + ' ,' + usuarioGrupo[1].nome + ' ,' + usuarioGrupo[2].nome;
      }
    }

    if (usuarioGrupo.find(function (permissao) {
      return permissao.nome === 'oi' || permissao.nome === 'admin';
    })) {
      this.getAno();
      this.getMes();
      this.getUfsDoUsuario();
      this.getTipoImovelServico();
    } else {
      this.permissao = false;
      this.$store.commit('setPermissaoNegada', { msg: 'Seu grupo de usu\xE1ro [ ' + msgGrupos + ' ] n\xE3o permisse acesso a esta \xE1rea.', status: false, show: true });
    }
  },
  methods: {
    addEmail: function addEmail() {
      if (this.emails.length < 5) {
        this.emails.push({
          email: ''
        });
      }
    },
    removeEmail: function removeEmail(counter) {
      this.emails.splice(counter, 1);
    },
    getAno: function getAno() {
      var vm = this;
      this.$axios.get(this.env.FINANCEIRO.SLA + '/getano', {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token
        }
      }).then(function (response) {
        vm.anos = response.data;
      });
    },
    getUfsDoUsuario: function getUfsDoUsuario() {
      this.ufs = this.$store.state.login.loginUsuario.estado;
    },
    getTipoImovelServico: function getTipoImovelServico() {
      var vm = this;
      this.$axios.get(this.env.FINANCEIRO.SLA + '/gettipoimovelservico', {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token
        }
      }).then(function (response) {
        vm.tipo_imovel_servicos = response.data;
      });
    },

    configuraBotaoArquivo: function configuraBotaoArquivo(event) {
      this.formNotificacao.arquivo_de_notificacao.valor = event.target.files[0];
    },
    salvarNotificao: function salvarNotificao() {
      var vm = this;
      if (!this.validacaoForm()) {
        this.$store.commit('setAlert', { msg: 'Preencha corretamente os campos.', status: false, show: true });
        return;
      }
      this.controlerBtnSubmit = false;

      this.$axios.post(this.env.FINANCEIRO.NOTIFICACAO + '/notificacoes', this.preencherFormData(), {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token,
          'Content-Type': 'multipart/form-data'
        }
      }).then(function (response) {
        var refreshComponentes = Math.floor(Math.random() * 2 * 1000);
        document.getElementById('alertGlobal').style.zIndex = 99999;
        if (response.status === 200 || response.status === 201) {
          vm.$store.commit('setAlert', { msg: 'Notifica\xE7\xE3o salva com sucesso.', status: true, show: true });
        } else {
          vm.$store.commit('setAlert', { msg: 'Notifica\xE7\xE3o n\xE3o foi salva.', status: false, show: true });
        }
        vm.limparDadosFormulario();
        vm.controlerBtnSubmit = true;
        vm.$store.commit('setRefreshComponente', refreshComponentes);
        vm.$router.push('/ListarNotificacoes');
      }).catch(function (error) {
        vm.$store.commit('setAlert', { msg: '' + error.response.data.erro, status: false, show: true });
        vm.controlerBtnSubmit = true;
      });
    },
    preencherFormData: function preencherFormData() {
      var email = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.emails);
      var formData = new FormData();
      formData.append('ano_de_referencia', this.formNotificacao.ano_de_referencia.valor);
      formData.append('mes_de_referencia', this.formNotificacao.mes_de_referencia.valor);
      formData.append('uf_selecionada', this.formNotificacao.uf_selecionada.valor);
      formData.append('tipo_imovel_servico', this.formNotificacao.tipo_imovel_servico.valor);
      formData.append('descricao', this.formNotificacao.descricao.valor);
      formData.append('email_envio', email);
      formData.append('data_resposta_esperada', this.formNotificacao.data_resposta_esperada.valor);
      formData.append('arquivo_de_notificacao', this.formNotificacao.arquivo_de_notificacao.valor);
      formData.append('name', this.$store.state.login.loginUsuario.usuario.name);
      formData.append('email', this.$store.state.login.loginUsuario.usuario.email);
      return formData;
    },
    limparDadosFormulario: function limparDadosFormulario() {
      this.formNotificacao.mes_de_referencia.valor = '';
      this.formNotificacao.ano_de_referencia.valor = '';
      this.formNotificacao.descricao.valor = '';
      this.emails = [{ email: '' }];
      this.formNotificacao.tipo_imovel_servico.valor = '';
      this.formNotificacao.uf_selecionada.valor = '';
      this.formNotificacao.data_resposta_esperada.valor = '';
      this.formNotificacao.arquivo_de_notificacao.valor = '';
      this.$refs['file_notificacoes'].value = null;
    },
    validacaoForm: function validacaoForm() {
      var validado = true;
      if (this.formNotificacao.mes_de_referencia.valor === '' || this.formNotificacao.ano_de_referencia.valor === '' || this.formNotificacao.uf_selecionada.valor === '' || this.formNotificacao.tipo_imovel_servico.valor === '' || this.formNotificacao.descricao.valor === '') {
        validado = false;
      }
      return validado;
    },
    getMes: function getMes() {
      var vm = this;
      this.$axios.get(this.env.FINANCEIRO.SLA + '/getmes', {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token
        }
      }).then(function (response) {
        vm.meses = response.data;
      });
    }
  }
});

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_pagination_2__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_pagination_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_pagination_2__);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      page: 1,
      startIndex: 1,
      endIndex: 15,
      perPage: 15,
      records: [],
      recordsLength: 0,
      env: __webpack_require__.i({"NODE_ENV":"production","AUTENTICA":"https://autentica-single.portalssp.com/api","CADASTRO_USUARIO":"https://cadastro.oi.portalssp.com","RECUPERAR_SENHA":"https://cadastro.oi.portalssp.com/reset","STORAGE":"https://storage.portalssp.com/api/v1","FINANCEIRO":__webpack_require__.i({"SLA":"https://financeiro.sla.portalssp.com/api","NOTIFICACAO":"https://financeiro.notificacoes.portalssp.com/api","GLOSA":"https://financeiro.glosa.portalssp.com/api/v1"}),"ADMINISTRATIVO":"undefined"}),
      notificacoes: null,
      historicoNotificacoes: [],
      ufs: [],
      tipo_imovel_servicos: [],
      anos: [],
      meses: [],
      ufSelecionada: null,
      contratoSelecionado: null,
      mesSelecionado: null,
      anoSelecionado: null,
      filtro: null,
      gruposPermitidos: ['oi', 'admin'],
      permissao: true
    };
  },

  components: {
    Pagination: __WEBPACK_IMPORTED_MODULE_0_vue_pagination_2___default.a
  },
  mounted: function mounted() {
    this.getGrupos();

    var usuarioGrupo = this.$store.state.login.loginUsuario.grupo;

    var msgGrupos = usuarioGrupo[0].nome;
    if (usuarioGrupo[1]) {
      msgGrupos = usuarioGrupo[0].nome + ' ,' + usuarioGrupo[1].nome;
      if (usuarioGrupo[2]) {
        msgGrupos = usuarioGrupo[0].nome + ' ,' + usuarioGrupo[1].nome + ' ,' + usuarioGrupo[2].nome;
      }
    }

    if (usuarioGrupo.find(function (permissao) {
      return permissao.nome === 'oi' || permissao.nome === 'admin';
    })) {
      this.getNotificacao();
      this.getPage(this.page);
      this.getUfsDoUsuario();
      this.getTipoImovelServico();
      this.getAno();
      this.getMes();
    } else {
      this.permissao = false;
      this.$store.commit('setPermissaoNegada', { msg: 'Seu grupo de usu\xE1ro [ ' + msgGrupos + ' ] n\xE3o permisse acesso a esta \xE1rea.', status: false, show: true });
    }
  },
  methods: {
    detalhesNotificacao: function detalhesNotificacao(idNotificacao) {
      this.$router.push('/ExibirNotificacao/?id=' + idNotificacao);
    },
    getPage: function getPage(page) {
      var startIndex = this.perPage * (page - 1) + 1;
      var endIndex = startIndex + this.perPage - 1;
      this.startIndex = startIndex;
      this.endIndex = endIndex;
      if (this.notificacoes !== null) {
        this.records = this.notificacoes;
      }
    },
    getNotificacao: function getNotificacao() {
      var parametros = {
        grupo: this.$store.state.login.loginUsuario.grupo,
        estado: this.$store.state.login.loginUsuario.estado,
        contrato: this.$store.state.login.loginUsuario.contrato,
        filtro: this.filtro
      };

      var vm = this;
      this.$axios.post(this.env.FINANCEIRO.NOTIFICACAO + '/getnotificacao', parametros, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token
        }
      }).then(function (response) {
        if (response.status === 200 || response.status === 201) {
          vm.notificacoes = response.data;
          vm.records = response.data;
          vm.recordsLength = response.data.length;
        } else {
          vm.$store.commit('setAlert', { msg: response.data.erro, status: false, show: true });
        }
      });
    },
    listarHistoricoNotificacoes: function listarHistoricoNotificacoes() {
      var parametros = {
        grupo: this.$store.state.login.loginUsuario.grupo,
        estado: this.$store.state.login.loginUsuario.estado,
        contrato: this.$store.state.login.loginUsuario.contrato
      };
      this.$store.commit('setHistoricoNotificacoes', parametros);
    },
    getUfsDoUsuario: function getUfsDoUsuario() {
      this.ufs = this.$store.state.login.loginUsuario.estado;
    },
    getTipoImovelServico: function getTipoImovelServico() {
      var vm = this;
      this.$axios.get(this.env.FINANCEIRO.SLA + '/gettipoimovelservico', {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token
        }
      }).then(function (response) {
        vm.tipo_imovel_servicos = response.data;
      });
    },
    getAno: function getAno() {
      var vm = this;
      this.$axios.get(this.env.FINANCEIRO.SLA + '/getano', {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token
        }
      }).then(function (response) {
        vm.anos = response.data;
      });
    },
    getMes: function getMes() {
      var date = new Date();
      this.mes_atual = date.getMonth();
      var vm = this;
      this.$axios.get(this.env.FINANCEIRO.SLA + '/getmes', {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token
        }
      }).then(function (response) {
        vm.meses = response.data;
      });
    },
    onChangeFiltro: function onChangeFiltro() {
      this.filtro = {
        ufSelecionada: this.ufSelecionada,
        contratoSelecionado: this.contratoSelecionado,
        mesSelecionado: this.mesSelecionado,
        anoSelecionado: this.anoSelecionado
      };

      this.page = 1;
      this.getNotificacao();
    },
    limparFiltro: function limparFiltro() {
      this.filtro = null;
      this.ufSelecionada = null;
      this.contratoSelecionado = null;
      this.mesSelecionado = null;
      this.anoSelecionado = null;

      this.page = 1;
      this.getNotificacao();
    },
    getGrupos: function getGrupos() {
      var grupos = [];
      this.$store.state.login.loginUsuario.grupo.forEach(function (element) {
        grupos.push(element.nome);
      });
      this.usuarioGrupos = grupos;
    }
  }
});

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      formExibirNotificacoes: {
        notificacao_id: { nome: 'notificacao_id', valor: null },
        status_notificacao_id: { nome: 'status_notificacao_id', valor: null },
        observacao_fornecedor: { nome: 'observacao_fornecedor', placeholder: 'Inserir justificativa', valor: null },
        uf_id: { nome: 'uf_id', valor: null },
        tipo_imovel_servico_id: { nome: 'tipo_imovel_servico_id', valor: null },
        hash: { nome: 'hash', valor: null },
        email: { nome: 'email', placeholder: 'Insira o email onde você foi notificado', valor: null }
      },
      usuario: '',
      controlerBtnSubmit: true,
      env: __webpack_require__.i({"NODE_ENV":"production","AUTENTICA":"https://autentica-single.portalssp.com/api","CADASTRO_USUARIO":"https://cadastro.oi.portalssp.com","RECUPERAR_SENHA":"https://cadastro.oi.portalssp.com/reset","STORAGE":"https://storage.portalssp.com/api/v1","FINANCEIRO":__webpack_require__.i({"SLA":"https://financeiro.sla.portalssp.com/api","NOTIFICACAO":"https://financeiro.notificacoes.portalssp.com/api","GLOSA":"https://financeiro.glosa.portalssp.com/api/v1"}),"ADMINISTRATIVO":"undefined"})
    };
  },

  mounted: function mounted() {
    this.formExibirNotificacoes.hash.valor = this.$route.params.hash;
    this.verificaHash();
    this.getDadosFormulario();
  },
  methods: {
    verificaHash: function verificaHash() {
      var vm = this;
      this.$axios.post(this.env.FINANCEIRO.NOTIFICACAO + '/verificarHashFormSemLogar', this.formExibirNotificacoes['hash']).then(function (response) {
        if (response.data) {
          return response.data;
        } else if (response.data === false) {
          vm.$store.commit('setAlert', { msg: 'Esse link perdeu a validade!', status: false, show: true });
          setTimeout(function () {
            vm.$router.push('/Login');
          }, 3500);
        }
      }).catch(function (error) {
        console.log(error);
        vm.$store.commit('setAlert', { msg: error.response.data.erro, status: false, show: true });
        setTimeout(function () {
          vm.$router.push('/Login');
        }, 3500);
        vm.controlerBtnSubmit = true;
      });
    },
    getDadosFormulario: function getDadosFormulario() {
      var vm = this;
      var hash = this.formExibirNotificacoes['hash'].valor;
      this.$axios.get(this.env.FINANCEIRO.NOTIFICACAO + '/getDadosFormularioRespostaNotificacaoDeslogado/' + hash).then(function (response) {
        if (response.data) {
          vm.formExibirNotificacoes.uf_id.valor = response.data.uf_id;
          vm.formExibirNotificacoes.tipo_imovel_servico_id.valor = response.data.tipo_imovel_servico_id;
          vm.formExibirNotificacoes.notificacao_id.valor = response.data.id;
          vm.formExibirNotificacoes.email.valor = response.data.email_fornecedor_resposta;
        } else if (response.data === false) {
          vm.$store.commit('setAlert', { msg: 'Esse link perdeu a validade!', status: false, show: true });
          setTimeout(function () {
            vm.$router.push('/Login');
          }, 3500);
        }
      }).catch(function (error) {
        console.log(error);
        vm.$store.commit('setAlert', { msg: error.response.data.erro, status: false, show: true });
        setTimeout(function () {
          vm.$router.push('/Login');
        }, 3500);
        vm.controlerBtnSubmit = true;
      });
    },
    enviarFormulario: function enviarFormulario() {
      var vm = this;
      this.controlerBtnSubmit = false;
      this.$axios.post(this.env.FINANCEIRO.NOTIFICACAO + '/salvarRespostaFornecedorSemLogin', this.preencherFormData()).then(function (response) {
        if (response.status === 200 || response.status === 201) {
          vm.$store.commit('setAlert', { msg: 'Resposta salva com sucesso.', status: true, show: true });
          setTimeout(function () {
            vm.$router.push('/Login');
          }, 3500);
        } else {
          vm.$store.commit('setAlert', { msg: 'Resposta não foi salva.', status: false, show: true });
        }
        vm.limparDadosFormulario();
        vm.controlerBtnSubmit = true;
      }).catch(function (error) {
        if (error.response.status === 422) {
          vm.controlerBtnSubmit = true;
          vm.$store.commit('setAlert', { msg: 'Preencha todos os campos corretamente!', status: false, show: true });
        } else {
          vm.controlerBtnSubmit = true;
          vm.$store.commit('setAlert', { msg: 'Algo deu errado! Tente novamente mais tarde tarde.', status: false, show: true });
        }
        vm.controlerBtnSubmit = true;
      });
    },
    preencherFormData: function preencherFormData() {
      var formData = new FormData();
      formData.append('notificacao_id', this.formExibirNotificacoes.notificacao_id.valor);
      formData.append('status_notificacao_id', this.formExibirNotificacoes.status_notificacao_id.valor);
      formData.append('observacao_fornecedor', this.formExibirNotificacoes.observacao_fornecedor.valor);
      formData.append('uf_selecionada', this.formExibirNotificacoes.uf_id.valor);
      formData.append('tipo_imovel_servico', this.formExibirNotificacoes.tipo_imovel_servico_id.valor);
      formData.append('email', this.formExibirNotificacoes.email.valor);
      return formData;
    },
    limparDadosFormulario: function limparDadosFormulario() {
      this.formExibirNotificacoes.status_notificacao_id.valor = '';
      this.formExibirNotificacoes.observacao_fornecedor.valor = '';
      this.formExibirNotificacoes.email.valor;
    }
  }
});

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      formExibirNotificacoes: {
        notificacao_id: { nome: 'notificacao_id', valor: null },
        status_notificacao_id: { nome: 'status_notificacao_id', valor: null },
        observacao_fornecedor: { nome: 'observacao_fornecedor', placeholder: 'Inserir justificativa', valor: null }
      },
      controlerBtnSubmit: true,
      env: __webpack_require__.i({"NODE_ENV":"production","AUTENTICA":"https://autentica-single.portalssp.com/api","CADASTRO_USUARIO":"https://cadastro.oi.portalssp.com","RECUPERAR_SENHA":"https://cadastro.oi.portalssp.com/reset","STORAGE":"https://storage.portalssp.com/api/v1","FINANCEIRO":__webpack_require__.i({"SLA":"https://financeiro.sla.portalssp.com/api","NOTIFICACAO":"https://financeiro.notificacoes.portalssp.com/api","GLOSA":"https://financeiro.glosa.portalssp.com/api/v1"}),"ADMINISTRATIVO":"undefined"})
    };
  },

  methods: {
    salvarFormularioExibirNotificacoes: function salvarFormularioExibirNotificacoes() {
      var vm = this;
      this.controlerBtnSubmit = false;
      this.$axios.post(this.env.FINANCEIRO.NOTIFICACAO + '/salvarRespostaFornecedor', this.preencherFormData(), {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token,
          'Content-Type': 'multipart/form-data'
        }
      }).then(function (response) {
        if (response.status === 200 || response.status === 201) {
          vm.$store.commit('setAlert', { msg: 'Resposta salva com sucesso.', status: true, show: true });
          vm.$store.commit('setNotificacaoAtual', response.data);
        } else {
          vm.$store.commit('setAlert', { msg: 'Resposta n\xE3o foi salva.', status: false, show: true });
        }
        vm.limparDadosFormulario();
        document.getElementById('exibirNotificacao').click();
        vm.controlerBtnSubmit = true;
      }).catch(function (error) {
        if (error.response && error.respose !== 500) {
          vm.removerValidacao();
          vm.aplicarValidacao(error.response.data.campos);
        } else {
          vm.$store.commit('setAlert', { alert: { msg: 'Algo deu errado! Tente novamente mais tarde tarde.', status: false, show: true } });
        }
        vm.controlerBtnSubmit = true;
      });
    },
    aplicarValidacao: function aplicarValidacao(erros) {
      erros.forEach(function (nomeCampo, indice) {
        var validacao = document.querySelector('.validacao_' + nomeCampo);
        validacao.classList.add('preenchimento-obrigatorio');
      });
      this.controlerBtnSubmit = true;
      this.$store.commit('setAlert', { alert: { msg: 'Existem campos a serem preenchidos', status: false, show: true } });
      return false;
    },
    removerValidacao: function removerValidacao() {
      for (var campo in this.formExibirNotificacoes) {
        if (this.formExibirNotificacoes[campo].valor !== null || this.formExibirNotificacoes[campo].valor !== '' && campo !== 'notificacao_id') {
          var validacao = document.querySelector('.validacao_' + campo);
          validacao.classList.remove('preenchimento-obrigatorio');
        }
      }
    },
    preencherFormData: function preencherFormData() {
      var formData = new FormData();
      formData.append('notificacao_id', this.$store.state.notificacaoAtual.notificacaoAtual.id);
      formData.append('status_notificacao_id', this.formExibirNotificacoes.status_notificacao_id.valor);
      formData.append('observacao_fornecedor', this.formExibirNotificacoes.observacao_fornecedor.valor);
      formData.append('name', this.$store.state.login.loginUsuario.usuario.name);
      formData.append('email', this.$store.state.login.loginUsuario.usuario.email);
      formData.append('uf_selecionada', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.$store.state.notificacaoAtual.notificacaoAtual.uf_id));
      formData.append('tipo_imovel_servico', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.$store.state.notificacaoAtual.notificacaoAtual.tipo_imovel_servico_id));
      return formData;
    },
    limparDadosFormulario: function limparDadosFormulario() {
      this.formExibirNotificacoes.status_notificacao_id.valor = '';
      this.formExibirNotificacoes.observacao_fornecedor.valor = '';
      this.removerValidacao();
    }
  }
});

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['consultaHistoricoNotificacoes'],
  data: function data() {
    return {
      filter: null,
      historicoNotificacoes: [],
      env: __webpack_require__.i({"NODE_ENV":"production","AUTENTICA":"https://autentica-single.portalssp.com/api","CADASTRO_USUARIO":"https://cadastro.oi.portalssp.com","RECUPERAR_SENHA":"https://cadastro.oi.portalssp.com/reset","STORAGE":"https://storage.portalssp.com/api/v1","FINANCEIRO":__webpack_require__.i({"SLA":"https://financeiro.sla.portalssp.com/api","NOTIFICACAO":"https://financeiro.notificacoes.portalssp.com/api","GLOSA":"https://financeiro.glosa.portalssp.com/api/v1"}),"ADMINISTRATIVO":"undefined"}),
      fieldsHistorico: [{ key: 'notificacao_id', label: 'Notificação Id' }, { key: 'email', label: 'Email' }, { key: 'acao', label: 'Ação' }, { key: 'status_resposta', label: 'Status' }, { key: 'uf', label: 'Uf' }, { key: 'tipo_imovel_servico', label: 'Contrato' }, { key: 'created_at', label: 'Data de criação' }]
    };
  },

  watch: {
    consultaHistoricoNotificacoes: function consultaHistoricoNotificacoes() {
      this.getEvidencias(this.consultaHistoricoNotificacoes);
    }
  },
  methods: {
    getEvidencias: function getEvidencias(parametros) {
      var vm = this;
      this.$axios.post(this.env.FINANCEIRO.NOTIFICACAO + '/gethistoriconotificacoes', parametros, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token
        }
      }).then(function (response) {
        vm.historicoNotificacoes = response.data;
      });
    }
  }
});

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      usuario: this.$store.state.login.loginUsuario.usuario,
      grupo: this.$store.state.login.loginUsuario.grupo,
      estado: this.$store.state.login.loginUsuario.estado,
      contrato: this.$store.state.login.loginUsuario.contrato
    };
  }
});

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fechamento_fixo_variavel_ExportFechamentoFixoVariavel_vue__ = __webpack_require__(911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fechamento_fixo_variavel_ExportFechamentoFixoVariavel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__fechamento_fixo_variavel_ExportFechamentoFixoVariavel_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__extracontratual_ExportarFechamentoExtra_vue__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__extracontratual_ExportarFechamentoExtra_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__extracontratual_ExportarFechamentoExtra_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__orcamento_ExportOrcamentosAprovados_vue__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__orcamento_ExportOrcamentosAprovados_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__orcamento_ExportOrcamentosAprovados_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__planilhas_operacional_ExportChamados__ = __webpack_require__(924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__planilhas_operacional_ExportChamados___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__planilhas_operacional_ExportChamados__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__planilhas_operacional_ExportLogPreventivas__ = __webpack_require__(925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__planilhas_operacional_ExportLogPreventivas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__planilhas_operacional_ExportLogPreventivas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__planilhas_operacional_ExportLogSetembro2019__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__planilhas_operacional_ExportLogSetembro2019___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__planilhas_operacional_ExportLogSetembro2019__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__planilhas_operacional_ExportPreventivas__ = __webpack_require__(927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__planilhas_operacional_ExportPreventivas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__planilhas_operacional_ExportPreventivas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__planilhas_adm_ExportChamados__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__planilhas_adm_ExportChamados___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__planilhas_adm_ExportChamados__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__planilhas_adm_ExportHistoricoChamados__ = __webpack_require__(919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__planilhas_adm_ExportHistoricoChamados___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__planilhas_adm_ExportHistoricoChamados__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__planilhas_adm_ExportChamadosDeaverage__ = __webpack_require__(914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__planilhas_adm_ExportChamadosDeaverage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__planilhas_adm_ExportChamadosDeaverage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__planilhas_adm_ExportPreventivas__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__planilhas_adm_ExportPreventivas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__planilhas_adm_ExportPreventivas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__planilhas_adm_ExportFranquias__ = __webpack_require__(917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__planilhas_adm_ExportFranquias___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__planilhas_adm_ExportFranquias__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__planilhas_adm_ExportFranquiasChamados__ = __webpack_require__(918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__planilhas_adm_ExportFranquiasChamados___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__planilhas_adm_ExportFranquiasChamados__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__planilhas_adm_ExportHistoricoNegociacoes__ = __webpack_require__(920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__planilhas_adm_ExportHistoricoNegociacoes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__planilhas_adm_ExportHistoricoNegociacoes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__planilhas_adm_ExportExtintores__ = __webpack_require__(915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__planilhas_adm_ExportExtintores___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__planilhas_adm_ExportExtintores__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__planilhas_adm_ExportFranquiaDinamica__ = __webpack_require__(916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__planilhas_adm_ExportFranquiaDinamica___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__planilhas_adm_ExportFranquiaDinamica__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__planilhas_adm_ExportRelatorioSemanalFranquias__ = __webpack_require__(922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__planilhas_adm_ExportRelatorioSemanalFranquias___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__planilhas_adm_ExportRelatorioSemanalFranquias__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__planilhas_adm_ExportRelatorioSemanalPreventivas__ = __webpack_require__(923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__planilhas_adm_ExportRelatorioSemanalPreventivas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__planilhas_adm_ExportRelatorioSemanalPreventivas__);


























/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      env: __webpack_require__.i({"NODE_ENV":"production","AUTENTICA":"https://autentica-single.portalssp.com/api","CADASTRO_USUARIO":"https://cadastro.oi.portalssp.com","RECUPERAR_SENHA":"https://cadastro.oi.portalssp.com/reset","STORAGE":"https://storage.portalssp.com/api/v1","FINANCEIRO":__webpack_require__.i({"SLA":"https://financeiro.sla.portalssp.com/api","NOTIFICACAO":"https://financeiro.notificacoes.portalssp.com/api","GLOSA":"https://financeiro.glosa.portalssp.com/api/v1"}),"ADMINISTRATIVO":"undefined"}),
      controlerBtnSubmit: false
    };
  },

  computed: {
    isFabricio: function isFabricio() {
      try {
        var email = (this.$store.state.login.loginUsuario.usuario.email || '').toLowerCase();
        return email === 'fabricio.elias@portalssp.com';
      } catch (e) {
        return false;
      }
    }
  },
  components: {
    'export-fechamento-fixo-variavel': __WEBPACK_IMPORTED_MODULE_1__fechamento_fixo_variavel_ExportFechamentoFixoVariavel_vue___default.a,

    'export-extracontratual': __WEBPACK_IMPORTED_MODULE_2__extracontratual_ExportarFechamentoExtra_vue___default.a,
    'export-orcamentos-aprovados': __WEBPACK_IMPORTED_MODULE_3__orcamento_ExportOrcamentosAprovados_vue___default.a,

    'export-chamados': __WEBPACK_IMPORTED_MODULE_4__planilhas_operacional_ExportChamados___default.a,
    'export-log-preventivas': __WEBPACK_IMPORTED_MODULE_5__planilhas_operacional_ExportLogPreventivas___default.a,
    'export-log-setembro-2019': __WEBPACK_IMPORTED_MODULE_6__planilhas_operacional_ExportLogSetembro2019___default.a,
    'export-preventivas': __WEBPACK_IMPORTED_MODULE_7__planilhas_operacional_ExportPreventivas___default.a,

    'export-adm-franquias-semanais': __WEBPACK_IMPORTED_MODULE_17__planilhas_adm_ExportRelatorioSemanalFranquias___default.a,
    'export-adm-preventivas-semanais': __WEBPACK_IMPORTED_MODULE_18__planilhas_adm_ExportRelatorioSemanalPreventivas___default.a,

    'export-adm-chamados': __WEBPACK_IMPORTED_MODULE_8__planilhas_adm_ExportChamados___default.a,
    'export-adm-historico-chamados': __WEBPACK_IMPORTED_MODULE_9__planilhas_adm_ExportHistoricoChamados___default.a,
    'export-adm-deaverage': __WEBPACK_IMPORTED_MODULE_10__planilhas_adm_ExportChamadosDeaverage___default.a,
    'export-adm-preventivas': __WEBPACK_IMPORTED_MODULE_11__planilhas_adm_ExportPreventivas___default.a,
    'export-adm-franquias': __WEBPACK_IMPORTED_MODULE_12__planilhas_adm_ExportFranquias___default.a,
    'export-adm-franquias-chamados': __WEBPACK_IMPORTED_MODULE_13__planilhas_adm_ExportFranquiasChamados___default.a,
    'export-adm-historico-negociacoes': __WEBPACK_IMPORTED_MODULE_14__planilhas_adm_ExportHistoricoNegociacoes___default.a,
    'export-adm-extintores': __WEBPACK_IMPORTED_MODULE_15__planilhas_adm_ExportExtintores___default.a,
    'export-adm-franquia-dinamica': __WEBPACK_IMPORTED_MODULE_16__planilhas_adm_ExportFranquiaDinamica___default.a
  },
  methods: {
    exportarBaseSimulacao: function exportarBaseSimulacao() {
      var _this = this;

      this.controlerBtnSubmit = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        url: this.env.FINANCEIRO.SLA + '/export-base-simulacao',
        method: 'post',
        data: {},
        headers: { 'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token }
      }).then(function (response) {
        var arquivo = response.data && response.data.arquivo_download;
        if (arquivo) {
          var urlDownload = _this.env.FINANCEIRO.SLA + '/download-arquivo-xlsx/' + arquivo;
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(urlDownload, {
            responseType: 'blob',
            headers: { 'Authorization': 'Bearer ' + _this.$store.state.login.loginUsuario.token }
          }).then(function (resp) {
            var blob = new Blob([resp.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            var link = document.createElement('a');
            var url = window.URL.createObjectURL(blob);
            link.href = url;
            var sugestao = arquivo || 'BaseESimulacao-' + new Date().toISOString().slice(0, 10) + '.xlsx';
            link.setAttribute('download', sugestao);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);
          }).catch(function () {
            window.open(urlDownload, '_blank');
          });
        }
      }).finally(function () {
        _this.controlerBtnSubmit = false;
      });
    }
  }
});

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal_ExportarExtra_vue__ = __webpack_require__(896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal_ExportarExtra_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__modal_ExportarExtra_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      env: __webpack_require__.i({"NODE_ENV":"production","AUTENTICA":"https://autentica-single.portalssp.com/api","CADASTRO_USUARIO":"https://cadastro.oi.portalssp.com","RECUPERAR_SENHA":"https://cadastro.oi.portalssp.com/reset","STORAGE":"https://storage.portalssp.com/api/v1","FINANCEIRO":__webpack_require__.i({"SLA":"https://financeiro.sla.portalssp.com/api","NOTIFICACAO":"https://financeiro.notificacoes.portalssp.com/api","GLOSA":"https://financeiro.glosa.portalssp.com/api/v1"}),"ADMINISTRATIVO":"undefined"}),
      fechamentos: '',
      controlerBtnSubmit: false
    };
  },

  components: {
    'modal-exportar-extra': __WEBPACK_IMPORTED_MODULE_0__modal_ExportarExtra_vue___default.a
  },
  methods: {
    abrirModal: function abrirModal() {
      this.$store.commit('setModalExportarExtra', { show: true });
    },
    exportarExtra: function exportarExtra(ano) {
      var _this = this;

      this.controlerBtnSubmit = true;

      var parametros = {
        estado: this.$store.state.login.loginUsuario.estado,
        ano: ano
      };
      var vm = this;
      this.$axios.post(this.env.FINANCEIRO.SLA + '/exportFechamentoExtraContratual', parametros, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token
        }
      }).then(function (response) {
        if (response.status === 200 || response.status === 201) {
          var arquivoDownload = response.data.arquivo_download;

          window.location.href = vm.env.FINANCEIRO.SLA.slice(0, -3) + 'download-arquivo-xlsx/' + arquivoDownload;

          setTimeout(function () {
            vm.controlerBtnSubmit = false;
          }, 10000);
        } else {
          vm.$store.commit('setAlert', { msg: response.data.erro, status: false, show: true });
          vm.controlerBtnSubmit = false;
        }
      }).catch(function () {
        _this.controlerBtnSubmit = false;
      });
    }
  }
});

/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal_FechamentoFixoVariavel_vue__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal_FechamentoFixoVariavel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__modal_FechamentoFixoVariavel_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      env: __webpack_require__.i({"NODE_ENV":"production","AUTENTICA":"https://autentica-single.portalssp.com/api","CADASTRO_USUARIO":"https://cadastro.oi.portalssp.com","RECUPERAR_SENHA":"https://cadastro.oi.portalssp.com/reset","STORAGE":"https://storage.portalssp.com/api/v1","FINANCEIRO":__webpack_require__.i({"SLA":"https://financeiro.sla.portalssp.com/api","NOTIFICACAO":"https://financeiro.notificacoes.portalssp.com/api","GLOSA":"https://financeiro.glosa.portalssp.com/api/v1"}),"ADMINISTRATIVO":"undefined"}),
      controlerBtnSubmit: false
    };
  },

  components: {
    'modal-fechamento-fixo-variavel': __WEBPACK_IMPORTED_MODULE_0__modal_FechamentoFixoVariavel_vue___default.a
  },
  mounted: function mounted() {},
  methods: {
    abrirModal: function abrirModal() {
      this.$store.commit('setModalFechamentoFixoVariavel', { show: true });
    },
    downloadAnexo: function downloadAnexo(mesAno) {
      var _this = this;

      this.controlerBtnSubmit = true;
      var vm = this;
      var payload = {
        estado: this.$store.state.login.loginUsuario.estado,
        mes: mesAno.split('-')[1],
        ano: mesAno.split('-')[0]
      };
      this.$axios.post(this.env.FINANCEIRO.SLA + '/exportFechamentoFixoVariavel', payload, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token
        }
      }).then(function (response) {
        if (response.status === 200 || response.status === 201) {
          var arquivoDownload = response.data.arquivo_download;

          window.location.href = vm.env.FINANCEIRO.SLA.slice(0, -3) + 'download-arquivo-xlsx/' + arquivoDownload;

          setTimeout(function () {
            vm.controlerBtnSubmit = false;
          }, 10000);
        } else {
          vm.$store.commit('setAlert', { msg: response.data.erro, status: false, show: true });
          vm.controlerBtnSubmit = false;
        }
      }).catch(function () {
        _this.controlerBtnSubmit = false;
      });
      console.log(payload);
    }
  }
});

/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      env: __webpack_require__.i({"NODE_ENV":"production","AUTENTICA":"https://autentica-single.portalssp.com/api","CADASTRO_USUARIO":"https://cadastro.oi.portalssp.com","RECUPERAR_SENHA":"https://cadastro.oi.portalssp.com/reset","STORAGE":"https://storage.portalssp.com/api/v1","FINANCEIRO":__webpack_require__.i({"SLA":"https://financeiro.sla.portalssp.com/api","NOTIFICACAO":"https://financeiro.notificacoes.portalssp.com/api","GLOSA":"https://financeiro.glosa.portalssp.com/api/v1"}),"ADMINISTRATIVO":"undefined"}),
      orcamentos: '',
      columns: [{
        label: 'chamado_id',
        field: 'chamado_id'
      }, {
        label: 'sigla_estacao',
        field: 'sigla_estacao'
      }, {
        label: 'codigo_ssp',
        field: 'codigo_ssp'
      }, {
        label: 'uf',
        field: 'uf'
      }, {
        label: 'valor_orcamento',
        field: 'valor_orcamento',
        dataFormat: this.priceFormat
      }, {
        label: 'usuario_nome',
        field: 'usuario_nome'
      }, {
        label: 'usuario_email',
        field: 'usuario_email'
      }, {
        label: 'justificativa',
        field: 'justificativa'
      }, {
        label: 'servico_id',
        field: 'servico_id'
      }, {
        label: 'servico',
        field: 'servico'
      }, {
        label: 'created_at',
        field: 'created_at'
      }, {
        label: 'mes',
        field: 'mes'
      }, {
        label: 'ano',
        field: 'ano'
      }, {
        label: 'status',
        field: 'status'
      }, {
        label: 'proprietario',
        field: 'proprietario'
      }],
      data: []
    };
  },

  mounted: function mounted() {
    this.getOrcamentosAprovados();
  },
  methods: {
    priceFormat: function priceFormat(value) {
      return 'R$ ' + value;
    },
    getOrcamentosAprovados: function getOrcamentosAprovados() {
      var vm = this;
      this.$axios.post(this.env.FINANCEIRO.SLA + '/exportarOrcamentosAprovados', {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.login.loginUsuario.token
        }
      }).then(function (response) {
        if (response.status === 200 || response.status === 201) {
          vm.orcamentos = response.data;
          vm.formatarDados();
        } else {
          vm.$store.commit('setAlert', { msg: response.data.erro, status: false, show: true });
        }
      });
    },
    formatarDados: function formatarDados() {
      var _this = this;

      this.orcamentos.forEach(function (element) {
        var dadosOrcamento = {
          chamado_id: element.chamado_id,
          sigla_estacao: element.sigla_estacao,
          codigo_ssp: element.codigo_ssp,
          uf: element.uf,
          valor_orcamento: element.valor_orcamento,
          usuario_nome: element.usuario_nome,
          usuario_email: element.usuario_email,
          justificativa: element.justificativa,
          servico_id: element.servico_id,
          servico: element.servico,
          created_at: element.created_at,
          mes: element.mes,
          ano: element.ano,
          status: element.status,
          proprietario: element.proprietario
        };
        _this.data.push(dadosOrcamento);
      });
    }
  }
});

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      env: __webpack_require__.i({"NODE_ENV":"production","AUTENTICA":"https://autentica-single.portalssp.com/api","CADASTRO_USUARIO":"https://cadastro.oi.portalssp.com","RECUPERAR_SENHA":"https://cadastro.oi.portalssp.com/reset","STORAGE":"https://storage.portalssp.com/api/v1","FINANCEIRO":__webpack_require__.i({"SLA":"https://financeiro.sla.portalssp.com/api","NOTIFICACAO":"https://financeiro.notificacoes.portalssp.com/api","GLOSA":"https://financeiro.glosa.portalssp.com/api/v1"}),"ADMINISTRATIVO":"undefined"}),
      glosas: [],
      controlerBtnSubmit: false,
      itens: '',
      columns: [{
        label: 'Contrato',
        field: 'contrato'
      }, {
        label: 'Tipo Contrato',
        field: 'tipo'
      }, {
        label: 'UF',
        field: 'uf'
      }, {
        label: 'Mes',
        field: 'mes'
      }, {
        label: 'Ano',
        field: 'ano'
      }, {
        label: 'Valor Multa',
        field: 'multa'
      }, {
        label: 'Valor Glosa',
        field: 'valor'
      }, {
        label: 'Valor Total',
        field: 'valorTotal'
      }, {
        label: 'Enviado',
        field: 'enviado'
      }],
      data: [],
      filtro: []
    };
  },

  mounted: function mounted() {
    this.exportarPlanilhaGeral();
  },
  methods: {
    exportarPlanilhaGeral: function exportarPlanilhaGeral() {
      var vm = this;

      this.controlerLoading = false;


      this.$axios.get(this.env.FINANCEIRO.SLA + '/getPlanilhaGeralSla/1', {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token
        }
      }).then(function (response) {
        vm.filtro = response.data;
        vm.data = response.data;
        vm.controlerBtnSubmit = true;
      });
    },
    priceFormat: function priceFormat(value) {
      return 'R$ ' + value;
    }
  }
});

/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal_PlanilhasChamados_vue__ = __webpack_require__(899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal_PlanilhasChamados_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__modal_PlanilhasChamados_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'modal-planilhas-chamados': __WEBPACK_IMPORTED_MODULE_0__modal_PlanilhasChamados_vue___default.a
  },
  data: function data() {
    return {
      env: __webpack_require__.i({"NODE_ENV":"production","AUTENTICA":"https://autentica-single.portalssp.com/api","CADASTRO_USUARIO":"https://cadastro.oi.portalssp.com","RECUPERAR_SENHA":"https://cadastro.oi.portalssp.com/reset","STORAGE":"https://storage.portalssp.com/api/v1","FINANCEIRO":__webpack_require__.i({"SLA":"https://financeiro.sla.portalssp.com/api","NOTIFICACAO":"https://financeiro.notificacoes.portalssp.com/api","GLOSA":"https://financeiro.glosa.portalssp.com/api/v1"}),"ADMINISTRATIVO":"undefined"}),
      planilha: []
    };
  },

  methods: {
    abrirModal: function abrirModal() {
      this.$store.commit('setPlanilhasChamados', { show: true });
    },

    downloadAnexo: function downloadAnexo(bienio) {
      var grupo = '';
      if (localStorage.getItem('sessaoUsuario')) {
        var sessaoUsuario = JSON.parse(localStorage.getItem('sessaoUsuario'));
        grupo = sessaoUsuario.grupo.nome;
      } else {
        vm.$store.commit('setAlert', { msg: 'Ocorreu um erro ao recuperar as definições de segurança. Se persistir favor avisar ao Suporte SSP.', status: false, show: true });
        return;
      }
      var vm = this;
      var dados = '';
      if (grupo === 'adminVTAL') {
        dados = {
          'dirBucket': 'aplicacao-ssp-planilhas-desenvolvimento',
          'nomeArquivo': 'predial-adm/vtal/chamados-adm.csv'
        };
      } else {
        dados = {
          'dirBucket': 'aplicacao-ssp-planilhas-desenvolvimento',
          'nomeArquivo': 'predial-adm/chamados-' + bienio + '-adm.csv'
        };
      }
      this.$axios.post(this.env.FINANCEIRO.SLA + '/getPlanilhasExternas', dados, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token
        }
      }).then(function (response) {
        if (response.data.mensagem) {
          vm.$store.commit('setAlert', { msg: response.data.mensagem, status: false, show: true });
          return;
        }
        window.open(response.data.url, '_blank');
      });
    }
  }
});

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      env: __webpack_require__.i({"NODE_ENV":"production","AUTENTICA":"https://autentica-single.portalssp.com/api","CADASTRO_USUARIO":"https://cadastro.oi.portalssp.com","RECUPERAR_SENHA":"https://cadastro.oi.portalssp.com/reset","STORAGE":"https://storage.portalssp.com/api/v1","FINANCEIRO":__webpack_require__.i({"SLA":"https://financeiro.sla.portalssp.com/api","NOTIFICACAO":"https://financeiro.notificacoes.portalssp.com/api","GLOSA":"https://financeiro.glosa.portalssp.com/api/v1"}),"ADMINISTRATIVO":"undefined"}),
      planilha: []
    };
  },

  methods: {
    downloadAnexo: function downloadAnexo() {
      var grupo = '';
      if (localStorage.getItem('sessaoUsuario')) {
        var sessaoUsuario = JSON.parse(localStorage.getItem('sessaoUsuario'));
        grupo = sessaoUsuario.grupo.nome;
      } else {
        vm.$store.commit('setAlert', { msg: 'Ocorreu um erro ao recuperar as definições de segurança. Se persistir favor avisar ao Suporte SSP.', status: false, show: true });
        return;
      }
      var vm = this;
      var dados = '';
      if (grupo === 'adminVTAL') {
        dados = {
          'dirBucket': 'aplicacao-ssp-planilhas-desenvolvimento',
          'nomeArquivo': 'predial-adm/vtal/chamados-adm-deaverage.csv'
        };
      } else {
        dados = {
          'dirBucket': 'aplicacao-ssp-planilhas-desenvolvimento',
          'nomeArquivo': 'predial-adm/chamados-adm-deaverage.csv'
        };
      }
      this.$axios.post(this.env.FINANCEIRO.SLA + '/getPlanilhasExternas', dados, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token
        }
      }).then(function (response) {
        if (response.data.mensagem) {
          vm.$store.commit('setAlert', { msg: response.data.mensagem, status: false, show: true });
          return;
        }
        window.open(response.data.url, '_blank');
      });
    }
  }
});

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_excel_xlsx__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);




__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_0_vue_excel_xlsx__["a" /* default */]);

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      env: __webpack_require__.i({"NODE_ENV":"production","AUTENTICA":"https://autentica-single.portalssp.com/api","CADASTRO_USUARIO":"https://cadastro.oi.portalssp.com","RECUPERAR_SENHA":"https://cadastro.oi.portalssp.com/reset","STORAGE":"https://storage.portalssp.com/api/v1","FINANCEIRO":__webpack_require__.i({"SLA":"https://financeiro.sla.portalssp.com/api","NOTIFICACAO":"https://financeiro.notificacoes.portalssp.com/api","GLOSA":"https://financeiro.glosa.portalssp.com/api/v1"}),"ADMINISTRATIVO":"undefined"}),
      franquias: [],
      controlerBtnSubmit: false,

      columns: [{
        label: "N° Preventiva",
        field: "preventiva_id"
      }, {
        label: "UF",
        field: "uf"
      }, {
        label: "Gram",
        field: "gram"
      }, {
        label: "Gram Atendimento",
        field: "gram_atendimento"
      }, {
        label: "Sigla",
        field: "sigla"
      }, {
        label: "Sigla Op.",
        field: "sigla_operacao"
      }, {
        label: "Código Imóvel",
        field: "codigo_imovel"
      }, {
        label: "Tipo de Imóvel",
        field: "tipo_imovel_contrato"
      }, {
        label: "Qtd de Extintores",
        field: "quantidade"
      }, {
        label: "Tipo",
        field: "tipo"
      }, {
        label: "Tamanho",
        field: "tamanho"
      }, {
        label: "Descrição",
        field: "descricao"
      }, {
        label: "Data de Vencimento",
        field: "data_vencimento"
      }, {
        label: "Data Programada",
        field: "data_programada"
      }, {
        label: "Data de Execução",
        field: "data_execucao"
      }, {
        label: "Atualizado em",
        field: "atualizado_em"
      }]
    };
  },

  mounted: function mounted() {
    this.planilhaExtintores();
  },
  methods: {
    planilhaExtintores: function planilhaExtintores() {
      var vm = this;

      this.$axios.get(this.env.FINANCEIRO.SLA + "/getExtintores", {
        headers: {
          Authorization: "Bearer " + this.$store.state.login.loginUsuario.token
        }
      }).then(function (response) {
        vm.extintores = vm.formatarDados(response.data);
        vm.data = vm.extintores;
        vm.controlerBtnSubmit = true;
      });
    },
    priceFormat: function priceFormat(value) {
      return "R$ " + value;
    },
    formatarDados: function formatarDados(dados) {
      var _this = this;

      dados.forEach(function (element) {
        element.data_vencimento = _this.formataDataBrasil(element.data_vencimento);
        element.data_execucao = _this.formataDataBrasil(element.data_execucao);
        element.data_programada = _this.formataDataBrasil(element.data_programada);
        element.atualizado_em = _this.formataDataHoraBrasil(element.atualizado_em);
      });
      return dados;
    },

    formataDataBrasil: function formataDataBrasil(dataForm) {
      if (dataForm !== "" && dataForm !== undefined && dataForm !== null) {
        var dataHoraAntigaSeparada = dataForm.split(" ");
        var dataSeparada = dataHoraAntigaSeparada[0].split("-");
        return dataSeparada[2] + "/" + dataSeparada[1] + "/" + dataSeparada[0];
      }
      return dataForm;
    },
    formataDataHoraBrasil: function formataDataHoraBrasil(dataForm) {
      if (dataForm !== "" && dataForm !== undefined && dataForm !== null) {
        var dataHoraAntigaSeparada = dataForm.split(" ");
        var dataSeparada = dataHoraAntigaSeparada[0].split("-");
        return dataSeparada[2] + "/" + dataSeparada[1] + "/" + dataSeparada[0] + " " + dataHoraAntigaSeparada[1];
      }
      return dataForm;
    }
  }
});

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal_PeriodoFranquias_vue__ = __webpack_require__(898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal_PeriodoFranquias_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__modal_PeriodoFranquias_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'modal-periodo-franquias': __WEBPACK_IMPORTED_MODULE_0__modal_PeriodoFranquias_vue___default.a
  },
  data: function data() {
    return {
      env: __webpack_require__.i({"NODE_ENV":"production","AUTENTICA":"https://autentica-single.portalssp.com/api","CADASTRO_USUARIO":"https://cadastro.oi.portalssp.com","RECUPERAR_SENHA":"https://cadastro.oi.portalssp.com/reset","STORAGE":"https://storage.portalssp.com/api/v1","FINANCEIRO":__webpack_require__.i({"SLA":"https://financeiro.sla.portalssp.com/api","NOTIFICACAO":"https://financeiro.notificacoes.portalssp.com/api","GLOSA":"https://financeiro.glosa.portalssp.com/api/v1"}),"ADMINISTRATIVO":"undefined"}),
      controlerBtnSubmit: true
    };
  },

  methods: {
    planilhaFranquia: function planilhaFranquia() {
      var vm = this;
      vm.controlerBtnSubmit = false;
      vm.$axios.get(vm.env.FINANCEIRO.SLA + '/export-franquia', {
        headers: {
          Authorization: 'Bearer ' + vm.$store.state.login.loginUsuario.token
        },
        responseType: 'arraybuffer' }).then(function (response) {
        var blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });

        var url = window.URL.createObjectURL(blob);
        var link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "franquias.xlsx");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        vm.controlerBtnSubmit = true;
      }).finally(function () {
        vm.controlerBtnSubmit = true;
      });
    }
  }
});

/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_excel_xlsx__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);





__WEBPACK_IMPORTED_MODULE_2_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vue_excel_xlsx__["a" /* default */]);

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      env: __webpack_require__.i({"NODE_ENV":"production","AUTENTICA":"https://autentica-single.portalssp.com/api","CADASTRO_USUARIO":"https://cadastro.oi.portalssp.com","RECUPERAR_SENHA":"https://cadastro.oi.portalssp.com/reset","STORAGE":"https://storage.portalssp.com/api/v1","FINANCEIRO":__webpack_require__.i({"SLA":"https://financeiro.sla.portalssp.com/api","NOTIFICACAO":"https://financeiro.notificacoes.portalssp.com/api","GLOSA":"https://financeiro.glosa.portalssp.com/api/v1"}),"ADMINISTRATIVO":"undefined"}),
      franquias: [],
      controlerBtnSubmit: false,

      columns: [{
        label: "Número franquia",
        field: "id"
      }, {
        label: "Status",
        field: "status"
      }, {
        label: "Nome Solicitante",
        field: "usuario_nome"
      }, {
        label: "Email Solicitante",
        field: "usuario_email"
      }, {
        label: "Regional",
        field: "regional"
      }, {
        label: "Estado",
        field: "uf"
      }, {
        label: "Sigla",
        field: "sigla"
      }, {
        label: "Sigla Operações",
        field: "sigla_operacao"
      }, {
        label: "Endereço",
        field: "endereco"
      }, {
        label: "Código do Imóvel",
        field: "codigo_imovel"
      }, {
        label: "Serviço",
        field: "servico"
      }, {
        label: "Fornecedor",
        field: "fornecedor"
      }, {
        label: "Custo",
        field: "custo"
      }, {
        label: "Proprietário",
        field: "proprietario"
      }, {
        label: "Mês",
        field: "mes"
      }, {
        label: "Ano",
        field: "ano"
      }, {
        label: "Data de Execução",
        field: "data_execucao"
      }, {
        label: "Data de Criação",
        field: "data"
      }]
    };
  },

  watch: {},
  mounted: function mounted() {
    this.planilhaFranquia();
  },
  methods: {
    planilhaFranquia: function planilhaFranquia() {
      var vm = this;

      this.$axios.get(this.env.FINANCEIRO.SLA + "/getFranquias", {
        headers: {
          Authorization: "Bearer " + this.$store.state.login.loginUsuario.token
        }
      }).then(function (response) {
        vm.franquias = response.data;
        vm.data = response.data;
        vm.formatarDados();
        vm.controlerBtnSubmit = true;
      });
    },
    priceFormat: function priceFormat(value) {
      return "R$ " + value;
    },
    formatarDados: function formatarDados() {
      var _this = this;

      this.franquias.sort(function (a, b) {
        return a.id - b.id;
      });
      this.data = [];
      this.data = this.franquias.map(function (franquia) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, franquia, {
          data_execucao: franquia.data_execucao == null ? "" : _this.formataDataBrasil(franquia.data_execucao),
          data: franquia.data == null ? "" : _this.formataDataBrasil(franquia.data),

          mes: _this.formataMesPorExtenso(franquia.mes)
        });
      });
    },

    moeda: function moeda(val) {
      if (val !== "" && val !== null) {
        var val2 = val.toLocaleString("pt-br", { style: "currency", currency: "BRL" });
        val2 = val2.replace(".", ",");
        return val2;
      } else {
        return val;
      }
    },
    formataDataBrasil: function formataDataBrasil(dataForm) {
      if (dataForm !== "" && dataForm !== undefined && dataForm !== null) {
        var dataHoraAntigaSeparada = dataForm.split(" ");
        var dataSeparada = dataHoraAntigaSeparada[0].split("-");
        return dataSeparada[2] + "/" + dataSeparada[1] + "/" + dataSeparada[0];
      }
      return dataForm;
    },
    formataMesPorExtenso: function formataMesPorExtenso(mes) {
      var mesesAno = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];
      return "" + mesesAno[mes - 1];
    }
  }
});

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_excel_xlsx__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);





__WEBPACK_IMPORTED_MODULE_2_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vue_excel_xlsx__["a" /* default */]);

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      env: __webpack_require__.i({"NODE_ENV":"production","AUTENTICA":"https://autentica-single.portalssp.com/api","CADASTRO_USUARIO":"https://cadastro.oi.portalssp.com","RECUPERAR_SENHA":"https://cadastro.oi.portalssp.com/reset","STORAGE":"https://storage.portalssp.com/api/v1","FINANCEIRO":__webpack_require__.i({"SLA":"https://financeiro.sla.portalssp.com/api","NOTIFICACAO":"https://financeiro.notificacoes.portalssp.com/api","GLOSA":"https://financeiro.glosa.portalssp.com/api/v1"}),"ADMINISTRATIVO":"undefined"}),
      franquias: [],
      controlerBtnSubmit: false,

      columns: [{
        label: 'franquia_id',
        field: 'franquia_id'
      }, {
        label: 'dt_criacao_franquia',
        field: 'dt_criacao_franquia'
      }, {
        label: 'franquia_status',
        field: 'franquia_status'
      }, {
        label: 'chamado_id',
        field: 'chamado_id'
      }, {
        label: 'chamado_status',
        field: 'chamado_status'
      }, {
        label: 'dt_criacao_chamado',
        field: 'dt_criacao_chamado'
      }, {
        label: 'uf',
        field: 'uf'
      }, {
        label: 'sigla',
        field: 'sigla'
      }]
    };
  },

  watch: {},
  mounted: function mounted() {
    this.planilhaFranquia();
  },
  methods: {
    planilhaFranquia: function planilhaFranquia() {
      var vm = this;

      this.$axios.get(this.env.FINANCEIRO.SLA + '/getFranquiasChamados', {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token
        }
      }).then(function (response) {
        vm.franquias = response.data;
        vm.data = response.data;
        vm.formatarDados();
        vm.controlerBtnSubmit = true;
      });
    },
    priceFormat: function priceFormat(value) {
      return 'R$ ' + value;
    },
    formatarDados: function formatarDados() {
      this.data = [];
      this.data = this.franquias.map(function (franquia) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, franquia);
      });
    },

    moeda: function moeda(val) {
      if (val !== '' && val !== null) {
        var val2 = val.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
        val2 = val2.replace('.', ',');
        return val2;
      } else {
        return val;
      }
    },
    formataDataBrasil: function formataDataBrasil(dataForm) {
      if (dataForm !== '' && dataForm !== undefined && dataForm !== null) {
        var dataHoraAntigaSeparada = dataForm.split(' ');
        var dataSeparada = dataHoraAntigaSeparada[0].split('-');
        return dataSeparada[2] + '/' + dataSeparada[1] + '/' + dataSeparada[0];
      }
      return dataForm;
    },
    formataMesPorExtenso: function formataMesPorExtenso(mes) {
      var mesesAno = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
      return '' + mesesAno[mes - 1];
    }
  }
});

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      env: __webpack_require__.i({"NODE_ENV":"production","AUTENTICA":"https://autentica-single.portalssp.com/api","CADASTRO_USUARIO":"https://cadastro.oi.portalssp.com","RECUPERAR_SENHA":"https://cadastro.oi.portalssp.com/reset","STORAGE":"https://storage.portalssp.com/api/v1","FINANCEIRO":__webpack_require__.i({"SLA":"https://financeiro.sla.portalssp.com/api","NOTIFICACAO":"https://financeiro.notificacoes.portalssp.com/api","GLOSA":"https://financeiro.glosa.portalssp.com/api/v1"}),"ADMINISTRATIVO":"undefined"}),
      planilha: []
    };
  },

  methods: {
    downloadAnexo: function downloadAnexo() {
      var grupo = '';
      if (localStorage.getItem('sessaoUsuario')) {
        var sessaoUsuario = JSON.parse(localStorage.getItem('sessaoUsuario'));
        grupo = sessaoUsuario.grupo.nome;
      } else {
        vm.$store.commit('setAlert', { msg: 'Ocorreu um erro ao recuperar as definições de segurança. Se persistir favor avisar ao Suporte SSP.', status: false, show: true });
        return;
      }
      var vm = this;
      var dados = '';
      if (grupo === 'adminVTAL') {
        dados = {
          'dirBucket': 'aplicacao-ssp-planilhas-desenvolvimento',
          'nomeArquivo': 'predial-adm/vtal/historico-chamados-adm.csv'
        };
      } else {
        dados = {
          'dirBucket': 'aplicacao-ssp-planilhas-desenvolvimento',
          'nomeArquivo': 'predial-adm/historico-chamados-adm.csv'
        };
      }
      this.$axios.post(this.env.FINANCEIRO.SLA + '/getPlanilhasExternas', dados, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token
        }
      }).then(function (response) {
        if (response.data.mensagem) {
          vm.$store.commit('setAlert', { msg: response.data.mensagem, status: false, show: true });
          return;
        }
        window.open(response.data.url, '_blank');
      });
    }
  }
});

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal_FechamentoFixoVariavel_vue__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal_FechamentoFixoVariavel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__modal_FechamentoFixoVariavel_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      env: __webpack_require__.i({"NODE_ENV":"production","AUTENTICA":"https://autentica-single.portalssp.com/api","CADASTRO_USUARIO":"https://cadastro.oi.portalssp.com","RECUPERAR_SENHA":"https://cadastro.oi.portalssp.com/reset","STORAGE":"https://storage.portalssp.com/api/v1","FINANCEIRO":__webpack_require__.i({"SLA":"https://financeiro.sla.portalssp.com/api","NOTIFICACAO":"https://financeiro.notificacoes.portalssp.com/api","GLOSA":"https://financeiro.glosa.portalssp.com/api/v1"}),"ADMINISTRATIVO":"undefined"}),
      controlerBtnSubmit: false
    };
  },

  components: {
    'modal-fechamento-fixo-variavel': __WEBPACK_IMPORTED_MODULE_0__modal_FechamentoFixoVariavel_vue___default.a
  },
  mounted: function mounted() {},
  methods: {
    abrirModal: function abrirModal() {
      this.$store.commit('setModalFechamentoFixoVariavel', { show: true });
    },
    downloadAnexo: function downloadAnexo(mesAno) {
      var _this = this;

      this.controlerBtnSubmit = true;
      var vm = this;
      var payload = {
        estado: this.$store.state.login.loginUsuario.estado
      };
      this.$axios.post(this.env.FINANCEIRO.SLA + '/getNegociacoesFranquias', payload, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token
        }
      }).then(function (response) {
        if (response.status === 200 || response.status === 201) {
          var arquivoDownload = response.data.arquivo_download;

          window.location.href = vm.env.FINANCEIRO.SLA.slice(0, -3) + 'download-arquivo-xlsx/' + arquivoDownload;

          setTimeout(function () {
            vm.controlerBtnSubmit = false;
          }, 10000);
        } else {
          vm.$store.commit('setAlert', { msg: response.data.erro, status: false, show: true });
          vm.controlerBtnSubmit = false;
        }
      }).catch(function () {
        _this.controlerBtnSubmit = false;
      });
      console.log(payload);
    }
  }
});

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal_PlanilhasPreventivas_vue__ = __webpack_require__(900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal_PlanilhasPreventivas_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__modal_PlanilhasPreventivas_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'modal-planilhas-preventivas': __WEBPACK_IMPORTED_MODULE_0__modal_PlanilhasPreventivas_vue___default.a
  },
  data: function data() {
    return {
      env: __webpack_require__.i({"NODE_ENV":"production","AUTENTICA":"https://autentica-single.portalssp.com/api","CADASTRO_USUARIO":"https://cadastro.oi.portalssp.com","RECUPERAR_SENHA":"https://cadastro.oi.portalssp.com/reset","STORAGE":"https://storage.portalssp.com/api/v1","FINANCEIRO":__webpack_require__.i({"SLA":"https://financeiro.sla.portalssp.com/api","NOTIFICACAO":"https://financeiro.notificacoes.portalssp.com/api","GLOSA":"https://financeiro.glosa.portalssp.com/api/v1"}),"ADMINISTRATIVO":"undefined"}),
      planilha: []
    };
  },

  methods: {
    abrirModal: function abrirModal() {
      this.$store.commit('setPlanilhasPreventivas', { show: true });
    },

    downloadAnexo: function downloadAnexo(bienio) {
      var grupo = '';
      if (localStorage.getItem('sessaoUsuario')) {
        var sessaoUsuario = JSON.parse(localStorage.getItem('sessaoUsuario'));
        grupo = sessaoUsuario.grupo.nome;
      } else {
        vm.$store.commit('setAlert', { msg: 'Ocorreu um erro ao recuperar as definições de segurança. Se persistir favor avisar ao Suporte SSP.', status: false, show: true });
        return;
      }
      var vm = this;
      var dados = '';
      if (grupo === 'adminVTAL') {
        dados = {
          'dirBucket': 'aplicacao-ssp-planilhas-desenvolvimento',
          'nomeArquivo': 'predial-adm/vtal/preventivas-adm.csv'
        };
      } else {
        dados = {
          'dirBucket': 'aplicacao-ssp-planilhas-desenvolvimento',
          'nomeArquivo': 'predial-adm/preventivas-' + bienio + '-adm.csv'
        };
      }

      this.$axios.post(this.env.FINANCEIRO.SLA + '/getPlanilhasExternas', dados, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token
        }
      }).then(function (response) {
        if (response.data.mensagem) {
          vm.$store.commit('setAlert', { msg: response.data.mensagem, status: false, show: true });
          return;
        }
        window.open(response.data.url, '_blank');
      });
    }
  }
});

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal_FechamentoFixoVariavel_vue__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal_FechamentoFixoVariavel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__modal_FechamentoFixoVariavel_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      env: __webpack_require__.i({"NODE_ENV":"production","AUTENTICA":"https://autentica-single.portalssp.com/api","CADASTRO_USUARIO":"https://cadastro.oi.portalssp.com","RECUPERAR_SENHA":"https://cadastro.oi.portalssp.com/reset","STORAGE":"https://storage.portalssp.com/api/v1","FINANCEIRO":__webpack_require__.i({"SLA":"https://financeiro.sla.portalssp.com/api","NOTIFICACAO":"https://financeiro.notificacoes.portalssp.com/api","GLOSA":"https://financeiro.glosa.portalssp.com/api/v1"}),"ADMINISTRATIVO":"undefined"}),
      controlerBtnSubmit: false
    };
  },

  components: {
    'modal-fechamento-fixo-variavel': __WEBPACK_IMPORTED_MODULE_0__modal_FechamentoFixoVariavel_vue___default.a
  },
  mounted: function mounted() {},
  methods: {
    abrirModal: function abrirModal() {
      this.$store.commit('setModalFechamentoFixoVariavel', { show: true });
    },
    downloadAnexo: function downloadAnexo(mesAno) {
      var _this = this;

      this.controlerBtnSubmit = true;
      var vm = this;
      var payload = {
        estado: this.$store.state.login.loginUsuario.estado
      };
      this.$axios.post(this.env.FINANCEIRO.SLA + '/getRelatorioSemanalFranquias', payload, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token
        }
      }).then(function (response) {
        if (response.status === 200 || response.status === 201) {
          var arquivoDownload = response.data.arquivo_download;

          window.location.href = vm.env.FINANCEIRO.SLA.slice(0, -3) + 'download-arquivo-xlsx/' + arquivoDownload;

          setTimeout(function () {
            vm.controlerBtnSubmit = false;
          }, 10000);
        } else {
          vm.$store.commit('setAlert', { msg: response.data.erro, status: false, show: true });
          vm.controlerBtnSubmit = false;
        }
      }).catch(function () {
        _this.controlerBtnSubmit = false;
      });
      console.log(payload);
    }
  }
});

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal_FechamentoFixoVariavel_vue__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal_FechamentoFixoVariavel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__modal_FechamentoFixoVariavel_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      env: __webpack_require__.i({"NODE_ENV":"production","AUTENTICA":"https://autentica-single.portalssp.com/api","CADASTRO_USUARIO":"https://cadastro.oi.portalssp.com","RECUPERAR_SENHA":"https://cadastro.oi.portalssp.com/reset","STORAGE":"https://storage.portalssp.com/api/v1","FINANCEIRO":__webpack_require__.i({"SLA":"https://financeiro.sla.portalssp.com/api","NOTIFICACAO":"https://financeiro.notificacoes.portalssp.com/api","GLOSA":"https://financeiro.glosa.portalssp.com/api/v1"}),"ADMINISTRATIVO":"undefined"}),
      controlerBtnSubmit: false
    };
  },

  components: {
    'modal-fechamento-fixo-variavel': __WEBPACK_IMPORTED_MODULE_0__modal_FechamentoFixoVariavel_vue___default.a
  },
  mounted: function mounted() {},
  methods: {
    abrirModal: function abrirModal() {
      this.$store.commit('setModalFechamentoFixoVariavel', { show: true });
    },
    downloadAnexo: function downloadAnexo(mesAno) {
      var _this = this;

      this.controlerBtnSubmit = true;
      var vm = this;
      var payload = {
        estado: this.$store.state.login.loginUsuario.estado
      };
      this.$axios.post(this.env.FINANCEIRO.SLA + '/getRelatorioSemanalPreventivas', payload, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token
        }
      }).then(function (response) {
        if (response.status === 200 || response.status === 201) {
          var arquivoDownload = response.data.arquivo_download;

          window.location.href = vm.env.FINANCEIRO.SLA.slice(0, -3) + 'download-arquivo-xlsx/' + arquivoDownload;

          setTimeout(function () {
            vm.controlerBtnSubmit = false;
          }, 10000);
        } else {
          vm.$store.commit('setAlert', { msg: response.data.erro, status: false, show: true });
          vm.controlerBtnSubmit = false;
        }
      }).catch(function () {
        _this.controlerBtnSubmit = false;
      });
      console.log(payload);
    }
  }
});

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      env: __webpack_require__.i({"NODE_ENV":"production","AUTENTICA":"https://autentica-single.portalssp.com/api","CADASTRO_USUARIO":"https://cadastro.oi.portalssp.com","RECUPERAR_SENHA":"https://cadastro.oi.portalssp.com/reset","STORAGE":"https://storage.portalssp.com/api/v1","FINANCEIRO":__webpack_require__.i({"SLA":"https://financeiro.sla.portalssp.com/api","NOTIFICACAO":"https://financeiro.notificacoes.portalssp.com/api","GLOSA":"https://financeiro.glosa.portalssp.com/api/v1"}),"ADMINISTRATIVO":"undefined"}),
      planilha: []
    };
  },

  methods: {
    downloadAnexo: function downloadAnexo() {
      var grupo = '';
      if (localStorage.getItem('sessaoUsuario')) {
        var sessaoUsuario = JSON.parse(localStorage.getItem('sessaoUsuario'));
        grupo = sessaoUsuario.grupo.nome;
      } else {
        vm.$store.commit('setAlert', { msg: 'Ocorreu um erro ao recuperar as definições de segurança. Se persistir favor avisar ao Suporte SSP.', status: false, show: true });
        return;
      }
      var vm = this;
      var dados = '';
      if (grupo === 'adminVTAL') {
        dados = {
          'dirBucket': 'aplicacao-ssp-planilhas-desenvolvimento',
          'nomeArquivo': 'predial-operacional/grupo1/vtal/chamados.csv'
        };
      } else {
        dados = {
          'dirBucket': 'aplicacao-ssp-planilhas-desenvolvimento',
          'nomeArquivo': 'predial-operacional/grupo1/chamados.csv'
        };
      }
      this.$axios.post(this.env.FINANCEIRO.SLA + '/getPlanilhasExternas', dados, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token
        }
      }).then(function (response) {
        if (response.data.mensagem) {
          vm.$store.commit('setAlert', { msg: response.data.mensagem, status: false, show: true });
          return;
        }
        window.open(response.data.url, '_blank');
      });
    }
  }
});

/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      env: __webpack_require__.i({"NODE_ENV":"production","AUTENTICA":"https://autentica-single.portalssp.com/api","CADASTRO_USUARIO":"https://cadastro.oi.portalssp.com","RECUPERAR_SENHA":"https://cadastro.oi.portalssp.com/reset","STORAGE":"https://storage.portalssp.com/api/v1","FINANCEIRO":__webpack_require__.i({"SLA":"https://financeiro.sla.portalssp.com/api","NOTIFICACAO":"https://financeiro.notificacoes.portalssp.com/api","GLOSA":"https://financeiro.glosa.portalssp.com/api/v1"}),"ADMINISTRATIVO":"undefined"}),
      planilha: []
    };
  },

  methods: {
    downloadAnexo: function downloadAnexo() {
      var grupo = '';
      if (localStorage.getItem('sessaoUsuario')) {
        var sessaoUsuario = JSON.parse(localStorage.getItem('sessaoUsuario'));
        grupo = sessaoUsuario.grupo.nome;
      } else {
        vm.$store.commit('setAlert', { msg: 'Ocorreu um erro ao recuperar as definições de segurança. Se persistir favor avisar ao Suporte SSP.', status: false, show: true });
        return;
      }
      var vm = this;
      var dados = '';
      if (grupo === 'adminVTAL') {
        dados = {
          'dirBucket': 'aplicacao-ssp-planilhas-desenvolvimento',
          'nomeArquivo': 'predial-operacional/grupo1/vtal/log-preventivas.csv'
        };
      } else {
        dados = {
          'dirBucket': 'aplicacao-ssp-planilhas-desenvolvimento',
          'nomeArquivo': 'predial-operacional/grupo1/log-preventivas.csv'
        };
      }
      this.$axios.post(this.env.FINANCEIRO.SLA + '/getPlanilhasExternas', dados, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token
        }
      }).then(function (response) {
        if (response.data.mensagem) {
          vm.$store.commit('setAlert', { msg: response.data.mensagem, status: false, show: true });
          return;
        }
        window.open(response.data.url, '_blank');
      });
    }
  }
});

/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      env: __webpack_require__.i({"NODE_ENV":"production","AUTENTICA":"https://autentica-single.portalssp.com/api","CADASTRO_USUARIO":"https://cadastro.oi.portalssp.com","RECUPERAR_SENHA":"https://cadastro.oi.portalssp.com/reset","STORAGE":"https://storage.portalssp.com/api/v1","FINANCEIRO":__webpack_require__.i({"SLA":"https://financeiro.sla.portalssp.com/api","NOTIFICACAO":"https://financeiro.notificacoes.portalssp.com/api","GLOSA":"https://financeiro.glosa.portalssp.com/api/v1"}),"ADMINISTRATIVO":"undefined"}),
      planilha: []
    };
  },

  methods: {
    downloadAnexo: function downloadAnexo() {
      var grupo = '';
      if (localStorage.getItem('sessaoUsuario')) {
        var sessaoUsuario = JSON.parse(localStorage.getItem('sessaoUsuario'));
        grupo = sessaoUsuario.grupo.nome;
      } else {
        vm.$store.commit('setAlert', { msg: 'Ocorreu um erro ao recuperar as definições de segurança. Se persistir favor avisar ao Suporte SSP.', status: false, show: true });
        return;
      }
      var vm = this;
      var dados = '';
      if (grupo === 'adminVTAL') {
        dados = {
          'dirBucket': 'aplicacao-ssp-planilhas-desenvolvimento',
          'nomeArquivo': 'predial-operacional/grupo1/vtal/logApartirSetembro2019.csv'
        };
      } else {
        dados = {
          'dirBucket': 'aplicacao-ssp-planilhas-desenvolvimento',
          'nomeArquivo': 'predial-operacional/grupo1/logApartirSetembro2019.csv'
        };
      }
      this.$axios.post(this.env.FINANCEIRO.SLA + '/getPlanilhasExternas', dados, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token
        }
      }).then(function (response) {
        if (response.data.mensagem) {
          vm.$store.commit('setAlert', { msg: response.data.mensagem, status: false, show: true });
          return;
        }
        window.open(response.data.url, '_blank');
      });
    }
  }
});

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      env: __webpack_require__.i({"NODE_ENV":"production","AUTENTICA":"https://autentica-single.portalssp.com/api","CADASTRO_USUARIO":"https://cadastro.oi.portalssp.com","RECUPERAR_SENHA":"https://cadastro.oi.portalssp.com/reset","STORAGE":"https://storage.portalssp.com/api/v1","FINANCEIRO":__webpack_require__.i({"SLA":"https://financeiro.sla.portalssp.com/api","NOTIFICACAO":"https://financeiro.notificacoes.portalssp.com/api","GLOSA":"https://financeiro.glosa.portalssp.com/api/v1"}),"ADMINISTRATIVO":"undefined"}),
      planilha: []
    };
  },

  methods: {
    downloadAnexo: function downloadAnexo() {
      var grupo = '';
      if (localStorage.getItem('sessaoUsuario')) {
        var sessaoUsuario = JSON.parse(localStorage.getItem('sessaoUsuario'));
        grupo = sessaoUsuario.grupo.nome;
      } else {
        vm.$store.commit('setAlert', { msg: 'Ocorreu um erro ao recuperar as definições de segurança. Se persistir favor avisar ao Suporte SSP.', status: false, show: true });
        return;
      }
      var vm = this;
      var dados = '';
      if (grupo === 'adminVTAL') {
        dados = {
          'dirBucket': 'aplicacao-ssp-planilhas-desenvolvimento',
          'nomeArquivo': 'predial-operacional/grupo1/vtal/preventivas.csv'
        };
      } else {
        dados = {
          'dirBucket': 'aplicacao-ssp-planilhas-desenvolvimento',
          'nomeArquivo': 'predial-operacional/grupo1/preventivas.csv'
        };
      }
      this.$axios.post(this.env.FINANCEIRO.SLA + '/getPlanilhasExternas', dados, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token
        }
      }).then(function (response) {
        if (response.data.mensagem) {
          vm.$store.commit('setAlert', { msg: response.data.mensagem, status: false, show: true });
          return;
        }
        window.open(response.data.url, '_blank');
      });
    }
  }
});

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);




var _methods;



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ImportarPreventivas',

  data: function data() {
    return {
      env: __webpack_require__.i({"NODE_ENV":"production","AUTENTICA":"https://autentica-single.portalssp.com/api","CADASTRO_USUARIO":"https://cadastro.oi.portalssp.com","RECUPERAR_SENHA":"https://cadastro.oi.portalssp.com/reset","STORAGE":"https://storage.portalssp.com/api/v1","FINANCEIRO":__webpack_require__.i({"SLA":"https://financeiro.sla.portalssp.com/api","NOTIFICACAO":"https://financeiro.notificacoes.portalssp.com/api","GLOSA":"https://financeiro.glosa.portalssp.com/api/v1"}),"ADMINISTRATIVO":"undefined"}),
      carregando: false,
      erro: null,
      resultadoImportacao: null,
      statusDados: null,
      acaoEmProgresso: null,
      progresso: null,
      progressoActive: false,
      progressoTimeoutId: null,
      pendentesInfo: null
    };
  },


  computed: {
    progressoPercentual: function progressoPercentual() {
      if (!this.progresso || !this.progresso.total || this.progresso.total === 0) return 0;
      var pct = Math.floor(this.progresso.atual / this.progresso.total * 100);
      return pct > 100 ? 100 : pct;
    },
    isFabricio: function isFabricio() {
      try {
        var email = (this.$store.state.login.loginUsuario.usuario.email || '').toLowerCase();
        return email === 'fabricio.elias@portalssp.com';
      } catch (e) {
        return false;
      }
    }
  },

  created: function created() {
    if (!this.isFabricio) return;
    this.verificarStatus();
    this.carregarPendentes();
  },


  methods: (_methods = {
    exportarBaseSimulacao: function exportarBaseSimulacao() {
      var _this = this;

      this.acaoEmProgresso = 'export-base-simulacao';
      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        url: this.env.FINANCEIRO.SLA + '/export-base-simulacao',
        method: 'post',
        data: {},
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token
        }
      }).then(function (response) {
        _this.resultadoImportacao = response.data;
        var arquivo = response.data && response.data.arquivo_download;
        if (arquivo) {
          var urlDownload = _this.env.FINANCEIRO.SLA + '/download-arquivo-xlsx/' + arquivo;
          __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(urlDownload, {
            responseType: 'blob',
            headers: { 'Authorization': 'Bearer ' + _this.$store.state.login.loginUsuario.token }
          }).then(function (resp) {
            var blob = new Blob([resp.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            var link = document.createElement('a');
            var url = window.URL.createObjectURL(blob);
            link.href = url;

            var sugestao = response.data && response.data.arquivo_download || 'BaseESimulacao-' + new Date().toISOString().slice(0, 10) + '.xlsx';
            link.setAttribute('download', sugestao);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);
          }).catch(function (err) {
            window.open(urlDownload, '_blank');
          });
        }
        _this.carregando = false;
        _this.acaoEmProgresso = null;
      }).catch(function (error) {
        var mensagemErro = error.message;
        if (error.response && error.response.data && error.response.data.message) {
          mensagemErro = error.response.data.message;
        }
        _this.erro = 'Erro: ' + mensagemErro;
        _this.acaoEmProgresso = null;
      }).finally(function () {
        if (_this.acaoEmProgresso !== 'export-base-simulacao') {
          _this.carregando = false;
          _this.acaoEmProgresso = null;
        }
      });
    },
    atualizarQteProgramada: function atualizarQteProgramada() {
      var _this2 = this;

      this.acaoEmProgresso = 'atualizar-qte-programada';
      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        url: this.env.FINANCEIRO.SLA + '/simulacao-agregados/atualizar-qte-programada',
        method: 'post',
        headers: { 'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token }
      }).then(function (response) {
        _this2.resultadoImportacao = response.data;
      }).catch(function (error) {
        var mensagemErro = error.message;
        if (error.response && error.response.data && error.response.data.message) {
          mensagemErro = error.response.data.message;
        }
        _this2.erro = 'Erro: ' + mensagemErro;
      }).finally(function () {
        _this2.carregando = false;
        _this2.acaoEmProgresso = null;
      });
    },
    montarExportQteProgramada: function montarExportQteProgramada() {
      var _this3 = this;

      this.acaoEmProgresso = 'montar-export-qte-programada';
      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        url: this.env.FINANCEIRO.SLA + '/simulacao-export/montar-qte-programada',
        method: 'post',
        headers: { 'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token }
      }).then(function (response) {
        _this3.resultadoImportacao = response.data;
      }).catch(function (error) {
        var mensagemErro = error.message;
        if (error.response && error.response.data && error.response.data.message) {
          mensagemErro = error.response.data.message;
        }
        _this3.erro = 'Erro: ' + mensagemErro;
      }).finally(function () {
        _this3.carregando = false;_this3.acaoEmProgresso = null;
      });
    },
    montarExportQteProgramadaDeCache: function montarExportQteProgramadaDeCache() {
      var _this4 = this;

      this.acaoEmProgresso = 'montar-export-qte-programada-de-cache';
      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        url: this.env.FINANCEIRO.SLA + '/simulacao-export/montar-qte-programada-de-cache',
        method: 'post',
        headers: { 'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token }
      }).then(function (response) {
        _this4.resultadoImportacao = response.data;
      }).catch(function (error) {
        var mensagemErro = error.message;
        if (error.response && error.response.data && error.response.data.message) {
          mensagemErro = error.response.data.message;
        }
        _this4.erro = 'Erro: ' + mensagemErro;
      }).finally(function () {
        _this4.carregando = false;_this4.acaoEmProgresso = null;
      });
    },
    importarModeloQteProgramadaExtras: function importarModeloQteProgramadaExtras() {
      var _this5 = this;

      this.acaoEmProgresso = 'importar-modelo-qte-extras';
      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        url: this.env.FINANCEIRO.SLA + '/simulacao-export/importar-modelo-qte-programada-extras',
        method: 'post',
        headers: { 'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token }
      }).then(function (response) {
        _this5.resultadoImportacao = response.data;
      }).catch(function (error) {
        var mensagemErro = error.message;
        if (error.response && error.response.data && error.response.data.message) {
          mensagemErro = error.response.data.message;
        }
        _this5.erro = 'Erro: ' + mensagemErro;
      }).finally(function () {
        _this5.carregando = false;_this5.acaoEmProgresso = null;
      });
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'montarExportQteProgramadaDeCache', function montarExportQteProgramadaDeCache() {
    var _this6 = this;

    this.acaoEmProgresso = 'montar-export-qte-programada-de-cache';
    __WEBPACK_IMPORTED_MODULE_3_axios___default()({
      url: this.env.FINANCEIRO.SLA + '/simulacao-export/montar-qte-programada-de-cache',
      method: 'post',
      headers: { 'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token }
    }).then(function (response) {
      _this6.resultadoImportacao = response.data;
    }).catch(function (error) {
      var mensagemErro = error.message;
      if (error.response && error.response.data && error.response.data.message) {
        mensagemErro = error.response.data.message;
      }
      _this6.erro = 'Erro: ' + mensagemErro;
    }).finally(function () {
      _this6.carregando = false;_this6.acaoEmProgresso = null;
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'recalcularPeriodoQteProgramada', function recalcularPeriodoQteProgramada() {
    var _this7 = this;

    this.acaoEmProgresso = 'recalcular-periodo-qte-programada';
    __WEBPACK_IMPORTED_MODULE_3_axios___default()({
      url: this.env.FINANCEIRO.SLA + '/simulacao-agregados/recalcular-periodo-qte-programada',
      method: 'post',
      data: {},
      headers: { 'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token }
    }).then(function (response) {
      _this7.resultadoImportacao = response.data;
    }).catch(function (error) {
      var mensagemErro = error.message;
      if (error.response && error.response.data && error.response.data.message) {
        mensagemErro = error.response.data.message;
      }
      _this7.erro = 'Erro: ' + mensagemErro;
    }).finally(function () {
      _this7.carregando = false;_this7.acaoEmProgresso = null;
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'recalcularPeriodoQteEntregue', function recalcularPeriodoQteEntregue() {
    var _this8 = this;

    this.acaoEmProgresso = 'recalcular-periodo-qte-entregue';
    __WEBPACK_IMPORTED_MODULE_3_axios___default()({
      url: this.env.FINANCEIRO.SLA + '/simulacao-agregados/recalcular-periodo-qte-entregue',
      method: 'post',
      data: {},
      headers: { 'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token }
    }).then(function (response) {
      _this8.resultadoImportacao = response.data;
    }).catch(function (error) {
      var mensagemErro = error.message;
      if (error.response && error.response.data && error.response.data.message) {
        mensagemErro = error.response.data.message;
      }
      _this8.erro = 'Erro: ' + mensagemErro;
    }).finally(function () {
      _this8.carregando = false;_this8.acaoEmProgresso = null;
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'recalcularPeriodoQtesEntregues', function recalcularPeriodoQtesEntregues() {
    var _this9 = this;

    this.acaoEmProgresso = 'recalcular-periodo-qtes-entregues';
    __WEBPACK_IMPORTED_MODULE_3_axios___default()({
      url: this.env.FINANCEIRO.SLA + '/simulacao-agregados/recalcular-periodo-qtes-entregues',
      method: 'post',
      data: {},
      headers: { 'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token }
    }).then(function (response) {
      _this9.resultadoImportacao = response.data;
    }).catch(function (error) {
      var mensagemErro = error.message;
      if (error.response && error.response.data && error.response.data.message) {
        mensagemErro = error.response.data.message;
      }
      _this9.erro = 'Erro: ' + mensagemErro;
    }).finally(function () {
      _this9.carregando = false;_this9.acaoEmProgresso = null;
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'recalcularPeriodoSomaValoresEntregues', function recalcularPeriodoSomaValoresEntregues() {
    var _this10 = this;

    this.acaoEmProgresso = 'recalcular-periodo-soma-entregues';
    __WEBPACK_IMPORTED_MODULE_3_axios___default()({
      url: this.env.FINANCEIRO.SLA + '/simulacao-agregados/recalcular-periodo-soma-entregues',
      method: 'post',
      data: {},
      headers: { 'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token }
    }).then(function (response) {
      _this10.resultadoImportacao = response.data;
    }).catch(function (error) {
      var mensagemErro = error.message;
      if (error.response && error.response.data && error.response.data.message) {
        mensagemErro = error.response.data.message;
      }
      _this10.erro = 'Erro: ' + mensagemErro;
    }).finally(function () {
      _this10.carregando = false;_this10.acaoEmProgresso = null;
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'recalcularPeriodoSomaValoresNaoEntregues', function recalcularPeriodoSomaValoresNaoEntregues() {
    var _this11 = this;

    this.acaoEmProgresso = 'recalcular-periodo-soma-nao-entregues';
    __WEBPACK_IMPORTED_MODULE_3_axios___default()({
      url: this.env.FINANCEIRO.SLA + '/simulacao-agregados/recalcular-periodo-soma-nao-entregues',
      method: 'post',
      data: {},
      headers: { 'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token }
    }).then(function (response) {
      _this11.resultadoImportacao = response.data;
    }).catch(function (error) {
      var mensagemErro = error.message;
      if (error.response && error.response.data && error.response.data.message) {
        mensagemErro = error.response.data.message;
      }
      _this11.erro = 'Erro: ' + mensagemErro;
    }).finally(function () {
      _this11.carregando = false;_this11.acaoEmProgresso = null;
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'recalcularPeriodoSomaValoresEntreguesDispersos', function recalcularPeriodoSomaValoresEntreguesDispersos() {
    var _this12 = this;

    this.acaoEmProgresso = 'recalcular-periodo-soma-entregues-dispersos';
    __WEBPACK_IMPORTED_MODULE_3_axios___default()({
      url: this.env.FINANCEIRO.SLA + '/simulacao-agregados/recalcular-periodo-soma-entregues-dispersos',
      method: 'post',
      data: {},
      headers: { 'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token }
    }).then(function (response) {
      _this12.resultadoImportacao = response.data;
    }).catch(function (error) {
      var mensagemErro = error.message;
      if (error.response && error.response.data && error.response.data.message) {
        mensagemErro = error.response.data.message;
      }
      _this12.erro = 'Erro: ' + mensagemErro;
    }).finally(function () {
      _this12.carregando = false;_this12.acaoEmProgresso = null;
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'recalcularPeriodoSomaValoresNaoEntreguesDispersos', function recalcularPeriodoSomaValoresNaoEntreguesDispersos() {
    var _this13 = this;

    this.acaoEmProgresso = 'recalcular-periodo-soma-nao-entregues-dispersos';
    __WEBPACK_IMPORTED_MODULE_3_axios___default()({
      url: this.env.FINANCEIRO.SLA + '/simulacao-agregados/recalcular-periodo-soma-nao-entregues-dispersos',
      method: 'post',
      data: {},
      headers: { 'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token }
    }).then(function (response) {
      _this13.resultadoImportacao = response.data;
    }).catch(function (error) {
      var mensagemErro = error.message;
      if (error.response && error.response.data && error.response.data.message) {
        mensagemErro = error.response.data.message;
      }
      _this13.erro = 'Erro: ' + mensagemErro;
    }).finally(function () {
      _this13.carregando = false;_this13.acaoEmProgresso = null;
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'recalcularPeriodoTaxaEntrega', function recalcularPeriodoTaxaEntrega() {
    var _this14 = this;

    this.acaoEmProgresso = 'recalcular-periodo-taxa-entrega';
    __WEBPACK_IMPORTED_MODULE_3_axios___default()({
      url: this.env.FINANCEIRO.SLA + '/simulacao-agregados/recalcular-periodo-taxa-entrega',
      method: 'post',
      data: {},
      headers: { 'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token }
    }).then(function (response) {
      _this14.resultadoImportacao = response.data;
    }).catch(function (error) {
      var mensagemErro = error.message;
      if (error.response && error.response.data && error.response.data.message) {
        mensagemErro = error.response.data.message;
      }
      _this14.erro = 'Erro: ' + mensagemErro;
    }).finally(function () {
      _this14.carregando = false;_this14.acaoEmProgresso = null;
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'recalcularPeriodoQteNaoEntregue', function recalcularPeriodoQteNaoEntregue() {
    var _this15 = this;

    this.acaoEmProgresso = 'recalcular-periodo-qte-nao-entregue';
    __WEBPACK_IMPORTED_MODULE_3_axios___default()({
      url: this.env.FINANCEIRO.SLA + '/simulacao-agregados/recalcular-periodo-qte-nao-entregue',
      method: 'post',
      data: {},
      headers: { 'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token }
    }).then(function (response) {
      _this15.resultadoImportacao = response.data;
    }).catch(function (error) {
      var mensagemErro = error.message;
      if (error.response && error.response.data && error.response.data.message) {
        mensagemErro = error.response.data.message;
      }
      _this15.erro = 'Erro: ' + mensagemErro;
    }).finally(function () {
      _this15.carregando = false;_this15.acaoEmProgresso = null;
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'importarBase2425', function importarBase2425() {
    this.executarAcao('importar-base24-25', 'post');
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'ajustarValorFixoZero', function ajustarValorFixoZero() {
    var _this16 = this;

    this.acaoEmProgresso = 'ajustar-valor-fixo-zero';

    return __WEBPACK_IMPORTED_MODULE_3_axios___default()({
      url: this.env.FINANCEIRO.SLA + '/ajustar-valor-fixo-zero',
      method: 'post',
      headers: {
        'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token
      }
    }).then(function (response) {
      _this16.resultadoImportacao = response.data;
      _this16.carregando = false;
      _this16.acaoEmProgresso = null;
      _this16.verificarStatus();
    }).catch(function (error) {
      var mensagemErro = error.message;
      if (error.response && error.response.data && error.response.data.message) {
        mensagemErro = error.response.data.message;
      }
      _this16.erro = 'Erro: ' + mensagemErro;
      _this16.acaoEmProgresso = null;
    }).finally(function () {
      if (_this16.acaoEmProgresso !== 'ajustar-valor-fixo-zero') {
        _this16.carregando = false;
        _this16.acaoEmProgresso = null;
      }
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'calcularCamposDerivadosBase', function calcularCamposDerivadosBase() {
    var _this17 = this;

    this.acaoEmProgresso = 'calcular-campos-derivados-base24-25';

    return __WEBPACK_IMPORTED_MODULE_3_axios___default()({
      url: this.env.FINANCEIRO.SLA + '/calcular-campos-derivados-base24-25',
      method: 'post',
      headers: {
        'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token
      }
    }).then(function (response) {
      _this17.resultadoImportacao = response.data;
      _this17.carregando = false;
      _this17.acaoEmProgresso = null;
      _this17.verificarStatus();
    }).catch(function (error) {
      var mensagemErro = error.message;
      if (error.response && error.response.data && error.response.data.message) {
        mensagemErro = error.response.data.message;
      }
      _this17.erro = 'Erro: ' + mensagemErro;
      _this17.acaoEmProgresso = null;
    }).finally(function () {
      if (_this17.acaoEmProgresso !== 'calcular-campos-derivados-base24-25') {
        _this17.carregando = false;
        _this17.acaoEmProgresso = null;
      }
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'importarValores2025', function importarValores2025() {
    this.executarAcao('importar-valores-2025', 'post');
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'importarValoresFaturamento', function importarValoresFaturamento() {
    this.executarAcao('importar-valores-faturamento', 'post');
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'limparBase2425', function limparBase2425() {
    this.executarAcao('limpar-base24-25', 'delete');
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'limparValores2025', function limparValores2025() {
    this.executarAcao('limpar-valores-2025', 'delete');
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'limparValoresFaturamento', function limparValoresFaturamento() {
    this.executarAcao('limpar-valores-faturamento', 'delete');
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'iniciarPollingProgresso', function iniciarPollingProgresso() {
    this.pararPollingProgresso();
    this.progresso = { total: 0, atual: 0, status: 'running' };
    this.progressoActive = true;
    this.doProgressoPoll();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'pararPollingProgresso', function pararPollingProgresso() {
    this.progressoActive = false;
    if (this.progressoTimeoutId) {
      clearTimeout(this.progressoTimeoutId);
      this.progressoTimeoutId = null;
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'calcularBase2425', function calcularBase2425() {
    var _this18 = this;

    this.acaoEmProgresso = 'calcular-base24-25';

    __WEBPACK_IMPORTED_MODULE_3_axios___default()({
      url: this.env.FINANCEIRO.SLA + '/calcular-base24-25',
      method: 'post',
      headers: {
        'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token
      }
    }).then(function (response) {
      _this18.resultadoImportacao = response.data;
      _this18.carregando = false;
      _this18.acaoEmProgresso = null;
      _this18.verificarStatus();
    }).catch(function (error) {
      var mensagemErro = error.message;
      if (error.response && error.response.data && error.response.data.message) {
        mensagemErro = error.response.data.message;
      }
      _this18.erro = 'Erro: ' + mensagemErro;
      _this18.acaoEmProgresso = null;
    }).finally(function () {
      if (_this18.acaoEmProgresso !== 'calcular-base24-25') {
        _this18.carregando = false;
        _this18.acaoEmProgresso = null;
      }
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'calcularValorFixoMensal', function calcularValorFixoMensal() {
    var _this19 = this;

    this.acaoEmProgresso = 'calcular-valor-fixo-mensal';

    __WEBPACK_IMPORTED_MODULE_3_axios___default()({
      url: this.env.FINANCEIRO.SLA + '/calcular-valor-fixo-mensal',
      method: 'post',
      headers: {
        'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token
      }
    }).then(function (response) {
      _this19.resultadoImportacao = response.data;
      _this19.carregando = false;
      _this19.acaoEmProgresso = null;
      _this19.verificarStatus();
    }).catch(function (error) {
      var mensagemErro = error.message;
      if (error.response && error.response.data && error.response.data.message) {
        mensagemErro = error.response.data.message;
      }
      _this19.erro = 'Erro: ' + mensagemErro;
      _this19.acaoEmProgresso = null;
    }).finally(function () {
      if (_this19.acaoEmProgresso !== 'calcular-valor-fixo-mensal') {
        _this19.carregando = false;
        _this19.acaoEmProgresso = null;
      }
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'calcularValorFixoMensalRestante', function calcularValorFixoMensalRestante() {
    var _this20 = this;

    this.acaoEmProgresso = 'calcular-valor-fixo-mensal-restante';

    __WEBPACK_IMPORTED_MODULE_3_axios___default()({
      url: this.env.FINANCEIRO.SLA + '/calcular-valor-fixo-mensal-restante',
      method: 'post',
      headers: {
        'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token
      }
    }).then(function (response) {
      _this20.resultadoImportacao = response.data;
      _this20.carregando = false;
      _this20.acaoEmProgresso = null;
      _this20.verificarStatus();
    }).catch(function (error) {
      var mensagemErro = error.message;
      if (error.response && error.response.data && error.response.data.message) {
        mensagemErro = error.response.data.message;
      }
      _this20.erro = 'Erro: ' + mensagemErro;
      _this20.acaoEmProgresso = null;
    }).finally(function () {
      if (_this20.acaoEmProgresso !== 'calcular-valor-fixo-mensal-restante') {
        _this20.carregando = false;
        _this20.acaoEmProgresso = null;
      }
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'doProgressoPoll', function doProgressoPoll() {
    var _this21 = this;

    if (!this.progressoActive || this.acaoEmProgresso !== 'calcular-base24-25') return;
    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.env.FINANCEIRO.SLA + '/progresso-base24-25', {
      headers: { 'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token }
    }).then(function (resp) {
      if (resp.data && resp.data.success) {
        _this21.progresso = resp.data.progresso;
        if (_this21.progresso && _this21.progresso.status === 'running') {
          _this21.progressoTimeoutId = setTimeout(function () {
            return _this21.doProgressoPoll();
          }, 1500);
        } else {
          _this21.pararPollingProgresso();
          _this21.acaoEmProgresso = null;
        }
      }
    }).catch(function () {
      _this21.pararPollingProgresso();
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'executarAcao', function executarAcao(endpoint, method) {
    var _this22 = this;

    this.erro = null;
    this.resultadoImportacao = null;
    this.acaoEmProgresso = endpoint;

    if (endpoint !== 'calcular-base24-25') {
      this.carregando = true;
    } else {
      this.iniciarPollingProgresso();
    }

    __WEBPACK_IMPORTED_MODULE_3_axios___default()({
      url: this.env.FINANCEIRO.SLA + '/' + endpoint,
      method: method,
      headers: {
        'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token
      }
    }).then(function (response) {
      if (response.data.success) {
        _this22.resultadoImportacao = response.data;
        _this22.verificarStatus();
      } else {
        _this22.erro = response.data.message || 'Operação com falhas';
      }
    }).catch(function (error) {
      var mensagemErro = error.message;
      if (error.response && error.response.data && error.response.data.message) {
        mensagemErro = error.response.data.message;
      }
      _this22.erro = 'Erro: ' + mensagemErro;
    }).finally(function () {
      if (endpoint !== 'calcular-base24-25') {
        _this22.carregando = false;
        _this22.acaoEmProgresso = null;
      }
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'verificarStatus', function verificarStatus() {
    var _this23 = this;

    this.carregando = true;

    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.env.FINANCEIRO.SLA + '/status-importacao', {
      headers: {
        'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token
      }
    }).then(function (response) {
      if (response.data.success) {
        _this23.statusDados = response.data;
      }
      _this23.carregando = false;
    }).catch(function (error) {
      console.error('Erro ao verificar status:', error);
      _this23.carregando = false;
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'limparResultado', function limparResultado() {
    this.resultadoImportacao = null;
    this.verificarStatus();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'etapaCalcularValorFixoMensal', function etapaCalcularValorFixoMensal() {
    return this.calcularValorFixoMensal();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'etapaAjustarZero', function etapaAjustarZero() {
    return this.ajustarValorFixoZero();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'etapaCalcularDerivados', function etapaCalcularDerivados() {
    return this.calcularCamposDerivadosBase();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'carregarPendentes', function carregarPendentes() {
    var _this24 = this;

    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.env.FINANCEIRO.SLA + '/base2425/pendingCount', {
      headers: { 'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token }
    }).then(function (resp) {
      if (resp.data && resp.data.success) _this24.pendentesInfo = resp.data;
    }).catch(function () {});
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'executarEtapasPreExport', function executarEtapasPreExport() {
    var _this25 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _this25.etapaCalcularValorFixoMensal();

            case 3:
              _context.next = 5;
              return _this25.etapaAjustarZero();

            case 5:
              _context.next = 7;
              return _this25.etapaCalcularDerivados();

            case 7:
              _context.next = 9;
              return _this25.carregarPendentes();

            case 9:
              _context.next = 13;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context['catch'](0);

            case 13:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this25, [[0, 11]]);
    }))();
  }), _methods)
});

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SimulacaoGeral',

  data: function data() {
    return {
      env: __webpack_require__.i({"NODE_ENV":"production","AUTENTICA":"https://autentica-single.portalssp.com/api","CADASTRO_USUARIO":"https://cadastro.oi.portalssp.com","RECUPERAR_SENHA":"https://cadastro.oi.portalssp.com/reset","STORAGE":"https://storage.portalssp.com/api/v1","FINANCEIRO":__webpack_require__.i({"SLA":"https://financeiro.sla.portalssp.com/api","NOTIFICACAO":"https://financeiro.notificacoes.portalssp.com/api","GLOSA":"https://financeiro.glosa.portalssp.com/api/v1"}),"ADMINISTRATIVO":"undefined"}),
      dados: [],
      carregando: true,
      erro: null,
      meses: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
      fornecedores: [],
      ufs: [],
      filtroFornecedor: '',
      filtroUf: '',
      graficoInstance: null
    };
  },


  computed: {
    isFabricio: function isFabricio() {
      try {
        var email = (this.$store.state.login.loginUsuario.usuario.email || '').toLowerCase();
        return email === 'fabricio.elias@portalssp.com';
      } catch (e) {
        return false;
      }
    },
    dadosFiltrados: function dadosFiltrados() {
      var _this = this;

      var resultado = this.dados;

      if (this.filtroFornecedor) {
        resultado = resultado.filter(function (item) {
          return item.fornecedor === _this.filtroFornecedor;
        });
      }

      if (this.filtroUf) {
        resultado = resultado.filter(function (item) {
          return item.uf === _this.filtroUf;
        });
      }

      return resultado;
    }
  },

  created: function created() {
    if (!this.isFabricio) {
      this.carregando = false;
      this.erro = null;
      return;
    }
    this.carregarDados();
  },


  methods: {
    carregarDados: function carregarDados() {
      var _this2 = this;

      this.carregando = true;
      this.erro = null;

      var url = this.env.FINANCEIRO.SLA + '/simulacao-geral';
      var queryParams = [];

      if (this.filtroFornecedor) {
        queryParams.push('fornecedor=' + encodeURIComponent(this.filtroFornecedor));
      }

      if (this.filtroUf) {
        queryParams.push('uf=' + encodeURIComponent(this.filtroUf));
      }

      if (queryParams.length > 0) {
        url += '?' + queryParams.join('&');
      }

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url).then(function (response) {
        if (response.data.success) {
          _this2.dados = response.data.dados;
          _this2.fornecedores = response.data.fornecedores;
          _this2.ufs = response.data.ufs;

          _this2.$nextTick(function () {
            _this2.inicializarGrafico();
          });
        } else {
          _this2.erro = 'Erro ao carregar os dados';
        }
        _this2.carregando = false;
      }).catch(function (error) {
        _this2.erro = 'Erro ao carregar os dados: ' + error.message;
        _this2.carregando = false;
      });
    },
    obterValorMes: function obterValorMes(item, mesIndex) {
      return item.valores[mesIndex] || 0;
    },
    calcularTotalMes: function calcularTotalMes(mesIndex) {
      return this.dadosFiltrados.reduce(function (total, item) {
        return total + (item.valores[mesIndex] || 0);
      }, 0);
    },
    inicializarGrafico: function inicializarGrafico() {
      var url = this.env.FINANCEIRO.SLA + '/simulacao-geral-resumo-fornecedor';

      if (this.filtroUf) {
        url += '?uf=' + encodeURIComponent(this.filtroUf);
      }

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url).then(function (response) {
        if (response.data.success && response.data.dados) {
          console.log('Dados do gráfico:', response.data.dados);
        }
      }).catch(function (error) {
        console.error('Erro ao carregar dados para o gráfico:', error);
      });
    },
    atualizarFiltros: function atualizarFiltros() {
      this.carregarDados();
    }
  },

  watch: {
    filtroFornecedor: function filtroFornecedor() {
      this.atualizarFiltros();
    },
    filtroUf: function filtroUf() {
      this.atualizarFiltros();
    }
  }
});

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__evidencia_print_EvidenciaImpressao_vue__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__evidencia_print_EvidenciaImpressao_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__evidencia_print_EvidenciaImpressao_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__exportarSla_Index_vue__ = __webpack_require__(932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__exportarSla_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__exportarSla_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__glosa_table_TableGlosaEvidencia_vue__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__glosa_table_TableGlosaEvidencia_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__glosa_table_TableGlosaEvidencia_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__table_TableFechamentoMultaGlosa_vue__ = __webpack_require__(935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__table_TableFechamentoMultaGlosa_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__table_TableFechamentoMultaGlosa_vue__);








/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['refresh_componentes', 'anoSelecionado', 'semresultado'],
  data: function data() {
    return {
      items: [],
      ufIdSelecionada: '',
      tipoImovelServicoSelecionado: [],
      cabecalho_sla: [],
      itens_sla: [],
      percentual_multa_periodo: [],
      valor_mensal_contrato: [],
      valor_multa: [],
      valor_multa_aplicada: [],
      multa_extra_mensal: [],
      indice_performance: [],
      numero_contrato_original: '',
      contrato: [],
      meses: [],
      env: __webpack_require__.i({"NODE_ENV":"production","AUTENTICA":"https://autentica-single.portalssp.com/api","CADASTRO_USUARIO":"https://cadastro.oi.portalssp.com","RECUPERAR_SENHA":"https://cadastro.oi.portalssp.com/reset","STORAGE":"https://storage.portalssp.com/api/v1","FINANCEIRO":__webpack_require__.i({"SLA":"https://financeiro.sla.portalssp.com/api","NOTIFICACAO":"https://financeiro.notificacoes.portalssp.com/api","GLOSA":"https://financeiro.glosa.portalssp.com/api/v1"}),"ADMINISTRATIVO":"undefined"}),
      refreshEvidenciaAtual: '',
      listarEvidenciasPorItem: [],
      dadosFechamentoSla: []
    };
  },

  components: {
    'exibir-evidencia-impressao': __WEBPACK_IMPORTED_MODULE_1__evidencia_print_EvidenciaImpressao_vue___default.a,
    'exportar-sla': __WEBPACK_IMPORTED_MODULE_2__exportarSla_Index_vue___default.a,
    'table-glosa-evidencia': __WEBPACK_IMPORTED_MODULE_3__glosa_table_TableGlosaEvidencia_vue___default.a,
    'table-fechamento-multa-glosa': __WEBPACK_IMPORTED_MODULE_4__table_TableFechamentoMultaGlosa_vue___default.a
  },
  methods: {
    getSla: function getSla(ufSelecionada, contratoSelecionado) {
      this.ufIdSelecionada = ufSelecionada;
      this.tipoImovelServicoSelecionado = contratoSelecionado;
      var formData = new FormData();
      var vm = this;
      this.$store.commit('setContrato', 0);
      formData.append('uf_id', ufSelecionada);
      formData.append('tipo_contrato_id', contratoSelecionado.tipo_contrato_id);
      formData.append('tipo_imovel_contrato_id', contratoSelecionado.tipo_imovel_contrato_id);
      formData.append('tipo_imovel_servico_id', contratoSelecionado.id);
      formData.append('ano_selecionado', this.$store.state.ano.ano_selecionado);
      formData.append('fornecedor_id', this.$store.state.fornecedor.dadosFornecedor.fornecedor_id);
      formData.append('contrato_id', this.$store.state.fornecedor.dadosFornecedor.contrato_id);

      this.$axios.post(this.env.FINANCEIRO.SLA + '/getslas', formData, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token
        }
      }).then(function (response) {
        if (response.data.sla.hasOwnProperty('itens_sla')) {
          vm.itens_sla = response.data.sla.itens_sla;
          vm.meses = response.data.sla.meses;
          vm.numero_contrato_original = response.data.sla.contrato.numero_contrato_original;
          vm.percentual_multa_periodo = response.data.sla.percentual_multa_periodo;
          vm.valor_mensal_contrato = response.data.sla.valor_mensal_contrato;
          vm.contrato = response.data.sla.contrato;
          vm.valor_multa = response.data.sla.multa;
          vm.multa_extra_mensal = response.data.sla.multa_extra_mensal;
          vm.valor_multa_aplicada = response.data.sla.multa_aplicada;
          vm.indice_performance = response.data.sla.indice_performance;
          vm.formatarCabecalhoSla([response.data.sla]);
          vm.$store.commit('setItensSla', response.data.sla);
          vm.$store.commit('setContrato', response.data.sla.contrato);
          vm.semresultado = null;
        } else {
          vm.semresultado = true;
          console.log('Não foi encontrado contrato com esse filtro');
        }
      }).catch(function (e) {
        vm.semresultado = null;
        console.log('Algo de errado com a requisição getSlas!');
      });
    },
    formatarCabecalhoSla: function formatarCabecalhoSla(itensSla) {
      var vm = this;
      var mapa = itensSla;
      mapa.map(function (item) {
        vm.cabecalho_sla = {
          fornecedor: item.fornecedor.sigla,
          natureza: item.contrato.tipo_imovel_servico,
          numero_contrato_original: item.contrato.numero_contrato_original,
          valor_mensal_contrato: item.contrato.valor_mensal_contrato
        };
      });
    },
    listarHistoricoSla: function listarHistoricoSla() {
      var vm = this;
      this.$axios.get(this.env.FINANCEIRO.SLA + '/gethistorico/' + vm.$store.state.contrato.itensContrato.contrato_id, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token
        }
      }).then(function (response) {
        var promises = response.data.map(function (item) {
          return {
            'usuário': item.usuario,
            'item_SLA': item.numero_item,
            'mês': item.mes,
            'ano': item.ano,
            'ação': item.acao,
            'alterado_em': item.data
          };
        });
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function (evidenciasFormatadas) {
          vm.$store.commit('setHistoricoSla', evidenciasFormatadas);
        });
      }).catch(function (e) {
        console.log('Algo de errado com a busca de histórico!');
      });
    },
    listarEvidenciaAtual: function listarEvidenciaAtual(evidenciasAtuais) {
      var consultaEvidenciaPorMes = { contrato_id: evidenciasAtuais[0].contrato_id, item_sla_id: evidenciasAtuais[0].item_sla_id, mes_id: evidenciasAtuais[0].mes_id, ano_selecionado: this.anoSelecionado };
      this.$store.commit('setEvidenciasPorMes', consultaEvidenciaPorMes);
    },

    existeEvidenciasAnuladas: function existeEvidenciasAnuladas(evidencias) {
      if (evidencias === null) {
        return 0;
      }
      var existeAnulado = evidencias.filter(function (item) {
        return item.anulado === 1;
      });
      return existeAnulado.length ? 1 : 0;
    },
    exibeModalAdicionarEvidencia: function exibeModalAdicionarEvidencia() {
      this.$store.commit('setAdicionarEvidencia', { conteudo: null, show: true });
    },
    exibeModalAdicionarGlosa: function exibeModalAdicionarGlosa() {
      this.$store.commit('setAdicionarGlosa', { conteudo: null, show: true });
    }
  }
});

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListarSla_vue__ = __webpack_require__(931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListarSla_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ListarSla_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'listar-sla': __WEBPACK_IMPORTED_MODULE_0__ListarSla_vue___default.a
  }
});

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ControleApuracaoSla_vue__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ControleApuracaoSla_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ControleApuracaoSla_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['refresh_componentes'],
  data: function data() {
    return {
      showModal: false,
      grupo: '',
      contratos: [],
      fornecedores: [],
      proprietarios: [],
      data_expiracao: '',
      ufs: [],
      anos: [],
      uf_selecionada: '',
      contrato_selecionado: '-- Selecionar Contrato --',
      fornecedor_selecionado: '-- Selecionar Fornecedor --',
      proprietario_selecionado: '',
      ano_selecionado: new Date().getFullYear(),
      tipo_imovel_servicos: '',
      env: __webpack_require__.i({"NODE_ENV":"production","AUTENTICA":"https://autentica-single.portalssp.com/api","CADASTRO_USUARIO":"https://cadastro.oi.portalssp.com","RECUPERAR_SENHA":"https://cadastro.oi.portalssp.com/reset","STORAGE":"https://storage.portalssp.com/api/v1","FINANCEIRO":__webpack_require__.i({"SLA":"https://financeiro.sla.portalssp.com/api","NOTIFICACAO":"https://financeiro.notificacoes.portalssp.com/api","GLOSA":"https://financeiro.glosa.portalssp.com/api/v1"}),"ADMINISTRATIVO":"undefined"}),
      gruposPermitidos: ['oi', 'admin', 'adminVTAL'],
      permissao: true,
      semresultado: 1
    };
  },

  mounted: function mounted() {
    var usuarioGrupo = this.$store.state.login.loginUsuario.grupo;

    var msgGrupos = usuarioGrupo[0].nome;
    if (usuarioGrupo[1]) {
      msgGrupos = usuarioGrupo[0].nome + ' ,' + usuarioGrupo[1].nome;
      if (usuarioGrupo[2]) {
        msgGrupos = usuarioGrupo[0].nome + ' ,' + usuarioGrupo[1].nome + ' ,' + usuarioGrupo[2].nome;
      }
    }
    console.log(msgGrupos);

    if (usuarioGrupo.find(function (permissao) {
      return permissao.nome === 'oi' || permissao.nome === 'admin' || permissao.nome === 'adminVTAL';
    })) {
      setTimeout(function () {
        vm.getUfsDoUsuario();
        vm.getAno();
        vm.getContratosPorUf();
        vm.getTipoImovelServico();
        vm.changeAno();
      }, 100);
      var vm = this;
      if (this.$store.state.alertAtualizacoes.alertAtualizacoes.status === false && this.$store.state.alertAtualizacoes.alertAtualizacoes.status === false) {}
    }
  },
  watch: {
    refresh_componentes: function refresh_componentes() {
      this.changeContrato();
    }
  },
  methods: {
    modalll: function modalll() {
      this.$store.commit('setAlert', { msg: 'Preencha todos os campos corretamente', status: false, show: true });
    },
    getUfsDoUsuario: function getUfsDoUsuario() {
      this.ufs = this.$store.state.login.loginUsuario.estado;
    },
    getAno: function getAno() {
      var anoatual = new Date().getUTCFullYear();
      for (var i = anoatual; i >= 2023; i--) {
        this.anos.push(i);
      }
    },
    getContratosPorUf: function getContratosPorUf() {
      var vm = this;
      this.$axios.post(this.env.FINANCEIRO.SLA + '/getcontratosporuf', vm.ufs, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token
        }
      }).then(function (response) {
        vm.contratos = response.data;
      });
    },
    getFornecedorContrato: function getFornecedorContrato(ano, uf, tipoImovelServico) {
      var vm = this;
      vm.fornecedores = [];
      vm.fornecedor_selecionado = '-- Selecionar Fornecedor --';
      vm.$store.commit('setDadosFornecedor', null);
      this.$axios.post(this.env.FINANCEIRO.SLA + '/getfornecedorcontratosuf', { ano: ano, uf: uf, tipoImovelServico: tipoImovelServico }, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token
        }
      }).then(function (response) {
        vm.fornecedores = response.data;
        if (vm.fornecedores.length > 1) {
          vm.semresultado = null;
        } else if (vm.fornecedores.length === 1) {
          vm.fornecedor_selecionado = vm.fornecedores[0];
          vm.$store.commit('setDadosFornecedor', vm.fornecedor_selecionado);
          vm.changeFornecedor();
        } else if (vm.fornecedores.length === 0) {
          vm.semresultado = 1;
        }
      });
    },
    getProprietario: function getProprietario() {
      var vm = this;
      this.$axios.post(this.env.FINANCEIRO.SLA + '/getproprietariosuf', vm.ufs, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token
        }
      }).then(function (response) {
        vm.proprietarios = response.data;
      });
    },
    getTipoImovelServico: function getTipoImovelServico() {
      var vm = this;
      this.$axios.get(this.env.FINANCEIRO.SLA + '/gettipoimovelservico', {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token
        }
      }).then(function (response) {
        vm.tipo_imovel_servicos = response.data.filter(function (el) {
          return [1, 2, 3, 4, 7, 8].includes(el.id);
        });
      });
    },
    limparContrato: function limparContrato() {
      var vm = this;
      vm.contrato_selecionado = '-- Selecionar Contrato --';
      vm.semresultado = null;
      vm.fornecedor_selecionado = this.fornecedor_default;
      vm.$store.commit('setContrato', 0);
      vm.$store.commit('setDadosFornecedor', '');
    },
    changeFornecedor: function changeFornecedor() {
      var vm = this;
      vm.$store.commit('setDadosFornecedor', vm.fornecedor_selecionado);
      if (vm.uf_selecionada !== '' && vm.contrato_selecionado !== '-- Selecionar Contrato --' && vm.fornecedor_selecionado !== '-- Selecionar Fornecedor --') {
        vm.$refs.controleApuracaoSla.getSla(vm.uf_selecionada, vm.contrato_selecionado, vm.fornecedor_selecionado, vm.ano_selecionado);
      }
    },
    changeContrato: function changeContrato() {
      var vm = this;
      vm.semresultado = null;
      vm.$store.commit('setDadosFornecedor', '');
      vm.$store.commit('setInfoContrato', '');
      vm.$store.commit('setInfoContrato', vm.contrato_selecionado);
      vm.$store.commit('setUfContratoSelecionado', { ufSelecionada: vm.uf_selecionada, contratoSelecionado: vm.contrato_selecionado });
      vm.getFornecedorContrato(vm.ano_selecionado, vm.uf_selecionada, vm.contrato_selecionado);
    },
    changeAno: function changeAno() {
      this.$store.commit('setAno', this.ano_selecionado);
    },

    exibeInfoFechamento: function exibeInfoFechamento() {
      this.$store.commit('setAlertCalendario', { status: true, show: true });
    }
  },
  components: {
    'controle-apuracao-sla': __WEBPACK_IMPORTED_MODULE_0__ControleApuracaoSla_vue___default.a
  }
});

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      controlerBtnSubmit: true,
      env: __webpack_require__.i({"NODE_ENV":"production","AUTENTICA":"https://autentica-single.portalssp.com/api","CADASTRO_USUARIO":"https://cadastro.oi.portalssp.com","RECUPERAR_SENHA":"https://cadastro.oi.portalssp.com/reset","STORAGE":"https://storage.portalssp.com/api/v1","FINANCEIRO":__webpack_require__.i({"SLA":"https://financeiro.sla.portalssp.com/api","NOTIFICACAO":"https://financeiro.notificacoes.portalssp.com/api","GLOSA":"https://financeiro.glosa.portalssp.com/api/v1"}),"ADMINISTRATIVO":"undefined"})
    };
  },

  methods: {
    exportarSla: function exportarSla() {
      var _this = this;

      this.controlerBtnSubmit = false;
      this.$store.commit('setControleExibicaoImpressao', !this.$store.state.itensSla.controleExibicaoImpressao);
      setTimeout(function () {
        var conteudo = document.getElementsByClassName('container-visualizacao-sla')[0].innerHTML;
        var printWin = window.open();
        printWin.document.write('' + conteudo);
        printWin.document.write('\n          <style>\n            table {\n              font-size:10px;\n              border: 1px solid #ddd !important;\n              width: 100%;\n              }\n            table td {\n              border: 1px solid #ddd !important;\n            }\n            .desabilitar-impressao {display: none;}\n            .ajusta-cabecalho-impressao {\n              width: initial !important;\n              min-width: initial !important;\n              height: initial !important;\n              min-height: initial !important;\n              display: flex;\n              justify-content: center;\n            }\n            .ajusta-resultado-calculo-impressao {\n              background: #dcdcdc78 !important;\n            }\n          </style>\n        ');
        printWin.document.close();
        printWin.focus();
        printWin.print();
        printWin.close();
        _this.$store.commit('setControleExibicaoImpressao', !_this.$store.state.itensSla.controleExibicaoImpressao);
        _this.controlerBtnSubmit = true;
      }, 0);
    }
  }
});

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_v_money__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_v_money___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_v_money__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['multas'],
  data: function data() {
    return {
      env: __webpack_require__.i({"NODE_ENV":"production","AUTENTICA":"https://autentica-single.portalssp.com/api","CADASTRO_USUARIO":"https://cadastro.oi.portalssp.com","RECUPERAR_SENHA":"https://cadastro.oi.portalssp.com/reset","STORAGE":"https://storage.portalssp.com/api/v1","FINANCEIRO":__webpack_require__.i({"SLA":"https://financeiro.sla.portalssp.com/api","NOTIFICACAO":"https://financeiro.notificacoes.portalssp.com/api","GLOSA":"https://financeiro.glosa.portalssp.com/api/v1"}),"ADMINISTRATIVO":"undefined"}),
      infoMultas: [],
      arquivo_anexo: null,
      observacao: '',
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: ' ',
        precision: 2,
        masked: false
      },
      controlerBtnSubmit: true,
      novoFechamento: true
    };
  },

  components: {
    Money: __WEBPACK_IMPORTED_MODULE_0_v_money__["Money"]
  },
  mounted: function mounted() {
    this.defineContrato();
  },
  watch: {
    multas: function multas() {
      this.defineContrato();
    }
  },
  methods: {
    defineContrato: function defineContrato() {
      this.infoMultas = this.multas.dados ? this.multas.dados : [];
      this.novoFechamento = this.infoMultas.modo === 'NOVO';
    },
    confirmarAcao: function confirmarAcao() {
      return confirm('Confirma esta ação?');
    },
    salvarConfirmacaoMultaGlosa: function salvarConfirmacaoMultaGlosa() {
      var vm = this;
      if (!this.confirmarAcao()) {
        return;
      }
      this.controlerBtnSubmit = false;
      if (this.arquivo_anexo !== null) {
        this.$axios.post(this.env.FINANCEIRO.SLA + '/salvarConfirmacaoMultaGlosa', this.getFormRequest(), {
          headers: {
            'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token,
            'Content-Type': 'application/json'
          }
        }).then(function (response) {
          vm.finalizaPosConclusaoFechamentoMultaGlosa();
        }).catch(function (error) {
          vm.controlerBtnSubmit = true;
          console.log(error);
        });
      } else {
        this.$store.commit('setAlert', { msg: 'Campo de anexo deve ser preenchido!', status: false, show: true });
        vm.controlerBtnSubmit = true;
      }
    },
    getFormRequest: function getFormRequest() {
      var formData = new FormData();
      formData.append('usuario', this.$store.state.login.loginUsuario.usuario.name);
      formData.append('email', this.$store.state.login.loginUsuario.usuario.email);
      formData.append('uf_id', this.infoMultas.uf_id);
      formData.append('tipo_imovel_servico_id', this.infoMultas.tipo_imovel_servico_id);
      formData.append('mes_id', this.infoMultas.mes_id);
      formData.append('ano', this.infoMultas.ano);
      formData.append('valor_multa', this.infoMultas.multa);
      formData.append('valor_glosa', this.infoMultas.glosa);
      formData.append('total_multa_glosa', this.infoMultas.total);
      formData.append('observacao', this.observacao);
      formData.append('envio_confirmado', 1);
      formData.append('anexos_multa_glosa', this.arquivo_anexo);

      return formData;
    },
    finalizaPosConclusaoFechamentoMultaGlosa: function finalizaPosConclusaoFechamentoMultaGlosa() {
      this.controlerBtnSubmit = true;
      var refreshComponentes = Math.floor(Math.random() * 2 * 1000);
      this.$store.commit('setRefreshComponente', refreshComponentes);
      this.closeModal();
      this.$store.commit('setConfirmarMultaGlosa', { dados: null });
      this.$store.commit('setAlert', { msg: 'Aplica\xE7\xE3o de multa e glosa confirmada com sucesso!', status: true, show: true });
    },

    closeModal: function closeModal() {
      this.observacao = null;
      this.$store.commit('setModalConfirmarMultaGlosa', { conteudo: null, show: false });
    },
    configuraBotaoArquivo: function configuraBotaoArquivo(event) {
      this.arquivo_anexo = event.target.files[0];
    },
    downloadAnexoMultaGlosa: function downloadAnexoMultaGlosa(nomeArquivo) {
      var vm = this;
      var dirBucket = 'anexosmultaglosa';
      this.$axios.get(this.env.FINANCEIRO.SLA + '/downloadanexomultaglosa/' + dirBucket + '/' + nomeArquivo, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token
        }
      }).then(function (response) {
        if (response.data.mensagem) {
          vm.$store.commit('setAlert', { msg: response.data.mensagem, status: false, show: true });
          return;
        }
        window.open(response.data.url, '_blank');
      });
      console.log(nomeArquivo);
    }
  }
});

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      filter: null,
      filterOn: []
    };
  }
});

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_v_money__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_v_money___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_v_money__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__glosa_print_GlosaImpressao_vue__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__glosa_print_GlosaImpressao_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__glosa_print_GlosaImpressao_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['contrato', 'ano', 'uf', 'multas', 'fornecedor'],
  data: function data() {
    return {
      anoSelecionado: '',
      contratoSelecionado: [],
      ufSelecionada: '',
      mesSelecionado: '',
      valorMultas: [],
      glosas: [],
      totalMultaGlosa: [],
      fechamentoMultaGlosa: [],
      confirmacaoMultaGlosaAtual: null,
      controlerLoading: true,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: ' ',
        precision: 2,
        masked: false
      },
      env: __webpack_require__.i({"NODE_ENV":"production","AUTENTICA":"https://autentica-single.portalssp.com/api","CADASTRO_USUARIO":"https://cadastro.oi.portalssp.com","RECUPERAR_SENHA":"https://cadastro.oi.portalssp.com/reset","STORAGE":"https://storage.portalssp.com/api/v1","FINANCEIRO":__webpack_require__.i({"SLA":"https://financeiro.sla.portalssp.com/api","NOTIFICACAO":"https://financeiro.notificacoes.portalssp.com/api","GLOSA":"https://financeiro.glosa.portalssp.com/api/v1"}),"ADMINISTRATIVO":"undefined"}),
      statusFechamento: { enviar: 'Enviar', enviado: 'Enviado' },
      dados: []
    };
  },
  mounted: function mounted() {
    this.definePros();
    this.getTotalGlosasAplicadasMensal();
    this.getConfirmacaoAplicacaoFechamentoMultaGlosa(this.ufSelecionada, this.anoSelecionado, this.contratoSelecionado);
  },
  components: {
    Money: __WEBPACK_IMPORTED_MODULE_1_v_money__["Money"],
    'exibir-glosas-impressao': __WEBPACK_IMPORTED_MODULE_2__glosa_print_GlosaImpressao_vue___default.a
  },
  watch: {
    ano: function ano() {
      this.definePros();
      this.getTotalGlosasAplicadasMensal();
      this.getConfirmacaoAplicacaoFechamentoMultaGlosa(this.ufSelecionada, this.anoSelecionado, this.contratoSelecionado);
    }
  },
  methods: {
    definePros: function definePros() {
      this.anoSelecionado = this.ano;
      this.contratoSelecionado = this.contrato;
      this.ufSelecionada = this.uf;
      this.valorMultas = this.multas;
    },
    exibirModalFechamentoMultaSla: function exibirModalFechamentoMultaSla(fechamentoMes, modo) {
      var siglaMes = fechamentoMes.mes_sigla;

      this.confirmacaoMultaGlosaAtual = {
        uf: this.contratoSelecionado.uf,
        uf_id: this.ufSelecionada,
        tipo_imovel_servico: this.contratoSelecionado.tipo_imovel_servico,
        tipo_imovel_servico_id: this.contratoSelecionado.tipo_imovel_servico_id,
        mes_id: fechamentoMes.mes_id,
        mes_sigla: siglaMes,
        ano: this.anoSelecionado,
        glosa: this.glosas[siglaMes].valor,
        multa: this.valorMultas[siglaMes].valor,
        total: this.totalMultaGlosa[siglaMes].valor,
        nome_arquivo: fechamentoMes.nome_arquivo,
        observacao: fechamentoMes.observacao,
        modo: modo
      };
      this.$store.commit('setModalConfirmarMultaGlosa', { conteudo: null, show: true });
      this.$store.commit('setConfirmarMultaGlosa', { dados: this.confirmacaoMultaGlosaAtual });
    },
    getTotalGlosasAplicadasMensal: function getTotalGlosasAplicadasMensal() {
      var _this = this;

      var vm = this;

      var formData = new FormData();
      formData.append('ano', this.anoSelecionado);
      formData.append('contrato_id', this.contratoSelecionado.contrato_id);

      this.$axios.post(this.env.FINANCEIRO.GLOSA + '/getGlosaFiltroAnoContrato', formData, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token
        }
      }).then(function (response) {
        vm.glosas = response.data;
        vm.getCalculoFechamentoMultaGlosa();
        vm.controlerLoading = true;
      }).catch(function (error) {
        _this.controlerLoading = true;
        console.log(error);
      });
    },
    getCalculoFechamentoMultaGlosa: function getCalculoFechamentoMultaGlosa() {
      var _this2 = this;

      var vm = this;
      this.controlerLoading = false;
      this.$axios.post(this.env.FINANCEIRO.SLA + '/getCalculoFechamentoMultaGlosa', {
        glosas: this.glosas,
        multas: this.valorMultas
      }, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token
        }
      }).then(function (response) {
        vm.totalMultaGlosa = response.data;
        vm.controlerLoading = true;
      }).catch(function (error) {
        _this2.controlerLoading = true;
        console.log(error);
      });
    },
    getConfirmacaoAplicacaoFechamentoMultaGlosa: function getConfirmacaoAplicacaoFechamentoMultaGlosa(uf, ano, contrato) {
      var vm = this;
      this.$axios.get(this.env.FINANCEIRO.SLA + '/getConfirmacaoFechamentoMultaGlosa', {
        params: {
          uf: uf,
          ano: ano,
          tipo_imovel_servico_id: contrato.tipo_imovel_servico_id
        },
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.login.loginUsuario.token,
          'Content-Type': 'application/json'
        }
      }).then(function (response) {
        vm.fechamentoMultaGlosa = response.data;
        var obj = response.data;
        var meses = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
        var res = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(obj);
        var arrayFechamento = [];
        var arrayFechamentoBlank = [];
        meses.forEach(function (item, index) {
          arrayFechamento[index] = res[index][1]['envio_confirmado'];
          arrayFechamentoBlank[item] = res[index][1]['envio_confirmado'];
        });
        vm.$store.state.fechamentoMultaGlosa = arrayFechamento;
      }).catch(function (error) {
        console.warn('erro', error);
      });
    }
  }
});

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'column',
  props: {
    'class': {
      type: String,
      default: ''
    }
  },
  created: function created() {}
});

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'row',
  created: function created() {}
});

/***/ }),
/* 623 */
/***/ (function(module, exports) {

module.exports = [{
  type: 'item',
  isHeader: true,
  name: 'Sistema de Serviços Patrimoniais'
}, {
  type: 'tree',
  icon: 'fa fa-cogs',
  grupos: ['admin', 'oi', 'adminVTAL'],
  name: 'Simulação Preventivas',
  items: [{
    type: 'item',
    icon: 'fa fa-circle-o',
    grupos: ['admin', 'oi', 'adminVTAL'],
    name: 'Quadro Geral',
    router: {
      name: 'SimulacaoGeral'
    }
  }, {
    type: 'item',
    icon: 'fa fa-upload',
    grupos: ['admin', 'oi', 'adminVTAL'],
    name: 'Importar Preventivas',
    router: {
      name: 'ImportarPreventivas'
    }
  }]
}, {
  type: 'item',
  icon: 'fa fa-bar-chart',
  grupos: ['admin', 'oi'],
  name: 'SLA',
  router: {
    name: 'ListarSla'
  }
}, {
  type: 'tree',
  icon: 'fa fa-bell',
  grupos: ['admin', 'oi', 'adminVTAL'],
  name: 'Notificações',
  items: [{
    type: 'item',
    icon: 'fa fa-circle-o',
    grupos: ['admin', 'oi', 'adminVTAL'],
    name: 'Adicionar notificação',
    router: {
      name: 'InserirNotificacao'
    }
  }, {
    type: 'item',
    icon: 'fa fa-table',
    grupos: ['admin', 'oi', 'adminVTAL'],
    name: 'Listar notificações',
    router: {
      name: 'ListarNotificacoes'
    }
  }]
}, {
  type: 'tree',
  icon: 'fa fa-fw fa-usd',
  grupos: ['admin', 'oi', 'adminVTAL'],
  name: 'Extracontratual',
  items: [{
    type: 'item',
    icon: 'fa fa-circle-o',
    grupos: ['admin', 'oi', 'adminVTAL'],
    name: 'Aplicar',
    router: {
      name: 'ListarFechamentoExtra'
    }
  }, {
    type: 'item',
    icon: 'fa fa-table',
    grupos: ['admin', 'oi', 'adminVTAL'],
    name: 'Listar',
    router: {
      name: 'ExibirFechamentoExtra'
    }
  }]
}, {
  type: 'tree',
  icon: 'fa fa-fw fa-usd',
  grupos: ['admin', 'oi', 'adminVTAL'],
  name: 'Glosa',
  items: [{
    type: 'item',
    icon: 'fa fa-circle-o',
    grupos: ['admin', 'oi', 'adminVTAL'],
    name: 'Aplicar',
    router: {
      name: 'AplicarGlosaFranquias'
    }
  }]
}, {
  type: 'item',
  icon: 'fa fa-file-excel-o',
  grupos: ['admin', 'oi', 'adminVTAL'],
  name: 'Planilhas',
  router: {
    name: 'Planilhas'
  }
}, {
  type: 'item',
  icon: 'fa fa-building',
  name: 'Novo SSP',
  grupos: ['admin', 'oi', 'adminVTAL'],
  router: {
    name: 'RedirecionarAdministrativo'
  }
}];

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_css__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_script__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_global__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_excel_xlsx__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_vue__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_eventBus_js__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_position_sticky__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_position_sticky___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_position_sticky__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_gtm__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_gtm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_gtm__);


















__WEBPACK_IMPORTED_MODULE_3_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_12_vue_position_sticky___default.a);
__WEBPACK_IMPORTED_MODULE_3_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_bootstrap_vue__["a" /* BootstrapVue */]);
__WEBPACK_IMPORTED_MODULE_3_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_bootstrap_vue__["b" /* IconsPlugin */]);
__WEBPACK_IMPORTED_MODULE_3_vue___default.a.use(__webpack_require__(511));
__WEBPACK_IMPORTED_MODULE_3_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_vue_excel_xlsx__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_3_vue___default.a.prototype.$bus = __WEBPACK_IMPORTED_MODULE_8__lib_eventBus_js__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_3_vue___default.a.prototype.$axios = __WEBPACK_IMPORTED_MODULE_9_axios___default.a;

__WEBPACK_IMPORTED_MODULE_3_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_13_vue_gtm___default.a, {
  id: 'GTM-WX38RH3',

  defer: false,
  enabled: false,
  debug: false,
  loadScript: false,
  vueRouter: __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */],
  trackOnNextTick: false });

new __WEBPACK_IMPORTED_MODULE_3_vue___default.a({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */],
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_4__App___default.a
  }
});

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var state = {
  alertAtualizacoes: {
    status: false,
    show: false
  }
};

var mutations = {
  setAlertAtualizacoes: function setAlertAtualizacoes(state, obj) {
    state.alertAtualizacoes = obj;
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var state = {
  alertCalendario: {
    status: false,
    show: false
  }
};

var mutations = {
  setAlertCalendario: function setAlertCalendario(state, obj) {
    state.alertCalendario = obj;
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var state = {
  ano_selecionado: ''
};

var mutations = {
  setAno: function setAno(state, value) {
    state.ano_selecionado = value;
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var state = {
  dados: {
    uf: '',
    uf_id: '',
    tipo_imovel_servico: '',
    tipo_imovel_servico_id: '',
    mes_id: '',
    mes_sigla: '',
    ano: '',
    glosa: '',
    multa: '',
    total: ''
  }
};

var mutations = {
  setConfirmarMultaGlosa: function setConfirmarMultaGlosa(state, obj) {
    state.dados = obj;
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var state = {
  itensContrato: Array
};

var mutations = {
  setContrato: function setContrato(state, obj) {
    state.itensContrato = obj;
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var state = {
  dadosFechamentoSla: Array
};

var mutations = {
  setDadosFechamentoSla: function setDadosFechamentoSla(state, obj) {
    state.dadosFechamentoSla = obj;
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var state = {
  evidencias: {
    contrato_id: '',
    item_sla_id: '',
    mes_id: '',
    ano_selecionado: ''
  }
};

var mutations = {
  setEvidenciasPorMes: function setEvidenciasPorMes(state, obj) {
    state.evidencias = obj;
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var state = {
  dadosFechamento: Array
};

var mutations = {
  setFechamentoAtual: function setFechamentoAtual(state, obj) {
    state.dadosFechamento = obj;
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var state = {
  dadosFechamento: Array
};

var mutations = {
  setDadosFechamento: function setDadosFechamento(state, obj) {
    state.dadosFechamento = obj;
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var state = {
  dadosFornecedor: {
    fornecedor: ''
  }
};

var mutations = {
  setDadosFornecedor: function setDadosFornecedor(state, obj) {
    state.dadosFornecedor = obj;
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var state = {
  historicoNotificacoes: Array
};

var mutations = {
  setHistoricoNotificacoes: function setHistoricoNotificacoes(state, obj) {
    state.historicoNotificacoes = obj;
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var state = {
  historicoSla: Array
};

var mutations = {
  setHistoricoSla: function setHistoricoSla(state, obj) {
    state.historicoSla = obj;
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var state = {
  infoContrato: {
    contrato_id: '',
    tipo_imovel_servico_id: '',
    nome: '',
    tipo_contrato_id: '',
    tipo_imovel_contrato_id: ''
  }
};

var mutations = {
  setInfoContrato: function setInfoContrato(state, obj) {
    state.infoContrato = obj;
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var state = {
  itemAtual: Array
};

var mutations = {
  setItemAtual: function setItemAtual(state, obj) {
    state.itemAtual = obj;
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var state = {
  itensSla: {
    fornecedor: Object,
    contrato: Array,
    itensSla: Array,
    evidencias: Array
  },
  controleExibicaoImpressao: false
};

var mutations = {
  setItensSla: function setItensSla(state, obj) {
    state.itensSla = obj;
  },
  setControleExibicaoImpressao: function setControleExibicaoImpressao(state, valor) {
    state.controleExibicaoImpressao = valor;
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var state = {
  loginUsuario: {
    usuario: Array,
    grupo: Array,
    contrato: Array,
    token: null,
    data_expiracao: String
  }
};

var mutations = {
  setLoginUsuario: function setLoginUsuario(state, obj) {
    state.loginUsuario = obj;
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var state = {
  alert: {
    msg: '',
    status: true,
    show: false
  },
  adicionarEvidencia: {
    conteudo: '',
    show: false
  },
  adicionarGlosa: {
    conteudo: '',
    show: false
  },
  extraContratual: {
    conteudo: '',
    show: false
  },
  modalListaGlosasPorMes: {
    conteudo: [],
    show: false
  },
  adicionarExtraContratual: {
    conteudo: '',
    show: false
  },
  modalConfirmarMultaGlosa: {
    conteudo: '',
    show: false
  },
  dadosFornecedor: {
    fornecedor: ''
  },
  planilhasChamados: {
    show: false
  },
  planilhaSLA: {
    show: false
  },
  planilhasPreventivas: {
    show: false
  },
  fechamentoFixoVariavel: {
    show: false
  },
  exportarExtra: {
    show: false
  }
};

var mutations = {
  setAlert: function setAlert(state, obj) {
    state.alert = obj;
  },
  setDadosFornecedor: function setDadosFornecedor(state, obj) {
    state.dadosFornecedor = obj;
  },
  setAdicionarEvidencia: function setAdicionarEvidencia(state, obj) {
    state.adicionarEvidencia = obj;
  },
  setAdicionarGlosa: function setAdicionarGlosa(state, obj) {
    state.adicionarGlosa = obj;
  },
  setExtraContratual: function setExtraContratual(state, obj) {
    state.extraContratual = obj;
  },
  setModalListaGlosasPorMes: function setModalListaGlosasPorMes(state, obj) {
    state.modalListaGlosasPorMes = obj;
  },
  setModalConfirmarMultaGlosa: function setModalConfirmarMultaGlosa(state, obj) {
    state.modalConfirmarMultaGlosa = obj;
  },
  setPlanilhasChamados: function setPlanilhasChamados(state, obj) {
    state.planilhasChamados = obj;
  },
  setPlanilhaSLA: function setPlanilhaSLA(state, obj) {
    state.planilhaSLA = obj;
  },
  setPlanilhasPreventivas: function setPlanilhasPreventivas(state, obj) {
    state.planilhasPreventivas = obj;
  },
  setModalFechamentoFixoVariavel: function setModalFechamentoFixoVariavel(state, obj) {
    state.fechamentoFixoVariavel = obj;
  },
  setModalExportarExtra: function setModalExportarExtra(state, obj) {
    state.exportarExtra = obj;
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var state = {
  notificacaoAtual: Array
};

var mutations = {
  setNotificacaoAtual: function setNotificacaoAtual(state, obj) {
    state.notificacaoAtual = obj;
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var state = {
  permissaoNegada: {
    msg: '',
    status: true,
    show: false
  }
};

var mutations = {
  setPermissaoNegada: function setPermissaoNegada(state, obj) {
    state.permissaoNegada = obj;
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var state = {
  refreshComponente: Number
};

var mutations = {
  setRefreshComponente: function setRefreshComponente(state, value) {
    state.refreshComponente = value;
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var state = {
  ufContratoSelecionado: []
};

var mutations = {
  setUfContratoSelecionado: function setUfContratoSelecionado(state, obj) {
    state.ufContratoSelecionado = obj;
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var state = {
  main: {
    name: 'Alexander Pierce',
    position: 'Web Developer',
    state: {
      color: '#3c763d',
      name: 'Online'
    },
    createdAt: new Date()
  }
};

var mutations = {};

/* harmony default export */ __webpack_exports__["default"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules__ = __webpack_require__(183);





__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: __WEBPACK_IMPORTED_MODULE_2__modules__["default"],
  strict: "production" !== 'production'
}));

/***/ }),
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 750 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 751 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 752 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 753 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 754 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 755 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 756 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 757 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 758 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 759 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 760 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 761 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 762 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 763 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 764 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 765 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 766 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 767 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 768 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 769 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 770 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 771 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 772 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 773 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 774 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 775 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 776 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 777 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 778 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 779 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 780 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 781 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 782 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 783 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 784 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 785 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 786 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 787 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 788 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 789 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 790 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 791 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 792 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 793 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 794 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 795 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 796 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 797 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 798 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 799 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 800 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 801 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 802 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 803 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 804 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 805 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 806 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 807 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 808 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 809 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 810 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 811 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 812 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 813 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 814 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 815 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 816 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 817 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 818 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 819 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 820 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 821 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 822 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 823 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 824 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 825 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 826 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 827 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 828 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 829 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 830 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 831 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 832 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 833 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 834 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 835 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 836 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 837 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 347,
	"./af.js": 347,
	"./ar": 355,
	"./ar-dz": 348,
	"./ar-dz.js": 348,
	"./ar-kw": 349,
	"./ar-kw.js": 349,
	"./ar-ly": 350,
	"./ar-ly.js": 350,
	"./ar-ma": 351,
	"./ar-ma.js": 351,
	"./ar-ps": 352,
	"./ar-ps.js": 352,
	"./ar-sa": 353,
	"./ar-sa.js": 353,
	"./ar-tn": 354,
	"./ar-tn.js": 354,
	"./ar.js": 355,
	"./az": 356,
	"./az.js": 356,
	"./be": 357,
	"./be.js": 357,
	"./bg": 358,
	"./bg.js": 358,
	"./bm": 359,
	"./bm.js": 359,
	"./bn": 361,
	"./bn-bd": 360,
	"./bn-bd.js": 360,
	"./bn.js": 361,
	"./bo": 362,
	"./bo.js": 362,
	"./br": 363,
	"./br.js": 363,
	"./bs": 364,
	"./bs.js": 364,
	"./ca": 365,
	"./ca.js": 365,
	"./cs": 366,
	"./cs.js": 366,
	"./cv": 367,
	"./cv.js": 367,
	"./cy": 368,
	"./cy.js": 368,
	"./da": 369,
	"./da.js": 369,
	"./de": 372,
	"./de-at": 370,
	"./de-at.js": 370,
	"./de-ch": 371,
	"./de-ch.js": 371,
	"./de.js": 372,
	"./dv": 373,
	"./dv.js": 373,
	"./el": 374,
	"./el.js": 374,
	"./en-au": 375,
	"./en-au.js": 375,
	"./en-ca": 376,
	"./en-ca.js": 376,
	"./en-gb": 377,
	"./en-gb.js": 377,
	"./en-ie": 378,
	"./en-ie.js": 378,
	"./en-il": 379,
	"./en-il.js": 379,
	"./en-in": 380,
	"./en-in.js": 380,
	"./en-nz": 381,
	"./en-nz.js": 381,
	"./en-sg": 382,
	"./en-sg.js": 382,
	"./eo": 383,
	"./eo.js": 383,
	"./es": 387,
	"./es-do": 384,
	"./es-do.js": 384,
	"./es-mx": 385,
	"./es-mx.js": 385,
	"./es-us": 386,
	"./es-us.js": 386,
	"./es.js": 387,
	"./et": 388,
	"./et.js": 388,
	"./eu": 389,
	"./eu.js": 389,
	"./fa": 390,
	"./fa.js": 390,
	"./fi": 391,
	"./fi.js": 391,
	"./fil": 392,
	"./fil.js": 392,
	"./fo": 393,
	"./fo.js": 393,
	"./fr": 396,
	"./fr-ca": 394,
	"./fr-ca.js": 394,
	"./fr-ch": 395,
	"./fr-ch.js": 395,
	"./fr.js": 396,
	"./fy": 397,
	"./fy.js": 397,
	"./ga": 398,
	"./ga.js": 398,
	"./gd": 399,
	"./gd.js": 399,
	"./gl": 400,
	"./gl.js": 400,
	"./gom-deva": 401,
	"./gom-deva.js": 401,
	"./gom-latn": 402,
	"./gom-latn.js": 402,
	"./gu": 403,
	"./gu.js": 403,
	"./he": 404,
	"./he.js": 404,
	"./hi": 405,
	"./hi.js": 405,
	"./hr": 406,
	"./hr.js": 406,
	"./hu": 407,
	"./hu.js": 407,
	"./hy-am": 408,
	"./hy-am.js": 408,
	"./id": 409,
	"./id.js": 409,
	"./is": 410,
	"./is.js": 410,
	"./it": 412,
	"./it-ch": 411,
	"./it-ch.js": 411,
	"./it.js": 412,
	"./ja": 413,
	"./ja.js": 413,
	"./jv": 414,
	"./jv.js": 414,
	"./ka": 415,
	"./ka.js": 415,
	"./kk": 416,
	"./kk.js": 416,
	"./km": 417,
	"./km.js": 417,
	"./kn": 418,
	"./kn.js": 418,
	"./ko": 419,
	"./ko.js": 419,
	"./ku": 421,
	"./ku-kmr": 420,
	"./ku-kmr.js": 420,
	"./ku.js": 421,
	"./ky": 422,
	"./ky.js": 422,
	"./lb": 423,
	"./lb.js": 423,
	"./lo": 424,
	"./lo.js": 424,
	"./lt": 425,
	"./lt.js": 425,
	"./lv": 426,
	"./lv.js": 426,
	"./me": 427,
	"./me.js": 427,
	"./mi": 428,
	"./mi.js": 428,
	"./mk": 429,
	"./mk.js": 429,
	"./ml": 430,
	"./ml.js": 430,
	"./mn": 431,
	"./mn.js": 431,
	"./mr": 432,
	"./mr.js": 432,
	"./ms": 434,
	"./ms-my": 433,
	"./ms-my.js": 433,
	"./ms.js": 434,
	"./mt": 435,
	"./mt.js": 435,
	"./my": 436,
	"./my.js": 436,
	"./nb": 437,
	"./nb.js": 437,
	"./ne": 438,
	"./ne.js": 438,
	"./nl": 440,
	"./nl-be": 439,
	"./nl-be.js": 439,
	"./nl.js": 440,
	"./nn": 441,
	"./nn.js": 441,
	"./oc-lnc": 442,
	"./oc-lnc.js": 442,
	"./pa-in": 443,
	"./pa-in.js": 443,
	"./pl": 444,
	"./pl.js": 444,
	"./pt": 446,
	"./pt-br": 445,
	"./pt-br.js": 445,
	"./pt.js": 446,
	"./ro": 447,
	"./ro.js": 447,
	"./ru": 448,
	"./ru.js": 448,
	"./sd": 449,
	"./sd.js": 449,
	"./se": 450,
	"./se.js": 450,
	"./si": 451,
	"./si.js": 451,
	"./sk": 452,
	"./sk.js": 452,
	"./sl": 453,
	"./sl.js": 453,
	"./sq": 454,
	"./sq.js": 454,
	"./sr": 456,
	"./sr-cyrl": 455,
	"./sr-cyrl.js": 455,
	"./sr.js": 456,
	"./ss": 457,
	"./ss.js": 457,
	"./sv": 458,
	"./sv.js": 458,
	"./sw": 459,
	"./sw.js": 459,
	"./ta": 460,
	"./ta.js": 460,
	"./te": 461,
	"./te.js": 461,
	"./tet": 462,
	"./tet.js": 462,
	"./tg": 463,
	"./tg.js": 463,
	"./th": 464,
	"./th.js": 464,
	"./tk": 465,
	"./tk.js": 465,
	"./tl-ph": 466,
	"./tl-ph.js": 466,
	"./tlh": 467,
	"./tlh.js": 467,
	"./tr": 468,
	"./tr.js": 468,
	"./tzl": 469,
	"./tzl.js": 469,
	"./tzm": 471,
	"./tzm-latn": 470,
	"./tzm-latn.js": 470,
	"./tzm.js": 471,
	"./ug-cn": 472,
	"./ug-cn.js": 472,
	"./uk": 473,
	"./uk.js": 473,
	"./ur": 474,
	"./ur.js": 474,
	"./uz": 476,
	"./uz-latn": 475,
	"./uz-latn.js": 475,
	"./uz.js": 476,
	"./vi": 477,
	"./vi.js": 477,
	"./x-pseudo": 478,
	"./x-pseudo.js": 478,
	"./yo": 479,
	"./yo.js": 479,
	"./zh-cn": 480,
	"./zh-cn.js": 480,
	"./zh-hk": 481,
	"./zh-hk.js": 481,
	"./zh-mo": 482,
	"./zh-mo.js": 482,
	"./zh-tw": 483,
	"./zh-tw.js": 483
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 848;

/***/ }),
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(807)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(531),
  /* template */
  __webpack_require__(998),
  /* scopeId */
  "data-v-676505f6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(800)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(532),
  /* template */
  __webpack_require__(992),
  /* scopeId */
  "data-v-58ee5e1d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(809)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(533),
  /* template */
  __webpack_require__(1000),
  /* scopeId */
  "data-v-6a6dfcab",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(757)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(534),
  /* template */
  __webpack_require__(942),
  /* scopeId */
  "data-v-0601efd2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(824)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(535),
  /* template */
  __webpack_require__(1016),
  /* scopeId */
  "data-v-8eaac5a8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(818)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(536),
  /* template */
  __webpack_require__(1009),
  /* scopeId */
  "data-v-7b04e3e0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(810)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(537),
  /* template */
  __webpack_require__(1002),
  /* scopeId */
  "data-v-6ccb7b30",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(821)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(538),
  /* template */
  __webpack_require__(1012),
  /* scopeId */
  "data-v-819bbeb8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(835)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(539),
  /* template */
  __webpack_require__(1027),
  /* scopeId */
  "data-v-ed29e824",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(774)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(540),
  /* template */
  __webpack_require__(962),
  /* scopeId */
  "data-v-22411fbb",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(768)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(541),
  /* template */
  __webpack_require__(954),
  /* scopeId */
  "data-v-130a652a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(828)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(542),
  /* template */
  __webpack_require__(1020),
  /* scopeId */
  "data-v-b13f671e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(801)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(543),
  /* template */
  __webpack_require__(993),
  /* scopeId */
  "data-v-5c9d0696",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(832)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(544),
  /* template */
  __webpack_require__(1024),
  /* scopeId */
  "data-v-d6782796",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(769)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(545),
  /* template */
  __webpack_require__(956),
  /* scopeId */
  "data-v-167f3b98",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(815)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(546),
  /* template */
  __webpack_require__(1006),
  /* scopeId */
  "data-v-789e09ea",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(758)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(547),
  /* template */
  __webpack_require__(943),
  /* scopeId */
  "data-v-07e1fb6b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(772)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(548),
  /* template */
  __webpack_require__(959),
  /* scopeId */
  "data-v-18fcb23a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(820)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(549),
  /* template */
  __webpack_require__(1011),
  /* scopeId */
  "data-v-7f07982a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(814)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(550),
  /* template */
  __webpack_require__(1005),
  /* scopeId */
  "data-v-741dfd8f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(551),
  /* template */
  __webpack_require__(988),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(776)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(553),
  /* template */
  __webpack_require__(964),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(795)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(554),
  /* template */
  __webpack_require__(986),
  /* scopeId */
  "data-v-45433736",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(780)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(555),
  /* template */
  __webpack_require__(968),
  /* scopeId */
  "data-v-2cff0848",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(556),
  /* template */
  __webpack_require__(975),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(808)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(557),
  /* template */
  __webpack_require__(999),
  /* scopeId */
  "data-v-68973dac",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(790)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(558),
  /* template */
  __webpack_require__(981),
  /* scopeId */
  "data-v-41365ba2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(827)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(559),
  /* template */
  __webpack_require__(1019),
  /* scopeId */
  "data-v-a1a20456",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(837)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(560),
  /* template */
  __webpack_require__(1029),
  /* scopeId */
  "data-v-f299e44c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(782)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(561),
  /* template */
  __webpack_require__(971),
  /* scopeId */
  "data-v-30f7a197",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(562),
  /* template */
  __webpack_require__(960),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(759)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(563),
  /* template */
  __webpack_require__(944),
  /* scopeId */
  "data-v-088ec2e2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(783)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(564),
  /* template */
  __webpack_require__(972),
  /* scopeId */
  "data-v-32722ec8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(819)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(565),
  /* template */
  __webpack_require__(1010),
  /* scopeId */
  "data-v-7b47752c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(805)
__webpack_require__(804)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(567),
  /* template */
  __webpack_require__(996),
  /* scopeId */
  "data-v-61fabc52",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(806)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(568),
  /* template */
  __webpack_require__(997),
  /* scopeId */
  "data-v-65c78a5b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(830)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(570),
  /* template */
  __webpack_require__(1022),
  /* scopeId */
  "data-v-bf8a6cf0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(572),
  /* template */
  __webpack_require__(938),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(825)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(574),
  /* template */
  __webpack_require__(1017),
  /* scopeId */
  "data-v-97b983a8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(796)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(576),
  /* template */
  __webpack_require__(987),
  /* scopeId */
  "data-v-45c17277",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(578),
  /* template */
  __webpack_require__(949),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  null,
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(781)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(580),
  /* template */
  __webpack_require__(970),
  /* scopeId */
  "data-v-2e1cf612",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(764)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(581),
  /* template */
  __webpack_require__(950),
  /* scopeId */
  "data-v-100bc86d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(811)
__webpack_require__(812)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(582),
  /* template */
  __webpack_require__(1003),
  /* scopeId */
  "data-v-6d09672b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(765)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(583),
  /* template */
  __webpack_require__(951),
  /* scopeId */
  "data-v-10881da4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(797)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(584),
  /* template */
  __webpack_require__(989),
  /* scopeId */
  "data-v-4c27ffc4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(585),
  /* template */
  __webpack_require__(1001),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(791)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(586),
  /* template */
  __webpack_require__(982),
  /* scopeId */
  "data-v-41f3bd4d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(836)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(587),
  /* template */
  __webpack_require__(1028),
  /* scopeId */
  "data-v-ed935b92",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(816)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(589),
  /* template */
  __webpack_require__(1007),
  /* scopeId */
  "data-v-7a3b2e4d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(763)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(590),
  /* template */
  __webpack_require__(948),
  /* scopeId */
  "data-v-0e296fa4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(767)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(591),
  /* template */
  __webpack_require__(953),
  /* scopeId */
  "data-v-11d9e17b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(785)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(592),
  /* template */
  __webpack_require__(976),
  /* scopeId */
  "data-v-3b78e754",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(760)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(594),
  /* template */
  __webpack_require__(945),
  /* scopeId */
  "data-v-0bb2270f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(755)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(595),
  /* template */
  __webpack_require__(940),
  /* scopeId */
  "data-v-0303ac13",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(822)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(596),
  /* template */
  __webpack_require__(1014),
  /* scopeId */
  "data-v-89807412",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(762)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(598),
  /* template */
  __webpack_require__(947),
  /* scopeId */
  "data-v-0d936a44",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(799)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(599),
  /* template */
  __webpack_require__(991),
  /* scopeId */
  "data-v-51e304af",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(777)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(600),
  /* template */
  __webpack_require__(965),
  /* scopeId */
  "data-v-29954077",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(798)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(601),
  /* template */
  __webpack_require__(990),
  /* scopeId */
  "data-v-4ea30f5e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(793)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(602),
  /* template */
  __webpack_require__(984),
  /* scopeId */
  "data-v-42d29196",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(761)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(603),
  /* template */
  __webpack_require__(946),
  /* scopeId */
  "data-v-0c604328",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(823)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(604),
  /* template */
  __webpack_require__(1015),
  /* scopeId */
  "data-v-8bd0a094",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(831)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(605),
  /* template */
  __webpack_require__(1023),
  /* scopeId */
  "data-v-d2112d12",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(834)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(606),
  /* template */
  __webpack_require__(1026),
  /* scopeId */
  "data-v-e0ea46c0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(786)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(607),
  /* template */
  __webpack_require__(977),
  /* scopeId */
  "data-v-3d20ee39",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(756)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(608),
  /* template */
  __webpack_require__(941),
  /* scopeId */
  "data-v-0501490f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(826)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(609),
  /* template */
  __webpack_require__(1018),
  /* scopeId */
  "data-v-97dc236c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(770)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(610),
  /* template */
  __webpack_require__(957),
  /* scopeId */
  "data-v-1843b610",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(794)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(611),
  /* template */
  __webpack_require__(985),
  /* scopeId */
  "data-v-44613850",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(817)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(612),
  /* template */
  __webpack_require__(1008),
  /* scopeId */
  "data-v-7a74ed8d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(787)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(613),
  /* template */
  __webpack_require__(978),
  /* scopeId */
  "data-v-3f927f76",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(615),
  /* template */
  __webpack_require__(973),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(766)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(616),
  /* template */
  __webpack_require__(952),
  /* scopeId */
  "data-v-11a5e360",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(802)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(617),
  /* template */
  __webpack_require__(994),
  /* scopeId */
  "data-v-5d31104d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(754)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(618),
  /* template */
  __webpack_require__(939),
  /* scopeId */
  "data-v-01a23054",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(792)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(619),
  /* template */
  __webpack_require__(983),
  /* scopeId */
  "data-v-421af64a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(813)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(620),
  /* template */
  __webpack_require__(1004),
  /* scopeId */
  "data-v-6ec0bde2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(621),
  /* template */
  __webpack_require__(955),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(622),
  /* template */
  __webpack_require__(969),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 938 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('HalfCircleSpinner', {
    staticStyle: {
      "margin": "200px auto",
      "float": "none"
    },
    attrs: {
      "animation-duration": 2000,
      "size": 80,
      "color": '#ec4141'
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 939 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (this.$store.state.modal.modalConfirmarMultaGlosa.show === true) ? _c('div', {
    staticClass: "in show modal fade adicionarEvidencia",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h3', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(((_vm.infoMultas.modo === 'NOVO' ? 'Confirmar' : 'Exibir') + " Aplicação de Multa e Glosa")) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "modal-body alert-body icon-acoes btable"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [(_vm.infoMultas.modo === 'NOVO') ? _c('div', [_vm._m(0), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (Object.keys(_vm.infoMultas).length) ? _c('div', {
    staticClass: "tabelaexibicao"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.infoMultas.uf))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.infoMultas.tipo_imovel_servico))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.infoMultas.mes_sigla))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.infoMultas.ano))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('money', _vm._b({
    staticClass: "formatacao-input-exibe-puro-texto",
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.infoMultas.multa),
      callback: function($$v) {
        _vm.$set(_vm.infoMultas, "multa", $$v)
      },
      expression: "infoMultas.multa"
    }
  }, 'money', _vm.money, false))], 1), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('money', _vm._b({
    staticClass: "formatacao-input-exibe-puro-texto",
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.infoMultas.glosa),
      callback: function($$v) {
        _vm.$set(_vm.infoMultas, "glosa", $$v)
      },
      expression: "infoMultas.glosa"
    }
  }, 'money', _vm.money, false))], 1), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('money', _vm._b({
    staticClass: "formatacao-input-exibe-puro-texto",
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.infoMultas.total),
      callback: function($$v) {
        _vm.$set(_vm.infoMultas, "total", $$v)
      },
      expression: "infoMultas.total"
    }
  }, 'money', _vm.money, false))], 1)])])]), _vm._v(" "), _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', {
    staticClass: "b-input-component"
  }, [_c('b-col', {
    attrs: {
      "sm": "3"
    }
  }, [_c('label', [_vm._v("Observação:")])]), _vm._v(" "), (_vm.infoMultas.modo === 'NOVO') ? _c('b-col', {
    attrs: {
      "sm": "12"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "placeholder": "Insira uma observação",
      "rows": "3",
      "max-rows": "6"
    },
    model: {
      value: (_vm.observacao),
      callback: function($$v) {
        _vm.observacao = $$v
      },
      expression: "observacao"
    }
  })], 1) : _c('b-col', {
    attrs: {
      "sm": "9"
    }
  }, [_c('p', [_vm._v(" " + _vm._s(_vm.infoMultas.observacao) + " ")])])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('b-row', {
    staticClass: "b-input-component"
  }, [(_vm.infoMultas.modo === 'NOVO') ? _c('div', [_c('b-col', {
    attrs: {
      "sm": "3"
    }
  }, [_c('label', [_vm._v("Inserir Anexo *:")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "12"
    }
  }, [_c('div', {
    staticClass: "form-group col-xs-12 col-sm-4 col-md-4 anexo-padding"
  }, [_c('input', {
    ref: "file_anexo",
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "id": "btn-upload",
      "value": ""
    },
    on: {
      "change": function($event) {
        return _vm.configuraBotaoArquivo($event)
      }
    }
  })])])], 1) : _c('div', [_c('b-col', {
    attrs: {
      "sm": "3"
    }
  }, [_c('label', [_vm._v("Anexo:")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "9"
    }
  }, [(_vm.infoMultas.nome_arquivo) ? _c('div', [_c('a', {
    attrs: {
      "href": "javascript:void(0)",
      "data-toggle": "listarGlosas"
    },
    on: {
      "click": function($event) {
        return _vm.downloadAnexoMultaGlosa(_vm.infoMultas.nome_arquivo)
      }
    }
  }, [_vm._v("\n                          Download\n                        ")])]) : _c('div', [_c('p', [_vm._v(" Nenhum anexo adicionado ")])])])], 1)])], 1)], 1) : _c('div', [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v("Nenhuma multa e/ou glosa encontrada para este contrato.")])])])])]), _vm._v(" "), (_vm.controlerBtnSubmit && _vm.novoFechamento) ? _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-submit",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), (_vm.controlerBtnSubmit) ? _c('button', {
    staticClass: "btn btn-primary btn-submit",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.salvarConfirmacaoMultaGlosa()
      }
    }
  }, [_vm._v("Confirmar")]) : _c('button', {
    staticClass: "btn btn-primary btn-submit",
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" aguarde...")])]) : _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-submit",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }, [_vm._v("Cancelar")])])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-danger"
  }, [_c('i', [_vm._v("* Campos obrigatórios")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("UF")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Contrato")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Mês")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Ano")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Multa")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Glosa")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Total")])])])
}]}

/***/ }),
/* 940 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('vue-excel-xlsx', {
    staticClass: "btn btn-primary",
    attrs: {
      "data": _vm.data,
      "columns": _vm.columns,
      "filename": 'orçamentos-corretivas',
      "sheetname": 'sheetname'
    }
  }, [_vm._v("\n    Orçamentos Corretivas\n  ")])], 1)
},staticRenderFns: []}

/***/ }),
/* 941 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.downloadAnexo()
      }
    }
  }, [_vm._v("\n    Chamados\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 942 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fingerprint-spinner",
    style: (_vm.spinnerStyle)
  }, _vm._l((_vm.ringsStyles), function(rs, index) {
    return _c('div', {
      key: index,
      staticClass: "spinner-ring",
      style: (rs)
    })
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 943 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "semipolar-spinner",
    style: (_vm.spinnerStyle)
  }, _vm._l((_vm.ringsStyles), function(rs, index) {
    return _c('div', {
      key: index,
      staticClass: "ring",
      style: (rs)
    })
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 944 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "form-glosa header"
  }, [_c('header', [_c('div', [_vm._m(0), _vm._v(" "), _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.mes_id),
      expression: "form.mes_id"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "mes_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.meses), function(mes) {
    return _c('option', {
      class: _vm.evidenciaEnviada[((mes.id) - 1)] === 0 ? '' : 'disabled',
      attrs: {
        "disabled": _vm.evidenciaEnviada[((mes.id) - 1)] === 0 ? false : true
      },
      domProps: {
        "value": mes.id
      }
    }, [_vm._v(_vm._s(((_vm.evidenciaEnviada[((mes.id) - 1)] === 0) ? ('' + mes.nome + '') : (' - ' + mes.nome + ' * fech. enviado'))))])
  }), 0)])]), _vm._v(" "), _c('div', [_vm._m(1), _vm._v(" "), _c('div', [_c('b-form-select', {
    attrs: {
      "options": _vm.existeGlosa
    },
    on: {
      "change": _vm.restauraFormSelecaoNegativa
    },
    model: {
      value: (_vm.form.existe_glosa),
      callback: function($$v) {
        _vm.$set(_vm.form, "existe_glosa", $$v)
      },
      expression: "form.existe_glosa"
    }
  })], 1)])]), _vm._v(" "), (_vm.form.existe_glosa === 1) ? _c('section', {
    staticClass: "form-glosa body"
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', {
    staticClass: "b-input-component"
  }, [_c('b-col', {
    attrs: {
      "sm": "3"
    }
  }, [_c('label', [_vm._v("Quantidade:")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "9"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.form.quantidade),
      callback: function($$v) {
        _vm.$set(_vm.form, "quantidade", $$v)
      },
      expression: "form.quantidade"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', {
    staticClass: "b-input-component"
  }, [_c('b-col', {
    attrs: {
      "sm": "3"
    }
  }, [_c('label', [_vm._v("Valor:")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "9"
    }
  }, [_c('money', _vm._b({
    model: {
      value: (_vm.form.valor),
      callback: function($$v) {
        _vm.$set(_vm.form, "valor", $$v)
      },
      expression: "form.valor"
    }
  }, 'money', _vm.money, false))], 1)], 1)], 1), _vm._v(" "), _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', {
    staticClass: "b-input-component"
  }, [_c('b-col', {
    attrs: {
      "sm": "3"
    }
  }, [_c('label', [_vm._v("Observação:")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "9"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "placeholder": "Insira uma observação",
      "rows": "3",
      "max-rows": "6"
    },
    model: {
      value: (_vm.form.observacao),
      callback: function($$v) {
        _vm.$set(_vm.form, "observacao", $$v)
      },
      expression: "form.observacao"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', {
    staticClass: "b-input-component"
  }, [_c('b-col', {
    attrs: {
      "sm": "3"
    }
  }, [_c('label', [_vm._v("Arquivo:")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "9"
    }
  }, [_c('input', {
    ref: "arquivo",
    attrs: {
      "type": "file",
      "value": ""
    },
    on: {
      "change": _vm.getArquivo
    }
  })])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-submit",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.fecharModal()
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), (_vm.controlerBtnSubmit) ? _c('button', {
    staticClass: "btn btn-primary btn-submit",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.salvarGlosa()
      }
    }
  }, [_vm._v("Salvar")]) : _c('button', {
    staticClass: "btn btn-primary btn-submit",
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" aguarde...")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', [_vm._v("Mês:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', [_vm._v("Existe glosa:")])])
}]}

/***/ }),
/* 945 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.controlerBtnSubmit) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.abrirModal()
      }
    }
  }, [_vm._v("Fechamento Fixo e Variável")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Carregando Fechamento Fixo e Variável...")]), _c('br'), _vm._v(" "), (_vm.controlerBtnSubmit) ? _c('span', {
    staticStyle: {
      "font-size": "10px",
      "color": "red"
    }
  }, [_c('svg', {
    staticClass: "bi bi-exclamation-circle",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "12",
      "height": "12",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z"
    }
  })]), _vm._v(" "), _c('b', [_vm._v("O tempo de download pode variar conforme o número de estados do usuário.")])]) : _vm._e(), _vm._v(" "), _c('modal-fechamento-fixo-variavel', {
    on: {
      "selecionado": _vm.downloadAnexo
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 946 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.downloadAnexo()
      }
    }
  }, [_vm._v("\n    Histórico de Chamados\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 947 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.downloadAnexo()
      }
    }
  }, [_vm._v("\n     Chamados Deaverage\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 948 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modalHistoricoNotificacoes",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body alert-body"
  }, [_c('div', {
    staticClass: "filtro-historico-notificacoes"
  }, [_c('b-form-group', {
    attrs: {
      "label": "Filtrar pesquisa",
      "label-for": "filterInput",
      "align": "center"
    }
  }, [_c('b-input-group', [_c('b-form-input', {
    staticClass: "text-align-center",
    attrs: {
      "type": "search",
      "id": "filterInput",
      "placeholder": "Pesquise por qualquer palavra chave"
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _vm._v(" "), _c('b-button', {
    staticClass: "limparPesquisaBotao",
    attrs: {
      "disabled": !_vm.filter,
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.filter = ''
      }
    }
  }, [_vm._v("Limpar pesquisa")])], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "items": _vm.historicoNotificacoes,
      "filter": _vm.filter,
      "fields": _vm.fieldsHistorico
    }
  })], 1)]), _vm._v(" "), _vm._m(1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h1', {
    staticClass: "modal-title"
  }, [_vm._v("Histórico de Notificações")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Fechar")])])
}]}

/***/ }),
/* 949 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('modal-alert-global'), _vm._v(" "), _c('modal-listar-evidencia', {
    attrs: {
      "consultaEvidencias": this.$store.state.evidenciasPorMes.evidencias
    }
  }), _vm._v(" "), _c('modal-inserir-evidencia'), _vm._v(" "), _c('modal-historico-sla'), _vm._v(" "), _c('modal-form-exibir-notificacao'), _vm._v(" "), _c('modal-historico-notificacao', {
    attrs: {
      "consultaHistoricoNotificacoes": this.$store.state.historicoNotificacoes.historicoNotificacoes
    }
  }), _vm._v(" "), _c('modal-alert-calendario'), _vm._v(" "), _c('modal-permissao-negada'), _vm._v(" "), _c('modal-adiconar-glosa'), _vm._v(" "), _c('modal-listar-glosas', {
    attrs: {
      "glosasMesAtual": this.$store.state.modal.modalListaGlosasPorMes
    }
  }), _vm._v(" "), (this.$store.state.modal.extraContratual.show) ? _c('modal-extraContratual') : _vm._e(), _vm._v(" "), _c('modal-confirmar-multa-glosa', {
    attrs: {
      "multas": this.$store.state.confirmarMultaGlosa.dados
    }
  }), _vm._v(" "), _c('modal-alert-atualizacoes')], 1)
},staticRenderFns: []}

/***/ }),
/* 950 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (this.$store.state.modal.planilhasPreventivas.show === true) ? _c('div', {
    staticClass: "in show modal fade planilhasPreventivas",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.fecharModal()
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h3', {
    staticClass: "modal-title"
  }, [_vm._v("Planilhas de Preventivas ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "d-flex justify-content-center align-items-center"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "bienio"
    }
  }, [_vm._v("Selecione os anos que deseja baixar:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bienio),
      expression: "bienio"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.bienio = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.bienios), function(b) {
    return _c('option', {
      key: b,
      domProps: {
        "value": b
      }
    }, [_vm._v(_vm._s(b.replace('_', '/')))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn-primary",
    attrs: {
      "id": "button"
    },
    on: {
      "click": function($event) {
        return _vm.selecionar()
      }
    }
  }, [_vm._v("Selecionar")])])])])])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 951 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    class: [(this.$store.state.permissaoNegada.permissaoNegada.show === true) ? 'in show' : '', 'modal fade permissaoNegada'],
    attrs: {
      "id": "permissaoNegada",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    class: [(this.$store.state.permissaoNegada.permissaoNegada.status) ? 'sucesso' : 'falhou', 'modal-header']
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.fecharModal()
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), (this.$store.state.permissaoNegada.permissaoNegada.status) ? _c('h4', {
    staticClass: "modal-title alert-title"
  }, [_vm._v(" Sucesso! "), _c('span', [_c('b-icon-unlock-fill')], 1)]) : _c('h4', {
    staticClass: "modal-title alert-title"
  }, [_vm._v(" Acesso negado! "), _c('span', [_c('b-icon-lock-fill')], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body alert-body",
    domProps: {
      "innerHTML": _vm._s(this.$store.state.permissaoNegada.permissaoNegada.msg)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.fecharModal()
      }
    }
  }, [_vm._v("Fechar")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 952 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.permissao) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "box box-default align-cabecalho"
  }, [_c('a', {
    staticClass: "info-fechamento",
    attrs: {
      "id": "info"
    },
    on: {
      "click": _vm.exibeInfoFechamento
    }
  }, [_vm._v("Datas fechamento financeiro")]), _vm._v(" "), _c('h2', [_vm._v("SLA Gerencial ")]), _vm._v(" "), _c('div', {
    staticClass: "cabecalho"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-inline"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group",
    attrs: {
      "al": "",
      "ign": "right"
    }
  }, [_c('label', {
    staticClass: "lb-sla-gerencial",
    attrs: {
      "for": "exampleInputName2"
    }
  }, [_vm._v("Ano:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ano_selecionado),
      expression: "ano_selecionado"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.ano_selecionado = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changeAno()
      }]
    }
  }, _vm._l((_vm.anos), function(i) {
    return _c('option', {
      key: i.id
    }, [_vm._v(_vm._s(i))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "lb-sla-gerencial",
    attrs: {
      "for": "exampleInputName2"
    }
  }, [_vm._v("Estado:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.uf_selecionada),
      expression: "uf_selecionada"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.uf_selecionada = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.limparContrato()
      }]
    }
  }, _vm._l((_vm.ufs), function(uf) {
    return _c('option', {
      key: uf.id,
      domProps: {
        "value": uf.id
      }
    }, [_vm._v(_vm._s(uf.nome))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "lb-sla-gerencial",
    attrs: {
      "for": "exampleInputName2"
    }
  }, [_vm._v("Contrato:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contrato_selecionado),
      expression: "contrato_selecionado"
    }],
    staticClass: "form-control",
    attrs: {
      "align": "center"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.contrato_selecionado = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changeContrato();
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "-- Selecionar Contrato --",
      "disabled": ""
    }
  }, [_vm._v("-- Selecionar Contrato --")]), _vm._v(" "), _vm._l((_vm.tipo_imovel_servicos), function(i) {
    return _c('option', {
      key: i.id,
      domProps: {
        "value": i
      }
    }, [_vm._v(_vm._s(i.nome))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "lb-sla-gerencial",
    attrs: {
      "for": "exampleInputName2"
    }
  }, [_vm._v("Fornecedor:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fornecedor_selecionado),
      expression: "fornecedor_selecionado"
    }],
    staticClass: "form-control",
    attrs: {
      "align": "center"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.fornecedor_selecionado = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changeFornecedor()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "-- Selecionar Fornecedor --",
      "disabled": ""
    }
  }, [_vm._v("-- Selecionar Fornecedor --")]), _vm._v(" "), _vm._l((_vm.fornecedores), function(i) {
    return _c('option', {
      key: i.id,
      domProps: {
        "value": i
      }
    }, [_vm._v(_vm._s(i.nome) + " - #" + _vm._s((i.numero_contrato.length > 0) ? i.numero_contrato.substring(0, (i.numero_contrato.length - 2)) : '') + " ")])
  })], 2)])])])])]), _vm._v(" "), _c('controle-apuracao-sla', {
    ref: "controleApuracaoSla",
    attrs: {
      "anoSelecionado": _vm.ano_selecionado,
      "semresultado": _vm.semresultado
    }
  })], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('strong', [_vm._v(" Selecione o SLA que deseja visualizar/preencher: ")])])
}]}

/***/ }),
/* 953 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('fieldset', [_c('legend', [_vm._v("Usuário:")]), _vm._v(" "), _c('ul', [(_vm.usuario.name) ? _c('li', [_c('strong', [_vm._v("Nome: ")]), _vm._v(_vm._s(_vm.usuario.name))]) : _vm._e(), _vm._v(" "), (_vm.usuario.email) ? _c('li', [_c('strong', [_vm._v("E-mail: ")]), _vm._v(_vm._s(_vm.usuario.email))]) : _vm._e(), _vm._v(" "), (_vm.usuario.telefone) ? _c('li', [_c('strong', [_vm._v("Telefone: ")]), _vm._v(_vm._s(_vm.usuario.telefone))]) : _vm._e(), _vm._v(" "), (_vm.usuario.created_at) ? _c('li', [_c('strong', [_vm._v("Criado: ")]), _vm._v(_vm._s(_vm._f("moment")(_vm.usuario.created_at, "DD/MM/YYYY HH:mm")))]) : _vm._e(), _vm._v(" "), (_vm.usuario.updated_at) ? _c('li', [_c('strong', [_vm._v("atualizado: ")]), _vm._v(_vm._s(_vm._f("moment")(_vm.usuario.updated_at, "DD/MM/YYYY HH:mm")))]) : _vm._e()])]), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Grupo:")]), _vm._v(" "), _c('ul', _vm._l((_vm.grupo), function(i) {
    return _c('li', [_vm._v(_vm._s(i.nome))])
  }), 0)]), _vm._v(" "), (_vm.estado.length) ? _c('fieldset', [_c('legend', [_vm._v("Estado vinculado:")]), _vm._v(" "), _c('ul', _vm._l((_vm.estado), function(i) {
    return _c('li', [_vm._v(_vm._s(i.nome))])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.contrato.length) ? _c('fieldset', [_c('legend', [_vm._v("Contrato vinculado:")]), _vm._v(" "), _c('ul', _vm._l((_vm.contrato), function(i) {
    return (i.numero_contrato) ? _c('li', [_vm._v("\n            " + _vm._s(i.numero_contrato) + "\n          ")]) : _vm._e()
  }), 0)]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h1', [_vm._v("Informações do usuário")])])
}]}

/***/ }),
/* 954 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "looping-rhombuses-spinner",
    style: (_vm.spinnerStyle)
  }, _vm._l((_vm.rhombusesStyles), function(rs, index) {
    return _c('div', {
      staticClass: "rhombus",
      style: (rs),
      attrs: {
        "ikey": index
      }
    })
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 955 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: this['class']
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 956 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scaling-squares-spinner",
    style: (_vm.spinnerStyle)
  }, _vm._l((_vm.squaresStyles), function(ss, index) {
    return _c('div', {
      key: index,
      staticClass: "square",
      class: ("square-" + (index + 1)),
      style: (ss)
    })
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 957 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.downloadAnexo()
      }
    }
  }, [_vm._v("\n    Log de Chamados\n")])])
},staticRenderFns: []}

/***/ }),
/* 958 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "bloco-animacao-redirecionar-usuario"
  }, [_c('h1', [_c('BreedingRhombusSpinner')], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 959 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spring-spinner",
    style: (_vm.spinnerStyle)
  }, [_c('div', {
    staticClass: "spring-spinner-part top",
    style: (_vm.spinnerPartStyle)
  }, [_c('div', {
    staticClass: "spring-spinner-rotator",
    style: (_vm.rotatorStyle)
  })]), _vm._v(" "), _c('div', {
    staticClass: "spring-spinner-part bottom",
    style: (_vm.spinnerPartStyle)
  }, [_c('div', {
    staticClass: "spring-spinner-rotator",
    style: (_vm.rotatorStyle)
  })])])
},staticRenderFns: []}

/***/ }),
/* 960 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(this.$store.state.itensSla.controleExibicaoImpressao) ? _c('div', [_c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "items": _vm.evidenciasPorItem
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 961 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    class: [(this.$store.state.alertAtualizacoes.alertAtualizacoes.show === true) ? 'in show' : '', 'modal fade'],
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "back-header modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.fecharModal()
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title alert-title color-h4"
  }, [_vm._v("⚠️ Últimas atualizações do sistema ⚠️")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._m(1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.fecharModal()
      }
    }
  }, [_vm._v("Fechar")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticStyle: {
      "display": "none !important"
    },
    attrs: {
      "id": "loadContent0"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "loadContent"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://manual.portalssp.com/notas-ssp-financeiro/",
      "target": "_blank"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Ver Mais")])])
}]}

/***/ }),
/* 962 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intersecting-circles-spinner",
    style: (_vm.spinnerStyle)
  }, [_c('div', {
    staticClass: "spinnerBlock",
    style: (_vm.spinnerBlockStyle)
  }, _vm._l((_vm.circleStyles), function(cs, index) {
    return _c('span', {
      key: index,
      staticClass: "circle",
      style: (cs)
    })
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 963 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(!_vm.controlerBtnSubmit) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.abrirModal()
      }
    }
  }, [_vm._v("Exportar Extra")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Carregando Extra Contratual...")])]), _vm._v(" "), _c('modal-exportar-extra', {
    on: {
      "selecionado": _vm.exportarExtra
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 964 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    attrs: {
      "id": "content-wrap"
    }
  }, [_c('section', {
    staticClass: "content"
  }, [_c('transition', {
    attrs: {
      "name": "page",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 965 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.controlerBtnSubmit == true) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.planilhaFranquia()
      }
    }
  }, [_vm._v("\n    Relatório Franquias (Excel)\n  ")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Carregando Relatório de Franquias...\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 966 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    class: [(this.$store.state.modal.alert.show === true) ? 'in show' : '', 'modal fade alertGlobal'],
    attrs: {
      "id": "alertGlobal",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    class: [(this.$store.state.modal.alert.status) ? 'sucesso' : 'falhou', 'modal-header']
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.fecharModal()
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), (this.$store.state.modal.alert.status) ? _c('h4', {
    staticClass: "modal-title alert-title"
  }, [_vm._v(" Sucesso! "), _c('span', [_vm._v(" :-) ")])]) : _c('h4', {
    staticClass: "modal-title alert-title"
  }, [_vm._v(" Algo deu errado! "), _c('span', [_vm._v(" :-( ")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body alert-body",
    domProps: {
      "innerHTML": _vm._s(this.$store.state.modal.alert.msg)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.fecharModal()
      }
    }
  }, [_vm._v("Fechar")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 967 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.animacao) ? _c('div', {
    staticClass: "bloco-animacao-redirecionar-usuario"
  }, [_c('h1', [_c('BreedingRhombusSpinner')], 1)]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "main-sidebar",
    attrs: {
      "id": "slider"
    }
  }, [_c('section', {
    staticClass: "sidebar"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "sidebar-menu",
    attrs: {
      "data-widget": "tree"
    }
  }, _vm._l((_vm.slideMenuItems), function(item, index) {
    return _c('va-slide-item', {
      key: index,
      attrs: {
        "data": item,
        "type": item.type,
        "isHeader": item.isHeader,
        "icon": item.icon,
        "name": item.name,
        "badge": item.badge,
        "items": item.items,
        "router": item.router,
        "link": item.link
      }
    })
  }), 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo image"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(853),
      "alt": "Logo do Sistema SSP"
    }
  })])
}]}

/***/ }),
/* 969 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 970 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (this.$store.state.modal.planilhasChamados.show === true) ? _c('div', {
    staticClass: "in show modal fade planilhasChamados",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.fecharModal()
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h3', {
    staticClass: "modal-title"
  }, [_vm._v("Planilhas de Chamados ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "d-flex justify-content-center align-items-center"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "bienio"
    }
  }, [_vm._v("Selecione os anos que deseja baixar:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bienio),
      expression: "bienio"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.bienio = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.bienios), function(b) {
    return _c('option', {
      key: b,
      domProps: {
        "value": b
      }
    }, [_vm._v(_vm._s(b.replace('_', '/')))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn-primary",
    attrs: {
      "id": "button"
    },
    on: {
      "click": function($event) {
        return _vm.selecionar()
      }
    }
  }, [_vm._v("Selecionar")])])])])])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 971 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "modal fade modal-evidencia",
    attrs: {
      "id": "listarEvidencias",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body alert-body icon-acoes btable"
  }, [_c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadingEvidencias),
      expression: "loadingEvidencias"
    }],
    staticClass: "loading"
  }, [_c('HalfCircleSpinner', {
    attrs: {
      "animation-duration": 2000,
      "size": 60,
      "color": '#3c8dbc'
    }
  })], 1), _vm._v(" "), (_vm.evidencias.length) ? _c('b-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loadingEvidencias),
      expression: "!loadingEvidencias"
    }],
    attrs: {
      "striped": "",
      "hover": "",
      "items": _vm.evidencias,
      "fields": _vm.fieldsEvidencias
    },
    scopedSlots: _vm._u([{
      key: "cell(arquivo)",
      fn: function(data) {
        return [(data.item.arquivo) ? _c('a', {
          attrs: {
            "href": "javascript:void(0)"
          },
          on: {
            "click": function($event) {
              return _vm.downloadArquivo(data.value)
            }
          }
        }, [_vm._v("Download")]) : _c('span', [_vm._v(" - ")])]
      }
    }, {
      key: "cell(excluir)",
      fn: function(data) {
        return [_c('div', {
          staticClass: "btn-excluir"
        }, [(_vm.controlerLoadingDelete) ? _c('a', {
          attrs: {
            "href": "javascript:void(0)"
          },
          on: {
            "click": function($event) {
              return _vm.excluirEvidencia(data.item.evidencia_id)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-times-circle-o"
        })]) : _c('a', {
          attrs: {
            "href": "javascript:void(0)"
          }
        }, [_vm._v("Aguarde...")])])]
      }
    }, {
      key: "cell(anulado)",
      fn: function(data) {
        return [(!data.value) ? _c('div', {
          staticClass: "btn-anular"
        }, [(_vm.controlerLoadingDelete) ? _c('a', {
          attrs: {
            "href": "javascript:void(0)",
            "title": "Anular evidência"
          },
          on: {
            "click": function($event) {
              return _vm.anularEvidencia(data.item.evidencia_id)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-times-circle-o"
        })]) : _c('a', {
          attrs: {
            "href": "javascript:void(0)"
          }
        }, [_vm._v("Aguarde...")])]) : _c('div', {
          staticClass: "btn-desanular"
        }, [(_vm.controlerLoadingDelete) ? _c('a', {
          attrs: {
            "href": "javascript:void(0)",
            "title": "Desanular evidência"
          },
          on: {
            "click": function($event) {
              return _vm.desanularEvidencia(data.item.evidencia_id)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-times-circle-o"
        })]) : _c('a', {
          attrs: {
            "href": "javascript:void(0)"
          }
        }, [_vm._v("Aguarde...")])])]
      }
    }], null, false, 2475427142)
  }) : (this.controlerLoading == false) ? _c('div', [_c('p', {
    staticClass: "sem-evidencias"
  }, [_vm._v("Procurando evidências...")])]) : _c('div', [_c('p', {
    staticClass: "sem-evidencias"
  }, [_vm._v("Ops... não há evidências por aqui... (-:")])])], 1), _vm._v(" "), _vm._m(1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h1', {
    staticClass: "modal-title"
  }, [_vm._v("Lista de evidências ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Fechar")])])
}]}

/***/ }),
/* 972 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(this.$store.state.modal.adicionarGlosa.show === true) ? _c('div', {
    staticClass: "in show modal fade adicionarGlosa",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    class: [(this.$store.state.modal.adicionarGlosa.status) ? 'sucesso' : 'falhou', 'modal-header']
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.fecharModal()
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title alert-title"
  }, [_c('span', [_c('b-icon', {
    attrs: {
      "icon": "wallet2"
    }
  })], 1), _vm._v(" Evidência de glosa\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body content-body"
  }, [_c('form-adicionar-glosa', {
    attrs: {
      "contrato": this.$store.state.contrato,
      "fecharModal": _vm.fecharModal
    }
  })], 1)])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 973 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('listar-sla', {
    attrs: {
      "refresh_componentes": this.$store.state.refreshComponente.refreshComponente
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 974 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.abrirModal()
      }
    }
  }, [_vm._v("\n        Chamados\n      ")]), _vm._v(" "), _c('modal-planilhas-chamados', {
    on: {
      "selecionado": _vm.downloadAnexo
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 975 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.ocultarItem) ? _c('li', {
    class: _vm.getType
  }, [(_vm.router && _vm.router.name) ? [_c('router-link', {
    attrs: {
      "to": _vm.router
    }
  }, [_c('i', {
    class: _vm.icon
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.badge),
      expression: "badge"
    }],
    staticClass: "pull-right-container"
  }, [_c('small', {
    staticClass: "label pull-right",
    class: [_vm.badge.type === 'String' ? 'bg-green' : 'label-primary']
  }, [_vm._v(_vm._s(_vm.badge.data))])])])] : [_vm._v("\n    " + _vm._s(_vm.isHeader ? _vm.name : '') + "\n    "), (!_vm.isHeader) ? _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    class: _vm.icon
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [(_vm.badge && _vm.badge.data) ? _c('small', {
    staticClass: "label pull-right",
    class: [_vm.badge.type === 'String' ? 'bg-green' : 'label-primary']
  }, [_vm._v(_vm._s(_vm.badge.data))]) : _c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])]) : _vm._e(), _vm._v(" "), (_vm.filterItems.length > 0) ? _c('ul', {
    staticClass: "treeview-menu"
  }, _vm._l((_vm.filterItems), function(item, index) {
    return (item.router && item.router.name) ? _c('router-link', {
      key: index,
      attrs: {
        "tag": "li",
        "data": item,
        "to": item.router
      }
    }, [(_vm.exibeSubMenuGrupoUsuario(item)) ? _c('a', [_c('i', {
      class: item.icon
    }), _vm._v(" " + _vm._s(item.name) + "\n        ")]) : _vm._e()]) : _vm._e()
  }), 1) : _vm._e()]], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 976 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h3', [_vm._v("Exportar planilhas - Financeiro")]), _vm._v(" "), _c('div', {
    staticClass: "botoes"
  }, [_c('export-extracontratual', {
    staticClass: "botoes-oper"
  }), _vm._v(" "), _c('export-fechamento-fixo-variavel', {
    staticClass: "botoes-oper"
  })], 1), _vm._v(" "), _c('h3', [_vm._v("Exportar planilhas - Operacional")]), _vm._v(" "), _c('div', {
    staticClass: "botoes"
  }, [_c('export-orcamentos-aprovados', {
    staticClass: "botoes-oper"
  }), _vm._v(" "), _c('export-chamados', {
    staticClass: "botoes-oper"
  }), _vm._v(" "), _c('export-log-setembro-2019', {
    staticClass: "botoes-oper"
  }), _vm._v(" "), _c('export-preventivas', {
    staticClass: "botoes-oper"
  }), _vm._v(" "), _c('export-log-preventivas', {
    staticClass: "botoes-oper"
  })], 1), _vm._v(" "), _c('h3', [_vm._v("Exportar planilhas - Novo SSP")]), _vm._v(" "), _c('div', {
    staticClass: "botoes"
  }, [_c('export-adm-chamados', {
    staticClass: "botoes-oper"
  }), _vm._v(" "), _c('export-adm-historico-chamados', {
    staticClass: "botoes-oper"
  }), _vm._v(" "), _c('export-adm-deaverage', {
    staticClass: "botoes-oper"
  }), _vm._v(" "), _c('export-adm-preventivas', {
    staticClass: "botoes-oper"
  }), _vm._v(" "), _c('export-adm-franquias', {
    staticClass: "botoes-oper"
  }), _vm._v(" "), _c('export-adm-franquias-chamados', {
    staticClass: "botoes-oper"
  }), _vm._v(" "), _c('export-adm-historico-negociacoes', {
    staticClass: "botoes-oper"
  }), _vm._v(" "), _c('export-adm-extintores', {
    staticClass: "botoes-oper"
  }), _vm._v(" "), (!_vm.controlerBtnSubmit) ? _c('button', {
    staticClass: "btn btn-success botoes-oper",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.exportarBaseSimulacao
    }
  }, [_vm._v("Relatório Preventivas 2024/2025 (Excel)")]) : _vm._e(), _vm._v(" "), (_vm.controlerBtnSubmit) ? _c('button', {
    staticClass: "btn btn-secondary botoes-oper",
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Exportando...")]) : _vm._e(), _vm._v(" "), _c('export-adm-franquia-dinamica', {
    staticClass: "botoes-oper"
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Exportar relatórios semanais - Novo SSP")]), _vm._v(" "), _c('div', {
    staticClass: "botoes"
  }, [_c('export-adm-franquias-semanais', {
    staticClass: "botoes-oper"
  }), _vm._v(" "), _c('export-adm-preventivas-semanais', {
    staticClass: "botoes-oper"
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Exportar evidência de SLA")]), _vm._v(" "), _c('div', [_vm._v("\n    Temporariamente desativado\n    ")])])
},staticRenderFns: []}

/***/ }),
/* 977 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.controlerBtnSubmit) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.downloadAnexo()
      }
    }
  }, [_vm._v("Preventivas")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Carregando...")]), _c('br')])
},staticRenderFns: []}

/***/ }),
/* 978 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isFabricio) ? _c('div', {
    staticClass: "simulacao-geral"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "header-content"
  }, [_c('h3', [_vm._v("Quadro Geral Preventivas - Simulação")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-success",
    attrs: {
      "to": "/importar-preventivas"
    }
  }, [_vm._v("\n          Importar Dados\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "filtros"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "filtroFornecedor"
    }
  }, [_vm._v("Fornecedor")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtroFornecedor),
      expression: "filtroFornecedor"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "filtroFornecedor"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filtroFornecedor = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Todos")]), _vm._v(" "), _vm._l((_vm.fornecedores), function(fornecedor) {
    return _c('option', {
      key: fornecedor,
      domProps: {
        "value": fornecedor
      }
    }, [_vm._v(_vm._s(fornecedor))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "filtroUf"
    }
  }, [_vm._v("UF")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtroUf),
      expression: "filtroUf"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "filtroUf"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filtroUf = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Todas")]), _vm._v(" "), _vm._l((_vm.ufs), function(uf) {
    return _c('option', {
      key: uf,
      domProps: {
        "value": uf
      }
    }, [_vm._v(_vm._s(uf))])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [(_vm.carregando) ? _c('div', {
    staticClass: "loading"
  }, [_vm._m(0)]) : (_vm.erro) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v("\n        " + _vm._s(_vm.erro) + "\n      ")]) : _c('div', {
    staticClass: "tabela-container"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Fornecedor")]), _vm._v(" "), _c('th', [_vm._v("Regional")]), _vm._v(" "), _c('th', [_vm._v("Descrição")]), _vm._v(" "), _c('th', [_vm._v("UF")]), _vm._v(" "), _vm._l((_vm.meses), function(mes, index) {
    return _c('th', {
      key: index
    }, [_vm._v(_vm._s(mes))])
  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.dadosFiltrados), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(item.fornecedor))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.regional))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.descricao))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.uf))]), _vm._v(" "), _vm._l((_vm.meses), function(mes, mesIndex) {
      return _c('td', {
        key: mesIndex
      }, [_vm._v("\n                " + _vm._s(_vm.obterValorMes(item, mesIndex)) + "\n              ")])
    })], 2)
  }), 0), _vm._v(" "), _c('tfoot', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("Totais")]), _vm._v(" "), _vm._l((_vm.meses), function(mes, index) {
    return _c('th', {
      key: index
    }, [_vm._v("\n                " + _vm._s(_vm.calcularTotalMes(index)) + "\n              ")])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "resumo"
  }, [_c('h4', [_vm._v("Resumo por Fornecedor")]), _vm._v(" "), _c('div', {
    staticClass: "grafico-container"
  }, [_c('canvas', {
    ref: "graficoFornecedores",
    attrs: {
      "id": "graficoFornecedores"
    }
  })])])])])]) : _c('div', {
    staticClass: "alert alert-warning m-3"
  }, [_vm._v("Acesso restrito.")])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner-border text-primary",
    attrs: {
      "role": "status"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Carregando...")])])
}]}

/***/ }),
/* 979 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (this.$store.state.modal.fechamentoFixoVariavel.show === true) ? _c('div', {
    staticClass: "in show modal fade fechamentoFixoVariavel",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.fecharModal()
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Planilha de Fechamento Fixo e Variável ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "d-flex justify-content-center align-items-center"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "bienio"
    }
  }, [_vm._v("Selecione o mês e ano que deseja baixar:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mesAnoSelecionado),
      expression: "mesAnoSelecionado"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "month",
      "name": "",
      "id": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.mesAnoSelecionado)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mesAnoSelecionado = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [(_vm.alert) ? _c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_c('b', [_vm._v("Selecione mês e ano!")])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn-primary",
    attrs: {
      "id": "button"
    },
    on: {
      "click": function($event) {
        return _vm.selecionar()
      }
    }
  }, [_vm._v("Selecionar")])])])])])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 980 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (this.$store.state.contrato.itensContrato.contrato_id && this.$store.state.fornecedor.dadosFornecedor !== null) ? _c('div', {
    staticClass: "container-visualizacao-sla"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('vue-position-sticky', {
    staticClass: "ajusta-cabecalho-impressao"
  }, [_c('div', {
    staticClass: "sticky"
  }, [_c('div', {
    staticClass: "box-header with-border desabilitar-impressao"
  }, [_c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.exibeModalAdicionarEvidencia
    }
  }, [_vm._v("Adicionar evidência")]), _vm._v(" "), (this.$store.state.contrato.itensContrato.tipo_contrato_id != 3 && this.$store.state.contrato.itensContrato.tipo_contrato_id != 4) ? _c('b-button', {
    attrs: {
      "variant": "primary evidencia-retencao"
    },
    on: {
      "click": _vm.exibeModalAdicionarGlosa
    }
  }, [_vm._v("Adicionar evidência de glosa")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "text-center desabilitar-impressao"
  }, [_c('h4', [_c('strong', [_vm._v("CONTROLE E APURAÇÃO DE SLA")])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "col-md-6 label-cabecalho"
  }, [_c('label', {
    staticClass: "label-cabecalho"
  }, [_vm._v("Fornecedor: ")]), _vm._v("\n              " + _vm._s(typeof _vm.cabecalho_sla.fornecedor !== "undefined" ? _vm.cabecalho_sla.fornecedor : '') + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 label-cabecalho"
  }, [_c('label', {
    staticClass: "label-cabecalho"
  }, [_vm._v("Nº Contrato: ")]), _vm._v("\n              " + _vm._s(typeof _vm.cabecalho_sla.numero_contrato_original !== "undefined" ? _vm.cabecalho_sla.numero_contrato_original : '') + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 label-cabecalho"
  }, [_c('label', {
    staticClass: "label-cabecalho"
  }, [_vm._v("Natureza: ")]), _vm._v("\n              " + _vm._s(typeof _vm.cabecalho_sla.natureza !== "undefined" ? _vm.cabecalho_sla.natureza : '') + "\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "sticky descricao"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-condensed table-hover",
    attrs: {
      "border": "1"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "desabilitar-impressao"
  }, [_c('th', {
    attrs: {
      "id": "item"
    }
  }, [_vm._v("ITEM")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "id": "descricao",
      "align": "center",
      "colspan": "15"
    }
  }, [_vm._v("DESCRIÇÃO")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-condensed table-hover",
    attrs: {
      "border": "1"
    }
  }, [_vm._l((_vm.itens_sla), function(item) {
    return _c('tbody', [_c('tr', [_c('td', {
      staticClass: "numero-item bg-color-extremidades alinhar-conteudo fonte-tabela",
      attrs: {
        "rowspan": "7"
      }
    }, [_vm._v(" " + _vm._s(item.numero_item))]), _vm._v(" "), _c('td', {
      staticClass: "descricao-sla bg-color-extremidades fonte-tabela",
      attrs: {
        "colspan": "25"
      }
    }, [_vm._v(_vm._s(item.descricao))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "detalhe-descricao fonte-tabela",
      attrs: {
        "colspan": "15"
      }
    }, [_vm._v(_vm._s(item.detalhamento_descricao))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "fonte-color-unidade-medicao fonte-tabela",
      attrs: {
        "colspan": "4"
      }
    }, [_vm._v(_vm._s(item.unidade_medicao_tipo))]), _vm._v(" "), _c('td', {
      staticClass: "alinhar-conteudo fonte-color-unidade-medicao fonte-tabela"
    }, [_c('strong', [_vm._v(_vm._s(item.peso_item))])]), _vm._v(" "), _c('td', {
      staticClass: "fonte-color-unidade-medicao fonte-tabela",
      attrs: {
        "colspan": "9"
      }
    }, [_vm._v("\n              Pontos - Inicia com 10 pts / perde " + _vm._s(item.peso_item) + " " + _vm._s(item.texto_taxa) + "\n            ")])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "meta-pontuacao fonte-tabela"
    }, [_vm._v("Meta de pontuação")]), _vm._v(" "), _c('td', {
      staticClass: "meta-pontuacao-valor alinhar-conteudo fonte-tabela"
    }, [_vm._v(_vm._s(item.meta_pontuacao))]), _vm._v(" "), _vm._l((_vm.meses), function(mes) {
      return _c('td', {
        staticClass: "meses alinhar-conteudo fonte-tabela"
      }, [_c('strong', [_vm._v(_vm._s(mes.sigla))])])
    })], 2), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "nao-conformidades fonte-tabela",
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v("Qtde de não-conformidades")]), _vm._v(" "), _vm._l((item.quantidade_apurada.mes), function(mes) {
      return _c('td', {
        staticClass: "meses alinhar-conteudo fonte-tabela"
      }, [(mes.total_nao_conformidades != 0 || _vm.existeEvidenciasAnuladas(mes.evidencias)) ? _c('a', {
        attrs: {
          "href": "javascript:void(0)",
          "data-toggle": "modal",
          "data-target": "#listarEvidencias"
        },
        on: {
          "click": function($event) {
            return _vm.listarEvidenciaAtual(mes.evidencias)
          }
        }
      }, [_vm._v("\n                " + _vm._s(mes.total_nao_conformidades) + "\n              ")]) : _c('span', [_vm._v(_vm._s(mes.total_nao_conformidades))])])
    })], 2), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "pontuacao-alcada fonte-tabela",
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v("Pontuação alcançada")]), _vm._v(" "), _vm._l((item.quantidade_apurada.mes), function(mes) {
      return _c('td', {
        staticClass: "meses alinhar-conteudo fonte-tabela"
      }, [_vm._v("\n              " + _vm._s(mes.pontuacao_alcancada) + "\n            ")])
    })], 2), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "multa fonte-tabela",
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v("% multa")]), _vm._v(" "), _vm._l((item.quantidade_apurada.mes), function(mes) {
      return _c('td', {
        staticClass: "meses alinhar-conteudo fonte-tabela"
      }, [_vm._v("\n              " + _vm._s(mes.multa) + "\n            ")])
    })], 2), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "fonte-tabela exibicao-evidencias-por-mes",
      attrs: {
        "colspan": "15"
      }
    }, [_c('exibir-evidencia-impressao', {
      attrs: {
        "evidencia": item.quantidade_apurada.mes
      }
    })], 1)])])
  }), _vm._v(" "), _c('tbody', {
    staticClass: "ajusta-resultado-calculo-impressao"
  }, [_c('tr', [_c('td', {
    staticClass: "percentual-multa-periodo bg-color-calculo-total-sla",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Percentual de Multa no período (%)")]), _vm._v(" "), _vm._l((_vm.percentual_multa_periodo), function(percentual) {
    return _c('td', {
      staticClass: "bg-color-calculo-total-sla text-center"
    }, [_vm._v("\n              " + _vm._s(percentual) + "\n            ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "valor-mensal-contrato bg-color-calculo-total-sla",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Valor Mensal do Contrato")]), _vm._v(" "), _vm._l((_vm.valor_mensal_contrato), function(valor_mensal) {
    return _c('td', {
      staticClass: "valor-contrato bg-color-calculo-total-sla text-center"
    }, [_vm._v("\n              " + _vm._s(valor_mensal.moeda) + "\n            ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "valor-multa bg-color-calculo-total-sla",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Valor da multa (R$)")]), _vm._v(" "), _vm._l((_vm.valor_multa), function(multa) {
    return _c('td', {
      staticClass: "bg-color-calculo-total-sla text-center"
    }, [_vm._v("\n              " + _vm._s(multa.moeda) + "\n            ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "valor-multa-utilizado-extra-mensal bg-color-calculo-total-sla",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Valor multa utilizado - Extra Mensal")]), _vm._v(" "), _vm._l((_vm.multa_extra_mensal), function(multa_extra) {
    return _c('td', {
      staticClass: "bg-color-calculo-total-sla text-center"
    }, [_vm._v("\n              " + _vm._s(multa_extra.moeda) + "\n            ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "valor-multa-a-ser-aplicada bg-color-calculo-total-sla",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Valor da multa a ser aplicada (R$)")]), _vm._v(" "), _vm._l((_vm.valor_multa_aplicada), function(multa_aplicada) {
    return _c('td', {
      staticClass: "valor-contrato text-center"
    }, [_vm._v("\n              " + _vm._s(multa_aplicada.moeda) + "\n            ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "indice-performance bg-color-calculo-total-sla",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Índice de performance")]), _vm._v(" "), _vm._l((_vm.indice_performance), function(performance) {
    return _c('td', {
      staticClass: "bg-color-calculo-total-sla text-center"
    }, [_vm._v("\n              " + _vm._s(performance) + "\n            ")])
  })], 2)])], 2), _vm._v(" "), (this.$store.state.contrato.itensContrato.tipo_contrato_id != 3 && this.$store.state.contrato.itensContrato.tipo_contrato_id != 4) ? _c('table-glosa-evidencia', {
    attrs: {
      "contrato": _vm.contrato,
      "fornecedor": (this.$store.state.fornecedor.dadosFornecedor.fornecedor_id !== '-- Selecionar Fornecedor --') ? this.$store.state.fornecedor.dadosFornecedor.fornecedor_id : null,
      "ano": _vm.anoSelecionado
    }
  }) : _vm._e(), _vm._v(" "), _c('table-fechamento-multa-glosa', {
    attrs: {
      "contrato": _vm.contrato,
      "ano": _vm.anoSelecionado,
      "uf": _vm.ufIdSelecionada,
      "fornecedor": (this.$store.state.fornecedor.dadosFornecedor.fornecedor_id !== '-- Selecionar Fornecedor --') ? this.$store.state.fornecedor.dadosFornecedor.fornecedor_id : null,
      "multas": _vm.valor_multa
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "grupo-botoes-rodape desabilitar-impressao"
  }, [_c('button', {
    staticClass: "btn btn-historico btn-default desabilitar-impressao",
    attrs: {
      "variant": "primary",
      "data-toggle": "modal",
      "data-target": "#modalHistoricoSla"
    },
    on: {
      "click": function($event) {
        return _vm.listarHistoricoSla()
      }
    }
  }, [_vm._v("Histórico")]), _vm._v(" "), _c('exportar-sla')], 1)]) : (_vm.semresultado !== null) ? _c('div', {
    staticClass: "sem-contrato"
  }, [_vm._m(0), _vm._v(" "), _c('p', [_vm._v("Selecione estado e contrato")])]) : _c('div', {
    staticClass: "sem-contrato"
  }, [_c('p', [_vm._v("Selecione estado e contrato")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Não foi encontrado contrato com os filtros selecionados")])])
}]}

/***/ }),
/* 981 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.permissao) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("UF")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ufSelecionada),
      expression: "ufSelecionada"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.ufSelecionada = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.onChangeFiltro()
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("- Selecione -")]), _vm._v(" "), _vm._l((_vm.ufs), function(uf) {
    return _c('option', {
      domProps: {
        "value": uf.id
      }
    }, [_vm._v(_vm._s(uf.nome))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Ano")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.anoSelecionado),
      expression: "anoSelecionado"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.anoSelecionado = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.onChangeFiltro()
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("- Selecione -")]), _vm._v(" "), _vm._l((_vm.anos), function(i) {
    return _c('option', [_vm._v(_vm._s(i.ano))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Mês")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mesSelecionado),
      expression: "mesSelecionado"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.loading || _vm.anoSelecionado == null
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.mesSelecionado = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.onChangeFiltro()
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("- Selecione -")]), _vm._v(" "), _vm._l((_vm.meses), function(mes) {
    return _c('option', {
      domProps: {
        "value": mes
      }
    }, [_vm._v(_vm._s(mes.nome))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Contrato")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contratoSelecionado),
      expression: "contratoSelecionado"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.loading,
      "align": "center"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.contratoSelecionado = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.onChangeFiltro()
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("- Selecione -")]), _vm._v(" "), _vm._l((_vm.tipo_imovel_servicos), function(i) {
    return _c('option', {
      domProps: {
        "value": i
      }
    }, [_vm._v(_vm._s(i.nome))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "margin-top": "24px"
    },
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.limparFiltro()
      }
    }
  }, [_vm._v(" Limpar Filtro\n        ")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "box box-default"
  }, [_vm._m(0), _vm._v(" "), (_vm.loading) ? _c('div', [_vm._m(1), _vm._v(" "), _c('HalfCircleSpinner', {
    staticStyle: {
      "margin": "0 auto",
      "float": "none"
    },
    attrs: {
      "animation-duration": 2000,
      "size": 60,
      "color": '#3c8dbc'
    }
  })], 1) : (_vm.fechamentos != '') ? _c('div', {
    staticClass: "box-body table-responsive no-padding"
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_c('tbody', [_vm._m(2), _vm._v(" "), _vm._l((_vm.records), function(fechamento, index) {
    return (index + 1 >= _vm.startIndex && index + 1 <= _vm.endIndex && !_vm.loading) ? _c('tr', {
      key: fechamento.id,
      attrs: {
        "key": fechamento.id
      }
    }, [_c('td', {
      staticClass: "text-center"
    }, [_c('a', {
      attrs: {
        "title": "Detalhes fechamento",
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          return _vm.detalhesFechamentoExtra(fechamento.id)
        }
      }
    }, [_vm._v(_vm._s(fechamento.id))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(fechamento.uf))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(fechamento.tipo_imovel_servico))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(fechamento.nome))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(fechamento.ano_de_referencia))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(fechamento.servicos && fechamento.servicos.length > 0) ? _c('span', _vm._l((fechamento.servicos), function(servico) {
      return _c('span', {
        key: servico.id,
        staticClass: "badge-servico"
      }, [_vm._v(_vm._s(servico.descricao))])
    }), 0) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('a', {
      attrs: {
        "title": "Excluir",
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          return _vm.excluirFechamentoExtra(fechamento.id)
        }
      }
    }, [_c('b-icon', {
      attrs: {
        "icon": "trash-fill",
        "font-scale": "1.2",
        "aria-hidden": "true"
      }
    })], 1)])]) : _vm._e()
  })], 2)])]) : _c('div', [(this.filtro == null) ? _c('h4', {
    staticClass: "form-inline"
  }, [_vm._v(" Você não possui fechamento preenchido. ")]) : _c('h4', {
    staticClass: "form-inline"
  }, [_vm._v(" Você não possui fechamento extracontratual filtrado. ")])]), _vm._v(" "), (!_vm.loading) ? _c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('pagination', {
    attrs: {
      "records": _vm.recordsLength,
      "per-page": _vm.perPage
    },
    on: {
      "paginate": _vm.getPage
    },
    model: {
      value: (_vm.page),
      callback: function($$v) {
        _vm.page = $$v
      },
      expression: "page"
    }
  })], 1) : _vm._e()])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-header"
  }, [_c('h3', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Fechamento Extracontratual")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticStyle: {
      "width": "100%",
      "text-align": "center"
    }
  }, [_c('b', [_vm._v("Carregando Dados. "), _c('p', [_vm._v(" Aguarde um momento...")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("ID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Estado")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Contrato")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Mês")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Ano")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Serviços")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Ação")])])
}]}

/***/ }),
/* 982 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.permissao) ? _c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [(this.$store.state.login.loginUsuario.grupo.nome != 'fornecedor' && this.$store.state.login.loginUsuario.grupo.nome != 'usuario' && this.$store.state.login.loginUsuario.grupo.nome != 'cgs') ? _c('div', {
    staticClass: "conteudo"
  }, [_c('form', [_c('div', {
    staticClass: "formulario"
  }, [_c('fieldset', [_c('legend', [_vm._v("Selecione o estado:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formNotificacao.uf_selecionada.valor),
      expression: "formNotificacao.uf_selecionada.valor"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.formNotificacao.uf_selecionada, "valor", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.ufs), function(uf) {
    return _c('option', {
      domProps: {
        "value": uf.id
      }
    }, [_vm._v(_vm._s(uf.nome))])
  }), 0)]), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Selecione o contrato")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formNotificacao.tipo_imovel_servico.valor),
      expression: "formNotificacao.tipo_imovel_servico.valor"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.formNotificacao.tipo_imovel_servico, "valor", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.tipo_imovel_servicos), function(i) {
    return _c('option', {
      domProps: {
        "value": i.id
      }
    }, [_vm._v(_vm._s(i.nome))])
  }), 0)]), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Selecione o mês de referência")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formNotificacao.mes_de_referencia.valor),
      expression: "formNotificacao.mes_de_referencia.valor"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.formNotificacao.mes_de_referencia, "valor", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.meses), function(mes) {
    return _c('option', {
      domProps: {
        "value": mes.id
      }
    }, [_vm._v(_vm._s(mes.nome))])
  }), 0)]), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Selecione o ano de referência")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formNotificacao.ano_de_referencia.valor),
      expression: "formNotificacao.ano_de_referencia.valor"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.formNotificacao.ano_de_referencia, "valor", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.anos), function(i) {
    return _c('option', [_vm._v(_vm._s(i.ano))])
  }), 0)]), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.formNotificacao.data_resposta_esperada.nome))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formNotificacao.data_resposta_esperada.valor),
      expression: "formNotificacao.data_resposta_esperada.valor"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.formNotificacao.data_resposta_esperada.valor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formNotificacao.data_resposta_esperada, "valor", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('fieldset', [_vm._m(1), _vm._v(" "), _vm._l((_vm.emails), function(email, contador) {
    return _c('div', {
      key: contador,
      staticClass: "div-email"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (email.email),
        expression: "email.email"
      }],
      staticClass: "form-control input-email",
      attrs: {
        "type": "email_envio",
        "id": "email_envio",
        "placeholder": "Insira o email"
      },
      domProps: {
        "value": (email.email)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(email, "email", $event.target.value)
        }
      }
    }), _vm._v(" "), (_vm.emails.length > 1) ? _c('button', {
      staticClass: "botao-remove-email",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeEmail(contador)
        }
      }
    }, [_c('b-icon', {
      attrs: {
        "icon": "trash-fill",
        "aria-hidden": "true"
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('br')])
  }), _vm._v(" "), (_vm.emails.length < 5) ? _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addEmail
    }
  }, [_vm._v("Adicionar mais um email")]) : _vm._e()], 2), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Insira uma descrição")]), _vm._v(" "), _c('div', {
    staticClass: "input-group textarea"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formNotificacao.descricao.valor),
      expression: "formNotificacao.descricao.valor"
    }],
    attrs: {
      "id": "descricao",
      "placeholder": _vm.formNotificacao.descricao.placeholder
    },
    domProps: {
      "value": (_vm.formNotificacao.descricao.valor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formNotificacao.descricao, "valor", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Anexar arquivo")]), _vm._v(" "), _c('input', {
    ref: "file_notificacoes",
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        return _vm.configuraBotaoArquivo($event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [(_vm.controlerBtnSubmit) ? _c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.salvarNotificao()
      }
    }
  }, [_vm._v("Salvar\n            ")]) : _c('button', {
    staticClass: "btn btn-primary btn-submit",
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" aguarde...\n            ")])])])])]) : _c('div', [_c('h4', [_vm._v("Seu grupo de usuário "), _c('b', [_vm._v(_vm._s(this.$store.state.login.loginUsuario.grupo.nome))]), _vm._v(", não permite acesso a esta área.")])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h2', [_vm._v("Nova Notificação")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('legend', [_vm._v("Insira o(s) email(s) para o comunicado de notificação "), _c('i', [_vm._v("(Máximo 5 emails)")])])
}]}

/***/ }),
/* 983 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "modal fade modal-evidencia",
    attrs: {
      "id": "modalHistoricoSla",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body alert-body"
  }, [_c('div', {
    staticClass: "filtro-historico-sla"
  }, [_c('b-form-group', {
    attrs: {
      "label": "Filtrar pesquisa",
      "label-for": "filterInput",
      "align": "center"
    }
  }, [_c('b-input-group', [_c('b-form-input', {
    staticStyle: {
      "margin": "10px",
      "text-align": "center"
    },
    attrs: {
      "type": "search",
      "placeholder": "Pesquise por qualquer palavra chave"
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _vm._v(" "), _c('b-button', {
    staticClass: "limparPesquisaBotao",
    attrs: {
      "disabled": !_vm.filter,
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.filter = ''
      }
    }
  }, [_vm._v("Limpar pesquisa")])], 1)], 1)], 1), _vm._v(" "), _c('b-table', {
    staticClass: "teste",
    attrs: {
      "striped": "",
      "hover": "",
      "items": this.$store.state.historicoSla.historicoSla,
      "filter": _vm.filter
    }
  })], 1), _vm._v(" "), _vm._m(1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h1', {
    staticClass: "modal-title"
  }, [_vm._v("Histórico de evidências")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Fechar")])])
}]}

/***/ }),
/* 984 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.controlerBtnSubmit == true) ? _c('vue-excel-xlsx', {
    staticClass: "btn btn-primary",
    attrs: {
      "data": _vm.data,
      "columns": _vm.columns,
      "filename": 'franquias',
      "sheetname": 'sheetname'
    }
  }, [_vm._v("\n  Franquias e Corretivas Associadas\n  ")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Carregando Franquias e Corretivas Associadas...")])], 1)
},staticRenderFns: []}

/***/ }),
/* 985 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.downloadAnexo()
      }
    }
  }, [_vm._v("\n    Preventivas\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 986 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "main-header"
  }, [_vm._m(0), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-static-top"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "navbar-custom-menu"
  }, [_c('ul', {
    staticClass: "nav navbar-nav perfil"
  }, [_c('li', {
    staticClass: "dropdown user user-menu"
  }, [_c('b-button', {
    attrs: {
      "variant": "link"
    },
    on: {
      "click": function($event) {
        return _vm.$store.commit('setAlertAtualizacoes', {
          show: true,
          status: true,
          msg: ''
        })
      }
    }
  }, [_c('b-icon', {
    staticClass: "atualizacoes",
    attrs: {
      "icon": "bell"
    }
  })], 1)], 1), _vm._v(" "), _c('li', {
    staticClass: "dropdown user user-menu"
  }, [_c('a', {
    staticClass: "icon-margin-top sigla-nome-usuario",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown"
    },
    on: {
      "click": function($event) {
        return _vm.getCalendario()
      }
    }
  }, [_c('b-button', {
    staticClass: "calendario"
  }, [_c('b-icon', {
    attrs: {
      "icon": "calendar3"
    }
  })], 1)], 1), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu dropdown-calendario"
  }, [_c('b-list-group', [_c('b-list-group-item', {
    attrs: {
      "variant": "info"
    }
  }, [_c('strong', [_vm._v("Extra contratual (mês corrente)")])]), _vm._v(" "), _c('b-list-group-item', {
    attrs: {
      "variant": "light"
    }
  }, [_vm._v("Ciclo de pagamento do dia 21 a 20 de cada mês.")]), _vm._v(" "), _c('b-list-group-item', {
    attrs: {
      "variant": "light"
    }
  }, [_vm._v("Até dia 25 - Fornecedor envia informações para o fop.")]), _vm._v(" "), _c('b-list-group-item', {
    attrs: {
      "variant": "light"
    }
  }, [_vm._v("De 25 ao 2º dia útil do mês - Fop envia pagamento para matriz.")]), _vm._v(" "), _c('b-list-group-item', {
    attrs: {
      "variant": "light"
    }
  }, [_vm._v("Do 2º dia útil ao dia 10 – Matriz cria PC.")]), _vm._v(" "), _c('b-list-group-item', {
    attrs: {
      "variant": "info"
    }
  }, [_c('strong', [_vm._v("SLA (mês anterior)")])]), _vm._v(" "), _c('b-list-group-item', {
    attrs: {
      "variant": "light"
    }
  }, [_vm._v("Dia 8 – Fechamento SLA SSP.")]), _vm._v(" "), _c('b-list-group-item', {
    attrs: {
      "variant": "light"
    }
  }, [_vm._v("Dia 8 ao dia 15 – Fop envia notificação para o fornecedor.")]), _vm._v(" "), _c('b-list-group-item', {
    attrs: {
      "variant": "light"
    }
  }, [_vm._v("Até dia 25 – Fornecedor envia de acordo para multa/glosa.")]), _vm._v(" "), _c('b-list-group-item', {
    attrs: {
      "variant": "light"
    }
  }, [_vm._v("De 25 ao 2º dia útil do mês - Fop envia multa/glosa para matriz. (Carta informando o mês do SLA (ex.: junho) e o mês do desconto (ex.: julho)).")])], 1)], 1)]), _vm._v(" "), _c('li', {
    staticClass: "dropdown user user-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle perfil",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown"
    }
  }, [_c('div', {
    staticClass: "sigla-nome-usuario"
  }, [_c('p', [_vm._v(_vm._s(_vm.siglaNomeUsuario))])]), _vm._v(" "), _c('span', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(this.$store.state.login.loginUsuario.usuario.name))])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "user-header"
  }, [_c('div', {
    staticClass: "sigla-nome-usuario sigla-nome-usuario-dropdown-menu"
  }, [_c('p', [_vm._v(_vm._s(_vm.siglaNomeUsuario))])]), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s(this.$store.state.login.loginUsuario.usuario.name) + "\n                " + _vm._s((this.$store.state.login.loginUsuario.grupo.length !== 0) ? this.$store.state.login.loginUsuario.grupo.nome : 'Sem grupo definido') + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "grupos-usuario"
  }, _vm._l((_vm.grupo), function(i) {
    return _c('p', [_vm._v(_vm._s(i.nome[0].toUpperCase() + i.nome.substring(1) + ';') + "   ")])
  }), 0)]), _vm._v(" "), _c('li', {
    staticClass: "user-footer"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('a', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.irPara('/perfilusuario')
      }
    }
  }, [_vm._v("Perfil do usuário")])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.irPara('/Logout')
      }
    }
  }, [_vm._v("Sair")])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "logo",
    attrs: {
      "href": "/"
    }
  }, [_c('span', {
    staticClass: "logo-mini"
  }, [_c('b'), _vm._v("SSP")]), _vm._v(" "), _c('span', {
    staticClass: "logo-lg"
  }, [_c('b', [_vm._v("Financeiro")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "sidebar-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "push-menu",
      "role": "button"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")])])
}]}

/***/ }),
/* 987 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (this.$store.state.modal.exportarExtra.show === true) ? _c('div', {
    staticClass: "in show modal fade exportarExtra",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.fecharModal()
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Exportar Extra Contratual")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "d-flex justify-content-center align-items-center"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "ano"
    }
  }, [_vm._v("Selecione o ano que deseja baixar:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.anoSelecionado),
      expression: "anoSelecionado"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "ano",
      "required": "",
      "min": _vm.minYear,
      "max": _vm.maxYear
    },
    domProps: {
      "value": (_vm.anoSelecionado)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.anoSelecionado = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [(_vm.alert) ? _c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_c('b', [_vm._v("Selecione o ano!")])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn-primary",
    attrs: {
      "id": "button"
    },
    on: {
      "click": function($event) {
        return _vm.selecionar()
      }
    }
  }, [_vm._v("Selecionar")])])])])])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 988 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    on: {
      "click": _vm.exportExcel
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 989 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.permissao) ? _c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "painel"
  }, [_c('div', {
    staticClass: "notificacoes"
  }, [_c('div', {
    staticClass: "cabecalho-notificacoes"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_c('div', {
    staticClass: "h2 mb-0 icon-detalhe-notificacao"
  }, [_c('router-link', {
    attrs: {
      "to": "/ListarNotificacoes"
    }
  }, [_c('b-icon-arrow-left-short')], 1)], 1)]), _vm._v(" "), _c('h2', [_vm._v("Notificação n° " + _vm._s(_vm.notificacaoAtual.id))])]), _vm._v(" "), _c('table', {
    staticClass: "table table-borderless",
    attrs: {
      "id": "tabelaControle"
    }
  }, [_c('tbody', [_vm._m(0), _vm._v(" "), _c('tr', [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-8 col-md-8"
  }, [_c('td', [_vm._v(_vm._s(_vm.notificacaoAtual.usuario))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-8 col-md-8"
  }, [_c('td', [_vm._v(_vm._s(_vm.notificacaoAtual.numero_contrato))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-8 col-md-8"
  }, [_c('td', [_vm._v(_vm._s(_vm.notificacaoAtual.mes_referencia))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-8 col-md-8"
  }, [_c('td', [_vm._v(_vm._s(_vm.notificacaoAtual.ano_referencia))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-8 col-md-8"
  }, [_c('td', [_vm._v(_vm._s(_vm.notificacaoAtual.descricao))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-8 col-md-8"
  }, [_c('td', [_vm._v(_vm._s(_vm.notificacaoAtual.data_envio))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-8 col-md-8"
  }, [(_vm.notificacaoAtual.data_resposta_esperada !== null) ? _c('td', [_vm._v("\n                  " + _vm._s(_vm.notificacaoAtual.data_resposta_esperada) + "\n                ")]) : _c('td', [_c('p', {
    staticClass: "text-center"
  }, [_vm._v("-")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-8 col-md-8"
  }, [(_vm.notificacaoAtual.arquivo) ? _c('td', [_c('a', {
    staticClass: "downloadArquivo",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.downloadArquivo(_vm.notificacaoAtual.arquivo)
      }
    }
  }, [_vm._v("Download")])]) : _c('td', [_c('span', {
    staticClass: "downloadArquivo"
  }, [_vm._v(" - ")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-8 col-md-8"
  }, [(_vm.notificacaoAtual.status === 'Concorda') ? _c('td', {
    staticClass: "text-center"
  }, [_c('span', {
    staticClass: "label label-success"
  }, [_vm._v(_vm._s(_vm.notificacaoAtual.status))])]) : (
    _vm.notificacaoAtual.status === 'Sem resposta'
  ) ? _c('td', {
    staticClass: "text-center"
  }, [_c('span', {
    staticClass: "label label-warning"
  }, [_vm._v(_vm._s(_vm.notificacaoAtual.status))])]) : _c('td', {
    staticClass: "text-center"
  }, [_c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm.notificacaoAtual.status))])])])]), _vm._v(" "), _c('br')])]), _c('hr'), _vm._v(" "), [_c('div', {
    staticClass: "accordion",
    attrs: {
      "role": "tablist"
    }
  }, [_c('b-card', {
    staticClass: "mb-1",
    attrs: {
      "no-body": ""
    }
  }, [_c('b-card-header', {
    staticClass: "p-2",
    attrs: {
      "header-tag": "header",
      "role": "tab"
    }
  }, [_c('b-button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle",
      value: ('accordion-2'),
      expression: "'accordion-2'"
    }],
    class: 'text-head'
  }, [_c('strong', [_vm._v("Histórico")])])], 1), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "id": 'accordion-2'
    }
  }, [_c('b-card-body', {
    staticClass: "bcard01"
  }, [_c('table', {
    staticClass: "table table-borderless",
    attrs: {
      "id": "tabelaControleHistorico"
    }
  }, [_c('tbody', _vm._l((_vm.historico), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('p', [_c('b', [_vm._v("Nome: ")]), _vm._v(" " + _vm._s(item.usuario))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Email: ")]), _vm._v(" " + _vm._s(item.email))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Ação: ")]), _vm._v(_vm._s(item.acao))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Data: ")]), _vm._v(_vm._s(_vm.formataData(item.created_at)))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("UF: ")]), _vm._v(_vm._s(item.uf))])])])
  }), 0)])])], 1)], 1)], 1)]], 2), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": _vm.notificacaoAtual
    }
  })])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_c('h4', {
    staticClass: "sub-header"
  }, [_vm._v("Dados da Notificação")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-4 col-md-4"
  }, [_c('td', [_c('strong', [_vm._v("Quem criou:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-4 col-md-4"
  }, [_c('td', [_c('strong', [_vm._v("Contrato:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-4 col-md-4"
  }, [_c('td', [_c('strong', [_vm._v("Mês de referência:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-4 col-md-4"
  }, [_c('td', [_c('strong', [_vm._v("Ano de referência:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-4 col-md-4"
  }, [_c('td', [_c('strong', [_vm._v("Descrição:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-4 col-md-4"
  }, [_c('td', [_c('strong', [_vm._v("Data de envio:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-4 col-md-4"
  }, [_c('td', [_c('strong', [_vm._v("Data resposta esperada:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-4 col-md-4"
  }, [_c('td', [_c('strong', [_vm._v("Arquivo:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-4 col-md-4"
  }, [_c('td', [_c('strong', [_vm._v("Status notificação")])])])
}]}

/***/ }),
/* 990 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.controlerBtnSubmit == true) ? _c('vue-excel-xlsx', {
    staticClass: "btn btn-primary",
    attrs: {
      "data": _vm.data,
      "columns": _vm.columns,
      "filename": 'franquias',
      "sheetname": 'sheetname'
    }
  }, [_vm._v("\n    Franquias\n  ")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Carregando Franquias...\n  ")])], 1)
},staticRenderFns: []}

/***/ }),
/* 991 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.controlerBtnSubmit == true) ? _c('vue-excel-xlsx', {
    staticClass: "btn btn-primary",
    attrs: {
      "data": _vm.data,
      "columns": _vm.columns,
      "filename": 'extintores',
      "sheetname": 'sheetname'
    }
  }, [_vm._v("\n    Extintores\n  ")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Carregando Extintores...\n  ")])], 1)
},staticRenderFns: []}

/***/ }),
/* 992 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "breeding-rhombus-spinner",
    style: (_vm.spinnerStyle)
  }, [_vm._l((_vm.rhombusesStyles), function(rs, index) {
    return _c('div', {
      key: index,
      staticClass: "rhombus",
      class: ("child-" + (index + 1)),
      style: (rs)
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "rhombus big",
    style: (_vm.bigRhombusStyle)
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 993 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pixel-spinner",
    style: (_vm.spinnerStyle)
  }, [_c('div', {
    staticClass: "pixel-spinner-inner",
    style: (_vm.spinnerInnerStyle)
  })])
},staticRenderFns: []}

/***/ }),
/* 994 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "tag-submit grupo-exportar"
  }, [(_vm.controlerBtnSubmit) ? _c('button', {
    staticClass: "btn btn-primary btn-exportar",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.exportarSla()
      }
    }
  }, [_vm._v(" Imprimir ")]) : _c('button', {
    staticClass: "btn btn-primary btn-exportar",
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" aguarde...")])])])
},staticRenderFns: []}

/***/ }),
/* 995 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert-body formulario"
  }, [_c('h1', {
    staticClass: "alert-title"
  }, [_vm._v("Resposta do fornecedor")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group border-blocos validacao_status_notificacao_id"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "input-group col-xs-12 col-sm-8 col-md-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-4 col-md-4 option-first"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formExibirNotificacoes.status_notificacao_id.valor),
      expression: "formExibirNotificacoes.status_notificacao_id.valor"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "inlineRadioOptions",
      "id": "inlineRadio1",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.formExibirNotificacoes.status_notificacao_id.valor, "2")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.formExibirNotificacoes.status_notificacao_id, "valor", "2")
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "inlineRadio1"
    }
  }, [_vm._v("Concordo")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4 col-md-4 option-first"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formExibirNotificacoes.status_notificacao_id.valor),
      expression: "formExibirNotificacoes.status_notificacao_id.valor"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "inlineRadioOptions",
      "id": "inlineRadio2",
      "value": "3"
    },
    domProps: {
      "checked": _vm._q(_vm.formExibirNotificacoes.status_notificacao_id.valor, "3")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.formExibirNotificacoes.status_notificacao_id, "valor", "3")
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "inlineRadio2"
    }
  }, [_vm._v("Nao Concordo")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group border-blocos validacao_observacao_fornecedor"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "input-group col-xs-12 col-sm-8 col-md-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-8 col-md-8 option-first"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formExibirNotificacoes.observacao_fornecedor.valor),
      expression: "formExibirNotificacoes.observacao_fornecedor.valor"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.formExibirNotificacoes.observacao_fornecedor.placeholder,
      "rows": "3"
    },
    domProps: {
      "value": (_vm.formExibirNotificacoes.observacao_fornecedor.valor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formExibirNotificacoes.observacao_fornecedor, "valor", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), (_vm.controlerBtnSubmit) ? _c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.enviarFormulario()
      }
    }
  }, [_vm._v("Salvar\n    ")]) : _c('button', {
    staticClass: "btn btn-primary btn-submit",
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" aguarde...")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-xs-12 col-sm-4 col-md-4"
  }, [_vm._v("Você concorda com a notificação apresentada?"), _c('i', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-xs-12 col-sm-4 col-md-4"
  }, [_vm._v("Justifique"), _c('i', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])
}]}

/***/ }),
/* 996 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "glosa-evidenca"
  }, [_c('table', {
    staticClass: "table table-bordered table-condensed table-hover",
    attrs: {
      "border": "1"
    }
  }, [_c('tbody', [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "titulo-lateral-linha fonte-tabela",
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v("Meses")]), _vm._v(" "), _vm._l((_vm.glosas), function(glosa) {
    return _c('td', {
      staticClass: "meses alinhar-conteudo fonte-tabela"
    }, [_c('strong', [_vm._v(_vm._s(glosa.mes.sigla))])])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "titulo-lateral-linha fonte-tabela",
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v("Qtde de preventivas não realizadas")]), _vm._v(" "), _vm._l((_vm.glosas), function(item) {
    return _c('td', {
      staticClass: "alinhar-conteudo fonte-tabela"
    }, [(item.quantidade) ? _c('div', [(item.quantidade) ? _c('a', {
      attrs: {
        "href": "javascript:void(0)",
        "data-toggle": "listarGlosas"
      },
      on: {
        "click": function($event) {
          return _vm.listaGlosasPorMes({
            itens: {
              contrato_id: _vm.contratoSelecionado.contrato_id,
              mes: item.mes,
              ano: _vm.anoSelecionado
            }
          })
        }
      }
    }, [_vm._v("\n                      " + _vm._s(item.quantidade) + "\n                  ")]) : _vm._e()]) : (item.quantidade === 0) ? _c('div', [_vm._v("\n                " + _vm._s(item.quantidade) + "\n              ")]) : _vm._e()])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "titulo-lateral-linha fonte-tabela",
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v("Valor da glosa ")]), _vm._v(" "), _vm._l((_vm.glosas), function(item) {
    return _c('td', {
      staticClass: "alinhar-conteudo fonte-tabela"
    }, [_c('money', _vm._b({
      staticClass: "formatacao-input-exibe-puro-texto",
      attrs: {
        "readonly": ""
      },
      model: {
        value: (item.moeda),
        callback: function($$v) {
          _vm.$set(item, "moeda", $$v)
        },
        expression: "item.moeda"
      }
    }, 'money', _vm.money, false))], 1)
  })], 2)])]), _vm._v(" "), _c('exibir-glosas-impressao', {
    attrs: {
      "filtro": {
        ano: _vm.anoSelecionado,
        contrato: _vm.contratoSelecionado
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "numero-item bg-color-extremidades alinhar-conteudo fonte-tabela",
    attrs: {
      "rowspan": "15"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "descricao-sla bg-color-extremidades fonte-tabela",
    attrs: {
      "colspan": "15"
    }
  }, [_vm._v("Penalidade por não execução de preventivas ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "detalhe-descricao fonte-tabela",
    attrs: {
      "colspan": "15"
    }
  }, [_c('strong', [_vm._v("Cada preventiva não realizada no prazo, gera glosa no respectivo valor")])])])
}]}

/***/ }),
/* 997 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "background"
  }, [_c('div', {
    staticClass: "conteudo tela-login"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("SSP Módulo Financeiro")]), _vm._v(" "), (_vm.show) ? _c('b-form', {
    staticClass: "login"
  }, [_c('b-form-group', {
    attrs: {
      "id": "input-group-1",
      "label": "Digite seu endereço de e-mail:",
      "label-for": "input-1",
      "description": ""
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "input-1",
      "type": "email",
      "required": "",
      "placeholder": "Digite aqui seu e-mail"
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.$set(_vm.form, "email", $$v)
      },
      expression: "form.email"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "id": "input-group-1",
      "label": "Senha:",
      "label-for": "input-2",
      "description": ""
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "input-2",
      "type": "password",
      "required": "",
      "placeholder": "Digite sua senha"
    },
    model: {
      value: (_vm.form.password),
      callback: function($$v) {
        _vm.$set(_vm.form, "password", $$v)
      },
      expression: "form.password"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ms-cadastro"
  }, [_c('div', [_c('p', [_c('a', {
    attrs: {
      "href": ((_vm.env.CADASTRO_USUARIO) + "/reset")
    }
  }, [_vm._v("Esqueci a senha.")])])])]), _vm._v(" "), _c('div', [_c('b-button', {
    attrs: {
      "type": "button",
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.onSubmit()
      }
    }
  }, [_vm._v("Entrar")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "indentificacao-ambiente"
  }, [_c('small', [_vm._v(_vm._s(_vm.env.NODE_ENV) + " v1")])])])
},staticRenderFns: []}

/***/ }),
/* 998 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "atom-spinner",
    style: (_vm.spinnerStyle)
  }, [_c('div', {
    staticClass: "spinner-inner"
  }, [_c('div', {
    staticClass: "spinner-line",
    style: (_vm.lineStyle)
  }), _vm._v(" "), _c('div', {
    staticClass: "spinner-line",
    style: (_vm.lineStyle)
  }), _vm._v(" "), _c('div', {
    staticClass: "spinner-line",
    style: (_vm.lineStyle)
  }), _vm._v(" "), _c('div', {
    staticClass: "spinner-circle",
    style: (_vm.circleStyle)
  }, [_vm._v("\n      ●\n    ")])])])
},staticRenderFns: []}

/***/ }),
/* 999 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "painel"
  }, [_c('div', {
    staticClass: "fechamentos"
  }, [_c('div', {
    staticClass: "cabecalho-fechamentos"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_c('div', {
    staticClass: "h2 mb-0 icon-detalhe-fechamentoextra"
  }, [_c('router-link', {
    attrs: {
      "to": "/ExibirFechamentoExtra"
    }
  }, [_c('b-icon-arrow-left-short')], 1)], 1)]), _vm._v(" "), _c('h2', [_vm._v("Fechamento extracontratual n° " + _vm._s(_vm.fechamentoAtual.id))])]), _vm._v(" "), _c('table', {
    staticClass: "table table-borderless",
    attrs: {
      "id": "tabelaControle"
    }
  }, [_c('tbody', [_vm._m(0), _vm._v(" "), _c('tr', [_vm._m(1), _vm._v(" "), _c('td', {
    staticClass: "col-md-9",
    attrs: {
      "nowrap": ""
    }
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-8 col-lg-8"
  }, [_vm._v("\n                " + _vm._s(_vm.fechamentoAtual.uf) + "\n              ")])])]), _vm._v(" "), _c('tr', [_vm._m(2), _vm._v(" "), _c('td', {
    staticClass: "col-md-9",
    attrs: {
      "nowrap": ""
    }
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-8 col-lg-8"
  }, [_vm._v("\n                " + _vm._s(_vm.fechamentoAtual.tipo_imovel_servico) + "\n              ")])])]), _vm._v(" "), _c('tr', [_vm._m(3), _vm._v(" "), _c('td', {
    staticClass: "col-md-9",
    attrs: {
      "nowrap": ""
    }
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-8 col-lg-8"
  }, [_vm._v("\n                " + _vm._s(_vm.fechamentoAtual.nome) + "\n              ")])])]), _vm._v(" "), _c('tr', [_vm._m(4), _vm._v(" "), _c('td', {
    staticClass: "col-md-9",
    attrs: {
      "nowrap": ""
    }
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-8 col-lg-8"
  }, [_vm._v("\n                " + _vm._s(_vm.fechamentoAtual.ano_de_referencia) + "\n              ")])])]), _vm._v(" "), _c('tr', [_vm._m(5), _vm._v(" "), (_vm.fechamentoAtual.valor_extra > 0) ? _c('td', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-8 col-lg-8"
  }, [_vm._v("\n                " + _vm._s(_vm.moeda(_vm.fechamentoAtual.valor_extra)) + "\n              ")])]) : _c('td', {
    staticClass: "col-md-9"
  }, [_vm._m(6)])]), _vm._v(" "), (_vm.fechamentoAtual.siglas_extra) ? _c('tr', [_c('td', {
    staticClass: "col-md-12",
    attrs: {
      "nowrap": "",
      "colspan": "2"
    }
  }, [_vm._m(7), _vm._v(" "), (_vm.fechamentoAtual.siglas_extra != '') ? _c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-12"
  }, [_c('table', {
    staticClass: "table table-borderless table-hover table-sm table-responsive w-100"
  }, [_vm._m(8), _vm._v(" "), _c('tbody', _vm._l((_vm.fechamentoAtual.siglas_extra), function(extra) {
    return _c('tr', {
      key: extra.id
    }, [_c('td', {
      attrs: {
        "nowrap": ""
      }
    }, [_vm._v(_vm._s(extra.numero_chamado))]), _vm._v(" "), _c('td', {
      attrs: {
        "nowrap": ""
      }
    }, [_vm._v(_vm._s(extra.sigla))]), _vm._v(" "), _c('td', {
      attrs: {
        "nowrap": ""
      }
    }, [_vm._v(_vm._s(_vm.moeda(extra.valor)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(extra.servico))])])
  }), 0)])]) : _c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-12"
  }, [_vm._v(" - ")])])]) : _c('tr', [_vm._m(9), _vm._v(" "), (_vm.fechamentoAtual.predio_id) ? _c('td', [_c('div', {
    staticClass: "col-sm-12 col-md-8 col-lg-8"
  }, _vm._l((_vm.predios), function(item) {
    return _c('div', {
      key: item.sigla,
      staticClass: "siglas_extra"
    }, [_c('b-badge', {
      staticClass: "bdg",
      attrs: {
        "pill": "",
        "variant": "light"
      }
    }, [_vm._v(_vm._s(item.sigla))])], 1)
  }), 0)]) : _c('td', [_vm._m(10)])]), _vm._v(" "), _c('tr', [_vm._m(11), _vm._v(" "), (_vm.fechamentoAtual.arquivo_carga_extra && _vm.fechamentoAtual.arquivo_carga_extra !== ' -- ') ? _c('td', [_c('div', {
    staticClass: "col-sm-12 col-md-8 col-lg-8"
  }, [_c('a', {
    staticClass: "downloadArquivo",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.downloadArquivo(_vm.fechamentoAtual.arquivo_carga_extra)
      }
    }
  }, [_vm._v("Download")])])]) : _c('td', [_vm._m(12)])]), _vm._v(" "), _c('tr', [_vm._m(13), _vm._v(" "), (_vm.fechamentoAtual.arquivo_extra && _vm.fechamentoAtual.arquivo_extra !== ' -- ') ? _c('td', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-8 col-lg-8"
  }, [_c('a', {
    staticClass: "downloadArquivo",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.downloadArquivo(_vm.fechamentoAtual.arquivo_extra)
      }
    }
  }, [_vm._v("Download")])])]) : _c('td', {
    staticClass: "col-md-9"
  }, [_vm._m(14)])]), _vm._v(" "), _c('tr', [_vm._m(15), _vm._v(" "), (_vm.fechamentoAtual.comodato_extra > 0) ? _c('td', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-8 col-lg-8"
  }, [_vm._v("\n                " + _vm._s(_vm.moeda(_vm.fechamentoAtual.comodato_extra)) + "\n              ")])]) : _c('td', {
    staticClass: "col-md-9"
  }, [_vm._m(16)])]), _vm._v(" "), (_vm.fechamentoAtual.siglas_comodato_extra) ? _c('tr', [_c('td', {
    staticClass: "col-md-12",
    attrs: {
      "nowrap": "",
      "colspan": "2"
    }
  }, [_vm._m(17), _vm._v(" "), (_vm.fechamentoAtual.siglas_comodato_extra != '') ? _c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-12"
  }, [_c('table', {
    staticClass: "table table-borderless table-hover table-sm table-responsive w-100"
  }, [_vm._m(18), _vm._v(" "), _c('tbody', _vm._l((_vm.fechamentoAtual.siglas_comodato_extra), function(comodato) {
    return _c('tr', {
      key: comodato.id
    }, [_c('td', {
      attrs: {
        "nowrap": ""
      }
    }, [_vm._v(_vm._s(comodato.numero_chamado))]), _vm._v(" "), _c('td', {
      attrs: {
        "nowrap": ""
      }
    }, [_vm._v(_vm._s(comodato.sigla))]), _vm._v(" "), _c('td', {
      attrs: {
        "nowrap": ""
      }
    }, [_vm._v(_vm._s(_vm.moeda(comodato.valor)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(comodato.servico))])])
  }), 0)])]) : _c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-12"
  }, [_vm._v(" - ")])])]) : _c('tr', [_vm._m(19), _vm._v(" "), (_vm.fechamentoAtual.predio_id) ? _c('td', [_c('div', {
    staticClass: "col-sm-12 col-md-8 col-lg-8"
  }, _vm._l((_vm.predios), function(item) {
    return _c('div', {
      key: item.sigla,
      staticClass: "siglas_extra"
    }, [_c('b-badge', {
      staticClass: "bdg",
      attrs: {
        "pill": "",
        "variant": "light"
      }
    }, [_vm._v(_vm._s(item.sigla))])], 1)
  }), 0)]) : _c('td', [_vm._m(20)])]), _vm._v(" "), _c('tr', [_vm._m(21), _vm._v(" "), (_vm.fechamentoAtual.arquivo_carga_comodato && _vm.fechamentoAtual.arquivo_carga_comodato !== ' -- ') ? _c('td', [_c('div', {
    staticClass: "col-sm-12 col-md-8 col-lg-8"
  }, [_c('a', {
    staticClass: "downloadArquivo",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.downloadArquivo(_vm.fechamentoAtual.arquivo_carga_comodato)
      }
    }
  }, [_vm._v("Download")])])]) : _c('td', [_vm._m(22)])]), _vm._v(" "), _c('tr', [_vm._m(23), _vm._v(" "), (_vm.fechamentoAtual.arquivo_comodato && _vm.fechamentoAtual.arquivo_comodato !== ' -- ') ? _c('td', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-8 col-lg-8"
  }, [_c('a', {
    staticClass: "downloadArquivo",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.downloadArquivo(_vm.fechamentoAtual.arquivo_comodato)
      }
    }
  }, [_vm._v("Download")])])]) : _c('td', {
    staticClass: "col-md-9"
  }, [_vm._m(24)])]), _vm._v(" "), _c('tr', [_vm._m(25), _vm._v(" "), _c('td', {
    staticClass: "col-md-9",
    attrs: {
      "nowrap": ""
    }
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-8 col-lg-8"
  }, [_vm._v("\n                " + _vm._s(_vm.fechamentoAtual.data_envio_fechamento) + "\n              ")])])]), _vm._v(" "), _c('tr', [_vm._m(26), _vm._v(" "), _c('td', {
    staticClass: "col-md-9",
    attrs: {
      "nowrap": ""
    }
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-8 col-lg-8"
  }, [_vm._v("\n                " + _vm._s(_vm.fechamentoAtual.email) + "\n              ")])])]), _vm._v(" "), _c('tr', [_vm._m(27), _vm._v(" "), _c('td', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-8 col-lg-8"
  }, [_vm._v("\n                " + _vm._s(_vm.fechamentoAtual.descricao_extra) + "\n              ")])])])])])]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": _vm.fechamentoAtual
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_c('h4', {
    staticClass: "sub-header"
  }, [_vm._v("Dados do Fechamento")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "col-md-3",
    attrs: {
      "nowrap": ""
    }
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-4 col-lg-4"
  }, [_c('strong', [_vm._v("Estado:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "col-md-3",
    attrs: {
      "nowrap": ""
    }
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-4 col-lg-4"
  }, [_c('strong', [_vm._v("Contrato:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "col-md-3",
    attrs: {
      "nowrap": ""
    }
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-4 col-lg-4"
  }, [_c('strong', [_vm._v("Mês de referência:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "col-md-3",
    attrs: {
      "nowrap": ""
    }
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-4 col-lg-4"
  }, [_c('strong', [_vm._v("Ano de referência:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "col-md-3",
    attrs: {
      "nowrap": ""
    }
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-4 col-lg-4"
  }, [_c('strong', [_vm._v("Valor Oi:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 col-md-8 col-lg-8"
  }, [_c('span', {
    staticClass: "downloadArquivo"
  }, [_vm._v(" - ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-12"
  }, [_c('strong', [_vm._v("Detalhamento Oi:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Número do chamado")]), _vm._v(" "), _c('th', [_vm._v("Sigla")]), _vm._v(" "), _c('th', [_vm._v("Valor")]), _vm._v(" "), _c('th', [_vm._v("Serviço")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "col-md-3",
    attrs: {
      "nowrap": ""
    }
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-4 col-lg-4"
  }, [_c('strong', [_vm._v("Siglas Oi:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 col-md-8 col-lg-8"
  }, [_c('span', [_vm._v(" - ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "nowrap": ""
    }
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-4 col-lg-4"
  }, [_c('strong', [_vm._v("Arquivo Carga Extra (Oi):")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 col-md-8 col-lg-8"
  }, [_c('span', {
    staticClass: "downloadArquivo"
  }, [_vm._v(" - ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "col-md-3",
    attrs: {
      "nowrap": ""
    }
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-4 col-lg-4"
  }, [_c('strong', [_vm._v("Arquivo Extracontratual Oi:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 col-md-8 col-lg-8"
  }, [_c('span', {
    staticClass: "downloadArquivo"
  }, [_vm._v(" - ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "col-md-3",
    attrs: {
      "nowrap": ""
    }
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-4 col-lg-4"
  }, [_c('strong', [_vm._v("Valor Comodato:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 col-md-8 col-lg-8"
  }, [_c('span', {
    staticClass: "downloadArquivo"
  }, [_vm._v(" - ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-12"
  }, [_c('strong', [_vm._v("Detalhamento Comodato:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Número do chamado")]), _vm._v(" "), _c('th', [_vm._v("Sigla")]), _vm._v(" "), _c('th', [_vm._v("Valor")]), _vm._v(" "), _c('th', [_vm._v("Serviço")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "col-md-3",
    attrs: {
      "nowrap": ""
    }
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-4 col-lg-4"
  }, [_c('strong', [_vm._v("Siglas Comodato:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 col-md-8 col-lg-8"
  }, [_c('span', [_vm._v(" - ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "nowrap": ""
    }
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-4 col-lg-4"
  }, [_c('strong', [_vm._v("Arquivo Carga Comodato:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 col-md-8 col-lg-8"
  }, [_c('span', {
    staticClass: "downloadArquivo"
  }, [_vm._v(" - ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "col-md-3",
    attrs: {
      "nowrap": ""
    }
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-4 col-lg-4"
  }, [_c('strong', [_vm._v("Arquivo Extracontratual Comodato:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 col-md-8 col-lg-8"
  }, [_c('span', {
    staticClass: "downloadArquivo"
  }, [_vm._v(" - ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "col-md-3",
    attrs: {
      "nowrap": ""
    }
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-4 col-lg-4"
  }, [_c('strong', [_vm._v("Data preenchimento:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "col-md-3",
    attrs: {
      "nowrap": ""
    }
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-4 col-lg-4"
  }, [_c('strong', [_vm._v("Email de quem preencheu:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-4 col-lg-4"
  }, [_c('strong', [_vm._v("Descrição:")])])])
}]}

/***/ }),
/* 1000 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "circles-to-rhombuses-spinner",
    style: (_vm.spinnertStyle)
  }, _vm._l((_vm.circlesStyles), function(cs, index) {
    return _c('div', {
      key: index,
      staticClass: "circle",
      style: (cs)
    })
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 1001 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "historico"
  }, _vm._l((_vm.historico), function(item, index) {
    return _c('div', {
      key: index
    }, [_vm._v("\n    " + _vm._s(item.usuario + ", " + item.email + ", " + item.acao + ", " + item.nome) + "\n  ")])
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 1002 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fulfilling-square-spinner",
    style: (_vm.spinnerStyle)
  }, [_c('div', {
    staticClass: "spinner-inner",
    style: (_vm.spinnerInnerStyle)
  })])
},staticRenderFns: []}

/***/ }),
/* 1003 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(this.$store.state.modal.extraContratual.show === true) ? _c('div', {
    staticClass: "in show modal fade adicionarExtra",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    class: [(this.$store.state.modal.extraContratual.status) ? 'sucesso' : 'falhou', 'modal-header']
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.fecharModal()
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "modal-body content-body"
  }, [_c('div', [_c('fieldset', [_c('ul', [_c('li', [_vm._v("Estado: " + _vm._s(_vm.dadosFechamento.uf_selecionada))]), _vm._v(" "), _c('li', [_vm._v("Ano: " + _vm._s(_vm.dadosFechamento.ano_selecionado))]), _vm._v(" "), _c('li', [_vm._v("Mês referente: " + _vm._s(_vm.dadosFechamento.mesSelecionado))]), _vm._v(" "), _c('li', [_vm._v("Tipo contrato: " + _vm._s(_vm.dadosFechamento.contrato_selecionado))]), _vm._v(" "), _c('li', [_vm._v("Número Contrato: " + _vm._s(_vm.contrato.numero_contrato_original))])])]), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Valores Oi")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('legend', [_vm._v("Valor Total")]), _vm._v(" "), _c('money', _vm._b({
    attrs: {
      "id": "valor_extra",
      "name": "valor_extra"
    },
    model: {
      value: (_vm.formFechamentoExtra.valor_extra.valor),
      callback: function($$v) {
        _vm.$set(_vm.formFechamentoExtra.valor_extra, "valor", $$v)
      },
      expression: "formFechamentoExtra.valor_extra.valor"
    }
  }, 'money', _vm.money, false)), _vm._v(" "), _c('hr'), _vm._v(" "), _c('legend', [_vm._v("Anexar Evidência")]), _vm._v(" "), _c('input', {
    ref: "arquivo_extra",
    attrs: {
      "type": "file",
      "name": "arquivo_extra"
    },
    on: {
      "change": function($event) {
        return _vm.setArquivo($event)
      }
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('legend', [_vm._v(_vm._s(_vm.formFechamentoExtra.arquivo_carga_extra.placeholder))]), _vm._v(" "), _c('input', {
    ref: _vm.formFechamentoExtra.arquivo_carga_extra.nome,
    attrs: {
      "type": "file",
      "name": "arquivo_carga_extra"
    },
    on: {
      "change": function($event) {
        return _vm.setArquivoCarga($event)
      }
    }
  }), _vm._v(" "), _vm._m(1)], 1)]), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Valores Comodato")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('legend', [_vm._v("Valor Total Comodato")]), _vm._v(" "), _c('money', _vm._b({
    attrs: {
      "id": "valor_comodato",
      "name": "valor_comodato"
    },
    model: {
      value: (_vm.formFechamentoExtra.valor_comodato.valor),
      callback: function($$v) {
        _vm.$set(_vm.formFechamentoExtra.valor_comodato, "valor", $$v)
      },
      expression: "formFechamentoExtra.valor_comodato.valor"
    }
  }, 'money', _vm.money, false)), _vm._v(" "), _c('hr'), _vm._v(" "), _c('legend', [_vm._v("Anexar Evidência Comodato")]), _vm._v(" "), _c('input', {
    ref: "arquivo_comodato",
    attrs: {
      "type": "file",
      "name": "arquivo_comodato"
    },
    on: {
      "change": function($event) {
        return _vm.setArquivoComodato($event)
      }
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('legend', [_vm._v(_vm._s(_vm.formFechamentoExtra.arquivo_carga_comodato.placeholder))]), _vm._v(" "), _c('input', {
    ref: _vm.formFechamentoExtra.arquivo_carga_comodato.nome,
    attrs: {
      "type": "file",
      "name": "arquivo_carga_comodato"
    },
    on: {
      "change": function($event) {
        return _vm.setArquivoCargaComodato($event)
      }
    }
  }), _vm._v(" "), _vm._m(2)], 1)]), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Descrição :")]), _vm._v(" "), _c('div', {
    staticClass: "input-group textarea"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formFechamentoExtra.descricao.valor),
      expression: "formFechamentoExtra.descricao.valor"
    }],
    attrs: {
      "id": "descricao",
      "placeholder": _vm.formFechamentoExtra.descricao.placeholder
    },
    domProps: {
      "value": (_vm.formFechamentoExtra.descricao.valor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formFechamentoExtra.descricao, "valor", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [(_vm.controlerBtnSubmit) ? _c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.salvarAplicacaoExtra()
      }
    }
  }, [_vm._v("Salvar\n          ")]) : _c('button', {
    staticClass: "btn btn-primary btn-submit",
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v("\n            aguarde...")])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "modal-title alert-title"
  }, [_c('span'), _vm._v("Pagamento Extracontratual\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("\n                  Cadastre todas as siglas com seus respectivos valores em uma tabela Excel com duas colunas, conforme\n                  este "), _c('a', {
    attrs: {
      "href": "/static/modelo-extracontratual.xlsx",
      "download": ""
    }
  }, [_vm._v("modelo")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("\n                  Cadastre todas as siglas com seus respectivos valores em uma tabela Excel com duas colunas, conforme\n                  este "), _c('a', {
    attrs: {
      "href": "/static/modelo-comodato-extracontratual.xlsx",
      "download": ""
    }
  }, [_vm._v("modelo")])])
}]}

/***/ }),
/* 1004 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "fechamento-multa-sla"
  }, [_c('table', {
    staticClass: "table table-bordered table-condensed table-hover",
    attrs: {
      "border": "1"
    }
  }, [_c('tbody', [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "titulo-lateral-linha fonte-tabela",
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v("Meses")]), _vm._v(" "), _vm._l((_vm.glosas), function(item) {
    return _c('td', {
      staticClass: "meses alinhar-conteudo fonte-tabela"
    }, [_c('strong', [_vm._v(_vm._s(item.mes.sigla))])])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "titulo-lateral-linha fonte-tabela",
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v("Valor da multa ")]), _vm._v(" "), _vm._l((_vm.valorMultas), function(multa) {
    return _c('td', {
      staticClass: "alinhar-conteudo fonte-tabela"
    }, [_c('money', _vm._b({
      staticClass: "formatacao-input-exibe-puro-texto",
      attrs: {
        "value": multa.moeda,
        "readonly": ""
      }
    }, 'money', _vm.money, false))], 1)
  })], 2), _vm._v(" "), (this.$store.state.contrato.itensContrato.tipo_contrato_id != 3 && this.$store.state.contrato.itensContrato.tipo_contrato_id != 4) ? _c('tr', [_c('td', {
    staticClass: "titulo-lateral-linha fonte-tabela",
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v("Valor da glosa")]), _vm._v(" "), _vm._l((_vm.glosas), function(item) {
    return _c('td', {
      staticClass: "alinhar-conteudo fonte-tabela"
    }, [_c('money', _vm._b({
      staticClass: "formatacao-input-exibe-puro-texto",
      attrs: {
        "value": item.moeda,
        "readonly": ""
      }
    }, 'money', _vm.money, false))], 1)
  })], 2) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "titulo-lateral-linha fonte-tabela",
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v("Total")]), _vm._v(" "), _vm._l((_vm.totalMultaGlosa), function(item) {
    return _c('td', {
      staticClass: "alinhar-conteudo fonte-tabela"
    }, [_c('money', _vm._b({
      staticClass: "formatacao-input-exibe-puro-texto",
      attrs: {
        "value": item.moeda,
        "readonly": ""
      }
    }, 'money', _vm.money, false))], 1)
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "titulo-lateral-linha fonte-tabela",
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v("Fechamento")]), _vm._v(" "), _vm._l((_vm.fechamentoMultaGlosa), function(fechamentoMes) {
    return _c('td', {
      staticClass: "alinhar-conteudo fonte-tabela"
    }, [(!fechamentoMes.envio_confirmado) ? _c('div', [_c('a', {
      attrs: {
        "href": "javascript:void(0)",
        "data-toggle": "listarGlosas"
      },
      on: {
        "click": function($event) {
          return _vm.exibirModalFechamentoMultaSla(fechamentoMes, 'NOVO')
        }
      }
    }, [_vm._v("\n              " + _vm._s(_vm.statusFechamento.enviar) + "\n              ")])]) : _c('div', [_c('a', {
      attrs: {
        "href": "javascript:void(0)",
        "data-toggle": "listarGlosas"
      },
      on: {
        "click": function($event) {
          return _vm.exibirModalFechamentoMultaSla(fechamentoMes, 'EXIBIR')
        }
      }
    }, [_vm._v("\n              " + _vm._s(_vm.statusFechamento.enviado) + "\n              ")])])])
  })], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "numero-item bg-color-extremidades alinhar-conteudo fonte-tabela",
    attrs: {
      "rowspan": "15"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "descricao-sla bg-color-extremidades fonte-tabela",
    attrs: {
      "colspan": "15"
    }
  }, [_vm._v("Resumo mensal")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "detalhe-descricao fonte-tabela",
    attrs: {
      "colspan": "15"
    }
  }, [_c('strong', [_vm._v("Fechamento mensal multa / sla")])])])
}]}

/***/ }),
/* 1005 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "trinity-rings-spinner",
    style: (_vm.spinnerStyle)
  }, [_c('div', {
    staticClass: "circle circle1",
    style: (_vm.ring1Style)
  }), _vm._v(" "), _c('div', {
    staticClass: "circle circle2",
    style: (_vm.ring2Style)
  }), _vm._v(" "), _c('div', {
    staticClass: "circle circle3",
    style: (_vm.ring3Style)
  })])
},staticRenderFns: []}

/***/ }),
/* 1006 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "self-building-square-spinner",
    style: (_vm.spinnerStyle)
  }, _vm._l((_vm.squaresStyles), function(ss, index) {
    return _c('div', {
      key: index,
      staticClass: "square",
      class: {
        'clear': index && index % 3 === 0
      },
      style: (ss)
    })
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 1007 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "modal fade modal-exibir-notificacao",
    attrs: {
      "id": "exibirNotificacao",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body alert-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group border-blocos validacao_status_notificacao_id"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "input-group col-xs-12 col-sm-8 col-md-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-4 col-md-4 option-first"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formExibirNotificacoes.status_notificacao_id.valor),
      expression: "formExibirNotificacoes.status_notificacao_id.valor"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "inlineRadioOptions",
      "id": "inlineRadio1",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.formExibirNotificacoes.status_notificacao_id.valor, "2")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.formExibirNotificacoes.status_notificacao_id, "valor", "2")
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "inlineRadio1"
    }
  }, [_vm._v("Concordo")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4 col-md-4 option-first"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formExibirNotificacoes.status_notificacao_id.valor),
      expression: "formExibirNotificacoes.status_notificacao_id.valor"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "inlineRadioOptions",
      "id": "inlineRadio2",
      "value": "3"
    },
    domProps: {
      "checked": _vm._q(_vm.formExibirNotificacoes.status_notificacao_id.valor, "3")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.formExibirNotificacoes.status_notificacao_id, "valor", "3")
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "inlineRadio2"
    }
  }, [_vm._v("Nao Concordo")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group border-blocos validacao_observacao_fornecedor"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "input-group col-xs-12 col-sm-8 col-md-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-8 col-md-8 option-first"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formExibirNotificacoes.observacao_fornecedor.valor),
      expression: "formExibirNotificacoes.observacao_fornecedor.valor"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.formExibirNotificacoes.observacao_fornecedor.placeholder,
      "rows": "3"
    },
    domProps: {
      "value": (_vm.formExibirNotificacoes.observacao_fornecedor.valor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formExibirNotificacoes.observacao_fornecedor, "valor", $event.target.value)
      }
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [(_vm.controlerBtnSubmit) ? _c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.salvarFormularioExibirNotificacoes()
      }
    }
  }, [_vm._v("Salvar\n            ")]) : _c('button', {
    staticClass: "btn btn-primary btn-submit",
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" aguarde...")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h1', {
    staticClass: "modal-title"
  }, [_vm._v("Resposta do fornecedor")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-xs-12 col-sm-4 col-md-4"
  }, [_vm._v("Você concorda com a notificação apresentada?"), _c('i', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-xs-12 col-sm-4 col-md-4"
  }, [_vm._v("Justifique"), _c('i', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])
}]}

/***/ }),
/* 1008 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isFabricio) ? _c('div', {
    staticClass: "importar-preventivas"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [(_vm.carregando && _vm.acaoEmProgresso !== 'calcular-base24-25') ? _c('div', {
    staticClass: "loading"
  }, [_vm._m(1), _vm._v(" "), _c('p', [_vm._v("Importando dados, por favor aguarde...")])]) : (_vm.erro) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v("\n        " + _vm._s(_vm.erro) + "\n      ")]) : (_vm.resultadoImportacao) ? _c('div', {
    staticClass: "alert alert-success"
  }, [_c('h4', [_vm._v("Ação concluída!")]), _vm._v(" "), (_vm.resultadoImportacao.message) ? _c('p', [_vm._v(_vm._s(_vm.resultadoImportacao.message))]) : _vm._e(), _vm._v(" "), (_vm.resultadoImportacao.dados_importados) ? _c('div', [_c('p', [_vm._v("Registros afetados:")]), _vm._v(" "), _c('ul', [(_vm.resultadoImportacao.dados_importados.base24_25 !== undefined) ? _c('li', [_c('strong', [_vm._v("Base24_25:")]), _vm._v(" " + _vm._s(_vm.resultadoImportacao.dados_importados.base24_25) + " registros")]) : _vm._e(), _vm._v(" "), (_vm.resultadoImportacao.dados_importados.valores_mensais_predios_2025 !== undefined) ? _c('li', [_c('strong', [_vm._v("Valores Mensais Prédios 2025:")]), _vm._v(" " + _vm._s(_vm.resultadoImportacao.dados_importados.valores_mensais_predios_2025) + " registros")]) : _vm._e(), _vm._v(" "), (_vm.resultadoImportacao.dados_importados.valores_faturamento !== undefined) ? _c('li', [_c('strong', [_vm._v("Valores Faturamento:")]), _vm._v(" " + _vm._s(_vm.resultadoImportacao.dados_importados.valores_faturamento) + " registros")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary mt-3",
    on: {
      "click": _vm.limparResultado
    }
  }, [_vm._v("Nova ação")])]) : _c('div', [(_vm.statusDados) ? _c('div', {
    staticClass: "mb-4"
  }, [_c('h4', [_vm._v("Status Atual:")]), _vm._v(" "), _c('div', {
    staticClass: "card bg-light p-3"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('h5', [_vm._v("Base24_25")]), _vm._v(" "), (_vm.statusDados.base24_25.tem_dados) ? _c('div', {
    staticClass: "alert alert-info"
  }, [_vm._v("\n                  Existem " + _vm._s(_vm.statusDados.base24_25.total) + " registros na tabela.\n                ")]) : _c('div', {
    staticClass: "alert alert-warning"
  }, [_vm._v("\n                  Não existem registros na tabela.\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('h5', [_vm._v("Valores Mensais Prédios 2025")]), _vm._v(" "), (_vm.statusDados.valores_mensais_predios_2025.tem_dados) ? _c('div', {
    staticClass: "alert alert-info"
  }, [_vm._v("\n                  Existem " + _vm._s(_vm.statusDados.valores_mensais_predios_2025.total) + " registros na tabela.\n                ")]) : _c('div', {
    staticClass: "alert alert-warning"
  }, [_vm._v("\n                  Não existem registros na tabela.\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 mt-3"
  }, [_c('h5', [_vm._v("Valores Faturamento")]), _vm._v(" "), (_vm.statusDados.valores_faturamento && _vm.statusDados.valores_faturamento.tem_dados) ? _c('div', {
    staticClass: "alert alert-info"
  }, [_vm._v("\n                  Existem " + _vm._s(_vm.statusDados.valores_faturamento.total) + " registros na tabela.\n                ")]) : _c('div', {
    staticClass: "alert alert-warning"
  }, [_vm._v("\n                  Não existem registros na tabela.\n                ")])])])])]) : _vm._e(), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "form-group mt-3"
  }, [_c('div', {
    staticClass: "btn-group mb-2",
    attrs: {
      "role": "group"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.carregando || _vm.acaoEmProgresso !== null
    },
    on: {
      "click": _vm.importarBase2425
    }
  }, [(_vm.acaoEmProgresso === 'importar-base24-25') ? _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Importando...")]) : _c('span', [_vm._v("Importar Base24_25")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.carregando || _vm.acaoEmProgresso !== null
    },
    on: {
      "click": _vm.importarValores2025
    }
  }, [(_vm.acaoEmProgresso === 'importar-valores-2025') ? _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Importando...")]) : _c('span', [_vm._v("Importar Valores 2025")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.carregando || _vm.acaoEmProgresso !== null
    },
    on: {
      "click": _vm.importarValoresFaturamento
    }
  }, [(_vm.acaoEmProgresso === 'importar-valores-faturamento') ? _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Importando...")]) : _c('span', [_vm._v("Importar Valores Faturamento")])])]), _vm._v(" "), _c('div', {
    staticClass: "btn-group mb-2 ml-2",
    attrs: {
      "role": "group"
    }
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "disabled": _vm.carregando || _vm.acaoEmProgresso !== null
    },
    on: {
      "click": _vm.limparBase2425
    }
  }, [(_vm.acaoEmProgresso === 'limpar-base24-25') ? _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Limpando...")]) : _c('span', [_vm._v("Limpar Base24_25")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "disabled": _vm.carregando || _vm.acaoEmProgresso !== null
    },
    on: {
      "click": _vm.limparValores2025
    }
  }, [(_vm.acaoEmProgresso === 'limpar-valores-2025') ? _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Limpando...")]) : _c('span', [_vm._v("Limpar Valores 2025")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "disabled": _vm.carregando || _vm.acaoEmProgresso !== null
    },
    on: {
      "click": _vm.limparValoresFaturamento
    }
  }, [(_vm.acaoEmProgresso === 'limpar-valores-faturamento') ? _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Limpando...")]) : _c('span', [_vm._v("Limpar Valores Faturamento")])])]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "type": "button",
      "disabled": _vm.carregando || _vm.acaoEmProgresso !== null
    },
    on: {
      "click": function($event) {
        return _vm.calcularBase2425()
      }
    }
  }, [(_vm.acaoEmProgresso === 'calcular-base24-25') ? _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Calculando...")]) : _c('span', [_vm._v("Calcular Base24_25")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info ml-2",
    attrs: {
      "type": "button",
      "disabled": _vm.carregando || _vm.acaoEmProgresso !== null
    },
    on: {
      "click": function($event) {
        return _vm.calcularValorFixoMensal()
      }
    }
  }, [(_vm.acaoEmProgresso === 'calcular-valor-fixo-mensal') ? _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Calculando...")]) : _c('span', [_vm._v("Calcular Valor Fixo Mensal - Faturamento")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info ml-2",
    attrs: {
      "type": "button",
      "disabled": _vm.carregando || _vm.acaoEmProgresso !== null
    },
    on: {
      "click": function($event) {
        return _vm.calcularValorFixoMensalRestante()
      }
    }
  }, [(_vm.acaoEmProgresso === 'calcular-valor-fixo-mensal-restante') ? _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Calculando...")]) : _c('span', [_vm._v("Calcular Valor Fixo Mensal - Restante")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success ml-2",
    attrs: {
      "type": "button",
      "disabled": _vm.carregando || _vm.acaoEmProgresso !== null
    },
    on: {
      "click": function($event) {
        return _vm.calcularCamposDerivadosBase()
      }
    }
  }, [(_vm.acaoEmProgresso === 'calcular-campos-derivados-base24-25') ? _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Calculando...")]) : _c('span', [_vm._v("Calcular Campos Derivados")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary ml-2",
    attrs: {
      "type": "button",
      "disabled": _vm.carregando || _vm.acaoEmProgresso !== null
    },
    on: {
      "click": function($event) {
        return _vm.ajustarValorFixoZero()
      }
    }
  }, [(_vm.acaoEmProgresso === 'ajustar-valor-fixo-zero') ? _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Ajustando...")]) : _c('span', [_vm._v("Ajustar Valor Fixo = 0")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary ml-2",
    attrs: {
      "type": "button",
      "disabled": _vm.carregando || _vm.acaoEmProgresso !== null
    },
    on: {
      "click": function($event) {
        return _vm.recalcularPeriodoQteProgramada()
      }
    }
  }, [(_vm.acaoEmProgresso === 'recalcular-periodo-qte-programada') ? _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Recalculando...")]) : _c('span', [_vm._v("1) Recalcular Período - Qte Programada")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary ml-2",
    attrs: {
      "type": "button",
      "disabled": _vm.carregando || _vm.acaoEmProgresso !== null
    },
    on: {
      "click": function($event) {
        return _vm.recalcularPeriodoQtesEntregues()
      }
    }
  }, [(_vm.acaoEmProgresso === 'recalcular-periodo-qtes-entregues') ? _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Recalculando...")]) : _c('span', [_vm._v("2) Recalcular Período - Entregue + Não entregues")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary ml-2",
    attrs: {
      "type": "button",
      "disabled": _vm.carregando || _vm.acaoEmProgresso !== null
    },
    on: {
      "click": function($event) {
        return _vm.recalcularPeriodoTaxaEntrega()
      }
    }
  }, [(_vm.acaoEmProgresso === 'recalcular-periodo-taxa-entrega') ? _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Recalculando...")]) : _c('span', [_vm._v("3) Recalcular Período - Taxa entrega")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary ml-2",
    attrs: {
      "type": "button",
      "disabled": _vm.carregando || _vm.acaoEmProgresso !== null
    },
    on: {
      "click": function($event) {
        return _vm.recalcularPeriodoSomaValoresEntregues()
      }
    }
  }, [(_vm.acaoEmProgresso === 'recalcular-periodo-soma-entregues') ? _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Recalculando...")]) : _c('span', [_vm._v("4) Recalcular Período - Soma valores ENTREGUES")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary ml-2",
    attrs: {
      "type": "button",
      "disabled": _vm.carregando || _vm.acaoEmProgresso !== null
    },
    on: {
      "click": function($event) {
        return _vm.recalcularPeriodoSomaValoresNaoEntregues()
      }
    }
  }, [(_vm.acaoEmProgresso === 'recalcular-periodo-soma-nao-entregues') ? _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Recalculando...")]) : _c('span', [_vm._v("5) Recalcular Período - Soma valores NÃO ENTREGUES")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary ml-2",
    attrs: {
      "type": "button",
      "disabled": _vm.carregando || _vm.acaoEmProgresso !== null
    },
    on: {
      "click": function($event) {
        return _vm.recalcularPeriodoSomaValoresEntreguesDispersos()
      }
    }
  }, [(_vm.acaoEmProgresso === 'recalcular-periodo-soma-entregues-dispersos') ? _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Recalculando...")]) : _c('span', [_vm._v("6) Recalcular Período - Soma ENTREGUES Dispersos")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary ml-2",
    attrs: {
      "type": "button",
      "disabled": _vm.carregando || _vm.acaoEmProgresso !== null
    },
    on: {
      "click": function($event) {
        return _vm.recalcularPeriodoSomaValoresNaoEntreguesDispersos()
      }
    }
  }, [(_vm.acaoEmProgresso === 'recalcular-periodo-soma-nao-entregues-dispersos') ? _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Recalculando...")]) : _c('span', [_vm._v("7) Recalcular Período - Soma NÃO ENTREGUES Dispersos")])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary ml-2",
    attrs: {
      "type": "button",
      "disabled": _vm.carregando || _vm.acaoEmProgresso !== null
    },
    on: {
      "click": function($event) {
        return _vm.exportarBaseSimulacao()
      }
    }
  }, [(_vm.acaoEmProgresso === 'export-base-simulacao') ? _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Exportando...")]) : _c('span', [_vm._v("Final) Exportar Base + Simulação")])]), _vm._v(" "), (_vm.pendentesInfo) ? _c('span', {
    staticClass: "badge badge-warning ml-2",
    attrs: {
      "title": "Pendentes na outbox + pendências de cálculo na base"
    }
  }, [_vm._v("\n            Pendentes: " + _vm._s(_vm.pendentesInfo.pendentes_total) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group"
    }
  }, [_c('button', {
    staticClass: "btn btn-outline-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.carregando || _vm.acaoEmProgresso !== null
    },
    on: {
      "click": _vm.etapaCalcularValorFixoMensal
    }
  }, [_vm._v("\n                1) Valor Fixo (faturamento)\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-outline-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.carregando || _vm.acaoEmProgresso !== null
    },
    on: {
      "click": _vm.etapaAjustarZero
    }
  }, [_vm._v("\n                2) Ajustar Valor Fixo = 0\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-outline-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.carregando || _vm.acaoEmProgresso !== null
    },
    on: {
      "click": _vm.etapaCalcularDerivados
    }
  }, [_vm._v("\n                3) Campos Derivados\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-outline-secondary",
    attrs: {
      "type": "button",
      "disabled": _vm.carregando || _vm.acaoEmProgresso !== null
    },
    on: {
      "click": _vm.carregarPendentes
    }
  }, [_vm._v("\n                Atualizar Pendentes\n              ")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success ml-2",
    attrs: {
      "type": "button",
      "disabled": _vm.carregando || _vm.acaoEmProgresso !== null
    },
    on: {
      "click": _vm.executarEtapasPreExport
    }
  }, [_vm._v("\n              Executar etapas 1-3\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/simulacao-geral')
      }
    }
  }, [_vm._v("Voltar para Simulação")])])])])])])]) : _c('div', {
    staticClass: "alert alert-warning m-3"
  }, [_vm._v("Acesso restrito.")])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h3', [_vm._v("Importar Dados de Preventivas")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner-border text-primary",
    attrs: {
      "role": "status"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Carregando...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-info"
  }, [_c('h5', [_vm._v("Arquivo para importação:")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Preventivas_2024_2025.xls")])]), _vm._v(" "), _c('p', [_vm._v("Este arquivo já está disponível no servidor e será importado diretamente sem necessidade de upload.")])])
}]}

/***/ }),
/* 1009 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fulfilling-bouncing-circle-spinner",
    style: (_vm.spinnerStyle)
  }, [_c('div', {
    staticClass: "circle",
    style: (_vm.circleStyle)
  }), _vm._v(" "), _c('div', {
    staticClass: "orbit",
    style: (_vm.orbitStyle)
  })])
},staticRenderFns: []}

/***/ }),
/* 1010 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(this.$store.state.modal.modalListaGlosasPorMes.show) ? _c('div', {
    staticClass: "in show modal fade",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.fecharModal()
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h1', {
    staticClass: "modal-title"
  }, [_vm._v("Lista de glosas")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body alert-body icon-acoes btable"
  }, [_c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadingGlosas === true),
      expression: "loadingGlosas === true"
    }],
    staticClass: "loading"
  }, [_c('HalfCircleSpinner', {
    attrs: {
      "animation-duration": 2000,
      "size": 60,
      "color": '#3c8dbc'
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "sem-glosas"
  }, [_vm._v("Procurando glosa...")])], 1), _vm._v(" "), (_vm.glosas.length) ? _c('b-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadingGlosas === false),
      expression: "loadingGlosas === false"
    }],
    attrs: {
      "striped": "",
      "hover": "",
      "items": _vm.glosas,
      "fields": _vm.fieldsGlosas
    },
    scopedSlots: _vm._u([{
      key: "cell(valor)",
      fn: function(data) {
        return [_c('money', _vm._b({
          staticClass: "formatacao-input-exibe-puro-texto",
          attrs: {
            "readonly": ""
          },
          model: {
            value: (data.item.valor),
            callback: function($$v) {
              _vm.$set(data.item, "valor", $$v)
            },
            expression: "data.item.valor"
          }
        }, 'money', _vm.money, false))]
      }
    }, {
      key: "cell(arquivo)",
      fn: function(data) {
        return [(data.item.arquivo) ? _c('a', {
          attrs: {
            "href": "javascript:void(0)"
          },
          on: {
            "click": function($event) {
              return _vm.downloadArquivo(data.value)
            }
          }
        }, [_vm._v("Download")]) : _c('span', [_vm._v(" - ")])]
      }
    }, {
      key: "cell(excluir)",
      fn: function(data) {
        return [_c('div', {
          staticClass: "btn-excluir"
        }, [(_vm.controlerLoadingDelete) ? _c('a', {
          attrs: {
            "href": "javascript:void(0)"
          },
          on: {
            "click": function($event) {
              return _vm.excluirGlosa(data.item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-times-circle-o"
        })]) : _c('a', {
          attrs: {
            "href": "javascript:void(0)"
          }
        }, [_vm._v("Aguarde...")])])]
      }
    }, {
      key: "cell(anulado)",
      fn: function(data) {
        return [(!data.value) ? _c('div', {
          staticClass: "btn-anular"
        }, [(_vm.controlerLoadingDelete) ? _c('a', {
          attrs: {
            "href": "javascript:void(0)",
            "title": "Anular evidência"
          },
          on: {
            "click": function($event) {
              return _vm.anularGlosa(data.item.glosa_id)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-times-circle-o"
        })]) : _c('a', {
          attrs: {
            "href": "javascript:void(0)"
          }
        }, [_vm._v("Aguarde...")])]) : _c('div', {
          staticClass: "btn-desanular"
        }, [(_vm.controlerLoadingDelete) ? _c('a', {
          attrs: {
            "href": "javascript:void(0)",
            "title": "Desanular evidência"
          },
          on: {
            "click": function($event) {
              return _vm.desanularGlosa(data.item.glosa_id)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-times-circle-o"
        })]) : _c('a', {
          attrs: {
            "href": "javascript:void(0)"
          }
        }, [_vm._v("Aguarde...")])])]
      }
    }], null, false, 3233059868)
  }) : (_vm.loadingGlosas === null) ? _c('div', [_c('p', {
    staticClass: "sem-glosas"
  }, [_vm._v("Ops... não há glosa por aqui... (-:")])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.fecharModal()
      }
    }
  }, [_vm._v("Fechar")])])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1011 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swapping-squares-spinner",
    style: (_vm.spinnerStyle)
  }, _vm._l((_vm.squaresStyles), function(ss, index) {
    return _c('div', {
      key: index,
      staticClass: "square",
      class: ("square-" + (index + 1)),
      style: (ss)
    })
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 1012 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "half-circle-spinner",
    style: (_vm.spinnerStyle)
  }, [_c('div', {
    staticClass: "circle circle-1",
    style: (_vm.circle1Style)
  }), _vm._v(" "), _c('div', {
    staticClass: "circle circle-2",
    style: (_vm.circle2Style)
  })])
},staticRenderFns: []}

/***/ }),
/* 1013 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(this.$store.state.itensSla.controleExibicaoImpressao) ? _c('div', [_c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "items": _vm.glosasPorItem
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1014 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.controlerBtnSubmit) ? _c('vue-excel-xlsx', {
    staticClass: "btn btn-primary",
    attrs: {
      "data": _vm.data,
      "columns": _vm.columns,
      "filename": 'planilha_geral',
      "sheetname": 'sheetname'
    }
  }, [_vm._v("\n    Resumo de SLA\n  ")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Carregando planilha...")])], 1)
},staticRenderFns: []}

/***/ }),
/* 1015 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.controlerBtnSubmit) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.downloadAnexo()
      }
    }
  }, [_vm._v("Franquia Negociações")]) : _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Carregando Negociações...")]), _c('br'), _vm._v(" "), (_vm.controlerBtnSubmit) ? _c('span', {
    staticStyle: {
      "font-size": "10px",
      "color": "red"
    }
  }, [_c('svg', {
    staticClass: "bi bi-exclamation-circle",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "12",
      "height": "12",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z"
    }
  })]), _vm._v(" "), _c('b', [_vm._v("O tempo de download pode variar conforme o número de estados do usuário.")])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1016 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flower-spinner",
    style: (_vm.spinnerStyle)
  }, [_c('div', {
    staticClass: "dots-container",
    style: (_vm.dotsContainerStyle)
  }, [_c('div', {
    staticClass: "big-dot",
    style: (_vm.biggerDotStyle)
  }, [_c('div', {
    staticClass: "small-dot",
    style: (_vm.smallerDotStyle)
  })])])])
},staticRenderFns: []}

/***/ }),
/* 1017 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    class: [(this.$store.state.alertCalendario.alertCalendario.show === true) ? 'in show' : '', 'modal fade'],
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "back-header modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.fecharModal()
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title alert-title color-h4"
  }, [_vm._v(" Datas fechamento financeiro")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('b-list-group', [_c('b-list-group-item', {
    attrs: {
      "variant": "info"
    }
  }, [_c('strong', [_vm._v("Extra contratual (mês corrente)")])]), _vm._v(" "), _c('b-list-group-item', {
    attrs: {
      "variant": "light"
    }
  }, [_vm._v("Ciclo de pagamento do dia 21 a 20 de cada mês.")]), _vm._v(" "), _c('b-list-group-item', {
    attrs: {
      "variant": "light"
    }
  }, [_vm._v("Até dia 25 - Fornecedor envia informações para o fop.")]), _vm._v(" "), _c('b-list-group-item', {
    attrs: {
      "variant": "light"
    }
  }, [_vm._v("De 25 ao 2º dia útil do mês - Fop envia pagamento para matriz.")]), _vm._v(" "), _c('b-list-group-item', {
    attrs: {
      "variant": "light"
    }
  }, [_vm._v("Do 2º dia útil ao dia 10 – Matriz cria PC.")]), _vm._v(" "), _c('b-list-group-item', {
    attrs: {
      "variant": "info"
    }
  }, [_c('strong', [_vm._v("SLA (mês anterior)")])]), _vm._v(" "), _c('b-list-group-item', {
    attrs: {
      "variant": "light"
    }
  }, [_vm._v("Dia 8 – Fechamento SLA SSP.")]), _vm._v(" "), _c('b-list-group-item', {
    attrs: {
      "variant": "light"
    }
  }, [_vm._v("Dia 8 ao dia 15 – Fop envia notificação para o fornecedor.")]), _vm._v(" "), _c('b-list-group-item', {
    attrs: {
      "variant": "light"
    }
  }, [_vm._v("Até dia 25 – Fornecedor envia de acordo para multa/glosa.")]), _vm._v(" "), _c('b-list-group-item', {
    attrs: {
      "variant": "light"
    }
  }, [_vm._v("De 25 ao 2º dia útil do mês - Fop envia multa/glosa para matriz. (Carta informando o mês do SLA (ex.: junho) e o mês do desconto (ex.: julho)).")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.fecharModal()
      }
    }
  }, [_vm._v("Fechar")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 1018 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.downloadAnexo()
      }
    }
  }, [_vm._v("\n    Log de Preventivas\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 1019 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.permissao && !_vm.loading) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_vm._m(0), _vm._v(" "), (_vm.janelaAplicacao < 0) ? _c('div', [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v("Não estamos no período de aplicação do Extracontratual")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('br')]) : _c('div', [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('h4', {
    staticClass: "box-title text-center"
  }, [_vm._v("Selecione os dados do contrato")]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12 col-sm-4 col-md-6"
  }, [_c('label', {
    staticClass: "col-sm-6 control-label",
    attrs: {
      "for": "inputEmail3"
    }
  }, [_vm._v("Estado:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.uf_selecionada),
      expression: "uf_selecionada"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.uf_selecionada = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.ufs), function(uf) {
    return _c('option', {
      key: uf.id,
      domProps: {
        "value": uf
      }
    }, [_vm._v(_vm._s(uf.nome))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-4 col-md-6"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "inputPassword3"
    }
  }, [_vm._v("Mês:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mesSelecionado),
      expression: "mesSelecionado"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.mesSelecionado = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.meses), function(mes) {
    return _c('option', {
      key: mes.id,
      domProps: {
        "value": mes
      }
    }, [_vm._v(_vm._s(mes.nome))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12 col-sm-4 col-md-6"
  }, [_c('label', {
    staticClass: "col-sm-6 control-label",
    attrs: {
      "for": "inputEmail3"
    }
  }, [_vm._v("Contrato:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contrato_selecionado),
      expression: "contrato_selecionado"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.contrato_selecionado = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.tipo_imovel_servicos), function(i) {
    return _c('option', {
      key: i.id,
      domProps: {
        "value": i
      }
    }, [_vm._v(_vm._s(i.nome))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-4 col-md-6"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "inputPassword3"
    }
  }, [_vm._v("Ano:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ano_selecionado),
      expression: "ano_selecionado"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.ano_selecionado = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.anos), function(i) {
    return _c('option', {
      key: i.id
    }, [_vm._v(_vm._s(i.ano))])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [(_vm.verificaCamposPrenchidos) ? _c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exibeModalFechamento()
      }
    }
  }, [_vm._v("Continuar\n          ")]) : _c('b-button', {
    attrs: {
      "variant": "primary",
      "disabled": ""
    }
  }, [_vm._v("Aguardando preenchimento dos campos\n          ")])], 1)])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h2', [_vm._v("Fechamento Extracontratual")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', {
    staticClass: "text-center"
  }, [_c('b', [_vm._v("Janela de aplicação:")]), _vm._v(" do dia 21 ao 2° dia útil do mês seguinte")])
}]}

/***/ }),
/* 1020 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "orbit-spinner",
    style: (_vm.spinnerStyle)
  }, [_c('div', {
    staticClass: "orbit one",
    style: (_vm.orbitStyle)
  }), _vm._v(" "), _c('div', {
    staticClass: "orbit two",
    style: (_vm.orbitStyle)
  }), _vm._v(" "), _c('div', {
    staticClass: "orbit three",
    style: (_vm.orbitStyle)
  })])
},staticRenderFns: []}

/***/ }),
/* 1021 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(this.$store.state.login.loginUsuario.token || _vm.rotasNaoAutenticadas()) ? _c('section', [_c('div', {
    class: (this.$store.state.login.loginUsuario.token ? 'wrapper' : 'wrapper menu-rota-nao-autenticada')
  }, [(this.$store.state.login.loginUsuario.token) ? _c('va-navibar') : _vm._e(), _vm._v(" "), _c('va-slider', {
    attrs: {
      "slideMenuItems": _vm.slideMenuItems
    }
  }), _vm._v(" "), _c('va-content-wrap')], 1), _vm._v(" "), _c('div', [_c('redirecionar-usuario-apos-login')], 1)]) : (this.$route.path == '/autenticar') ? _c('section', [_c('login-ssp')], 1) : _c('section', [_c('Login')], 1), _vm._v(" "), _c('section', [_c('Modals')], 1)])
},staticRenderFns: []}

/***/ }),
/* 1022 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', [_c('h1', [_vm._v("Saindo...")]), _vm._v(" "), _c('small', [_vm._v("Obrigado!")])])])
}]}

/***/ }),
/* 1023 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.abrirModal()
      }
    }
  }, [_vm._v("\n        Preventivas\n      ")]), _vm._v(" "), _c('modal-planilhas-preventivas', {
    on: {
      "selecionado": _vm.downloadAnexo
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1024 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "radar-spinner",
    style: (_vm.spinnerStyle)
  }, _vm._l((_vm.circlesStyles), function(cs, index) {
    return _c('div', {
      key: index,
      staticClass: "circle",
      style: (cs)
    }, [_c('div', {
      staticClass: "circle-inner-container",
      style: (_vm.circleInnerContainerStyle)
    }, [_c('div', {
      staticClass: "circle-inner",
      style: (_vm.circleInnerStyle)
    })])])
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 1025 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (this.$store.state.modal.adicionarEvidencia.show === true) ? _c('div', {
    staticClass: "in show modal fade adicionarEvidencia",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.fecharModal()
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h3', {
    staticClass: "modal-title"
  }, [_vm._v("Evidências para aplicação de SLA: " + _vm._s(_vm.conteudo.nome) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-6"
  }, [_c('label', {
    staticClass: "col-md-5 col-form-label"
  }, [_vm._v("Mês de referência: ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7 bloco_mes_de_referencia"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formEvidencia.mes_de_referencia.valor),
      expression: "formEvidencia.mes_de_referencia.valor"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.formEvidencia.mes_de_referencia, "valor", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.meses), function(mes) {
    return _c('option', {
      attrs: {
        "disabled": _vm.evidenciaEnviada[((mes.id) - 1)] === 0 ? false : true
      },
      domProps: {
        "value": mes.id
      }
    }, [_vm._v(_vm._s(((_vm.evidenciaEnviada[((mes.id) - 1)] === 0) ? ('' + mes.nome + '') : (' - ' + mes.nome + ' * fech. enviado'))))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-6"
  }, [_c('label', {
    staticClass: "col-md-5 col-form-label"
  }, [_vm._v("Existe evidência: ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7 bloco_existeEvidencia"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formEvidencia.existe_evidencia.valor),
      expression: "formEvidencia.existe_evidencia.valor"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.formEvidencia.existe_evidencia, "valor", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Sim")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Não")])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [(_vm.formEvidencia.existe_evidencia.valor == 1) ? _c('fieldset', {
    attrs: {
      "id": "for-group"
    }
  }, [_c('div', {
    staticClass: "existeEvidencia"
  }, [_c('div', {
    staticClass: "col-md-12 input-border"
  }, [_c('label', {
    staticClass: "col-md-4 col-form-label"
  }, [_vm._v("Não conformidade apurada:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 bloco_nao_conformidade_apurada"
  }, [_c('b-form-input', {
    attrs: {
      "size": "sm"
    },
    model: {
      value: (_vm.formEvidencia.nao_conformidade_apurada.valor),
      callback: function($$v) {
        _vm.$set(_vm.formEvidencia.nao_conformidade_apurada, "valor", $$v)
      },
      expression: "formEvidencia.nao_conformidade_apurada.valor"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 input-border"
  }, [_c('label', {
    staticClass: "col-md-4 col-form-label"
  }, [_vm._v("Item SLA: ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 bloco_item_sla"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formEvidencia.item_sla_id.valor),
      expression: "formEvidencia.item_sla_id.valor"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.formEvidencia.item_sla_id, "valor", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.setUnidadeMedicao()
      }]
    }
  }, _vm._l((_vm.itens_sla), function(item) {
    return _c('option', {
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.abreviacao_item))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 input-border"
  }, [_c('label', {
    staticClass: "col-md-4 col-form-label"
  }, [_vm._v("Unidade de medição: ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 bloco_unidade_de_medicao"
  }, [_c('b-form-input', {
    attrs: {
      "size": "sm",
      "disabled": ""
    },
    model: {
      value: (_vm.formEvidencia.unidade_medicao.nome),
      callback: function($$v) {
        _vm.$set(_vm.formEvidencia.unidade_medicao, "nome", $$v)
      },
      expression: "formEvidencia.unidade_medicao.nome"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 input-border"
  }, [_c('label', {
    staticClass: "col-md-4 col-form-label"
  }, [_vm._v("Quantidade apurada: ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 bloco_quantidade_apurada"
  }, [_c('b-form-input', {
    attrs: {
      "size": "sm",
      "type": "text",
      "maxlength": "3",
      "onkeypress": "return event.charCode >= 48 && event.charCode <= 57"
    },
    model: {
      value: (_vm.formEvidencia.quantidade_apurada.valor),
      callback: function($$v) {
        _vm.$set(_vm.formEvidencia.quantidade_apurada, "valor", $$v)
      },
      expression: "formEvidencia.quantidade_apurada.valor"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 input-border"
  }, [_c('label', {
    staticClass: "col-md-4 col-form-label"
  }, [_vm._v("Observações: ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 bloco_observacoes"
  }, [_c('b-form-input', {
    attrs: {
      "size": "sm"
    },
    model: {
      value: (_vm.formEvidencia.observacoes.valor),
      callback: function($$v) {
        _vm.$set(_vm.formEvidencia.observacoes, "valor", $$v)
      },
      expression: "formEvidencia.observacoes.valor"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 input-border"
  }, [_c('label', {
    staticClass: "col-md-4 col-form-label"
  }, [_vm._v("Evidências: ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 bloco_evidencias"
  }, [_c('b-form-input', {
    attrs: {
      "size": "sm"
    },
    model: {
      value: (_vm.formEvidencia.evidencias.valor),
      callback: function($$v) {
        _vm.$set(_vm.formEvidencia.evidencias, "valor", $$v)
      },
      expression: "formEvidencia.evidencias.valor"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 input-border"
  }, [_c('label', {
    staticClass: "col-md-4 col-form-label"
  }, [_vm._v("Inserir Anexo: ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    ref: _vm.formEvidencia.arquivo_de_evidencia.nome,
    attrs: {
      "type": "file"
    }
  })])])])]) : _vm._e()])], 1), _vm._v(" "), (_vm.controleBtnSubmit) ? _c('div', {
    staticClass: "modal-footer"
  }, [(_vm.formEvidencia.existe_evidencia.valor != null) ? _c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.salvarEvidencia()
      }
    }
  }, [_vm._v("Salvar\n        ")]) : _vm._e(), _vm._v(" "), (_vm.formEvidencia.existe_evidencia.valor != null) ? _c('button', {
    staticClass: "btn btn-primary pull-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.salvarEvidencia()
      }
    }
  }, [_vm._v("+ Nova Evidência\n        ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-fechar",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.fecharModal();
        _vm.limparDadosFormulario()
      }
    }
  }, [_vm._v("Fechar\n        ")])]) : _c('div', {
    staticClass: "box-footer pull-right"
  }, [_vm._m(0)])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-primary btn-submit",
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" aguarde...")])
}]}

/***/ }),
/* 1026 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.controlerBtnSubmit) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.downloadAnexo()
      }
    }
  }, [_vm._v("Franquias")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Carregando...")]), _c('br')])
},staticRenderFns: []}

/***/ }),
/* 1027 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hollow-dots-spinner",
    style: (_vm.spinnerStyle)
  }, _vm._l((_vm.dotsStyles), function(ds, index) {
    return _c('div', {
      key: index,
      staticClass: "dot",
      style: (ds)
    })
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 1028 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.permissao) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "cabecalho"
  }, [_c('div', {
    staticClass: "form-inline"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-3"
  }, [_c('label', [_vm._v(" UF: ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ufSelecionada),
      expression: "ufSelecionada"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.ufSelecionada = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.onChangeFiltro()
      }]
    }
  }, _vm._l((_vm.ufs), function(uf) {
    return _c('option', {
      domProps: {
        "value": uf.id
      }
    }, [_vm._v(_vm._s(uf.nome))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-4"
  }, [_c('label', [_vm._v(" Contrato: ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contratoSelecionado),
      expression: "contratoSelecionado"
    }],
    staticClass: "form-control",
    attrs: {
      "align": "center"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.contratoSelecionado = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.onChangeFiltro()
      }]
    }
  }, _vm._l((_vm.tipo_imovel_servicos), function(i) {
    return _c('option', {
      domProps: {
        "value": i
      }
    }, [_vm._v(_vm._s(i.nome))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-3"
  }, [_c('label', [_vm._v(" Mês: ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mesSelecionado),
      expression: "mesSelecionado"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.mesSelecionado = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.onChangeFiltro()
      }]
    }
  }, _vm._l((_vm.meses), function(mes) {
    return _c('option', {
      domProps: {
        "value": mes
      }
    }, [_vm._v(_vm._s(mes.nome))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-2"
  }, [_c('label', [_vm._v(" Ano: ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.anoSelecionado),
      expression: "anoSelecionado"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.anoSelecionado = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.onChangeFiltro()
      }]
    }
  }, _vm._l((_vm.anos), function(i) {
    return _c('option', [_vm._v(_vm._s(i.ano))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group clear-buton col-md-12",
    attrs: {
      "align": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.limparFiltro()
      }
    }
  }, [_vm._v(" Limpar Filtro\n            ")])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "box box-default"
  }, [_vm._m(0), _vm._v(" "), (_vm.notificacoes != '') ? _c('div', {
    staticClass: "box-body table-responsive no-padding"
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_c('tbody', [_vm._m(1), _vm._v(" "), _vm._l((_vm.records), function(notificacao, index) {
    return (index + 1 >= _vm.startIndex && index + 1 <= _vm.endIndex) ? _c('tr', {
      key: notificacao.id,
      attrs: {
        "key": notificacao.id
      }
    }, [_c('td', {
      staticClass: "text-center"
    }, [_c('a', {
      attrs: {
        "title": "Detalhes notificação",
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          return _vm.detalhesNotificacao(notificacao.id)
        }
      }
    }, [_vm._v(_vm._s(notificacao.id))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(notificacao.uf))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(notificacao.tipo_imovel_servico))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(notificacao.sigla))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(notificacao.ano_referencia))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(notificacao.data_envio))]), _vm._v(" "), (notificacao.status_resposta === 'Concorda') ? _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      staticClass: "label label-success"
    }, [_vm._v(_vm._s(notificacao.status_resposta))])]) : (notificacao.status_resposta === 'Sem resposta') ? _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      staticClass: "label label-warning"
    }, [_vm._v(_vm._s(notificacao.status_resposta))])]) : _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      staticClass: "label label-danger"
    }, [_vm._v(_vm._s(notificacao.status_resposta))])])]) : _vm._e()
  })], 2)])]) : _c('div', [(this.filtro == null) ? _c('h4', {
    staticClass: "form-inline"
  }, [_vm._v(" Você não possui notificação. ")]) : _c('h4', {
    staticClass: "form-inline"
  }, [_vm._v(" Você não possui notificação filtrada. ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('pagination', {
    attrs: {
      "records": _vm.recordsLength,
      "per-page": _vm.perPage
    },
    on: {
      "paginate": _vm.getPage
    },
    model: {
      value: (_vm.page),
      callback: function($$v) {
        _vm.page = $$v
      },
      expression: "page"
    }
  })], 1)])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-header"
  }, [_c('h3', [_vm._v("Notificações")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("ID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Estado")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Contrato")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Mês")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Ano")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Data de Envio")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Retorno Fornecedor")])])
}]}

/***/ }),
/* 1029 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(0), _vm._v(" "), (_vm.franquias.length != 0) ? _c('div', {
    staticClass: "box-body"
  }, _vm._l((_vm.franquias), function(franquia) {
    return _c('div', {
      key: franquia.total,
      staticClass: "row"
    }, [_c('div', {
      staticClass: "form-group col-xs-12 col-sm-4 col-md-8"
    }, [_c('div', {
      staticClass: "col-sm-3 control-label"
    }, [_vm._v(_vm._s(franquia.trimestre_ano))]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-3 control-label"
    }, [_vm._v(_vm._s(_vm.formatarMoeda(franquia.valor_total)))]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-3 control-label"
    }, [_vm._v(_vm._s(franquia.total_unidades) + " unidades")]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-3"
    }, [_c('b-button', {
      attrs: {
        "variant": "primary",
        "disabled": _vm.loading
      },
      on: {
        "click": function($event) {
          return _vm.glosar(franquia.meses, franquia.trimestre, franquia.ano)
        }
      }
    }, [_vm._v("\n              " + _vm._s(_vm.loadingTrimestre == franquia.trimestre ? 'aguarde...' : 'Glosar') + "\n            ")])], 1)])])
  }), 0) : _c('div', {
    staticClass: "box-body"
  }, [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v("Não há pendências")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h2', [_vm._v("Pendências de Franquia pelo Fornecedor")])])])
}]}

/***/ }),
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./alertAtualizacoes.js": 625,
	"./alertCalendario.js": 626,
	"./ano.js": 627,
	"./confirmarMultaGlosa.js": 628,
	"./contrato.js": 629,
	"./dadosFechamentoSla.js": 630,
	"./evidenciasPorMes.js": 631,
	"./fechamentoAtual.js": 632,
	"./fechamentoExtra.js": 633,
	"./fornecedor.js": 634,
	"./historicoNotificacoes.js": 635,
	"./historicoSla.js": 636,
	"./index.js": 183,
	"./infoContrato.js": 637,
	"./itemAtual.js": 638,
	"./itensSla.js": 639,
	"./login.js": 640,
	"./modal.js": 641,
	"./notificacaoAtual.js": 642,
	"./permissaoNegada.js": 643,
	"./refreshComponente.js": 644,
	"./ufContratoSelecionado.js": 645,
	"./user.js": 646
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1045;

/***/ }),
/* 1046 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1047 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
]),[624]);


// WEBPACK FOOTER //
// static/js/app.04d7741a597264ddfc30.js